// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";

// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = `
//       <style>
//         body, html { margin:0!important; padding:0!important; }
//         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//         .watermark img { width: 300px; height: auto; }
//         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//         .question-grid__pre-ques { display:flex;}
//         .question-column__pre-ques { flex:1; }
//         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//         .page-footer span { float:right; }
//         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//         @media print {
//           body * { visibility: hidden !important; }
//           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         }
//         @page { size:A4; margin:0; }
//       </style>
//     `;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       // Cover Page
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div style="margin:0; padding:0;">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       // Syllabus Page
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="syllabus-heading-print">Test Syllabus</div>
//             <table class="syllabus-table-print">
//               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//               <tbody>
//                 ${quesPaperInfo.subj_chap_list
//                   .map(
//                     (subj) => `
//                   <tr>
//                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                     <td>${subj.chapters.join(", ")}</td>
//                   </tr>`
//                   )
//                   .join("")}
//               </tbody>
//             </table>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       // Questions per section
//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   ${subjectHtml}
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);
//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);

//     window.print();

//     setTimeout(() => {
//       if (printSection) document.body.removeChild(printSection);
//     }, 500);
//   };

//   const handleDownloadWord = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = ``;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               <div class="syllabus-heading-print">Test Syllabus</div>
//               <table class="syllabus-table-print">
//                 <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//                 <tbody>
//                   ${quesPaperInfo.subj_chap_list
//                     .map(
//                       (subj) => `
//                     <tr>
//                       <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                       <td>${subj.chapters.join(", ")}</td>
//                     </tr>`
//                     )
//                     .join("")}
//                 </tbody>
//               </table>
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   <div class="page-content">${subjectHtml}</div>
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const styledHTML = `
//       <html>
//         <head>
//           <meta charset="utf-8">
//           <style>
//             @page { size: A4; margin: 0; }
//             body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//             .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//             .page-content { max-width: 180mm; margin: auto; }
//             .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//             .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//             .question-block { margin-bottom: 14px; break-inside: avoid; }
//             .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//             .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//             .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//             .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//             .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//             .syllabus-table-print th { background-color: #f0f0f0; }
//             .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//           </style>
//         </head>
//         <body>
//           ${printContent}
//           <footer>
//             ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//             ${
//               quesPaperInfo?.footer?.address ||
//               "B – 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//             }
//           </footer>
//         </body>
//       </html>
//     `;

//     const blob = new Blob([styledHTML], {
//       type: "application/msword;charset=utf-8",
//     });
//     const filename = `${
//       quesPaperInfo?.ques_paper_name || "question-paper"
//     }.doc`;
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = filename;
//     link.click();
//   };

//   /**
//    * Generates the full HTML string for the question paper based on current state.
//    * This is the missing function that resolves the 'not defined' error.
//    */
//   const generatePrintableHTML = () => {
//     // Return early if essential data isn't loaded yet
//     if (!quesPaperInfo || questionData.length === 0) {
//       return "<p>Loading data, please wait...</p>";
//     }

//     // Helper function to calculate the number of pages for questions
//     const calculateTotalPagesForPrint = (set) => {
//       let questionPages = 0;
//       if (!set) return questionPages;
//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             // Adjust questions per page based on layout
//             const questionsPerPage = twinColumn ? 20 : 10;
//             questionPages += Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//           }
//         });
//       });
//       return questionPages;
//     };

//     // Helper function to render text content, including LaTeX and images
//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             // Use inline-block for better alignment with text
//             return `<img src="${url}" style="width:auto; height:1.5em; max-width:100%; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             // Render LaTeX using KaTeX
//             return segment.replace(/\\\((.*?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(he.decode(math), {
//                   throwOnError: false,
//                   displayMode: false,
//                 });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     // Helper function to process the cover page HTML template
//     const processedCoverHTMLForPrint = (setName) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       const currentSet = questionData.find((s) => s.set_name === setName);
//       const totalQuesPages = calculateTotalPagesForPrint(currentSet);
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     // Start building the full HTML string with styles
//     let fullHtml = `
//     <style>
//       body { margin: 0; padding: 0; font-family: sans-serif; }
//       .a4-page { width: 210mm; height: 296mm; padding: 15mm; box-sizing: border-box; background: white; position: relative; page-break-after: always; overflow: hidden; }
//       .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//       .watermark img { width: 400px; height: auto; }
//       .section-heading__Pre-ques { font-size: 16px; font-weight: 600; padding-bottom: 4px; margin-top: 20px; border-bottom: 1px solid #333; }
//       .question-grid__pre-ques { display: flex; gap: 15mm; }
//       .question-column__pre-ques { flex: 1; min-width: 0; }
//       .question-block { margin-bottom: 12px; page-break-inside: avoid; }
//       .options__pre-ques p { margin: 4px 0 0 16px; font-size: 14px; }
//       .page-footer { position: absolute; bottom: 10mm; left: 15mm; right: 15mm; font-size: 11px; border-top: 1px solid #ccc; padding-top: 4px; color: #444; display: flex; justify-content: space-between; }
//       .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//       .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//       .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; }
//       .page-header__pre-ques { display: flex; justify-content: space-between; font-size: 13px; padding: 4px 0; margin-bottom: 8px; border-bottom: 1px solid #ccc; }
//     </style>
//   `;

//     // Loop through each selected set and build its pages
//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       if (!currentSet) return;

//       let pageCounter = 1;

//       // Add Cover Page if toggled
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         fullHtml += `<div class="a4-page">${
//           watermark
//             ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//             : ""
//         }${processedCoverHTMLForPrint(setName)}<div class="page-footer"><div>${
//           quesPaperInfo?.footer?.client_name || ""
//         } | ${
//           quesPaperInfo?.footer?.address || ""
//         }</div><div>Set ${setName} - Cover Page</div></div></div>`;
//       }

//       // Add Syllabus Page if toggled
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         fullHtml += `<div class="a4-page">${
//           watermark
//             ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//             : ""
//         }<div class="syllabus-heading-print">Test Syllabus</div><table class="syllabus-table-print"><thead><tr><th>Subject</th><th>Chapters</th></tr></thead><tbody>${quesPaperInfo.subj_chap_list
//           .map(
//             (subj) =>
//               `<tr><td><strong>${subj.subject_name.toUpperCase()}</strong></td><td>${subj.chapters.join(
//                 ", "
//               )}</td></tr>`
//           )
//           .join("")}</tbody></table><div class="page-footer"><div>${
//           quesPaperInfo?.footer?.client_name || ""
//         } | ${
//           quesPaperInfo?.footer?.address || ""
//         }</div><div>Set ${setName} - Syllabus</div></div></div>`;
//       }

//       // Loop through subjects and sections to create question pages
//       currentSet.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           const allQuestions = [...(section.questions || [])].sort(
//             (a, b) => a.set_ques_position - b.set_ques_position
//           );
//           if (allQuestions.length === 0) return;

//           const questionsPerPage = twinColumn ? 20 : 10;
//           const totalPagesForSection = Math.ceil(
//             allQuestions.length / questionsPerPage
//           );

//           for (let page = 0; page < totalPagesForSection; page++) {
//             const pageQuestions = allQuestions.slice(
//               page * questionsPerPage,
//               (page + 1) * questionsPerPage
//             );
//             const questionStartIndex = page * questionsPerPage;
//             let pageHtml = "";

//             if (twinColumn) {
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftCol = pageQuestions.slice(0, mid);
//               const rightCol = pageQuestions.slice(mid);
//               pageHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">${leftCol
//                 .map(
//                   (ques, i) =>
//                     `<div class="question-block"><p><strong>${
//                       questionStartIndex + i + 1
//                     }.</strong> ${renderQuestionTextForPrint(
//                       ques.ques_text
//                     )}</p><div class="options__pre-ques">${ques.options
//                       .sort(
//                         (a, b) => a.set_option_position - b.set_option_position
//                       )
//                       .map(
//                         (opt, oi) =>
//                           `<p><span>${getOptionLabel(
//                             oi,
//                             quesPaperInfo?.option_naming_pattern
//                           )}</span> ${renderQuestionTextForPrint(
//                             opt.option_text
//                           )}</p>`
//                       )
//                       .join("")}</div></div>`
//                 )
//                 .join(
//                   ""
//                 )}</div><div class="question-column__pre-ques">${rightCol
//                 .map(
//                   (ques, i) =>
//                     `<div class="question-block"><p><strong>${
//                       questionStartIndex + mid + i + 1
//                     }.</strong> ${renderQuestionTextForPrint(
//                       ques.ques_text
//                     )}</p><div class="options__pre-ques">${ques.options
//                       .sort(
//                         (a, b) => a.set_option_position - b.set_option_position
//                       )
//                       .map(
//                         (opt, oi) =>
//                           `<p><span>${getOptionLabel(
//                             oi,
//                             quesPaperInfo?.option_naming_pattern
//                           )}</span> ${renderQuestionTextForPrint(
//                             opt.option_text
//                           )}</p>`
//                       )
//                       .join("")}</div></div>`
//                 )
//                 .join("")}</div></div>`;
//             } else {
//               pageHtml += pageQuestions
//                 .map(
//                   (ques, i) =>
//                     `<div class="question-block"><p><strong>${
//                       questionStartIndex + i + 1
//                     }.</strong> ${renderQuestionTextForPrint(
//                       ques.ques_text
//                     )}</p><div class="options__pre-ques">${ques.options
//                       .sort(
//                         (a, b) => a.set_option_position - b.set_option_position
//                       )
//                       .map(
//                         (opt, oi) =>
//                           `<p><span>${getOptionLabel(
//                             oi,
//                             quesPaperInfo?.option_naming_pattern
//                           )}</span> ${renderQuestionTextForPrint(
//                             opt.option_text
//                           )}</p>`
//                       )
//                       .join("")}</div></div>`
//                 )
//                 .join("");
//             }

//             fullHtml += `<div class="a4-page">${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }<div class="page-header__pre-ques"><div>${
//               quesPaperInfo?.header?.date || ""
//             }</div><div>${subject.subject_name}</div><div>${
//               quesPaperInfo?.header?.test_name || ""
//             }</div></div><p class="section-heading__Pre-ques">Section ${
//               section.section_name
//             }</p><p><strong>Instruction:</strong> ${
//               section.section_instruction?.trim()
//                 ? renderQuestionTextForPrint(section.section_instruction)
//                 : "N/A"
//             }</p>${pageHtml}<div class="page-footer"><div>${
//               quesPaperInfo?.footer?.client_name || ""
//             } | ${
//               quesPaperInfo?.footer?.address || ""
//             }</div><div>Page ${pageCounter++}</div></div></div>`;
//           }
//         });
//       });

//       // Add Rough Work page if toggled
//       if (roughPage) {
//         fullHtml += `<div class="a4-page">${
//           watermark
//             ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//             : ""
//         }<h2 style="text-align:center; margin-top: 40px;">Rough Work</h2><div class="page-footer"><div>${
//           quesPaperInfo?.footer?.client_name || ""
//         } | ${
//           quesPaperInfo?.footer?.address || ""
//         }</div><div>Rough Work</div></div></div>`;
//       }
//     });
//     return fullHtml;
//   };

//   const handleDownloadPDF = async () => {
//     // // Get the container element that is actually visible on the screen
//     // const printArea = contentRef.current;
//     // if (!printArea) {
//     //   alert("Preview area not found. Cannot generate PDF.");
//     //   return;
//     // }

//     // // Show a loading indicator for better user experience
//     // const loader = document.createElement('div');
//     // loader.innerText = 'Generating PDF, please wait...';
//     // Object.assign(loader.style, {
//     //   position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
//     //   backgroundColor: 'rgba(255, 255, 255, 0.9)', padding: '20px', border: '1px solid #ccc',
//     //   borderRadius: '10px', boxShadow: '0 4px 15px rgba(0,0,0,0.2)', zIndex: '10000'
//     // });
//     // document.body.appendChild(loader);

//     // try {
//     //   // Find all the rendered ".a4-page" divs inside the live preview
//     //   const pages = printArea.querySelectorAll('.a4-page');
//     //   if (pages.length === 0) {
//     //     throw new Error("No pages found to export. Please select a set to preview.");
//     //   }

//     //   const doc = new jsPDF('p', 'mm', 'a4');
//     //   const pdfWidth = doc.internal.pageSize.getWidth();
//     //   const pdfHeight = doc.internal.pageSize.getHeight();

//     //   // Process each visible page sequentially
//     //   for (let i = 0; i < pages.length; i++) {
//     //     const pageElement = pages[i];

//     //     // Crucial step: Ensure the page is scrolled into view before capturing
//     //     // This forces the browser to fully render it.
//     //     pageElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     //     await new Promise(resolve => setTimeout(resolve, 100)); // Brief pause for rendering

//     //     const canvas = await html2canvas(pageElement, {
//     //       scale: 2.5,         // Increase scale for sharper text and images
//     //       useCORS: true,      // Allows capturing cross-origin images
//     //       logging: false,     // Clean up console logs
//     //       // Provide context to help html2canvas render correctly
//     //       windowWidth: printArea.scrollWidth,
//     //       windowHeight: printArea.scrollHeight,
//     //     });

//     //     // Add a new page to the PDF for each element after the first one
//     //     if (i > 0) {
//     //       doc.addPage();
//     //     }

//     //     const imgData = canvas.toDataURL('image/jpeg', 0.95);
//     //     doc.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST');
//     //   }

//     //   // Save the final document
//     //   doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);

//     // } catch (error) {
//     //   console.error("Error generating PDF:", error);
//     //   alert(`An error occurred while generating the PDF: ${error.message}`);
//     // } finally {
//     //   // Clean up by removing the loader
//     //   document.body.removeChild(loader);
//     // }
//     const loader = document.createElement("div");
//     loader.innerText = "Generating PDF, please wait...";
//     document.body.appendChild(loader);

//     try {
//       const htmlContent = generatePrintableHTML();
//       const container = document.createElement("div");
//       container.style.position = "fixed";
//       container.style.left = "-9999px";
//       container.style.top = "0";
//       container.innerHTML = htmlContent;
//       document.body.appendChild(container);

//       const images = Array.from(container.querySelectorAll("img"));
//       await Promise.all(
//         images.map((img) =>
//           img.complete
//             ? Promise.resolve()
//             : new Promise((res) => {
//                 img.onload = res;
//                 img.onerror = res;
//               })
//         )
//       );

//       const pages = container.querySelectorAll(".a4-page");
//       const doc = new jsPDF("p", "mm", "a4");
//       const pdfWidth = doc.internal.pageSize.getWidth();
//       const pdfHeight = doc.internal.pageSize.getHeight();

//       for (let i = 0; i < pages.length; i++) {
//         const pageElement = pages[i];
//         const canvas = await html2canvas(pageElement, {
//           backgroundColor: null,
//           scale: 2,
//           useCORS: true,
//         });
//         const imgData = canvas.toDataURL("image/jpeg", 0.95);
//         if (i !== 0) doc.addPage();
//         doc.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
//       }

//       doc.save(`${quesPaperInfo?.ques_paper_name || "exported"}.pdf`);
//       document.body.removeChild(container);
//     } catch (error) {
//       console.error("Error generating PDF:", error);
//       alert("Failed to generate PDF.");
//     } finally {
//       document.body.removeChild(loader);
//     }
//   };

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <div
//                   className="export-dropdown-container__pre-ques"
//                   ref={exportDropdownRef}
//                 >
//                   <button
//                     className="icon-btn__pre-ques"
//                     onClick={() => setShowExportOptions(!showExportOptions)}
//                   >
//                     <img
//                       src={ExportIcon}
//                       alt="exporticon"
//                       style={{ marginRight: "5px" }}
//                     />{" "}
//                     Export
//                   </button>
//                   {showExportOptions && (
//                     <div className="export-options-dropdown__pre-ques">
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadPDF}
//                       >
//                         <FaFilePdf className="Img-PDF" />
//                         <span>PDF</span>
//                       </button>
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadWord}
//                       >
//                         <FaFileWord className="Img-WORD" />
//                         <span>Word</span>
//                       </button>
//                     </div>
//                   )}
//                 </div>
//                 <button className="icon-btn__pre-ques" onClick={handlePrint}>
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {/* {watermark && <img src={watermarkImg} alt="watermark" className="watermark-image" />} */}
//               {selectedSetNames.length === 0 ? (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               ) : (
//                 questionData
//                   .filter((set) => selectedSetNames.includes(set.set_name))
//                   .map((set) => (
//                     <React.Fragment key={`set-${set.set_name}`}>
//                       {showCoverPage && quesPaperInfo?.paper_cover && (
//                         <div className="a4-page" key={`cover-${set.set_name}`}>
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div
//                             dangerouslySetInnerHTML={{
//                               __html: processedCoverHTML(set.set_name),
//                             }}
//                           />
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Cover Page
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {showCoverPage && quesPaperInfo?.subj_chap_list && (
//                         <div className="a4-page syllabus-page">
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div className="syllabus-heading_prev_ques">
//                             <h2 style={{ textAlign: "center" }}>
//                               Test Syllabus
//                             </h2>
//                           </div>
//                           <table className="syllabus-table_prev_ques">
//                             <thead>
//                               <tr>
//                                 <th>Subject</th>
//                                 <th>Chapters</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                                 <tr key={idx}>
//                                   <td>
//                                     <strong>
//                                       {subj.subject_name.toUpperCase()}
//                                     </strong>
//                                   </td>
//                                   <td>{subj.chapters.join(", ")}</td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Syllabus
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {set.subjects.map((subject, subjectIndex) => (
//                         <div
//                           className="a4-page"
//                           key={`set-${set.set_name}-subject-${subject.subject_id}`}
//                         >
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           {subject.sections.map((section) => {
//                             const questions = [
//                               ...(section.questions || []),
//                             ].sort(
//                               (a, b) =>
//                                 a.set_ques_position - b.set_ques_position
//                             );
//                             const mid = Math.ceil(questions.length / 2);
//                             const leftQuestions = questions.slice(0, mid);
//                             const rightQuestions = questions.slice(mid);
//                             return (
//                               <div
//                                 key={`section-${section.section_name}`}
//                                 className="section-container__pre-ques"
//                               >
//                                 <p className="section-heading__Pre-ques">
//                                   Section {section.section_name}
//                                 </p>
//                                 <p>
//                                   Instruction:{" "}
//                                   {section.section_instruction?.trim()
//                                     ? renderQuestionText(
//                                         section.section_instruction
//                                       )
//                                     : "N/A"}
//                                 </p>
//                                 <div className="page-header__pre-ques">
//                                   <div className="header-left__pre-ques">
//                                     {quesPaperInfo?.header?.date}
//                                   </div>
//                                   <div className="header-center__pre-ques">
//                                     {subject.subject_name}
//                                   </div>
//                                   <div className="header-right__pre-ques">
//                                     {quesPaperInfo?.header?.test_name}
//                                   </div>
//                                 </div>
//                                 {twinColumn ? (
//                                   <div className="question-grid__pre-ques">
//                                     <div className="question-column__pre-ques">
//                                       {leftQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                     <div className="question-column__pre-ques">
//                                       {rightQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + mid + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   </div>
//                                 ) : (
//                                   <div>
//                                     {questions.map((ques, index) => (
//                                       <div
//                                         key={ques.ques_id}
//                                         className="question-block"
//                                       >
//                                         <p>
//                                           <strong>{index + 1}.</strong>{" "}
//                                           {renderQuestionText(ques.ques_text)}
//                                         </p>
//                                         <div className="options__pre-ques">
//                                           {[...ques.options]
//                                             .sort(
//                                               (a, b) =>
//                                                 a.set_option_position -
//                                                 b.set_option_position
//                                             )
//                                             .map((opt, idx) => (
//                                               <p key={opt.option_id}>
//                                                 <span>
//                                                   {getOptionLabel(
//                                                     idx,
//                                                     quesPaperInfo?.option_naming_pattern
//                                                   )}
//                                                 </span>{" "}
//                                                 {renderQuestionText(
//                                                   opt.option_text
//                                                 )}
//                                               </p>
//                                             ))}
//                                         </div>
//                                       </div>
//                                     ))}
//                                   </div>
//                                 )}
//                               </div>
//                             );
//                           })}
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Page {subjectIndex + 1}
//                             </div>
//                             {/* <div className="footer-right">Set {set.set_name} - {subject.subject_name}</div> */}
//                           </div>
//                         </div>
//                       ))}
//                     </React.Fragment>
//                   ))
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";

// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = `
//       <style>
//         body, html { margin:0!important; padding:0!important; }
//         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//         .watermark img { width: 300px; height: auto; }
//         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//         .question-grid__pre-ques { display:flex;}
//         .question-column__pre-ques { flex:1; }
//         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//         .page-footer span { float:right; }
//         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//         @media print {
//           body * { visibility: hidden !important; }
//           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         }
//         @page { size:A4; margin:0; }
//       </style>
//     `;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       // Cover Page
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div style="margin:0; padding:0;">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       // Syllabus Page
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page" style="padding: 20px;">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="syllabus-heading-print">Test Syllabus</div>
//             <table class="syllabus-table-print">
//               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//               <tbody>
//                 ${quesPaperInfo.subj_chap_list
//                   .map(
//                     (subj) => `
//                   <tr>
//                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                     <td>${subj.chapters.join(", ")}</td>
//                   </tr>`
//                   )
//                   .join("")}
//               </tbody>
//             </table>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       // Questions per section
//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques" style="padding-left: 15px;" >Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong style="padding-left: 15px;">Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//                 if (roughPage) {
//                   const isLastPage = page === totalPages - 1;
//                   const roughMinHeight = isLastPage ? "100px" : "200px";
//                   subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//                 }
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });

//                 if (roughPage) {
//                   const isLastPage = page === totalPages - 1;
//                   const roughMinHeight = isLastPage ? "100px" : "200px";
//                   subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//                 }
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   ${subjectHtml}
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);
//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);
//     console.log(printContent);
//     window.print();

//     setTimeout(() => {
//       if (printSection) document.body.removeChild(printSection);
//     }, 500);
//   };

//   const handleDownloadWord = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = ``;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               <div class="syllabus-heading-print">Test Syllabus</div>
//               <table class="syllabus-table-print">
//                 <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//                 <tbody>
//                   ${quesPaperInfo.subj_chap_list
//                     .map(
//                       (subj) => `
//                     <tr>
//                       <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                       <td>${subj.chapters.join(", ")}</td>
//                     </tr>`
//                     )
//                     .join("")}
//                 </tbody>
//               </table>
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   <div class="page-content">${subjectHtml}</div>
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const styledHTML = `
//       <html>
//         <head>
//           <meta charset="utf-8">
//           <style>
//             @page { size: A4; margin: 0; }
//             body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//             .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//             .page-content { max-width: 180mm; margin: auto; }
//             .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//             .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//             .question-block { margin-bottom: 14px; break-inside: avoid; }
//             .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//             .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//             .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//             .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//             .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//             .syllabus-table-print th { background-color: #f0f0f0; }
//             .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//           </style>
//         </head>
//         <body>
//           ${printContent}
//           <footer>
//             ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//             ${
//               quesPaperInfo?.footer?.address ||
//               "B â€“ 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//             }
//           </footer>
//         </body>
//       </html>
//     `;

//     const blob = new Blob([styledHTML], {
//       type: "application/msword;charset=utf-8",
//     });
//     const filename = `${
//       quesPaperInfo?.ques_paper_name || "question-paper"
//     }.doc`;
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = filename;
//     link.click();
//   };

//   const handleDownloadPDF = () => {
//     if (!questionData || questionData.length === 0) return;

//     const doc = new jsPDF("p", "mm", "a4");

//     const generatePDFForSet = (set, callback) => {
//       const setName = set.set_name;
//       const syllabusRows = quesPaperInfo?.subj_chap_list?.map((item) => [
//         item.subject_name,
//         item.chapters.join(", "),
//       ]);

//       doc.html(processedCoverHTML(setName), {
//         callback: () => {
//           // Syllabus Page
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text("Test Syllabus", 105, 20, { align: "center" });

//           if (syllabusRows?.length) {
//             doc.autoTable({
//               head: [["Subject", "Chapters"]],
//               body: syllabusRows,
//               startY: 30,
//               styles: { fontSize: 10 },
//               headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               theme: "grid",
//             });
//           }

//           // Add question summary next
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text(`Set ${setName} - Question Paper Summary`, 14, 20);

//           set.subjects.forEach((subject) => {
//             const sectionRows = [];

//             subject.sections.forEach((section) => {
//               (section.questions || []).forEach((ques, index) => {
//                 const questionText = he
//                   .decode(ques.ques_text)
//                   .replace(/(<([^>]+)>)/gi, "")
//                   .slice(0, 100);
//                 sectionRows.push([
//                   section.section_name,
//                   `${index + 1}`,
//                   questionText,
//                   subject.subject_name,
//                   ques.ques_id || "",
//                 ]);
//               });
//             });

//             if (sectionRows.length > 0) {
//               doc.autoTable({
//                 head: [
//                   ["Section", "Q No", "Question Text", "Subject", "Ques ID"],
//                 ],
//                 body: sectionRows,
//                 startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 30,
//                 styles: { fontSize: 8 },
//                 headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               });
//             }

//             doc.addPage(); // optional: remove if not needed per subject
//           });

//           callback();
//         },
//         x: 10,
//         y: 10,
//         margin: 10,
//         html2canvas: { scale: 0.4 },
//       });
//     };

//     const setsToProcess = questionData.filter((set) =>
//       selectedSetNames.includes(set.set_name)
//     );
//     let index = 0;

//     const processNextSet = () => {
//       if (index < setsToProcess.length) {
//         generatePDFForSet(setsToProcess[index], () => {
//           index++;
//           processNextSet();
//         });
//       } else {
//         doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);
//       }
//     };

//     processNextSet();
//   };

//   const previewPages = React.useMemo(() => {
//     const pages = [];
//     if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//       return [];
//     }

//     const setsToRender = questionData.filter((set) =>
//       selectedSetNames.includes(set.set_name)
//     );

//     // This function pre-calculates the total number of question pages for a given set.
//     // This is needed for the #total_pages# placeholder on the cover page.
//     const calculateTotalQuestionPages = (set) => {
//       let count = 0;
//       if (!set) return 0;
//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           const questionsPerPage = 10;
//           count += Math.ceil(
//             (section.questions || []).length / questionsPerPage
//           );
//         });
//       });
//       return count;
//     };

//     setsToRender.forEach((set) => {
//       let questionPageCounter = 1; // This will be the running page number for display.
//       const totalQuestionPagesForSet = calculateTotalQuestionPages(set);

//       // 1. Add Cover Page
//       if (showCoverPage && quesPaperInfo.paper_cover) {
//         pages.push({
//           type: "cover",
//           key: `cover-${set.set_name}`,
//           setName: set.set_name,
//           totalQuestionPages: totalQuestionPagesForSet,
//         });
//       }

//       // 2. Add Syllabus Page
//       if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//         pages.push({
//           type: "syllabus",
//           key: `syllabus-${set.set_name}`,
//           setName: set.set_name,
//         });
//       }

//       // 3. Add Question Pages (Paginated)
//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           const allQuestions = [...(section.questions || [])].sort(
//             (a, b) => a.set_ques_position - b.set_ques_position
//           );
//           if (allQuestions.length === 0) return;

//           const questionsPerPage = 10;
//           const totalPagesInSection = Math.ceil(
//             allQuestions.length / questionsPerPage
//           );
//           let questionIndex = 0; // To track question number within the section

//           for (let i = 0; i < totalPagesInSection; i++) {
//             const pageQuestions = allQuestions.slice(
//               i * questionsPerPage,
//               (i + 1) * questionsPerPage
//             );

//             pages.push({
//               type: "questions",
//               key: `questions-${set.set_name}-${subject.subject_id}-${section.section_name}-${i}`,
//               setName: set.set_name,
//               subject,
//               section,
//               questions: pageQuestions,
//               questionIndexOffset: questionIndex,
//               pageNumber: questionPageCounter++,
//               isLastPageInSection: i === totalPagesInSection - 1,
//             });
//             questionIndex += pageQuestions.length;
//           }
//         });
//       });
//     });

//     return pages;
//   }, [
//     questionData,
//     quesPaperInfo,
//     selectedSetNames,
//     showCoverPage,
//     watermark,
//     twinColumn,
//     roughPage,
//   ]);

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <div
//                   className="export-dropdown-container__pre-ques"
//                   ref={exportDropdownRef}
//                 >
//                   <button
//                     className="icon-btn__pre-ques"
//                     onClick={() => setShowExportOptions(!showExportOptions)}
//                   >
//                     <img
//                       src={ExportIcon}
//                       alt="exporticon"
//                       style={{ marginRight: "5px" }}
//                     />{" "}
//                     Export
//                   </button>
//                   {showExportOptions && (
//                     <div className="export-options-dropdown__pre-ques">
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadPDF}
//                       >
//                         <FaFilePdf className="Img-PDF" />
//                         <span>PDF</span>
//                       </button>
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadWord}
//                       >
//                         <FaFileWord className="Img-WORD" />
//                         <span>Word</span>
//                       </button>
//                     </div>
//                   )}
//                 </div>
//                 <button className="icon-btn__pre-ques" onClick={handlePrint}>
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {previewPages.length > 0 ? (
//                 previewPages.map((page) => (
//                   <div
//                     className={`a4-page${
//                       roughPage && page.type === "questions"
//                         ? " has-roughwork"
//                         : ""
//                     }`}
//                     key={page.key}
//                   >
//                     {watermark && (
//                       <img
//                         src={watermarkImg}
//                         alt="watermark"
//                         className="watermark-image"
//                       />
//                     )}

//                     {/* Page Content */}
//                     {page.type === "cover" && (
//                       <div
//                         dangerouslySetInnerHTML={{
//                           __html: quesPaperInfo.paper_cover
//                             .replace(/#total_pages#/gi, page.totalQuestionPages)
//                             .replace(
//                               /#test_date#/gi,
//                               new Date().toLocaleDateString("en-GB")
//                             )
//                             .replace(/#set_name#/gi, page.setName),
//                         }}
//                       />
//                     )}

//                     {page.type === "syllabus" && (
//                       <div className="syllabus-page">
//                         <div className="syllabus-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Test Syllabus</h2>
//                         </div>
//                         <table className="syllabus-table_prev_ques">
//                           <thead>
//                             <tr>
//                               <th>Subject</th>
//                               <th>Chapters</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                               <tr key={idx}>
//                                 <td>
//                                   <strong>
//                                     {subj.subject_name.toUpperCase()}
//                                   </strong>
//                                 </td>
//                                 <td>{subj.chapters.join(", ")}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}

//                     {page.type === "questions" && (
//                       <div
//                         className="section-container__pre-ques"
//                         style={{ position: "relative", minHeight: "530px" }}
//                       >
//                         <p className="section-heading__Pre-ques">
//                           Section {page.section.section_name}
//                         </p>
//                         <p>
//                           Instruction:{" "}
//                           {page.section.section_instruction?.trim()
//                             ? renderQuestionText(
//                                 page.section.section_instruction
//                               )
//                             : "N/A"}
//                         </p>
//                         <div className="page-header__pre-ques">
//                           <div className="header-left__pre-ques">
//                             {quesPaperInfo?.header?.date}
//                           </div>
//                           <div className="header-center__pre-ques">
//                             {page.subject.subject_name}
//                           </div>
//                           <div className="header-right__pre-ques">
//                             {quesPaperInfo?.header?.test_name}
//                           </div>
//                         </div>

//                         {(() => {
//                           const questions = page.questions;
//                           const mid = Math.ceil(questions.length / 2);
//                           const leftQuestions = questions.slice(0, mid);
//                           const rightQuestions = questions.slice(mid);

//                           return twinColumn ? (
//                             <div className="question-grid__pre-ques">
//                               <div className="question-column__pre-ques">
//                                 {leftQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset + index + 1}.
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                               <div className="question-column__pre-ques">
//                                 {rightQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset +
//                                           mid +
//                                           index +
//                                           1}
//                                         .
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                             </div>
//                           ) : (
//                             <div>
//                               {questions.map((ques, index) => (
//                                 <div
//                                   key={ques.ques_id}
//                                   className="question-block"
//                                 >
//                                   <p>
//                                     <strong>
//                                       {page.questionIndexOffset + index + 1}.
//                                     </strong>{" "}
//                                     {renderQuestionText(ques.ques_text)}
//                                   </p>
//                                   <div className="options__pre-ques">
//                                     {[...ques.options]
//                                       .sort(
//                                         (a, b) =>
//                                           a.set_option_position -
//                                           b.set_option_position
//                                       )
//                                       .map((opt, idx) => (
//                                         <p key={opt.option_id}>
//                                           <span>
//                                             {getOptionLabel(
//                                               idx,
//                                               quesPaperInfo?.option_naming_pattern
//                                             )}
//                                           </span>{" "}
//                                           {renderQuestionText(opt.option_text)}
//                                         </p>
//                                       ))}
//                                   </div>
//                                 </div>
//                               ))}
//                             </div>
//                           );
//                         })()}

//                         {roughPage && (
//                           <div
//                             className="rough-work-section"
//                             style={{
//                               minHeight: page.isLastPageInSection
//                                 ? "100px"
//                                 : "200px",
//                             }}
//                           >
//                             <strong>Rough Work:</strong>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Page Footer */}
//                     <div className="page-footer">
//                       <div className="footer-left">
//                         {quesPaperInfo?.footer?.client_name} |{" "}
//                         {quesPaperInfo?.footer?.address}
//                       </div>
//                       <div className="footer-right">
//                         {page.type === "cover" &&
//                           `Set ${page.setName} - Cover Page`}
//                         {page.type === "syllabus" &&
//                           `Set ${page.setName} - Syllabus`}
//                         {page.type === "questions" && `Page ${page.pageNumber}`}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";

// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = `
//       <style>
//         body, html { margin:0!important; padding:0!important; }
//         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//         .watermark img { width: 300px; height: auto; }
//         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//         .question-grid__pre-ques { display:flex;}
//         .question-column__pre-ques { flex:1; }
//         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//         .page-footer span { float:right; }
//         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//         @media print {
//           body * { visibility: hidden !important; }
//           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         }
//         @page { size:A4; margin:0; }
//       </style>
//     `;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       // Cover Page
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div style="margin:0; padding:0;">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       // Syllabus Page
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page" style="padding: 20px;">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="syllabus-heading-print">Test Syllabus</div>
//             <table class="syllabus-table-print">
//               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//               <tbody>
//                 ${quesPaperInfo.subj_chap_list
//                   .map(
//                     (subj) => `
//                   <tr>
//                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                     <td>${subj.chapters.join(", ")}</td>
//                   </tr>`
//                   )
//                   .join("")}
//               </tbody>
//             </table>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       // Questions per section
//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques" style="padding-left: 15px;" >Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong style="padding-left: 15px;">Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//                 const isLastPage = page === totalPages - 1;
//                 const roughMinHeight = isLastPage ? "100px" : "200px";
//                 subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                   const isLastPage = page === totalPages - 1;
//                   const roughMinHeight = isLastPage ? "100px" : "200px";
//                   subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   ${subjectHtml}
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);
//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);
//     console.log(printContent);
//     window.print();

//     setTimeout(() => {
//       if (printSection) document.body.removeChild(printSection);
//     }, 500);
//   };

//   const handleDownloadWord = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = ``;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               <div class="syllabus-heading-print">Test Syllabus</div>
//               <table class="syllabus-table-print">
//                 <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//                 <tbody>
//                   ${quesPaperInfo.subj_chap_list
//                     .map(
//                       (subj) => `
//                     <tr>
//                       <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                       <td>${subj.chapters.join(", ")}</td>
//                     </tr>`
//                     )
//                     .join("")}
//                 </tbody>
//               </table>
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   <div class="page-content">${subjectHtml}</div>
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const styledHTML = `
//       <html>
//         <head>
//           <meta charset="utf-8">
//           <style>
//             @page { size: A4; margin: 0; }
//             body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//             .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//             .page-content { max-width: 180mm; margin: auto; }
//             .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//             .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//             .question-block { margin-bottom: 14px; break-inside: avoid; }
//             .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//             .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//             .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//             .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//             .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//             .syllabus-table-print th { background-color: #f0f0f0; }
//             .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//           </style>
//         </head>
//         <body>
//           ${printContent}
//           <footer>
//             ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//             ${
//               quesPaperInfo?.footer?.address ||
//               "B â€“ 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//             }
//           </footer>
//         </body>
//       </html>
//     `;

//     const blob = new Blob([styledHTML], {
//       type: "application/msword;charset=utf-8",
//     });
//     const filename = `${
//       quesPaperInfo?.ques_paper_name || "question-paper"
//     }.doc`;
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = filename;
//     link.click();
//   };

//   const handleDownloadPDF = () => {
//     if (!questionData || questionData.length === 0) return;

//     const doc = new jsPDF("p", "mm", "a4");

//     const generatePDFForSet = (set, callback) => {
//       const setName = set.set_name;
//       const syllabusRows = quesPaperInfo?.subj_chap_list?.map((item) => [
//         item.subject_name,
//         item.chapters.join(", "),
//       ]);

//       doc.html(processedCoverHTML(setName), {
//         callback: () => {
//           // Syllabus Page
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text("Test Syllabus", 105, 20, { align: "center" });

//           if (syllabusRows?.length) {
//             doc.autoTable({
//               head: [["Subject", "Chapters"]],
//               body: syllabusRows,
//               startY: 30,
//               styles: { fontSize: 10 },
//               headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               theme: "grid",
//             });
//           }

//           // Add question summary next
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text(`Set ${setName} - Question Paper Summary`, 14, 20);

//           set.subjects.forEach((subject) => {
//             const sectionRows = [];

//             subject.sections.forEach((section) => {
//               (section.questions || []).forEach((ques, index) => {
//                 const questionText = he
//                   .decode(ques.ques_text)
//                   .replace(/(<([^>]+)>)/gi, "")
//                   .slice(0, 100);
//                 sectionRows.push([
//                   section.section_name,
//                   `${index + 1}`,
//                   questionText,
//                   subject.subject_name,
//                   ques.ques_id || "",
//                 ]);
//               });
//             });

//             if (sectionRows.length > 0) {
//               doc.autoTable({
//                 head: [
//                   ["Section", "Q No", "Question Text", "Subject", "Ques ID"],
//                 ],
//                 body: sectionRows,
//                 startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 30,
//                 styles: { fontSize: 8 },
//                 headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               });
//             }

//             doc.addPage(); // optional: remove if not needed per subject
//           });

//           callback();
//         },
//         x: 10,
//         y: 10,
//         margin: 10,
//         html2canvas: { scale: 0.4 },
//       });
//     };

//     const setsToProcess = questionData.filter((set) =>
//       selectedSetNames.includes(set.set_name)
//     );
//     let index = 0;

//     const processNextSet = () => {
//       if (index < setsToProcess.length) {
//         generatePDFForSet(setsToProcess[index], () => {
//           index++;
//           processNextSet();
//         });
//       } else {
//         doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);
//       }
//     };

//     processNextSet();
//   };

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <div
//                   className="export-dropdown-container__pre-ques"
//                   ref={exportDropdownRef}
//                 >
//                   <button
//                     className="icon-btn__pre-ques"
//                     onClick={() => setShowExportOptions(!showExportOptions)}
//                   >
//                     <img
//                       src={ExportIcon}
//                       alt="exporticon"
//                       style={{ marginRight: "5px" }}
//                     />{" "}
//                     Export
//                   </button>
//                   {showExportOptions && (
//                     <div className="export-options-dropdown__pre-ques">
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadPDF}
//                       >
//                         <FaFilePdf className="Img-PDF" />
//                         <span>PDF</span>
//                       </button>
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadWord}
//                       >
//                         <FaFileWord className="Img-WORD" />
//                         <span>Word</span>
//                       </button>
//                     </div>
//                   )}
//                 </div>
//                 <button className="icon-btn__pre-ques" onClick={handlePrint}>
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {/* {watermark && <img src={watermarkImg} alt="watermark" className="watermark-image" />} */}
//               {selectedSetNames.length === 0 ? (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               ) : (
//                 questionData
//                   .filter((set) => selectedSetNames.includes(set.set_name))
//                   .map((set) => (
//                     <React.Fragment key={`set-${set.set_name}`}>
//                       {showCoverPage && quesPaperInfo?.paper_cover && (
//                         <div className="a4-page" key={`cover-${set.set_name}`}>
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div
//                             dangerouslySetInnerHTML={{
//                               __html: processedCoverHTML(set.set_name),
//                             }}
//                           />
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Cover Page
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {showCoverPage && quesPaperInfo?.subj_chap_list && (
//                         <div className="a4-page syllabus-page">
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div className="syllabus-heading_prev_ques">
//                             <h2 style={{ textAlign: "center" }}>
//                               Test Syllabus
//                             </h2>
//                           </div>
//                           <table className="syllabus-table_prev_ques">
//                             <thead>
//                               <tr>
//                                 <th>Subject</th>
//                                 <th>Chapters</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                                 <tr key={idx}>
//                                   <td>
//                                     <strong>
//                                       {subj.subject_name.toUpperCase()}
//                                     </strong>
//                                   </td>
//                                   <td>{subj.chapters.join(", ")}</td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Syllabus
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {set.subjects.map((subject, subjectIndex) => (
//                         // <div
//                         //   className="a4-page"
//                         //   key={`set-${set.set_name}-subject-${subject.subject_id}`}
//                         // >
//                         <div
//                           className={`a4-page${
//                             roughPage ? " has-roughwork" : ""
//                           }`}
//                           key={`set-${set.set_name}-subject-${subject.subject_id}`}
//                         >
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           {subject.sections.map((section) => {
//                             const questions = [
//                               ...(section.questions || []),
//                             ].sort(
//                               (a, b) =>
//                                 a.set_ques_position - b.set_ques_position
//                             );
//                             const mid = Math.ceil(questions.length / 2);
//                             const leftQuestions = questions.slice(0, mid);
//                             const rightQuestions = questions.slice(mid);
//                             return (
//                               // <div
//                               //   key={`section-${section.section_name}`}
//                               //   className="section-container__pre-ques"
//                               // >
//                               <div
//                                 key={`section-${section.section_name}`}
//                                 className="section-container__pre-ques"
//                                 style={{
//                                   position: "relative",
//                                   minHeight: "530px",
//                                 }} // To ensure height for absolute positioning
//                               >
//                                 <p className="section-heading__Pre-ques">
//                                   Section {section.section_name}
//                                 </p>
//                                 <p>
//                                   Instruction:{" "}
//                                   {section.section_instruction?.trim()
//                                     ? renderQuestionText(
//                                         section.section_instruction
//                                       )
//                                     : "N/A"}
//                                 </p>
//                                 <div className="page-header__pre-ques">
//                                   <div className="header-left__pre-ques">
//                                     {quesPaperInfo?.header?.date}
//                                   </div>
//                                   <div className="header-center__pre-ques">
//                                     {subject.subject_name}
//                                   </div>
//                                   <div className="header-right__pre-ques">
//                                     {quesPaperInfo?.header?.test_name}
//                                   </div>
//                                 </div>

//                                 {twinColumn ? (
//                                   <div className="question-grid__pre-ques">
//                                     <div className="question-column__pre-ques">
//                                       {leftQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                     <div className="question-column__pre-ques">
//                                       {rightQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + mid + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   </div>
//                                 ) : (
//                                   <div>
//                                     {questions.map((ques, index) => (
//                                       <div
//                                         key={ques.ques_id}
//                                         className="question-block"
//                                       >
//                                         <p>
//                                           <strong>{index + 1}.</strong>{" "}
//                                           {renderQuestionText(ques.ques_text)}
//                                         </p>
//                                         <div className="options__pre-ques">
//                                           {[...ques.options]
//                                             .sort(
//                                               (a, b) =>
//                                                 a.set_option_position -
//                                                 b.set_option_position
//                                             )
//                                             .map((opt, idx) => (
//                                               <p key={opt.option_id}>
//                                                 <span>
//                                                   {getOptionLabel(
//                                                     idx,
//                                                     quesPaperInfo?.option_naming_pattern
//                                                   )}
//                                                 </span>{" "}
//                                                 {renderQuestionText(
//                                                   opt.option_text
//                                                 )}
//                                               </p>
//                                             ))}
//                                         </div>
//                                       </div>
//                                     ))}
//                                   </div>
//                                 )}

//                                 {roughPage && (
//                                   <div className="rough-work-section">
//                                     <strong>Rough Work:</strong>
//                                     <div style={{ height: "100%" }} />
//                                   </div>
//                                 )}
//                               </div>
//                             );
//                           })}
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Page {subjectIndex + 1}
//                             </div>
//                             {/* <div className="footer-right">Set {set.set_name} - {subject.subject_name}</div> */}
//                           </div>
//                         </div>
//                       ))}
//                     </React.Fragment>
//                   ))
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";
// import Colors from "../../../Constants/Colors";
// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const [paginatedPages, setPaginatedPages] = useState([]);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Add this helper function to render content to HTML for measurement
//   const renderContentToHTML = (text) => {
//     if (!text) return "";
//     const decoded = he.decode(text);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts
//       .map((segment) => {
//         if (segment.startsWith("imgsrc=")) {
//           const url = segment.replace("imgsrc=", "");
//           return `<img src="${url}" alt="image" style="max-width: 80px; height: auto; vertical-align: middle; margin: 0 5px;" />`;
//         } else {
//           return segment.replace(/\\\((.*?)\\\)/g, (_, math) => {
//             try {
//               return katex.renderToString(math, {
//                 throwOnError: false,
//                 displayMode: false,
//               });
//             } catch (e) {
//               console.warn("Katex rendering error:", e);
//               return `<span style="color:red;">[LaTeX Error]</span>`;
//             }
//           });
//         }
//       })
//       .join("");
//   };

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     if (!paginatedPages || paginatedPages.length === 0) {
//       alert("There is no content to print.");
//       return;
//     }

//     const AVAILABLE_HEIGHT_MM = (PAGE_CONTENT_HEIGHT_PX / 3.78); // Convert px to mm
// const FOOTER_HEIGHT_MM = 12;
// const PADDING_MM = 8;
// const CALCULATED_WRAPPER_HEIGHT = `calc(297mm - ${PADDING_MM + FOOTER_HEIGHT_MM + 8}mm)`;

//     // Helper to process cover page HTML
//     const getProcessedCoverHTML = (page) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, page.totalQuestionPages)
//         .replace(/#test_date#/gi, new Date().toLocaleDateString("en-GB"))
//         .replace(/#set_name#/gi, page.setName);
//     };

//     let printContent = `
//     <style>
//       body, html { margin: 0 !important; padding: 0 !important; background-color: #fff; font-family: Calibri, sans-serif; }
//       .a4-page { width: 210mm; min-height: 297mm; margin: 0 auto; padding: 10mm; box-sizing: border-box; background: white; position: relative; page-break-after: always; }

//       .page-content-wrapper {
//          height: ${CALCULATED_WRAPPER_HEIGHT};
//         position: relative;
//         padding-bottom: 10mm; /* Space for footer */
//         overflow: hidden;
//       }
//       .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//       .watermark img { width: 300px; height: auto; }
//       .section-heading__Pre-ques { font-size: 16px; font-weight: 600; margin: 0px 0 4px 0; padding-left: 15px; }
//       .question-grid__pre-ques { display: flex; gap: 20px; }
//       .question-column__pre-ques { flex: 1; min-width: 0; }
//       .question-block { margin-bottom: 10px; page-break-inside: avoid; }
//       .question-block p { margin: 0 0 3px 0; line-height: 1.3; }
//       .options__pre-ques p { margin: 3px 0 1px 16px; font-size: 14px; line-height: 1.2; }
//       .page-footer {
//         position: absolute;
//         bottom: 8mm;
//         left: 10mm;
//         right: 10mm;
//         height: 15mm;
//         text-align: center;
//         font-size: 11px;
//         border-top: 1px solid #ccc;
//         padding-top: 4px;
//         color: #444;
//         display: flex;
//         justify-content: space-between;
//         background: white;
//         z-index: 10;
//       }
//       .page-header__pre-ques { display: flex; justify-content: space-between; font-size: 13px; padding: 4px 12px; margin-bottom: 6px; border-bottom: 1px solid #ccc; }
//       .rough-work-section { margin-top: 15px; border-top: 1px solid #ccc; padding-top: 8px; min-height: 60px; }
//       .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 5px; padding-bottom: 8px; }
//       .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//       .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//       .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//       .instructions-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 5px; padding-bottom: 8px; }
//       .instructions-content { margin-top: 5px; }
//       @media print {
//         body * { visibility: hidden !important; }
//         #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//         #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//       }
//       @page { size: A4; margin: 0; }
//     </style>
//   `;

//     // Iterate through the already calculated paginatedPages
//     paginatedPages.forEach((page) => {
//       printContent += `<div class="a4-page">`;

//       // Add watermark if enabled
//       if (watermark) {
//         printContent += `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`;
//       }

//       printContent += `<div class="page-content-wrapper">`;

//       // Generate content based on page type
//       switch (page.type) {
//         case "cover":
//           printContent += `
//     <div style="margin-top: 0 !important; padding-top: 0 !important; position: relative; top: 0;">
//       ${getProcessedCoverHTML(page)}
//     </div>`;
//           break;

//         case "instructions":
//           printContent += `
//           <div class="instructions-heading-print">Instructions</div>
//           <hr style="border: none; border-top: 1px solid #ccc; margin: 5px 0;" />
//           <div class="instructions-content" style="font-size: 14px; text-align: justify;">${quesPaperInfo.instructions_html}</div>`;
//           break;

//         case "syllabus":
//           printContent += `
//           <div class="syllabus-heading-print">Test Syllabus</div>
//           <table class="syllabus-table-print">
//             <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//             <tbody>
//               ${quesPaperInfo.subj_chap_list
//                 .map(
//                   (s) => `
//                 <tr>
//                   <td><strong>${s.subject_name.toUpperCase()}</strong></td>
//                   <td>${s.chapters.join(", ")}</td>
//                 </tr>
//               `
//                 )
//                 .join("")}
//             </tbody>
//           </table>`;
//           break;

//         case "questions":
//           let questionsHtml = `
//           <p class="section-heading__Pre-ques">Section ${
//             page.section.section_name
//           }</p>
//           <p style="padding-left: 15px; margin: 0 0 4px 0;"><strong>Instruction:</strong> ${
//             page.section.section_instruction?.trim()
//               ? renderContentToHTML(page.section.section_instruction)
//               : "N/A"
//           }</p>
//           <div class="page-header__pre-ques">
//             <div>${quesPaperInfo?.header?.date || ""}</div>
//             <div>${page.subject.subject_name}</div>
//             <div>${quesPaperInfo?.header?.test_name || ""}</div>
//           </div>`;

//           const renderQuestionColumn = (qs, offset) =>
//             qs
//               .map(
//                 (q, i) => `
//           <div class="question-block">
//             <p><strong>${offset + i + 1}.</strong> ${renderContentToHTML(
//                   q.ques_text
//                 )}</p>
//             <div class="options__pre-ques">
//               ${q.options
//                 .sort((a, b) => a.set_option_position - b.set_option_position)
//                 .map(
//                   (opt, oi) => `
//                 <p><span>${getOptionLabel(
//                   oi,
//                   quesPaperInfo?.option_naming_pattern
//                 )}</span> ${renderContentToHTML(opt.option_text)}</p>
//               `
//                 )
//                 .join("")}
//             </div>
//           </div>`
//               )
//               .join("");

//           if (twinColumn) {
//             const mid = Math.ceil(page.questions.length / 2);
//             questionsHtml += `
//             <div class="question-grid__pre-ques">
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(0, mid),
//                 page.questionIndexOffset
//               )}</div>
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(mid),
//                 page.questionIndexOffset + mid
//               )}</div>
//             </div>`;
//           } else {
//             questionsHtml += `<div>${renderQuestionColumn(
//               page.questions,
//               page.questionIndexOffset
//             )}</div>`;
//           }

//           // Add rough work section if enabled and this is the last page of the section
//           if (roughPage && page.isLastPageInSection) {
//             questionsHtml += `<div class="rough-work-section"><strong>Rough Work:</strong></div>`;
//           }

//           printContent += questionsHtml;
//           break;

//         default:
//           break;
//       }

//       printContent += `</div>`; // Close page-content-wrapper

//       // Add footer for all page types
//       printContent += `
//       <div class="page-footer">
//         <div>${quesPaperInfo?.footer?.client_name || ""} | ${
//         quesPaperInfo?.footer?.address || ""
//       }</div>
//         <div>
//           ${page.type === "cover" ? `Set ${page.setName} - Cover Page` : ""}
//           ${
//             page.type === "instructions"
//               ? `Set ${page.setName} - Instructions`
//               : ""
//           }
//           ${page.type === "syllabus" ? `Set ${page.setName} - Syllabus` : ""}
//           ${page.type === "questions" ? `Page ${page.pageNumber}` : ""}
//         </div>
//       </div>
//     `;

//       printContent += `</div>`; // Close a4-page
//     });

//     // Create and inject print section
//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);

//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);

//     // Print with a small delay to ensure rendering
//     setTimeout(() => {
//       window.print();
//       // Cleanup after printing
//       setTimeout(() => {
//         if (document.getElementById(printSectionId)) {
//           document.body.removeChild(document.getElementById(printSectionId));
//         }
//       }, 1000);
//     }, 500);
//   };

//   //   const handlePrint = () => {
//   //     const calculateTotalPagesForPrint = (set) => {
//   //       let total = 0;
//   //       let questionPages = 0;

//   //       if (showCoverPage) total++;
//   //       if (quesPaperInfo?.subj_chap_list?.length) total++;

//   //       if (!set) return { total, questionPages };

//   //       set.subjects.forEach((subject) => {
//   //         subject.sections.forEach((section) => {
//   //           if ((section.questions || []).length > 0) {
//   //             const questionsPerPage = 10;
//   //             const pages = Math.ceil(
//   //               section.questions.length / questionsPerPage
//   //             );
//   //             total += pages;
//   //             questionPages += pages;
//   //           }
//   //         });
//   //       });

//   //       return { total, questionPages };
//   //     };

//   //     const renderQuestionTextForPrint = (text) => {
//   //       if (!text) return "";
//   //       const decoded = he.decode(text);
//   //       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//   //       return parts
//   //         .map((segment, idx) => {
//   //           if (segment.startsWith("imgsrc=")) {
//   //             const url = segment.replace("imgsrc=", "");
//   //             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//   //           } else {
//   //             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//   //               try {
//   //                 return katex.renderToString(math, { throwOnError: false });
//   //               } catch (e) {
//   //                 return `<span style="color:red;">Invalid LaTeX</span>`;
//   //               }
//   //             });
//   //           }
//   //         })
//   //         .join("");
//   //     };

//   //     const processedCoverHTML = (setName, totalQuesPages) => {
//   //       if (!quesPaperInfo?.paper_cover) return "";
//   //       const testDate = new Date().toLocaleDateString("en-GB");
//   //       return quesPaperInfo.paper_cover
//   //         .replace(/#total_pages#/gi, totalQuesPages)
//   //         .replace(/#test_date#/gi, testDate)
//   //         .replace(/#set_name#/gi, setName);
//   //     };

//   //     let printContent = `
//   //       <style>
//   //         body, html { margin:0!important; padding:0!important; }
//   //         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//   //         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//   //         .watermark img { width: 300px; height: auto; }
//   //         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//   //         .question-grid__pre-ques { display:flex;}
//   //         .question-column__pre-ques { flex:1; }
//   //         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//   //         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//   //         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//   //         .page-footer span { float:right; }
//   //         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//   //         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//   //         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//   //         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//   //         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//   //         @media print {
//   //           body * { visibility: hidden !important; }
//   //           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//   //           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//   //         }
//   //         @page { size:A4; margin:0; }
//   //       </style>
//   //     `;

//   //     selectedSetNames.forEach((setName) => {
//   //       const currentSet = questionData.find((set) => set.set_name === setName);
//   //       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//   //       let questionPageNum = 1;

//   //       // Cover Page
//   //       if (showCoverPage && quesPaperInfo?.paper_cover) {
//   //         printContent += `
//   //           <div class="a4-page">
//   //             ${
//   //               watermark
//   //                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                 : ""
//   //             }
//   //             <div style="margin:0; padding:0;">
//   //               ${processedCoverHTML(setName, questionPages)}
//   //             </div>
//   //             <div class="page-footer">
//   //               ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //           quesPaperInfo?.footer?.address || ""
//   //         }
//   //               <span>Set ${setName} - Cover Page</span>
//   //             </div>
//   //           </div>`;
//   //       }

//   //       // Instructions Page
//   //       if (showCoverPage && quesPaperInfo?.instructions_html) {
//   //         printContent += `
//   //     <div class="a4-page" style="padding: 20px;">
//   //       ${
//   //         watermark
//   //           ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //           : ""
//   //       }
//   //       <div class="instructions-heading-print" style="font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px;">Instructions</div>

//   //       <hr style="border: none; border-top: 1px solid #ccc; margin-bottom: 16px;" />

//   //       <div style="font-size: 14px; text-align: justify;">
//   //         ${quesPaperInfo.instructions_html}
//   //       </div>

//   //       <div class="page-footer">
//   //         ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //           quesPaperInfo?.footer?.address || ""
//   //         }
//   //         <span>Set ${setName} - Instructions</span>
//   //       </div>
//   //     </div>`;
//   //       }

//   //       // Syllabus Page
//   //       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//   //         printContent += `
//   //           <div class="a4-page" style="padding: 20px;">
//   //             ${
//   //               watermark
//   //                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                 : ""
//   //             }
//   //             <div class="syllabus-heading-print">Test Syllabus</div>
//   //             <table class="syllabus-table-print">
//   //               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//   //               <tbody>
//   //                 ${quesPaperInfo.subj_chap_list
//   //                   .map(
//   //                     (subj) => `
//   //                   <tr>
//   //                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//   //                     <td>${subj.chapters.join(", ")}</td>
//   //                   </tr>`
//   //                   )
//   //                   .join("")}
//   //               </tbody>
//   //             </table>
//   //             <div class="page-footer">
//   //               ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //           quesPaperInfo?.footer?.address || ""
//   //         }
//   //               <span>Set ${setName} - Syllabus</span>
//   //             </div>
//   //           </div>`;
//   //       }

//   //       // Questions per section
//   //       if (currentSet) {
//   //         currentSet.subjects.forEach((subject) => {
//   //           subject.sections.forEach((section) => {
//   //             const allQuestions = [...(section.questions || [])].sort(
//   //               (a, b) => a.set_ques_position - b.set_ques_position
//   //             );
//   //             if (allQuestions.length === 0) return;

//   //             const questionsPerPage = 10;
//   //             const totalPages = Math.ceil(
//   //               allQuestions.length / questionsPerPage
//   //             );
//   //             let questionIndex = 0;

//   //             for (let page = 0; page < totalPages; page++) {
//   //               const pageQuestions = allQuestions.slice(
//   //                 page * questionsPerPage,
//   //                 (page + 1) * questionsPerPage
//   //               );
//   //               const mid = Math.ceil(pageQuestions.length / 2);
//   //               const leftQuestions = pageQuestions.slice(0, mid);
//   //               const rightQuestions = pageQuestions.slice(mid);

//   //               let subjectHtml = `
//   //                 <p class="section-heading__Pre-ques" style="padding-left: 15px;" >Section ${
//   //                   section.section_name
//   //                 }</p>
//   //                 <p><strong style="padding-left: 15px;">Instruction:</strong> ${
//   //                   section.section_instruction?.trim()
//   //                     ? renderQuestionTextForPrint(section.section_instruction)
//   //                     : "N/A"
//   //                 }</p>
//   //                 <div class="page-header__pre-ques">
//   //                   <div>${quesPaperInfo?.header?.date || ""}</div>
//   //                   <div>${subject.subject_name}</div>
//   //                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//   //                 </div>`;

//   //               if (twinColumn) {
//   //                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//   //                 leftQuestions.forEach((ques) => {
//   //                   subjectHtml += `
//   //                     <div class="question-block">
//   //                       <p><strong>${
//   //                         questionIndex + 1
//   //                       }.</strong> ${renderQuestionTextForPrint(
//   //                     ques.ques_text
//   //                   )}</p>
//   //                       <div class="options__pre-ques">
//   //                         ${ques.options
//   //                           .sort(
//   //                             (a, b) =>
//   //                               a.set_option_position - b.set_option_position
//   //                           )
//   //                           .map(
//   //                             (opt, i) =>
//   //                               `<p><span>${getOptionLabel(
//   //                                 i,
//   //                                 quesPaperInfo?.option_naming_pattern
//   //                               )}</span> ${renderQuestionTextForPrint(
//   //                                 opt.option_text
//   //                               )}</p>`
//   //                           )
//   //                           .join("")}
//   //                       </div>
//   //                     </div>`;
//   //                   questionIndex++;
//   //                 });
//   //                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//   //                 rightQuestions.forEach((ques) => {
//   //                   subjectHtml += `
//   //                     <div class="question-block">
//   //                       <p><strong>${
//   //                         questionIndex + 1
//   //                       }.</strong> ${renderQuestionTextForPrint(
//   //                     ques.ques_text
//   //                   )}</p>
//   //                       <div class="options__pre-ques">
//   //                         ${ques.options
//   //                           .sort(
//   //                             (a, b) =>
//   //                               a.set_option_position - b.set_option_position
//   //                           )
//   //                           .map(
//   //                             (opt, i) =>
//   //                               `<p><span>${getOptionLabel(
//   //                                 i,
//   //                                 quesPaperInfo?.option_naming_pattern
//   //                               )}</span> ${renderQuestionTextForPrint(
//   //                                 opt.option_text
//   //                               )}</p>`
//   //                           )
//   //                           .join("")}
//   //                       </div>
//   //                     </div>`;
//   //                   questionIndex++;
//   //                 });
//   //                 subjectHtml += `</div></div>`;
//   //                 if (roughPage) {
//   //                   const isLastPage = page === totalPages - 1;
//   //                   const roughMinHeight = isLastPage ? "100px" : "200px";
//   //                   subjectHtml += `
//   //   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//   //     <strong>Rough Work:</strong>
//   //   </div>
//   // `;
//   //                 }
//   //               } else {
//   //                 pageQuestions.forEach((ques) => {
//   //                   subjectHtml += `
//   //                     <div class="question-block">
//   //                       <p><strong>${
//   //                         questionIndex + 1
//   //                       }.</strong> ${renderQuestionTextForPrint(
//   //                     ques.ques_text
//   //                   )}</p>
//   //                       <div class="options__pre-ques">
//   //                         ${ques.options
//   //                           .sort(
//   //                             (a, b) =>
//   //                               a.set_option_position - b.set_option_position
//   //                           )
//   //                           .map(
//   //                             (opt, i) =>
//   //                               `<p><span>${getOptionLabel(
//   //                                 i,
//   //                                 quesPaperInfo?.option_naming_pattern
//   //                               )}</span> ${renderQuestionTextForPrint(
//   //                                 opt.option_text
//   //                               )}</p>`
//   //                           )
//   //                           .join("")}
//   //                       </div>
//   //                     </div>`;
//   //                   questionIndex++;
//   //                 });

//   //                 if (roughPage) {
//   //                   const isLastPage = page === totalPages - 1;
//   //                   const roughMinHeight = isLastPage ? "100px" : "200px";
//   //                   subjectHtml += `
//   //   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//   //     <strong>Rough Work:</strong>
//   //   </div>
//   // `;
//   //                 }
//   //               }

//   //               printContent += `
//   //                 <div class="a4-page">
//   //                   ${
//   //                     watermark
//   //                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                       : ""
//   //                   }
//   //                   ${subjectHtml}
//   //                   <div class="page-footer">
//   //                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //                 quesPaperInfo?.footer?.address || ""
//   //               }
//   //                     <span>Page ${questionPageNum++}</span>
//   //                   </div>
//   //                 </div>`;
//   //             }
//   //           });
//   //         });
//   //       }
//   //     });

//   //     const printSectionId = "printSectionDynamic";
//   //     let printSection = document.getElementById(printSectionId);
//   //     if (printSection) document.body.removeChild(printSection);
//   //     printSection = document.createElement("div");
//   //     printSection.id = printSectionId;
//   //     printSection.innerHTML = printContent;
//   //     document.body.appendChild(printSection);
//   //     console.log(printContent);
//   //     window.print();

//   //     setTimeout(() => {
//   //       if (printSection) document.body.removeChild(printSection);
//   //     }, 500);
//   //   };

//   // const handleDownloadWord = () => {
//   //   const calculateTotalPagesForPrint = (set) => {
//   //     let total = 0;
//   //     let questionPages = 0;

//   //     if (showCoverPage) total++;
//   //     if (quesPaperInfo?.subj_chap_list?.length) total++;

//   //     if (!set) return { total, questionPages };

//   //     set.subjects.forEach((subject) => {
//   //       subject.sections.forEach((section) => {
//   //         if ((section.questions || []).length > 0) {
//   //           const questionsPerPage = 10;
//   //           const pages = Math.ceil(
//   //             section.questions.length / questionsPerPage
//   //           );
//   //           total += pages;
//   //           questionPages += pages;
//   //         }
//   //       });
//   //     });

//   //     return { total, questionPages };
//   //   };

//   //   const renderQuestionTextForPrint = (text) => {
//   //     if (!text) return "";
//   //     const decoded = he.decode(text);
//   //     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//   //     return parts
//   //       .map((segment, idx) => {
//   //         if (segment.startsWith("imgsrc=")) {
//   //           const url = segment.replace("imgsrc=", "");
//   //           return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//   //         } else {
//   //           return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//   //             try {
//   //               return katex.renderToString(math, { throwOnError: false });
//   //             } catch (e) {
//   //               return `<span style="color:red;">Invalid LaTeX</span>`;
//   //             }
//   //           });
//   //         }
//   //       })
//   //       .join("");
//   //   };

//   //   const processedCoverHTML = (setName, totalQuesPages) => {
//   //     if (!quesPaperInfo?.paper_cover) return "";
//   //     const testDate = new Date().toLocaleDateString("en-GB");
//   //     return quesPaperInfo.paper_cover
//   //       .replace(/#total_pages#/gi, totalQuesPages)
//   //       .replace(/#test_date#/gi, testDate)
//   //       .replace(/#set_name#/gi, setName);
//   //   };

//   //   let printContent = ``;

//   //   selectedSetNames.forEach((setName) => {
//   //     const currentSet = questionData.find((set) => set.set_name === setName);
//   //     const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//   //     let questionPageNum = 1;

//   //     if (showCoverPage && quesPaperInfo?.paper_cover) {
//   //       printContent += `
//   //         <div class="a4-page">
//   //           ${
//   //             watermark
//   //               ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //               : ""
//   //           }
//   //           <div class="page-content">
//   //             ${processedCoverHTML(setName, questionPages)}
//   //           </div>
//   //           <div class="page-footer">
//   //             ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //         quesPaperInfo?.footer?.address || ""
//   //       }
//   //             <span>Set ${setName} - Cover Page</span>
//   //           </div>
//   //         </div>`;
//   //     }

//   //     if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//   //       printContent += `
//   //         <div class="a4-page">
//   //           ${
//   //             watermark
//   //               ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //               : ""
//   //           }
//   //           <div class="page-content">
//   //             <div class="syllabus-heading-print">Test Syllabus</div>
//   //             <table class="syllabus-table-print">
//   //               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//   //               <tbody>
//   //                 ${quesPaperInfo.subj_chap_list
//   //                   .map(
//   //                     (subj) => `
//   //                   <tr>
//   //                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//   //                     <td>${subj.chapters.join(", ")}</td>
//   //                   </tr>`
//   //                   )
//   //                   .join("")}
//   //               </tbody>
//   //             </table>
//   //           </div>
//   //           <div class="page-footer">
//   //             ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //         quesPaperInfo?.footer?.address || ""
//   //       }
//   //             <span>Set ${setName} - Syllabus</span>
//   //           </div>
//   //         </div>`;
//   //     }

//   //     if (currentSet) {
//   //       currentSet.subjects.forEach((subject) => {
//   //         subject.sections.forEach((section) => {
//   //           const allQuestions = [...(section.questions || [])].sort(
//   //             (a, b) => a.set_ques_position - b.set_ques_position
//   //           );
//   //           if (allQuestions.length === 0) return;

//   //           const questionsPerPage = 10;
//   //           const totalPages = Math.ceil(
//   //             allQuestions.length / questionsPerPage
//   //           );
//   //           let questionIndex = 0;

//   //           for (let page = 0; page < totalPages; page++) {
//   //             const pageQuestions = allQuestions.slice(
//   //               page * questionsPerPage,
//   //               (page + 1) * questionsPerPage
//   //             );
//   //             const mid = Math.ceil(pageQuestions.length / 2);
//   //             const leftQuestions = pageQuestions.slice(0, mid);
//   //             const rightQuestions = pageQuestions.slice(mid);

//   //             let subjectHtml = `
//   //               <p class="section-heading__Pre-ques">Section ${
//   //                 section.section_name
//   //               }</p>
//   //               <p><strong>Instruction:</strong> ${
//   //                 section.section_instruction?.trim()
//   //                   ? renderQuestionTextForPrint(section.section_instruction)
//   //                   : "N/A"
//   //               }</p>
//   //               <div class="page-header__pre-ques">
//   //                 <div>${quesPaperInfo?.header?.date || ""}</div>
//   //                 <div>${subject.subject_name}</div>
//   //                 <div>${quesPaperInfo?.header?.test_name || ""}</div>
//   //               </div>`;

//   //             if (twinColumn) {
//   //               subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//   //               leftQuestions.forEach((ques) => {
//   //                 subjectHtml += `
//   //                   <div class="question-block">
//   //                     <p><strong>${
//   //                       questionIndex + 1
//   //                     }.</strong> ${renderQuestionTextForPrint(
//   //                   ques.ques_text
//   //                 )}</p>
//   //                     <div class="options__pre-ques">
//   //                       ${ques.options
//   //                         .sort(
//   //                           (a, b) =>
//   //                             a.set_option_position - b.set_option_position
//   //                         )
//   //                         .map(
//   //                           (opt, i) =>
//   //                             `<p><span>${getOptionLabel(
//   //                               i,
//   //                               quesPaperInfo?.option_naming_pattern
//   //                             )}</span> ${renderQuestionTextForPrint(
//   //                               opt.option_text
//   //                             )}</p>`
//   //                         )
//   //                         .join("")}
//   //                     </div>
//   //                   </div>`;
//   //                 questionIndex++;
//   //               });
//   //               subjectHtml += `</div><div class="question-column__pre-ques">`;
//   //               rightQuestions.forEach((ques) => {
//   //                 subjectHtml += `
//   //                   <div class="question-block">
//   //                     <p><strong>${
//   //                       questionIndex + 1
//   //                     }.</strong> ${renderQuestionTextForPrint(
//   //                   ques.ques_text
//   //                 )}</p>
//   //                     <div class="options__pre-ques">
//   //                       ${ques.options
//   //                         .sort(
//   //                           (a, b) =>
//   //                             a.set_option_position - b.set_option_position
//   //                         )
//   //                         .map(
//   //                           (opt, i) =>
//   //                             `<p><span>${getOptionLabel(
//   //                               i,
//   //                               quesPaperInfo?.option_naming_pattern
//   //                             )}</span> ${renderQuestionTextForPrint(
//   //                               opt.option_text
//   //                             )}</p>`
//   //                         )
//   //                         .join("")}
//   //                     </div>
//   //                   </div>`;
//   //                 questionIndex++;
//   //               });
//   //               subjectHtml += `</div></div>`;
//   //             } else {
//   //               pageQuestions.forEach((ques) => {
//   //                 subjectHtml += `
//   //                   <div class="question-block">
//   //                     <p><strong>${
//   //                       questionIndex + 1
//   //                     }.</strong> ${renderQuestionTextForPrint(
//   //                   ques.ques_text
//   //                 )}</p>
//   //                     <div class="options__pre-ques">
//   //                       ${ques.options
//   //                         .sort(
//   //                           (a, b) =>
//   //                             a.set_option_position - b.set_option_position
//   //                         )
//   //                         .map(
//   //                           (opt, i) =>
//   //                             `<p><span>${getOptionLabel(
//   //                               i,
//   //                               quesPaperInfo?.option_naming_pattern
//   //                             )}</span> ${renderQuestionTextForPrint(
//   //                               opt.option_text
//   //                             )}</p>`
//   //                         )
//   //                         .join("")}
//   //                     </div>
//   //                   </div>`;
//   //                 questionIndex++;
//   //               });
//   //             }

//   //             printContent += `
//   //               <div class="a4-page">
//   //                 ${
//   //                   watermark
//   //                     ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                     : ""
//   //                 }
//   //                 <div class="page-content">${subjectHtml}</div>
//   //                 <div class="page-footer">
//   //                   ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //               quesPaperInfo?.footer?.address || ""
//   //             }
//   //                   <span>Page ${questionPageNum++}</span>
//   //                 </div>
//   //               </div>`;
//   //           }
//   //         });
//   //       });
//   //     }
//   //   });

//   //   const styledHTML = `
//   //     <html>
//   //       <head>
//   //         <meta charset="utf-8">
//   //         <style>
//   //           @page { size: A4; margin: 0; }
//   //           body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//   //           .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//   //           .page-content { max-width: 180mm; margin: auto; }
//   //           .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//   //           .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//   //           .question-block { margin-bottom: 14px; break-inside: avoid; }
//   //           .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//   //           .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//   //           .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//   //           .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//   //           .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//   //           .syllabus-table-print th { background-color: #f0f0f0; }
//   //           .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//   //         </style>
//   //       </head>
//   //       <body>
//   //         ${printContent}
//   //         <footer>
//   //           ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//   //           ${
//   //             quesPaperInfo?.footer?.address ||
//   //             "B â€“ 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//   //           }
//   //         </footer>
//   //       </body>
//   //     </html>
//   //   `;

//   //   const blob = new Blob([styledHTML], {
//   //     type: "application/msword;charset=utf-8",
//   //   });
//   //   const filename = `${
//   //     quesPaperInfo?.ques_paper_name || "question-paper"
//   //   }.doc`;
//   //   const link = document.createElement("a");
//   //   link.href = URL.createObjectURL(blob);
//   //   link.download = filename;
//   //   link.click();
//   // };

//   // const handleDownloadPDF = () => {
//   //   if (!questionData || questionData.length === 0) return;

//   //   const doc = new jsPDF("p", "mm", "a4");

//   //   const generatePDFForSet = (set, callback) => {
//   //     const setName = set.set_name;
//   //     const syllabusRows = quesPaperInfo?.subj_chap_list?.map((item) => [
//   //       item.subject_name,
//   //       item.chapters.join(", "),
//   //     ]);

//   //     doc.html(processedCoverHTML(setName), {
//   //       callback: () => {
//   //         // Syllabus Page
//   //         doc.addPage();
//   //         doc.setFontSize(16);
//   //         doc.text("Test Syllabus", 105, 20, { align: "center" });

//   //         if (syllabusRows?.length) {
//   //           doc.autoTable({
//   //             head: [["Subject", "Chapters"]],
//   //             body: syllabusRows,
//   //             startY: 30,
//   //             styles: { fontSize: 10 },
//   //             headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//   //             theme: "grid",
//   //           });
//   //         }

//   //         // Add question summary next
//   //         doc.addPage();
//   //         doc.setFontSize(16);
//   //         doc.text(`Set ${setName} - Question Paper Summary`, 14, 20);

//   //         set.subjects.forEach((subject) => {
//   //           const sectionRows = [];

//   //           subject.sections.forEach((section) => {
//   //             (section.questions || []).forEach((ques, index) => {
//   //               const questionText = he
//   //                 .decode(ques.ques_text)
//   //                 .replace(/(<([^>]+)>)/gi, "")
//   //                 .slice(0, 100);
//   //               sectionRows.push([
//   //                 section.section_name,
//   //                 `${index + 1}`,
//   //                 questionText,
//   //                 subject.subject_name,
//   //                 ques.ques_id || "",
//   //               ]);
//   //             });
//   //           });

//   //           if (sectionRows.length > 0) {
//   //             doc.autoTable({
//   //               head: [
//   //                 ["Section", "Q No", "Question Text", "Subject", "Ques ID"],
//   //               ],
//   //               body: sectionRows,
//   //               startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 30,
//   //               styles: { fontSize: 8 },
//   //               headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//   //             });
//   //           }

//   //           doc.addPage(); // optional: remove if not needed per subject
//   //         });

//   //         callback();
//   //       },
//   //       x: 10,
//   //       y: 10,
//   //       margin: 10,
//   //       html2canvas: { scale: 0.4 },
//   //     });
//   //   };

//   //   const setsToProcess = questionData.filter((set) =>
//   //     selectedSetNames.includes(set.set_name)
//   //   );
//   //   let index = 0;

//   //   const processNextSet = () => {
//   //     if (index < setsToProcess.length) {
//   //       generatePDFForSet(setsToProcess[index], () => {
//   //         index++;
//   //         processNextSet();
//   //       });
//   //     } else {
//   //       doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);
//   //     }
//   //   };

//   //   processNextSet();
//   // };
//   const PAGE_CONTENT_HEIGHT_PX = 2100;
//   useEffect(() => {
//     const calculateDynamicPages = () => {
//       if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//         setPaginatedPages([]);
//         return;
//       }

//       // A4 page configuration
//       // A4 is 297mm high, minus margins (~40mm) leaves ~257mm usable height
//       // 1mm ≈ 3.78px, so 257mm ≈ 970px
//       // const PAGE_CONTENT_HEIGHT_PX = 960;
//       // const ROUGH_WORK_MIN_HEIGHT_PX = 100;
//       // Updated - uses more of the A4 page (approximately 75-80% of available space)

//       const ROUGH_WORK_MIN_HEIGHT_PX = 50; // Reduced slightly to accommodate more content

//       const newPages = [];
//       const setsToRender = questionData.filter((set) =>
//         selectedSetNames.includes(set.set_name)
//       );

//       // Create hidden measurement container
//       const measureContainer = document.createElement("div");
//       measureContainer.style.position = "absolute";
//       measureContainer.style.visibility = "hidden";
//       measureContainer.style.left = "-9999px";
//       measureContainer.style.width = "calc(210mm - 40mm)"; // A4 width minus margins
//       measureContainer.style.fontFamily = "Calibri, sans-serif";
//       measureContainer.style.fontSize = "14px";
//       measureContainer.style.lineHeight = "1.4";
//       document.body.appendChild(measureContainer);

//       setsToRender.forEach((set) => {
//         let questionPageCounter = 1;

//         // Add Cover Page
//         if (showCoverPage && quesPaperInfo.paper_cover) {
//           newPages.push({
//             type: "cover",
//             key: `cover-${set.set_name}`,
//             setName: set.set_name,
//             totalQuestionPages: "Dynamic",
//           });
//         }

//         // Add Instructions Page
//         if (showCoverPage && quesPaperInfo.instructions_html) {
//           newPages.push({
//             type: "instructions",
//             key: `instructions-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Add Syllabus Page
//         if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//           newPages.push({
//             type: "syllabus",
//             key: `syllabus-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Dynamic Question Pagination
//         set.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             let currentPageQuestions = [];
//             let questionIndexOffset = 0;

//             // Measure section header height
//             const sectionHeaderHTML = `
//             <p style="font-size: 16px; font-weight: 600; margin: 20px 0 4px 0;">Section ${
//               section.section_name
//             }</p>
//             <p style="margin: 0 0 8px 0;">Instruction: ${
//               section.section_instruction?.trim()
//                 ? renderContentToHTML(section.section_instruction)
//                 : "N/A"
//             }</p>
//             <div style="display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc;">
//               <div>${quesPaperInfo?.header?.date || ""}</div>
//               <div>${subject.subject_name}</div>
//               <div>${quesPaperInfo?.header?.test_name || ""}</div>
//             </div>`;

//             measureContainer.innerHTML = sectionHeaderHTML;
//             let currentHeight = measureContainer.offsetHeight;

//             allQuestions.forEach((ques, index) => {
//               // Create HTML for single question to measure
//               const questionHTML = `
//               <div style="margin-bottom: 14px; page-break-inside: avoid;">
//                 <p style="margin: 0 0 4px 0; line-height: 1.4;">
//                   <strong>${
//                     questionIndexOffset + currentPageQuestions.length + 1
//                   }.</strong>
//                   ${renderContentToHTML(ques.ques_text)}
//                 </p>
//                 <div style="margin-left: 16px;">
//                   ${ques.options
//                     .sort(
//                       (a, b) => a.set_option_position - b.set_option_position
//                     )
//                     .map(
//                       (opt, i) => `
//                       <p style="margin: 4px 0; font-size: 14px; line-height: 1.3;">
//                         ${getOptionLabel(
//                           i,
//                           quesPaperInfo?.option_naming_pattern
//                         )} ${renderContentToHTML(opt.option_text)}
//                       </p>
//                     `
//                     )
//                     .join("")}
//                 </div>
//               </div>`;

//               // Measure question height
//               const tempDiv = document.createElement("div");
//               if (twinColumn) {
//                 tempDiv.style.width = "50%";
//               }
//               tempDiv.innerHTML = questionHTML;
//               measureContainer.innerHTML = "";
//               measureContainer.appendChild(tempDiv);

//               const questionHeight = tempDiv.offsetHeight;
//               const isLastQuestion = index === allQuestions.length - 1;
//               const roughWorkHeight =
//                 roughPage && isLastQuestion ? ROUGH_WORK_MIN_HEIGHT_PX : 0;

//               // Check if adding this question exceeds page height
//               if (
//                 currentHeight + questionHeight + roughWorkHeight >
//                   PAGE_CONTENT_HEIGHT_PX &&
//                 currentPageQuestions.length > 0
//               ) {
//                 // Page is full, save current page
//                 newPages.push({
//                   type: "questions",
//                   key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                   setName: set.set_name,
//                   subject,
//                   section,
//                   questions: currentPageQuestions,
//                   questionIndexOffset,
//                   pageNumber: questionPageCounter++,
//                   isLastPageInSection: false,
//                 });

//                 // Start new page
//                 questionIndexOffset += currentPageQuestions.length;
//                 currentPageQuestions = [ques];
//                 measureContainer.innerHTML = sectionHeaderHTML;
//                 currentHeight = measureContainer.offsetHeight + questionHeight;
//               } else {
//                 // Add question to current page
//                 currentPageQuestions.push(ques);
//                 currentHeight += questionHeight;
//               }
//             });

//             // Add final page for section
//             if (currentPageQuestions.length > 0) {
//               newPages.push({
//                 type: "questions",
//                 key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                 setName: set.set_name,
//                 subject,
//                 section,
//                 questions: currentPageQuestions,
//                 questionIndexOffset,
//                 pageNumber: questionPageCounter++,
//                 isLastPageInSection: true,
//               });
//             }
//           });
//         });

//         // Update cover page with actual question page count
//         const totalQPagesForSet = newPages.filter(
//           (p) => p.type === "questions" && p.setName === set.set_name
//         ).length;
//         const coverPageIndex = newPages.findIndex(
//           (p) => p.type === "cover" && p.setName === set.set_name
//         );
//         if (coverPageIndex > -1) {
//           newPages[coverPageIndex].totalQuestionPages = totalQPagesForSet;
//         }
//       });

//       // Cleanup
//       document.body.removeChild(measureContainer);
//       setPaginatedPages(newPages);
//     };

//     const timeoutId = setTimeout(calculateDynamicPages, 100);
//     return () => clearTimeout(timeoutId);
//   }, [
//     questionData,
//     quesPaperInfo,
//     selectedSetNames,
//     showCoverPage,
//     twinColumn,
//     roughPage,
//     watermark,
//   ]);

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <button
//                   className="icon-btn__pre-ques"
//                   style={{ marginRight: "70px" }}
//                   onClick={handlePrint}
//                 >
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {paginatedPages.length > 0 ? (
//                 paginatedPages.map((page) => (
//                   <div
//                     className={`a4-page${
//                       roughPage && page.type === "questions"
//                         ? " has-roughwork"
//                         : ""
//                     }`}
//                     key={page.key}
//                   >
//                     {watermark && (
//                       <img
//                         src={watermarkImg}
//                         alt="watermark"
//                         className="watermark-image"
//                       />
//                     )}

//                     {/* Page Content */}
//                     {page.type === "cover" && (
//                       <div
//                         dangerouslySetInnerHTML={{
//                           __html: quesPaperInfo.paper_cover
//                             .replace(/#total_pages#/gi, page.totalQuestionPages)
//                             .replace(
//                               /#test_date#/gi,
//                               new Date().toLocaleDateString("en-GB")
//                             )
//                             .replace(/#set_name#/gi, page.setName),
//                         }}
//                       />
//                     )}

//                     {page.type === "instructions" && (
//                       <div className="instructions-page">
//                         <div className="instructions-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Instructions</h2>
//                           <hr
//                             style={{
//                               border: "none",
//                               borderTop: `1px solid ${Colors.color4}`,
//                               margin: "1rem 0",
//                             }}
//                           />
//                         </div>
//                         <div
//                           dangerouslySetInnerHTML={{
//                             __html: quesPaperInfo.instructions_html,
//                           }}
//                         />
//                       </div>
//                     )}

//                     {page.type === "syllabus" && (
//                       <div className="syllabus-page">
//                         <div className="syllabus-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Test Syllabus</h2>
//                         </div>
//                         <table className="syllabus-table_prev_ques">
//                           <thead>
//                             <tr>
//                               <th>Subject</th>
//                               <th>Chapters</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                               <tr key={idx}>
//                                 <td>
//                                   <strong>
//                                     {subj.subject_name.toUpperCase()}
//                                   </strong>
//                                 </td>
//                                 <td>{subj.chapters.join(", ")}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}

//                     {page.type === "questions" && (
//                       <div
//                         className="section-container__pre-ques"
//                         style={{ position: "relative", minHeight: "530px" }}
//                       >
//                         <p className="section-heading__Pre-ques">
//                           Section {page.section.section_name}
//                         </p>
//                         <p>
//                           Instruction:{" "}
//                           {page.section.section_instruction?.trim()
//                             ? renderQuestionText(
//                                 page.section.section_instruction
//                               )
//                             : "N/A"}
//                         </p>
//                         <div className="page-header__pre-ques">
//                           <div className="header-left__pre-ques">
//                             {quesPaperInfo?.header?.date}
//                           </div>
//                           <div className="header-center__pre-ques">
//                             {page.subject.subject_name}
//                           </div>
//                           <div className="header-right__pre-ques">
//                             {quesPaperInfo?.header?.test_name}
//                           </div>
//                         </div>

//                         {(() => {
//                           const questions = page.questions;
//                           const mid = Math.ceil(questions.length / 2);
//                           const leftQuestions = questions.slice(0, mid);
//                           const rightQuestions = questions.slice(mid);

//                           return twinColumn ? (
//                             <div className="question-grid__pre-ques">
//                               <div className="question-column__pre-ques">
//                                 {leftQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset + index + 1}.
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                               <div className="question-column__pre-ques">
//                                 {rightQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset +
//                                           mid +
//                                           index +
//                                           1}
//                                         .
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                             </div>
//                           ) : (
//                             <div>
//                               {questions.map((ques, index) => (
//                                 <div
//                                   key={ques.ques_id}
//                                   className="question-block"
//                                 >
//                                   <p>
//                                     <strong>
//                                       {page.questionIndexOffset + index + 1}.
//                                     </strong>{" "}
//                                     {renderQuestionText(ques.ques_text)}
//                                   </p>
//                                   <div className="options__pre-ques">
//                                     {[...ques.options]
//                                       .sort(
//                                         (a, b) =>
//                                           a.set_option_position -
//                                           b.set_option_position
//                                       )
//                                       .map((opt, idx) => (
//                                         <p key={opt.option_id}>
//                                           <span>
//                                             {getOptionLabel(
//                                               idx,
//                                               quesPaperInfo?.option_naming_pattern
//                                             )}
//                                           </span>{" "}
//                                           {renderQuestionText(opt.option_text)}
//                                         </p>
//                                       ))}
//                                   </div>
//                                 </div>
//                               ))}
//                             </div>
//                           );
//                         })()}

//                         {roughPage && (
//                           <div
//                             className="rough-work-section"
//                             style={{
//                               minHeight: page.isLastPageInSection
//                                 ? "100px"
//                                 : "200px",
//                             }}
//                           >
//                             <strong>Rough Work:</strong>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Page Footer */}
//                     <div className="page-footer">
//                       <div className="footer-left">
//                         {quesPaperInfo?.footer?.client_name} |{" "}
//                         {quesPaperInfo?.footer?.address}
//                       </div>
//                       <div className="footer-right">
//                         {page.type === "cover" &&
//                           `Set ${page.setName} - Cover Page`}
//                         {page.type === "syllabus" &&
//                           `Set ${page.setName} - Syllabus`}
//                         {page.type === "questions" && `Page ${page.pageNumber}`}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";
// import Colors from "../../../Constants/Colors";
// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const [paginatedPages, setPaginatedPages] = useState([]);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Add this helper function to render content to HTML for measurement
//   const renderContentToHTML = (text) => {
//     if (!text) return "";
//     const decoded = he.decode(text);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts
//       .map((segment) => {
//         if (segment.startsWith("imgsrc=")) {
//           const url = segment.replace("imgsrc=", "");
//           return `<img src="${url}" alt="image" style="max-width: 80px; height: auto; vertical-align: middle; margin: 0 5px;" />`;
//         } else {
//           return segment.replace(/\\\((.*?)\\\)/g, (_, math) => {
//             try {
//               return katex.renderToString(math, {
//                 throwOnError: false,
//                 displayMode: false,
//               });
//             } catch (e) {
//               console.warn("Katex rendering error:", e);
//               return `<span style="color:red;">[LaTeX Error]</span>`;
//             }
//           });
//         }
//       })
//       .join("");
//   };

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     if (!paginatedPages || paginatedPages.length === 0) {
//       alert("There is no content to print.");
//       return;
//     }

//     // Helper to process cover page HTML
//     const getProcessedCoverHTML = (page) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, page.totalQuestionPages)
//         .replace(/#test_date#/gi, new Date().toLocaleDateString("en-GB"))
//         .replace(/#set_name#/gi, page.setName);
//     };

//     let printContent = `
//     <style>
//       body, html { margin: 0 !important; padding: 0 !important; background-color: #fff; font-family: Calibri, sans-serif; }
//       .a4-page { width: 210mm; min-height: 297mm; margin: 0 auto; padding: 8mm; box-sizing: border-box; background: white; position: relative; page-break-after: always; }
      
//       .page-content-wrapper { 
//         height: calc(297mm - 15mm); 
//         position: relative; 
//         padding-bottom: 15mm; /* Reduced from 25mm */
//         overflow: hidden;
//       }
//         .question-block img,
//   .question-grid__pre-ques img,
//   .question-column__pre-ques img,
//   .options__pre-ques img {
//     width: 30px !important;
//     height: auto !important;
//     margin: 5px !important;
//     vertical-align: middle !important;
//   }

//       .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//       .watermark img { width: 300px; height: auto; }
//       .section-heading__Pre-ques { font-size: 16px; font-weight: 600; margin: 0px 0 2px 0; padding-left: 15px; } /* Reduced margin */
//       .question-grid__pre-ques { display: flex; gap: 15px; } /* Reduced gap */
//       .question-column__pre-ques { flex: 1; min-width: 0; }
//       .question-block { margin-bottom: 6px; page-break-inside: avoid; } /* Reduced margin */
//       .question-block p { margin: 0 0 2px 0; line-height: 1.2; } /* Reduced line-height and margin */
//       .options__pre-ques p { margin: 2px 0 0px 16px; font-size: 14px; line-height: 1.1; } /* Reduced margins and line-height */
//       .page-footer { 
//         position: absolute; 
//         bottom: 5mm; 
//         left: 8mm; 
//         right: 8mm; 
//         height: 12mm; /* Reduced height */
//         text-align: center; 
//         font-size: 11px; 
//         border-top: 1px solid #ccc; 
//         padding-top: 3px; /* Reduced padding */
//         color: #444; 
//         display: flex; 
//         justify-content: space-between;
//         background: white;
//         z-index: 10;
//       }
//       .page-header__pre-ques { display: flex; justify-content: space-between; font-size: 13px; padding: 3px 12px; margin-bottom: 4px; border-bottom: 1px solid #ccc; } /* Reduced padding and margin */
//       .rough-work-section { margin-top: 10px !important; 
//       border-top: 1px dashed #ccc !important; 
//       padding-top: 5px !important; 
//       min-height: 40px !important;
//       page-break-inside: avoid !important;
//       break-inside: avoid !important;
//       page-break-before: avoid !important;} /* Reduced spacing */
//       .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 3px; padding-bottom: 5px; } /* Reduced margins */
//       .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//       .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 6px; text-align: left; vertical-align: top; } /* Reduced padding */
//       .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//       .instructions-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 3px; padding-bottom: 5px; } /* Reduced margins */
//       .instructions-content { margin-top: 3px; } /* Reduced margin */
//       @media print {
//         body * { visibility: hidden !important; }
//         #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//         #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         .rough-work-section {
//         page-break-inside: avoid !important;
//         break-inside: avoid !important;
//         orphans: 3;
//         widows: 3;
//       }
//       }
//       @page { size: A4; margin: 0; }
//     </style>
//   `;

//     // Iterate through the already calculated paginatedPages
//     paginatedPages.forEach((page) => {
//       printContent += `<div class="a4-page">`;

//       // Add watermark if enabled
//       if (watermark) {
//         printContent += `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`;
//       }

//       printContent += `<div class="page-content-wrapper">`;

//       // Generate content based on page type
//       switch (page.type) {
//         case "cover":
//           printContent += `
//     <div class="cover-page-optimal" style="
//       transform: scale(0.9) !important; /* Balanced shrinking - 15% shrink */
//       transform-origin: top center !important;
//       width: 205mm !important; /* Precise compensation (100/0.85) */
//       height: 297mm !important; /* Use mm consistently - A4 height minus footer/margins */
//       font-size: 11.5px !important; /* Good readability */
//       line-height: 1.15 !important; /* Optimal line spacing */
//       margin: 0 !important;
//       padding: 0px !important; /* Efficient padding in mm */
//       max-height: 297mm !important; /* Safe maximum in mm */
//       overflow: hidden !important;
//       box-sizing: border-box !important;
//       position: absolute !important;
//       top: 0 !important;
//       left: 0 !important;
//       background: white !important;
//     ">
//       ${getProcessedCoverHTML(page)}
//     </div>`;
//           break;

//         case "instructions":
//           printContent += `
//           <div class="instructions-heading-print">Instructions</div>
//           <hr style="border: none; border-top: 1px solid #ccc; margin: 5px 0;" />
//           <div class="instructions-content" style="font-size: 14px; text-align: justify;">${quesPaperInfo.instructions_html}</div>`;
//           break;

//         case "syllabus":
//           printContent += `
//           <div class="syllabus-heading-print">Test Syllabus</div>
//           <table class="syllabus-table-print">
//             <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//             <tbody>
//               ${quesPaperInfo.subj_chap_list
//                 .map(
//                   (s) => `
//                 <tr>
//                   <td><strong>${s.subject_name.toUpperCase()}</strong></td>
//                   <td>${s.chapters.join(", ")}</td>
//                 </tr>
//               `
//                 )
//                 .join("")}
//             </tbody>
//           </table>`;
//           break;

//         case "questions":
//           let questionsHtml = `
//           <p class="section-heading__Pre-ques">Section ${
//             page.section.section_name
//           }</p>
//           <p style="padding-left: 15px; margin: 0 0 4px 0;"><strong>Instruction:</strong> ${
//             page.section.section_instruction?.trim()
//               ? renderContentToHTML(page.section.section_instruction)
//               : "N/A"
//           }</p>
//           <div class="page-header__pre-ques">
//             <div>${quesPaperInfo?.header?.date || ""}</div>
//             <div>${page.subject.subject_name}</div>
//             <div>${quesPaperInfo?.header?.test_name || ""}</div>
//           </div>`;

//           const renderQuestionColumn = (qs, offset) =>
//             qs
//               .map(
//                 (q, i) => `
//           <div class="question-block">
//             <p><strong>${offset + i + 1}.</strong> ${renderContentToHTML(
//                   q.ques_text
//                 )}</p>
//             <div class="options__pre-ques">
//               ${q.options
//                 .sort((a, b) => a.set_option_position - b.set_option_position)
//                 .map(
//                   (opt, oi) => `
//                 <p><span>${getOptionLabel(
//                   oi,
//                   quesPaperInfo?.option_naming_pattern
//                 )}</span> ${renderContentToHTML(opt.option_text)}</p>
//               `
//                 )
//                 .join("")}
//             </div>
//           </div>`
//               )
//               .join("");

//           if (twinColumn) {
//             const mid = Math.ceil(page.questions.length / 2);
//             questionsHtml += `
//             <div class="question-grid__pre-ques">
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(0, mid),
//                 page.questionIndexOffset
//               )}</div>
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(mid),
//                 page.questionIndexOffset + mid
//               )}</div>
//             </div>`;
//           } else {
//             questionsHtml += `<div>${renderQuestionColumn(
//               page.questions,
//               page.questionIndexOffset
//             )}</div>`;
//           }

//           // Add rough work section if enabled and this is the last page of the section
//           if (roughPage) {
//             const roughWorkHeight = page.isLastPageInSection ? "60px" : "120px";
//             questionsHtml += `
//             <div class="rough-work-section" style="min-height: ${roughWorkHeight};">
//             <strong>Rough Work:</strong>
//             </div>`;
//           }

//           printContent += questionsHtml;
//           break;

//         default:
//           break;
//       }

//       printContent += `</div>`; // Close page-content-wrapper

//       // Add footer for all page types
//       printContent += `
//       <div class="page-footer">
//         <div>${quesPaperInfo?.footer?.client_name || ""} | ${
//         quesPaperInfo?.footer?.address || ""
//       }</div>
//         <div>
//           ${page.type === "cover" ? `Set ${page.setName} - Cover Page` : ""}
//           ${
//             page.type === "instructions"
//               ? `Set ${page.setName} - Instructions`
//               : ""
//           }
//           ${page.type === "syllabus" ? `Set ${page.setName} - Syllabus` : ""}
//           ${page.type === "questions" ? `Page ${page.pageNumber}` : ""}
//         </div>
//       </div>
//     `;

//       printContent += `</div>`; // Close a4-page
//     });

//     // Create and inject print section
//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);

//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);

//     // Print with a small delay to ensure rendering
//     setTimeout(() => {
//       window.print();
//       // Cleanup after printing
//       setTimeout(() => {
//         if (document.getElementById(printSectionId)) {
//           document.body.removeChild(document.getElementById(printSectionId));
//         }
//       }, 1000);
//     }, 500);
//   };

//   useEffect(() => {
//     const calculateDynamicPages = () => {
//       if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//         setPaginatedPages([]);
//         return;
//       }

//       // Adjust page content height based on layout mode
//       const BASE_PAGE_CONTENT_HEIGHT_PX = 2110;
//       const PAGE_CONTENT_HEIGHT_PX = twinColumn
//         ? BASE_PAGE_CONTENT_HEIGHT_PX
//         : BASE_PAGE_CONTENT_HEIGHT_PX * 0.55; // Reduce available height for single column to maintain consistency

//       const ROUGH_WORK_MIN_HEIGHT_PX = 40;

//       const newPages = [];
//       const setsToRender = questionData.filter((set) =>
//         selectedSetNames.includes(set.set_name)
//       );

//       // Create hidden measurement container
//       const measureContainer = document.createElement("div");
//       measureContainer.style.position = "absolute";
//       measureContainer.style.visibility = "hidden";
//       measureContainer.style.left = "-9999px";
//       measureContainer.style.width = "calc(210mm - 40mm)";
//       measureContainer.style.fontFamily = "Calibri, sans-serif";
//       measureContainer.style.fontSize = "14px";
//       measureContainer.style.lineHeight = "1.4";
//       document.body.appendChild(measureContainer);

//       setsToRender.forEach((set) => {
//         let questionPageCounter = 1;
//         let globalQuestionCounter = 0;

//         // Add Cover Page
//         if (showCoverPage && quesPaperInfo.paper_cover) {
//           newPages.push({
//             type: "cover",
//             key: `cover-${set.set_name}`,
//             setName: set.set_name,
//             totalQuestionPages: "Dynamic",
//           });
//         }

//         // Add Instructions Page
//         if (showCoverPage && quesPaperInfo.instructions_html) {
//           newPages.push({
//             type: "instructions",
//             key: `instructions-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Add Syllabus Page
//         if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//           newPages.push({
//             type: "syllabus",
//             key: `syllabus-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Dynamic Question Pagination
//         set.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             let currentPageQuestions = [];
//             let currentPageStartIndex = globalQuestionCounter;

//             // Measure section header height
//             const sectionHeaderHTML = `
//             <p style="font-size: 16px; font-weight: 600; margin: 20px 0 4px 0;">Section ${
//               section.section_name
//             }</p>
//             <p style="margin: 0 0 8px 0;">Instruction: ${
//               section.section_instruction?.trim()
//                 ? renderContentToHTML(section.section_instruction)
//                 : "N/A"
//             }</p>
//             <div style="display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc;">
//               <div>${quesPaperInfo?.header?.date || ""}</div>
//               <div>${subject.subject_name}</div>
//               <div>${quesPaperInfo?.header?.test_name || ""}</div>
//             </div>`;

//             measureContainer.innerHTML = sectionHeaderHTML;
//             let currentHeight = measureContainer.offsetHeight;

//             allQuestions.forEach((ques, index) => {
//               // Create HTML for single question to measure
//               const questionHTML = `
//               <div style="margin-bottom: 8px; page-break-inside: avoid;">
//                 <p style="margin: 0 0 3px 0; line-height: 1.3;">
//                   <strong>${
//                     globalQuestionCounter + currentPageQuestions.length + 1
//                   }.</strong> 
//                   ${renderContentToHTML(ques.ques_text)}
//                 </p>
//                 <div style="margin-left: 16px;">
//                   ${ques.options
//                     .sort(
//                       (a, b) => a.set_option_position - b.set_option_position
//                     )
//                     .map(
//                       (opt, i) => `
//                         <p style="margin: 3px 0; font-size: 14px; line-height: 1.2;">
//                           ${getOptionLabel(
//                             i,
//                             quesPaperInfo?.option_naming_pattern
//                           )} ${renderContentToHTML(opt.option_text)}
//                         </p>
//                       `
//                     )
//                     .join("")}
//                 </div>
//               </div>`;

//               // Measure question height consistently
//               const tempDiv = document.createElement("div");
//               // Always measure at consistent width for fair comparison
//               tempDiv.style.width = twinColumn ? "50%" : "100%";
//               tempDiv.innerHTML = questionHTML;
//               measureContainer.innerHTML = "";
//               measureContainer.appendChild(tempDiv);

//               let questionHeight = tempDiv.offsetHeight;

//               // Apply layout-specific height adjustment
//               if (twinColumn) {
//                 // In twin column, questions are side by side, so we can fit more vertically
//                 questionHeight = questionHeight;
//               } else {
//                 // In single column, questions take full width and stack vertically
//                 // Apply a multiplier to account for the visual difference
//                 questionHeight = questionHeight * 1.0; // Keep actual measured height
//               }

//               const isLastQuestion = index === allQuestions.length - 1;
//               const roughWorkHeight = roughPage
//                 ? isLastQuestion
//                   ? 60
//                   : 120
//                 : 0;

//               // Check if adding this question exceeds page height
//               const availableHeight = PAGE_CONTENT_HEIGHT_PX - 50;
//               const totalHeightNeeded =
//                 currentHeight + questionHeight + roughWorkHeight;

//               if (
//                 totalHeightNeeded > availableHeight &&
//                 currentPageQuestions.length > 0
//               ) {
//                 // Page is full, save current page
//                 newPages.push({
//                   type: "questions",
//                   key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                   setName: set.set_name,
//                   subject,
//                   section,
//                   questions: currentPageQuestions,
//                   questionIndexOffset: currentPageStartIndex,
//                   pageNumber: questionPageCounter++,
//                   isLastPageInSection: false,
//                 });

//                 // Update global counter and start new page
//                 globalQuestionCounter += currentPageQuestions.length;
//                 currentPageStartIndex = globalQuestionCounter;
//                 currentPageQuestions = [ques];
//                 measureContainer.innerHTML = sectionHeaderHTML;
//                 currentHeight = measureContainer.offsetHeight + questionHeight;
//               } else {
//                 // Add question to current page
//                 currentPageQuestions.push(ques);
//                 currentHeight += questionHeight;
//               }
//             });

//             // Add final page for section
//             if (currentPageQuestions.length > 0) {
//               newPages.push({
//                 type: "questions",
//                 key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                 setName: set.set_name,
//                 subject,
//                 section,
//                 questions: currentPageQuestions,
//                 questionIndexOffset: currentPageStartIndex,
//                 pageNumber: questionPageCounter++,
//                 isLastPageInSection: true,
//               });

//               globalQuestionCounter += currentPageQuestions.length;
//             }
//           });
//         });

//         // Update cover page with actual question page count
//         const totalQPagesForSet = newPages.filter(
//           (p) => p.type === "questions" && p.setName === set.set_name
//         ).length;
//         const coverPageIndex = newPages.findIndex(
//           (p) => p.type === "cover" && p.setName === set.set_name
//         );
//         if (coverPageIndex > -1) {
//           newPages[coverPageIndex].totalQuestionPages = totalQPagesForSet;
//         }
//       });

//       // Cleanup
//       document.body.removeChild(measureContainer);
//       setPaginatedPages(newPages);
//     };

//     const timeoutId = setTimeout(calculateDynamicPages, 100);
//     return () => clearTimeout(timeoutId);
//   }, [
//     questionData,
//     quesPaperInfo,
//     selectedSetNames,
//     showCoverPage,
//     twinColumn,
//     roughPage,
//     watermark,
//   ]);

//   // useEffect(() => {
//   //   const calculateDynamicPages = () => {
//   //     if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//   //       setPaginatedPages([]);
//   //       return;
//   //     }

//   //     // A4 page configuration
//   //     // A4 is 297mm high, minus margins (~40mm) leaves ~257mm usable height
//   //     // 1mm ≈ 3.78px, so 257mm ≈ 970px
//   //     // const PAGE_CONTENT_HEIGHT_PX = 960;
//   //     // const ROUGH_WORK_MIN_HEIGHT_PX = 100;
//   //     // Updated - uses more of the A4 page (approximately 75-80% of available space)
//   //     const PAGE_CONTENT_HEIGHT_PX = 2110;
//   //     const ROUGH_WORK_MIN_HEIGHT_PX = 40; // Reduced slightly to accommodate more content

//   //     const newPages = [];
//   //     const setsToRender = questionData.filter((set) =>
//   //       selectedSetNames.includes(set.set_name)
//   //     );

//   //     // Create hidden measurement container
//   //     const measureContainer = document.createElement("div");
//   //     measureContainer.style.position = "absolute";
//   //     measureContainer.style.visibility = "hidden";
//   //     measureContainer.style.left = "-9999px";
//   //     measureContainer.style.width = "calc(210mm - 40mm)"; // A4 width minus margins
//   //     measureContainer.style.fontFamily = "Calibri, sans-serif";
//   //     measureContainer.style.fontSize = "14px";
//   //     measureContainer.style.lineHeight = "1.4";
//   //     document.body.appendChild(measureContainer);

//   //     setsToRender.forEach((set) => {
//   //       let questionPageCounter = 1;

//   //       // Add Cover Page
//   //       if (showCoverPage && quesPaperInfo.paper_cover) {
//   //         newPages.push({
//   //           type: "cover",
//   //           key: `cover-${set.set_name}`,
//   //           setName: set.set_name,
//   //           totalQuestionPages: "Dynamic",
//   //         });
//   //       }

//   //       // Add Instructions Page
//   //       if (showCoverPage && quesPaperInfo.instructions_html) {
//   //         newPages.push({
//   //           type: "instructions",
//   //           key: `instructions-${set.set_name}`,
//   //           setName: set.set_name,
//   //         });
//   //       }

//   //       // Add Syllabus Page
//   //       if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//   //         newPages.push({
//   //           type: "syllabus",
//   //           key: `syllabus-${set.set_name}`,
//   //           setName: set.set_name,
//   //         });
//   //       }

//   //       // Dynamic Question Pagination
//   //       set.subjects.forEach((subject) => {
//   //         subject.sections.forEach((section) => {
//   //           const allQuestions = [...(section.questions || [])].sort(
//   //             (a, b) => a.set_ques_position - b.set_ques_position
//   //           );
//   //           if (allQuestions.length === 0) return;

//   //           let currentPageQuestions = [];
//   //           let questionIndexOffset = 0;

//   //           // Measure section header height
//   //           const sectionHeaderHTML = `
//   //           <p style="font-size: 16px; font-weight: 600; margin: 20px 0 4px 0;">Section ${
//   //             section.section_name
//   //           }</p>
//   //           <p style="margin: 0 0 8px 0;">Instruction: ${
//   //             section.section_instruction?.trim()
//   //               ? renderContentToHTML(section.section_instruction)
//   //               : "N/A"
//   //           }</p>
//   //           <div style="display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc;">
//   //             <div>${quesPaperInfo?.header?.date || ""}</div>
//   //             <div>${subject.subject_name}</div>
//   //             <div>${quesPaperInfo?.header?.test_name || ""}</div>
//   //           </div>`;

//   //           measureContainer.innerHTML = sectionHeaderHTML;
//   //           let currentHeight = measureContainer.offsetHeight;

//   //           allQuestions.forEach((ques, index) => {
//   //             // Create HTML for single question to measure
//   //             // In the questionHTML template, replace the question block div:
//   //             const questionHTML = `
//   // <div style="margin-bottom: 8px; page-break-inside: avoid;"> <!-- Reduced from 14px -->
//   //   <p style="margin: 0 0 3px 0; line-height: 1.3;"> <!-- Reduced margin and line-height -->
//   //     <strong>${
//   //       questionIndexOffset + currentPageQuestions.length + 1
//   //     }.</strong>
//   //     ${renderContentToHTML(ques.ques_text)}
//   //   </p>
//   //   <div style="margin-left: 16px;">
//   //     ${ques.options
//   //       .sort((a, b) => a.set_option_position - b.set_option_position)
//   //       .map(
//   //         (opt, i) => `
//   //           <p style="margin: 3px 0; font-size: 14px; line-height: 1.2;"> <!-- Reduced margin and line-height -->
//   //             ${getOptionLabel(
//   //               i,
//   //               quesPaperInfo?.option_naming_pattern
//   //             )} ${renderContentToHTML(opt.option_text)}
//   //           </p>
//   //         `
//   //       )
//   //       .join("")}
//   //   </div>
//   // </div>`;

//   //             // Measure question height
//   //             const tempDiv = document.createElement("div");
//   //             if (twinColumn) {
//   //               tempDiv.style.width = "50%";
//   //             }
//   //             tempDiv.innerHTML = questionHTML;
//   //             measureContainer.innerHTML = "";
//   //             measureContainer.appendChild(tempDiv);

//   //             const questionHeight = tempDiv.offsetHeight;
//   //             const isLastQuestion = index === allQuestions.length - 1;
//   //             const roughWorkHeight = roughPage
//   //               ? isLastQuestion
//   //                 ? 60
//   //                 : 120
//   //               : 0; // Match preview heights exactly

//   //             // Check if adding this question exceeds page height
//   //             const availableHeight = PAGE_CONTENT_HEIGHT_PX - 50; // Even smaller buffer
//   //             const totalHeightNeeded =
//   //               currentHeight + questionHeight + roughWorkHeight;

//   //             if (
//   //               totalHeightNeeded > availableHeight &&
//   //               currentPageQuestions.length > 0
//   //             ) {
//   //               // Page is full, save current page
//   //               newPages.push({
//   //                 type: "questions",
//   //                 key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//   //                 setName: set.set_name,
//   //                 subject,
//   //                 section,
//   //                 questions: currentPageQuestions,
//   //                 questionIndexOffset,
//   //                 pageNumber: questionPageCounter++,
//   //                 isLastPageInSection: false,
//   //               });

//   //               // Start new page
//   //               questionIndexOffset += currentPageQuestions.length;
//   //               currentPageQuestions = [ques];
//   //               measureContainer.innerHTML = sectionHeaderHTML;
//   //               currentHeight = measureContainer.offsetHeight + questionHeight;
//   //             } else {
//   //               // Add question to current page
//   //               currentPageQuestions.push(ques);
//   //               currentHeight += questionHeight;
//   //             }
//   //           });

//   //           // Add final page for section
//   //           if (currentPageQuestions.length > 0) {
//   //             newPages.push({
//   //               type: "questions",
//   //               key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//   //               setName: set.set_name,
//   //               subject,
//   //               section,
//   //               questions: currentPageQuestions,
//   //               questionIndexOffset,
//   //               pageNumber: questionPageCounter++,
//   //               isLastPageInSection: true,
//   //             });
//   //           }
//   //         });
//   //       });

//   //       // Update cover page with actual question page count
//   //       const totalQPagesForSet = newPages.filter(
//   //         (p) => p.type === "questions" && p.setName === set.set_name
//   //       ).length;
//   //       const coverPageIndex = newPages.findIndex(
//   //         (p) => p.type === "cover" && p.setName === set.set_name
//   //       );
//   //       if (coverPageIndex > -1) {
//   //         newPages[coverPageIndex].totalQuestionPages = totalQPagesForSet;
//   //       }
//   //     });

//   //     // Cleanup
//   //     document.body.removeChild(measureContainer);
//   //     setPaginatedPages(newPages);
//   //   };

//   //   const timeoutId = setTimeout(calculateDynamicPages, 100);
//   //   return () => clearTimeout(timeoutId);
//   // }, [
//   //   questionData,
//   //   quesPaperInfo,
//   //   selectedSetNames,
//   //   showCoverPage,
//   //   twinColumn,
//   //   roughPage,
//   //   watermark,
//   // ]);

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <button
//                   className="icon-btn__pre-ques"
//                   style={{ marginRight: "70px" }}
//                   onClick={handlePrint}
//                 >
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {paginatedPages.length > 0 ? (
//                 paginatedPages.map((page) => (
//                   <div
//                     className={`a4-page${
//                       roughPage && page.type === "questions"
//                         ? " has-roughwork"
//                         : ""
//                     }`}
//                     key={page.key}
//                   >
//                     {watermark && (
//                       <img
//                         src={watermarkImg}
//                         alt="watermark"
//                         className="watermark-image"
//                       />
//                     )}

//                     {/* Page Content */}
//                     {page.type === "cover" && (
//                       <div
//                         dangerouslySetInnerHTML={{
//                           __html: quesPaperInfo.paper_cover
//                             .replace(/#total_pages#/gi, page.totalQuestionPages)
//                             .replace(
//                               /#test_date#/gi,
//                               new Date().toLocaleDateString("en-GB")
//                             )
//                             .replace(/#set_name#/gi, page.setName),
//                         }}
//                       />
//                     )}

//                     {page.type === "instructions" && (
//                       <div className="instructions-page">
//                         <div className="instructions-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Instructions</h2>
//                           <hr
//                             style={{
//                               border: "none",
//                               borderTop: `1px solid ${Colors.color4}`,
//                               margin: "1rem 0",
//                             }}
//                           />
//                         </div>
//                         <div
//                           dangerouslySetInnerHTML={{
//                             __html: quesPaperInfo.instructions_html,
//                           }}
//                         />
//                       </div>
//                     )}

//                     {page.type === "syllabus" && (
//                       <div className="syllabus-page">
//                         <div className="syllabus-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Test Syllabus</h2>
//                         </div>
//                         <table className="syllabus-table_prev_ques">
//                           <thead>
//                             <tr>
//                               <th>Subject</th>
//                               <th>Chapters</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                               <tr key={idx}>
//                                 <td>
//                                   <strong>
//                                     {subj.subject_name.toUpperCase()}
//                                   </strong>
//                                 </td>
//                                 <td>{subj.chapters.join(", ")}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}

//                     {page.type === "questions" && (
//                       <div
//                         className="section-container__pre-ques"
//                         style={{ position: "relative", minHeight: "530px" }}
//                       >
//                         <p className="section-heading__Pre-ques">
//                           Section {page.section.section_name}
//                         </p>
//                         <p>
//                           Instruction:{" "}
//                           {page.section.section_instruction?.trim()
//                             ? renderQuestionText(
//                                 page.section.section_instruction
//                               )
//                             : "N/A"}
//                         </p>
//                         <div className="page-header__pre-ques">
//                           <div className="header-left__pre-ques">
//                             {quesPaperInfo?.header?.date}
//                           </div>
//                           <div className="header-center__pre-ques">
//                             {page.subject.subject_name}
//                           </div>
//                           <div className="header-right__pre-ques">
//                             {quesPaperInfo?.header?.test_name}
//                           </div>
//                         </div>

//                         {(() => {
//                           const questions = page.questions;
//                           const mid = Math.ceil(questions.length / 2);
//                           const leftQuestions = questions.slice(0, mid);
//                           const rightQuestions = questions.slice(mid);

//                           return twinColumn ? (
//                             <div className="question-grid__pre-ques">
//                               <div className="question-column__pre-ques">
//                                 {leftQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset + index + 1}.
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                               <div className="question-column__pre-ques">
//                                 {rightQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset +
//                                           mid +
//                                           index +
//                                           1}
//                                         .
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                             </div>
//                           ) : (
//                             <div>
//                               {questions.map((ques, index) => (
//                                 <div
//                                   key={ques.ques_id}
//                                   className="question-block"
//                                 >
//                                   <p>
//                                     <strong>
//                                       {page.questionIndexOffset + index + 1}.
//                                     </strong>{" "}
//                                     {renderQuestionText(ques.ques_text)}
//                                   </p>
//                                   <div className="options__pre-ques">
//                                     {[...ques.options]
//                                       .sort(
//                                         (a, b) =>
//                                           a.set_option_position -
//                                           b.set_option_position
//                                       )
//                                       .map((opt, idx) => (
//                                         <p key={opt.option_id}>
//                                           <span>
//                                             {getOptionLabel(
//                                               idx,
//                                               quesPaperInfo?.option_naming_pattern
//                                             )}
//                                           </span>{" "}
//                                           {renderQuestionText(opt.option_text)}
//                                         </p>
//                                       ))}
//                                   </div>
//                                 </div>
//                               ))}
//                             </div>
//                           );
//                         })()}

//                         {roughPage && (
//                           <div
//                             className="rough-work-section"
//                             style={{
//                               minHeight: page.isLastPageInSection
//                                 ? "60px"
//                                 : "120px", // Reduced heights
//                             }}
//                           >
//                             <strong>Rough Work:</strong>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Page Footer */}
//                     <div className="page-footer">
//                       <div className="footer-left">
//                         {quesPaperInfo?.footer?.client_name} |{" "}
//                         {quesPaperInfo?.footer?.address}
//                       </div>
//                       <div className="footer-right">
//                         {page.type === "cover" &&
//                           `Set ${page.setName} - Cover Page`}
//                         {page.type === "syllabus" &&
//                           `Set ${page.setName} - Syllabus`}
//                         {page.type === "questions" && `Page ${page.pageNumber}`}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;



// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";

// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = `
//       <style>
//         body, html { margin:0!important; padding:0!important; }
//         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//         .watermark img { width: 300px; height: auto; }
//         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//         .question-grid__pre-ques { display:flex;}
//         .question-column__pre-ques { flex:1; }
//         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//         .page-footer span { float:right; }
//         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//         @media print {
//           body * { visibility: hidden !important; }
//           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         }
//         @page { size:A4; margin:0; }
//       </style>
//     `;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       // Cover Page
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div style="margin:0; padding:0;">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       // Syllabus Page
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="syllabus-heading-print">Test Syllabus</div>
//             <table class="syllabus-table-print">
//               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//               <tbody>
//                 ${quesPaperInfo.subj_chap_list
//                   .map(
//                     (subj) => `
//                   <tr>
//                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                     <td>${subj.chapters.join(", ")}</td>
//                   </tr>`
//                   )
//                   .join("")}
//               </tbody>
//             </table>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       // Questions per section
//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   ${subjectHtml}
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);
//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);

//     window.print();

//     setTimeout(() => {
//       if (printSection) document.body.removeChild(printSection);
//     }, 500);
//   };

//   const handleDownloadWord = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = ``;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               <div class="syllabus-heading-print">Test Syllabus</div>
//               <table class="syllabus-table-print">
//                 <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//                 <tbody>
//                   ${quesPaperInfo.subj_chap_list
//                     .map(
//                       (subj) => `
//                     <tr>
//                       <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                       <td>${subj.chapters.join(", ")}</td>
//                     </tr>`
//                     )
//                     .join("")}
//                 </tbody>
//               </table>
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   <div class="page-content">${subjectHtml}</div>
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const styledHTML = `
//       <html>
//         <head>
//           <meta charset="utf-8">
//           <style>
//             @page { size: A4; margin: 0; }
//             body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//             .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//             .page-content { max-width: 180mm; margin: auto; }
//             .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//             .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//             .question-block { margin-bottom: 14px; break-inside: avoid; }
//             .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//             .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//             .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//             .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//             .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//             .syllabus-table-print th { background-color: #f0f0f0; }
//             .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//           </style>
//         </head>
//         <body>
//           ${printContent}
//           <footer>
//             ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//             ${
//               quesPaperInfo?.footer?.address ||
//               "B – 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//             }
//           </footer>
//         </body>
//       </html>
//     `;

//     const blob = new Blob([styledHTML], {
//       type: "application/msword;charset=utf-8",
//     });
//     const filename = `${
//       quesPaperInfo?.ques_paper_name || "question-paper"
//     }.doc`;
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = filename;
//     link.click();
//   };

//   /**
//    * Generates the full HTML string for the question paper based on current state.
//    * This is the missing function that resolves the 'not defined' error.
//    */
//   const generatePrintableHTML = () => {
//     // Return early if essential data isn't loaded yet
//     if (!quesPaperInfo || questionData.length === 0) {
//       return "<p>Loading data, please wait...</p>";
//     }

//     // Helper function to calculate the number of pages for questions
//     const calculateTotalPagesForPrint = (set) => {
//       let questionPages = 0;
//       if (!set) return questionPages;
//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             // Adjust questions per page based on layout
//             const questionsPerPage = twinColumn ? 20 : 10;
//             questionPages += Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//           }
//         });
//       });
//       return questionPages;
//     };

//     // Helper function to render text content, including LaTeX and images
//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             // Use inline-block for better alignment with text
//             return `<img src="${url}" style="width:auto; height:1.5em; max-width:100%; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             // Render LaTeX using KaTeX
//             return segment.replace(/\\\((.*?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(he.decode(math), {
//                   throwOnError: false,
//                   displayMode: false,
//                 });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     // Helper function to process the cover page HTML template
//     const processedCoverHTMLForPrint = (setName) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       const currentSet = questionData.find((s) => s.set_name === setName);
//       const totalQuesPages = calculateTotalPagesForPrint(currentSet);
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     // Start building the full HTML string with styles
//     let fullHtml = `
//     <style>
//       body { margin: 0; padding: 0; font-family: sans-serif; }
//       .a4-page { width: 210mm; height: 296mm; padding: 15mm; box-sizing: border-box; background: white; position: relative; page-break-after: always; overflow: hidden; }
//       .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//       .watermark img { width: 400px; height: auto; }
//       .section-heading__Pre-ques { font-size: 16px; font-weight: 600; padding-bottom: 4px; margin-top: 20px; border-bottom: 1px solid #333; }
//       .question-grid__pre-ques { display: flex; gap: 15mm; }
//       .question-column__pre-ques { flex: 1; min-width: 0; }
//       .question-block { margin-bottom: 12px; page-break-inside: avoid; }
//       .options__pre-ques p { margin: 4px 0 0 16px; font-size: 14px; }
//       .page-footer { position: absolute; bottom: 10mm; left: 15mm; right: 15mm; font-size: 11px; border-top: 1px solid #ccc; padding-top: 4px; color: #444; display: flex; justify-content: space-between; }
//       .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//       .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//       .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; }
//       .page-header__pre-ques { display: flex; justify-content: space-between; font-size: 13px; padding: 4px 0; margin-bottom: 8px; border-bottom: 1px solid #ccc; }
//     </style>
//   `;

//     // Loop through each selected set and build its pages
//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       if (!currentSet) return;

//       let pageCounter = 1;

//       // Add Cover Page if toggled
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         fullHtml += `<div class="a4-page">${
//           watermark
//             ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//             : ""
//         }${processedCoverHTMLForPrint(setName)}<div class="page-footer"><div>${
//           quesPaperInfo?.footer?.client_name || ""
//         } | ${
//           quesPaperInfo?.footer?.address || ""
//         }</div><div>Set ${setName} - Cover Page</div></div></div>`;
//       }

//       // Add Syllabus Page if toggled
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         fullHtml += `<div class="a4-page">${
//           watermark
//             ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//             : ""
//         }<div class="syllabus-heading-print">Test Syllabus</div><table class="syllabus-table-print"><thead><tr><th>Subject</th><th>Chapters</th></tr></thead><tbody>${quesPaperInfo.subj_chap_list
//           .map(
//             (subj) =>
//               `<tr><td><strong>${subj.subject_name.toUpperCase()}</strong></td><td>${subj.chapters.join(
//                 ", "
//               )}</td></tr>`
//           )
//           .join("")}</tbody></table><div class="page-footer"><div>${
//           quesPaperInfo?.footer?.client_name || ""
//         } | ${
//           quesPaperInfo?.footer?.address || ""
//         }</div><div>Set ${setName} - Syllabus</div></div></div>`;
//       }

//       // Loop through subjects and sections to create question pages
//       currentSet.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           const allQuestions = [...(section.questions || [])].sort(
//             (a, b) => a.set_ques_position - b.set_ques_position
//           );
//           if (allQuestions.length === 0) return;

//           const questionsPerPage = twinColumn ? 20 : 10;
//           const totalPagesForSection = Math.ceil(
//             allQuestions.length / questionsPerPage
//           );

//           for (let page = 0; page < totalPagesForSection; page++) {
//             const pageQuestions = allQuestions.slice(
//               page * questionsPerPage,
//               (page + 1) * questionsPerPage
//             );
//             const questionStartIndex = page * questionsPerPage;
//             let pageHtml = "";

//             if (twinColumn) {
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftCol = pageQuestions.slice(0, mid);
//               const rightCol = pageQuestions.slice(mid);
//               pageHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">${leftCol
//                 .map(
//                   (ques, i) =>
//                     `<div class="question-block"><p><strong>${
//                       questionStartIndex + i + 1
//                     }.</strong> ${renderQuestionTextForPrint(
//                       ques.ques_text
//                     )}</p><div class="options__pre-ques">${ques.options
//                       .sort(
//                         (a, b) => a.set_option_position - b.set_option_position
//                       )
//                       .map(
//                         (opt, oi) =>
//                           `<p><span>${getOptionLabel(
//                             oi,
//                             quesPaperInfo?.option_naming_pattern
//                           )}</span> ${renderQuestionTextForPrint(
//                             opt.option_text
//                           )}</p>`
//                       )
//                       .join("")}</div></div>`
//                 )
//                 .join(
//                   ""
//                 )}</div><div class="question-column__pre-ques">${rightCol
//                 .map(
//                   (ques, i) =>
//                     `<div class="question-block"><p><strong>${
//                       questionStartIndex + mid + i + 1
//                     }.</strong> ${renderQuestionTextForPrint(
//                       ques.ques_text
//                     )}</p><div class="options__pre-ques">${ques.options
//                       .sort(
//                         (a, b) => a.set_option_position - b.set_option_position
//                       )
//                       .map(
//                         (opt, oi) =>
//                           `<p><span>${getOptionLabel(
//                             oi,
//                             quesPaperInfo?.option_naming_pattern
//                           )}</span> ${renderQuestionTextForPrint(
//                             opt.option_text
//                           )}</p>`
//                       )
//                       .join("")}</div></div>`
//                 )
//                 .join("")}</div></div>`;
//             } else {
//               pageHtml += pageQuestions
//                 .map(
//                   (ques, i) =>
//                     `<div class="question-block"><p><strong>${
//                       questionStartIndex + i + 1
//                     }.</strong> ${renderQuestionTextForPrint(
//                       ques.ques_text
//                     )}</p><div class="options__pre-ques">${ques.options
//                       .sort(
//                         (a, b) => a.set_option_position - b.set_option_position
//                       )
//                       .map(
//                         (opt, oi) =>
//                           `<p><span>${getOptionLabel(
//                             oi,
//                             quesPaperInfo?.option_naming_pattern
//                           )}</span> ${renderQuestionTextForPrint(
//                             opt.option_text
//                           )}</p>`
//                       )
//                       .join("")}</div></div>`
//                 )
//                 .join("");
//             }

//             fullHtml += `<div class="a4-page">${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }<div class="page-header__pre-ques"><div>${
//               quesPaperInfo?.header?.date || ""
//             }</div><div>${subject.subject_name}</div><div>${
//               quesPaperInfo?.header?.test_name || ""
//             }</div></div><p class="section-heading__Pre-ques">Section ${
//               section.section_name
//             }</p><p><strong>Instruction:</strong> ${
//               section.section_instruction?.trim()
//                 ? renderQuestionTextForPrint(section.section_instruction)
//                 : "N/A"
//             }</p>${pageHtml}<div class="page-footer"><div>${
//               quesPaperInfo?.footer?.client_name || ""
//             } | ${
//               quesPaperInfo?.footer?.address || ""
//             }</div><div>Page ${pageCounter++}</div></div></div>`;
//           }
//         });
//       });

//       // Add Rough Work page if toggled
//       if (roughPage) {
//         fullHtml += `<div class="a4-page">${
//           watermark
//             ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//             : ""
//         }<h2 style="text-align:center; margin-top: 40px;">Rough Work</h2><div class="page-footer"><div>${
//           quesPaperInfo?.footer?.client_name || ""
//         } | ${
//           quesPaperInfo?.footer?.address || ""
//         }</div><div>Rough Work</div></div></div>`;
//       }
//     });
//     return fullHtml;
//   };

//   const handleDownloadPDF = async () => {
//     // // Get the container element that is actually visible on the screen
//     // const printArea = contentRef.current;
//     // if (!printArea) {
//     //   alert("Preview area not found. Cannot generate PDF.");
//     //   return;
//     // }

//     // // Show a loading indicator for better user experience
//     // const loader = document.createElement('div');
//     // loader.innerText = 'Generating PDF, please wait...';
//     // Object.assign(loader.style, {
//     //   position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
//     //   backgroundColor: 'rgba(255, 255, 255, 0.9)', padding: '20px', border: '1px solid #ccc',
//     //   borderRadius: '10px', boxShadow: '0 4px 15px rgba(0,0,0,0.2)', zIndex: '10000'
//     // });
//     // document.body.appendChild(loader);

//     // try {
//     //   // Find all the rendered ".a4-page" divs inside the live preview
//     //   const pages = printArea.querySelectorAll('.a4-page');
//     //   if (pages.length === 0) {
//     //     throw new Error("No pages found to export. Please select a set to preview.");
//     //   }

//     //   const doc = new jsPDF('p', 'mm', 'a4');
//     //   const pdfWidth = doc.internal.pageSize.getWidth();
//     //   const pdfHeight = doc.internal.pageSize.getHeight();

//     //   // Process each visible page sequentially
//     //   for (let i = 0; i < pages.length; i++) {
//     //     const pageElement = pages[i];

//     //     // Crucial step: Ensure the page is scrolled into view before capturing
//     //     // This forces the browser to fully render it.
//     //     pageElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     //     await new Promise(resolve => setTimeout(resolve, 100)); // Brief pause for rendering

//     //     const canvas = await html2canvas(pageElement, {
//     //       scale: 2.5,         // Increase scale for sharper text and images
//     //       useCORS: true,      // Allows capturing cross-origin images
//     //       logging: false,     // Clean up console logs
//     //       // Provide context to help html2canvas render correctly
//     //       windowWidth: printArea.scrollWidth,
//     //       windowHeight: printArea.scrollHeight,
//     //     });

//     //     // Add a new page to the PDF for each element after the first one
//     //     if (i > 0) {
//     //       doc.addPage();
//     //     }

//     //     const imgData = canvas.toDataURL('image/jpeg', 0.95);
//     //     doc.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST');
//     //   }

//     //   // Save the final document
//     //   doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);

//     // } catch (error) {
//     //   console.error("Error generating PDF:", error);
//     //   alert(`An error occurred while generating the PDF: ${error.message}`);
//     // } finally {
//     //   // Clean up by removing the loader
//     //   document.body.removeChild(loader);
//     // }
//     const loader = document.createElement("div");
//     loader.innerText = "Generating PDF, please wait...";
//     document.body.appendChild(loader);

//     try {
//       const htmlContent = generatePrintableHTML();
//       const container = document.createElement("div");
//       container.style.position = "fixed";
//       container.style.left = "-9999px";
//       container.style.top = "0";
//       container.innerHTML = htmlContent;
//       document.body.appendChild(container);

//       const images = Array.from(container.querySelectorAll("img"));
//       await Promise.all(
//         images.map((img) =>
//           img.complete
//             ? Promise.resolve()
//             : new Promise((res) => {
//                 img.onload = res;
//                 img.onerror = res;
//               })
//         )
//       );

//       const pages = container.querySelectorAll(".a4-page");
//       const doc = new jsPDF("p", "mm", "a4");
//       const pdfWidth = doc.internal.pageSize.getWidth();
//       const pdfHeight = doc.internal.pageSize.getHeight();

//       for (let i = 0; i < pages.length; i++) {
//         const pageElement = pages[i];
//         const canvas = await html2canvas(pageElement, {
//           backgroundColor: null,
//           scale: 2,
//           useCORS: true,
//         });
//         const imgData = canvas.toDataURL("image/jpeg", 0.95);
//         if (i !== 0) doc.addPage();
//         doc.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
//       }

//       doc.save(`${quesPaperInfo?.ques_paper_name || "exported"}.pdf`);
//       document.body.removeChild(container);
//     } catch (error) {
//       console.error("Error generating PDF:", error);
//       alert("Failed to generate PDF.");
//     } finally {
//       document.body.removeChild(loader);
//     }
//   };

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <div
//                   className="export-dropdown-container__pre-ques"
//                   ref={exportDropdownRef}
//                 >
//                   <button
//                     className="icon-btn__pre-ques"
//                     onClick={() => setShowExportOptions(!showExportOptions)}
//                   >
//                     <img
//                       src={ExportIcon}
//                       alt="exporticon"
//                       style={{ marginRight: "5px" }}
//                     />{" "}
//                     Export
//                   </button>
//                   {showExportOptions && (
//                     <div className="export-options-dropdown__pre-ques">
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadPDF}
//                       >
//                         <FaFilePdf className="Img-PDF" />
//                         <span>PDF</span>
//                       </button>
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadWord}
//                       >
//                         <FaFileWord className="Img-WORD" />
//                         <span>Word</span>
//                       </button>
//                     </div>
//                   )}
//                 </div>
//                 <button className="icon-btn__pre-ques" onClick={handlePrint}>
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {/* {watermark && <img src={watermarkImg} alt="watermark" className="watermark-image" />} */}
//               {selectedSetNames.length === 0 ? (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               ) : (
//                 questionData
//                   .filter((set) => selectedSetNames.includes(set.set_name))
//                   .map((set) => (
//                     <React.Fragment key={`set-${set.set_name}`}>
//                       {showCoverPage && quesPaperInfo?.paper_cover && (
//                         <div className="a4-page" key={`cover-${set.set_name}`}>
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div
//                             dangerouslySetInnerHTML={{
//                               __html: processedCoverHTML(set.set_name),
//                             }}
//                           />
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Cover Page
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {showCoverPage && quesPaperInfo?.subj_chap_list && (
//                         <div className="a4-page syllabus-page">
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div className="syllabus-heading_prev_ques">
//                             <h2 style={{ textAlign: "center" }}>
//                               Test Syllabus
//                             </h2>
//                           </div>
//                           <table className="syllabus-table_prev_ques">
//                             <thead>
//                               <tr>
//                                 <th>Subject</th>
//                                 <th>Chapters</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                                 <tr key={idx}>
//                                   <td>
//                                     <strong>
//                                       {subj.subject_name.toUpperCase()}
//                                     </strong>
//                                   </td>
//                                   <td>{subj.chapters.join(", ")}</td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Syllabus
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {set.subjects.map((subject, subjectIndex) => (
//                         <div
//                           className="a4-page"
//                           key={`set-${set.set_name}-subject-${subject.subject_id}`}
//                         >
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           {subject.sections.map((section) => {
//                             const questions = [
//                               ...(section.questions || []),
//                             ].sort(
//                               (a, b) =>
//                                 a.set_ques_position - b.set_ques_position
//                             );
//                             const mid = Math.ceil(questions.length / 2);
//                             const leftQuestions = questions.slice(0, mid);
//                             const rightQuestions = questions.slice(mid);
//                             return (
//                               <div
//                                 key={`section-${section.section_name}`}
//                                 className="section-container__pre-ques"
//                               >
//                                 <p className="section-heading__Pre-ques">
//                                   Section {section.section_name}
//                                 </p>
//                                 <p>
//                                   Instruction:{" "}
//                                   {section.section_instruction?.trim()
//                                     ? renderQuestionText(
//                                         section.section_instruction
//                                       )
//                                     : "N/A"}
//                                 </p>
//                                 <div className="page-header__pre-ques">
//                                   <div className="header-left__pre-ques">
//                                     {quesPaperInfo?.header?.date}
//                                   </div>
//                                   <div className="header-center__pre-ques">
//                                     {subject.subject_name}
//                                   </div>
//                                   <div className="header-right__pre-ques">
//                                     {quesPaperInfo?.header?.test_name}
//                                   </div>
//                                 </div>
//                                 {twinColumn ? (
//                                   <div className="question-grid__pre-ques">
//                                     <div className="question-column__pre-ques">
//                                       {leftQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                     <div className="question-column__pre-ques">
//                                       {rightQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + mid + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   </div>
//                                 ) : (
//                                   <div>
//                                     {questions.map((ques, index) => (
//                                       <div
//                                         key={ques.ques_id}
//                                         className="question-block"
//                                       >
//                                         <p>
//                                           <strong>{index + 1}.</strong>{" "}
//                                           {renderQuestionText(ques.ques_text)}
//                                         </p>
//                                         <div className="options__pre-ques">
//                                           {[...ques.options]
//                                             .sort(
//                                               (a, b) =>
//                                                 a.set_option_position -
//                                                 b.set_option_position
//                                             )
//                                             .map((opt, idx) => (
//                                               <p key={opt.option_id}>
//                                                 <span>
//                                                   {getOptionLabel(
//                                                     idx,
//                                                     quesPaperInfo?.option_naming_pattern
//                                                   )}
//                                                 </span>{" "}
//                                                 {renderQuestionText(
//                                                   opt.option_text
//                                                 )}
//                                               </p>
//                                             ))}
//                                         </div>
//                                       </div>
//                                     ))}
//                                   </div>
//                                 )}
//                               </div>
//                             );
//                           })}
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Page {subjectIndex + 1}
//                             </div>
//                             {/* <div className="footer-right">Set {set.set_name} - {subject.subject_name}</div> */}
//                           </div>
//                         </div>
//                       ))}
//                     </React.Fragment>
//                   ))
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";

// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = `
//       <style>
//         body, html { margin:0!important; padding:0!important; }
//         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//         .watermark img { width: 300px; height: auto; }
//         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//         .question-grid__pre-ques { display:flex;}
//         .question-column__pre-ques { flex:1; }
//         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//         .page-footer span { float:right; }
//         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//         @media print {
//           body * { visibility: hidden !important; }
//           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         }
//         @page { size:A4; margin:0; }
//       </style>
//     `;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       // Cover Page
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div style="margin:0; padding:0;">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       // Syllabus Page
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page" style="padding: 20px;">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="syllabus-heading-print">Test Syllabus</div>
//             <table class="syllabus-table-print">
//               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//               <tbody>
//                 ${quesPaperInfo.subj_chap_list
//                   .map(
//                     (subj) => `
//                   <tr>
//                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                     <td>${subj.chapters.join(", ")}</td>
//                   </tr>`
//                   )
//                   .join("")}
//               </tbody>
//             </table>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       // Questions per section
//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques" style="padding-left: 15px;" >Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong style="padding-left: 15px;">Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//                 if (roughPage) {
//                   const isLastPage = page === totalPages - 1;
//                   const roughMinHeight = isLastPage ? "100px" : "200px";
//                   subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//                 }
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });

//                 if (roughPage) {
//                   const isLastPage = page === totalPages - 1;
//                   const roughMinHeight = isLastPage ? "100px" : "200px";
//                   subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//                 }
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   ${subjectHtml}
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);
//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);
//     console.log(printContent);
//     window.print();

//     setTimeout(() => {
//       if (printSection) document.body.removeChild(printSection);
//     }, 500);
//   };

//   const handleDownloadWord = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = ``;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               <div class="syllabus-heading-print">Test Syllabus</div>
//               <table class="syllabus-table-print">
//                 <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//                 <tbody>
//                   ${quesPaperInfo.subj_chap_list
//                     .map(
//                       (subj) => `
//                     <tr>
//                       <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                       <td>${subj.chapters.join(", ")}</td>
//                     </tr>`
//                     )
//                     .join("")}
//                 </tbody>
//               </table>
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   <div class="page-content">${subjectHtml}</div>
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const styledHTML = `
//       <html>
//         <head>
//           <meta charset="utf-8">
//           <style>
//             @page { size: A4; margin: 0; }
//             body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//             .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//             .page-content { max-width: 180mm; margin: auto; }
//             .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//             .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//             .question-block { margin-bottom: 14px; break-inside: avoid; }
//             .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//             .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//             .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//             .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//             .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//             .syllabus-table-print th { background-color: #f0f0f0; }
//             .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//           </style>
//         </head>
//         <body>
//           ${printContent}
//           <footer>
//             ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//             ${
//               quesPaperInfo?.footer?.address ||
//               "B â€“ 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//             }
//           </footer>
//         </body>
//       </html>
//     `;

//     const blob = new Blob([styledHTML], {
//       type: "application/msword;charset=utf-8",
//     });
//     const filename = `${
//       quesPaperInfo?.ques_paper_name || "question-paper"
//     }.doc`;
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = filename;
//     link.click();
//   };

//   const handleDownloadPDF = () => {
//     if (!questionData || questionData.length === 0) return;

//     const doc = new jsPDF("p", "mm", "a4");

//     const generatePDFForSet = (set, callback) => {
//       const setName = set.set_name;
//       const syllabusRows = quesPaperInfo?.subj_chap_list?.map((item) => [
//         item.subject_name,
//         item.chapters.join(", "),
//       ]);

//       doc.html(processedCoverHTML(setName), {
//         callback: () => {
//           // Syllabus Page
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text("Test Syllabus", 105, 20, { align: "center" });

//           if (syllabusRows?.length) {
//             doc.autoTable({
//               head: [["Subject", "Chapters"]],
//               body: syllabusRows,
//               startY: 30,
//               styles: { fontSize: 10 },
//               headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               theme: "grid",
//             });
//           }

//           // Add question summary next
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text(`Set ${setName} - Question Paper Summary`, 14, 20);

//           set.subjects.forEach((subject) => {
//             const sectionRows = [];

//             subject.sections.forEach((section) => {
//               (section.questions || []).forEach((ques, index) => {
//                 const questionText = he
//                   .decode(ques.ques_text)
//                   .replace(/(<([^>]+)>)/gi, "")
//                   .slice(0, 100);
//                 sectionRows.push([
//                   section.section_name,
//                   `${index + 1}`,
//                   questionText,
//                   subject.subject_name,
//                   ques.ques_id || "",
//                 ]);
//               });
//             });

//             if (sectionRows.length > 0) {
//               doc.autoTable({
//                 head: [
//                   ["Section", "Q No", "Question Text", "Subject", "Ques ID"],
//                 ],
//                 body: sectionRows,
//                 startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 30,
//                 styles: { fontSize: 8 },
//                 headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               });
//             }

//             doc.addPage(); // optional: remove if not needed per subject
//           });

//           callback();
//         },
//         x: 10,
//         y: 10,
//         margin: 10,
//         html2canvas: { scale: 0.4 },
//       });
//     };

//     const setsToProcess = questionData.filter((set) =>
//       selectedSetNames.includes(set.set_name)
//     );
//     let index = 0;

//     const processNextSet = () => {
//       if (index < setsToProcess.length) {
//         generatePDFForSet(setsToProcess[index], () => {
//           index++;
//           processNextSet();
//         });
//       } else {
//         doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);
//       }
//     };

//     processNextSet();
//   };

//   const previewPages = React.useMemo(() => {
//     const pages = [];
//     if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//       return [];
//     }

//     const setsToRender = questionData.filter((set) =>
//       selectedSetNames.includes(set.set_name)
//     );

//     // This function pre-calculates the total number of question pages for a given set.
//     // This is needed for the #total_pages# placeholder on the cover page.
//     const calculateTotalQuestionPages = (set) => {
//       let count = 0;
//       if (!set) return 0;
//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           const questionsPerPage = 10;
//           count += Math.ceil(
//             (section.questions || []).length / questionsPerPage
//           );
//         });
//       });
//       return count;
//     };

//     setsToRender.forEach((set) => {
//       let questionPageCounter = 1; // This will be the running page number for display.
//       const totalQuestionPagesForSet = calculateTotalQuestionPages(set);

//       // 1. Add Cover Page
//       if (showCoverPage && quesPaperInfo.paper_cover) {
//         pages.push({
//           type: "cover",
//           key: `cover-${set.set_name}`,
//           setName: set.set_name,
//           totalQuestionPages: totalQuestionPagesForSet,
//         });
//       }

//       // 2. Add Syllabus Page
//       if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//         pages.push({
//           type: "syllabus",
//           key: `syllabus-${set.set_name}`,
//           setName: set.set_name,
//         });
//       }

//       // 3. Add Question Pages (Paginated)
//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           const allQuestions = [...(section.questions || [])].sort(
//             (a, b) => a.set_ques_position - b.set_ques_position
//           );
//           if (allQuestions.length === 0) return;

//           const questionsPerPage = 10;
//           const totalPagesInSection = Math.ceil(
//             allQuestions.length / questionsPerPage
//           );
//           let questionIndex = 0; // To track question number within the section

//           for (let i = 0; i < totalPagesInSection; i++) {
//             const pageQuestions = allQuestions.slice(
//               i * questionsPerPage,
//               (i + 1) * questionsPerPage
//             );

//             pages.push({
//               type: "questions",
//               key: `questions-${set.set_name}-${subject.subject_id}-${section.section_name}-${i}`,
//               setName: set.set_name,
//               subject,
//               section,
//               questions: pageQuestions,
//               questionIndexOffset: questionIndex,
//               pageNumber: questionPageCounter++,
//               isLastPageInSection: i === totalPagesInSection - 1,
//             });
//             questionIndex += pageQuestions.length;
//           }
//         });
//       });
//     });

//     return pages;
//   }, [
//     questionData,
//     quesPaperInfo,
//     selectedSetNames,
//     showCoverPage,
//     watermark,
//     twinColumn,
//     roughPage,
//   ]);

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <div
//                   className="export-dropdown-container__pre-ques"
//                   ref={exportDropdownRef}
//                 >
//                   <button
//                     className="icon-btn__pre-ques"
//                     onClick={() => setShowExportOptions(!showExportOptions)}
//                   >
//                     <img
//                       src={ExportIcon}
//                       alt="exporticon"
//                       style={{ marginRight: "5px" }}
//                     />{" "}
//                     Export
//                   </button>
//                   {showExportOptions && (
//                     <div className="export-options-dropdown__pre-ques">
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadPDF}
//                       >
//                         <FaFilePdf className="Img-PDF" />
//                         <span>PDF</span>
//                       </button>
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadWord}
//                       >
//                         <FaFileWord className="Img-WORD" />
//                         <span>Word</span>
//                       </button>
//                     </div>
//                   )}
//                 </div>
//                 <button className="icon-btn__pre-ques" onClick={handlePrint}>
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {previewPages.length > 0 ? (
//                 previewPages.map((page) => (
//                   <div
//                     className={`a4-page${
//                       roughPage && page.type === "questions"
//                         ? " has-roughwork"
//                         : ""
//                     }`}
//                     key={page.key}
//                   >
//                     {watermark && (
//                       <img
//                         src={watermarkImg}
//                         alt="watermark"
//                         className="watermark-image"
//                       />
//                     )}

//                     {/* Page Content */}
//                     {page.type === "cover" && (
//                       <div
//                         dangerouslySetInnerHTML={{
//                           __html: quesPaperInfo.paper_cover
//                             .replace(/#total_pages#/gi, page.totalQuestionPages)
//                             .replace(
//                               /#test_date#/gi,
//                               new Date().toLocaleDateString("en-GB")
//                             )
//                             .replace(/#set_name#/gi, page.setName),
//                         }}
//                       />
//                     )}

//                     {page.type === "syllabus" && (
//                       <div className="syllabus-page">
//                         <div className="syllabus-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Test Syllabus</h2>
//                         </div>
//                         <table className="syllabus-table_prev_ques">
//                           <thead>
//                             <tr>
//                               <th>Subject</th>
//                               <th>Chapters</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                               <tr key={idx}>
//                                 <td>
//                                   <strong>
//                                     {subj.subject_name.toUpperCase()}
//                                   </strong>
//                                 </td>
//                                 <td>{subj.chapters.join(", ")}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}

//                     {page.type === "questions" && (
//                       <div
//                         className="section-container__pre-ques"
//                         style={{ position: "relative", minHeight: "530px" }}
//                       >
//                         <p className="section-heading__Pre-ques">
//                           Section {page.section.section_name}
//                         </p>
//                         <p>
//                           Instruction:{" "}
//                           {page.section.section_instruction?.trim()
//                             ? renderQuestionText(
//                                 page.section.section_instruction
//                               )
//                             : "N/A"}
//                         </p>
//                         <div className="page-header__pre-ques">
//                           <div className="header-left__pre-ques">
//                             {quesPaperInfo?.header?.date}
//                           </div>
//                           <div className="header-center__pre-ques">
//                             {page.subject.subject_name}
//                           </div>
//                           <div className="header-right__pre-ques">
//                             {quesPaperInfo?.header?.test_name}
//                           </div>
//                         </div>

//                         {(() => {
//                           const questions = page.questions;
//                           const mid = Math.ceil(questions.length / 2);
//                           const leftQuestions = questions.slice(0, mid);
//                           const rightQuestions = questions.slice(mid);

//                           return twinColumn ? (
//                             <div className="question-grid__pre-ques">
//                               <div className="question-column__pre-ques">
//                                 {leftQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset + index + 1}.
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                               <div className="question-column__pre-ques">
//                                 {rightQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset +
//                                           mid +
//                                           index +
//                                           1}
//                                         .
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                             </div>
//                           ) : (
//                             <div>
//                               {questions.map((ques, index) => (
//                                 <div
//                                   key={ques.ques_id}
//                                   className="question-block"
//                                 >
//                                   <p>
//                                     <strong>
//                                       {page.questionIndexOffset + index + 1}.
//                                     </strong>{" "}
//                                     {renderQuestionText(ques.ques_text)}
//                                   </p>
//                                   <div className="options__pre-ques">
//                                     {[...ques.options]
//                                       .sort(
//                                         (a, b) =>
//                                           a.set_option_position -
//                                           b.set_option_position
//                                       )
//                                       .map((opt, idx) => (
//                                         <p key={opt.option_id}>
//                                           <span>
//                                             {getOptionLabel(
//                                               idx,
//                                               quesPaperInfo?.option_naming_pattern
//                                             )}
//                                           </span>{" "}
//                                           {renderQuestionText(opt.option_text)}
//                                         </p>
//                                       ))}
//                                   </div>
//                                 </div>
//                               ))}
//                             </div>
//                           );
//                         })()}

//                         {roughPage && (
//                           <div
//                             className="rough-work-section"
//                             style={{
//                               minHeight: page.isLastPageInSection
//                                 ? "100px"
//                                 : "200px",
//                             }}
//                           >
//                             <strong>Rough Work:</strong>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Page Footer */}
//                     <div className="page-footer">
//                       <div className="footer-left">
//                         {quesPaperInfo?.footer?.client_name} |{" "}
//                         {quesPaperInfo?.footer?.address}
//                       </div>
//                       <div className="footer-right">
//                         {page.type === "cover" &&
//                           `Set ${page.setName} - Cover Page`}
//                         {page.type === "syllabus" &&
//                           `Set ${page.setName} - Syllabus`}
//                         {page.type === "questions" && `Page ${page.pageNumber}`}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";

// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = `
//       <style>
//         body, html { margin:0!important; padding:0!important; }
//         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//         .watermark img { width: 300px; height: auto; }
//         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//         .question-grid__pre-ques { display:flex;}
//         .question-column__pre-ques { flex:1; }
//         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//         .page-footer span { float:right; }
//         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//         @media print {
//           body * { visibility: hidden !important; }
//           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         }
//         @page { size:A4; margin:0; }
//       </style>
//     `;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       // Cover Page
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div style="margin:0; padding:0;">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       // Syllabus Page
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page" style="padding: 20px;">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="syllabus-heading-print">Test Syllabus</div>
//             <table class="syllabus-table-print">
//               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//               <tbody>
//                 ${quesPaperInfo.subj_chap_list
//                   .map(
//                     (subj) => `
//                   <tr>
//                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                     <td>${subj.chapters.join(", ")}</td>
//                   </tr>`
//                   )
//                   .join("")}
//               </tbody>
//             </table>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       // Questions per section
//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques" style="padding-left: 15px;" >Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong style="padding-left: 15px;">Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//                 const isLastPage = page === totalPages - 1;
//                 const roughMinHeight = isLastPage ? "100px" : "200px";
//                 subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                   const isLastPage = page === totalPages - 1;
//                   const roughMinHeight = isLastPage ? "100px" : "200px";
//                   subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   ${subjectHtml}
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);
//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);
//     console.log(printContent);
//     window.print();

//     setTimeout(() => {
//       if (printSection) document.body.removeChild(printSection);
//     }, 500);
//   };

//   const handleDownloadWord = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = ``;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               <div class="syllabus-heading-print">Test Syllabus</div>
//               <table class="syllabus-table-print">
//                 <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//                 <tbody>
//                   ${quesPaperInfo.subj_chap_list
//                     .map(
//                       (subj) => `
//                     <tr>
//                       <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                       <td>${subj.chapters.join(", ")}</td>
//                     </tr>`
//                     )
//                     .join("")}
//                 </tbody>
//               </table>
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   <div class="page-content">${subjectHtml}</div>
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const styledHTML = `
//       <html>
//         <head>
//           <meta charset="utf-8">
//           <style>
//             @page { size: A4; margin: 0; }
//             body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//             .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//             .page-content { max-width: 180mm; margin: auto; }
//             .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//             .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//             .question-block { margin-bottom: 14px; break-inside: avoid; }
//             .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//             .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//             .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//             .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//             .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//             .syllabus-table-print th { background-color: #f0f0f0; }
//             .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//           </style>
//         </head>
//         <body>
//           ${printContent}
//           <footer>
//             ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//             ${
//               quesPaperInfo?.footer?.address ||
//               "B â€“ 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//             }
//           </footer>
//         </body>
//       </html>
//     `;

//     const blob = new Blob([styledHTML], {
//       type: "application/msword;charset=utf-8",
//     });
//     const filename = `${
//       quesPaperInfo?.ques_paper_name || "question-paper"
//     }.doc`;
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = filename;
//     link.click();
//   };

//   const handleDownloadPDF = () => {
//     if (!questionData || questionData.length === 0) return;

//     const doc = new jsPDF("p", "mm", "a4");

//     const generatePDFForSet = (set, callback) => {
//       const setName = set.set_name;
//       const syllabusRows = quesPaperInfo?.subj_chap_list?.map((item) => [
//         item.subject_name,
//         item.chapters.join(", "),
//       ]);

//       doc.html(processedCoverHTML(setName), {
//         callback: () => {
//           // Syllabus Page
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text("Test Syllabus", 105, 20, { align: "center" });

//           if (syllabusRows?.length) {
//             doc.autoTable({
//               head: [["Subject", "Chapters"]],
//               body: syllabusRows,
//               startY: 30,
//               styles: { fontSize: 10 },
//               headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               theme: "grid",
//             });
//           }

//           // Add question summary next
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text(`Set ${setName} - Question Paper Summary`, 14, 20);

//           set.subjects.forEach((subject) => {
//             const sectionRows = [];

//             subject.sections.forEach((section) => {
//               (section.questions || []).forEach((ques, index) => {
//                 const questionText = he
//                   .decode(ques.ques_text)
//                   .replace(/(<([^>]+)>)/gi, "")
//                   .slice(0, 100);
//                 sectionRows.push([
//                   section.section_name,
//                   `${index + 1}`,
//                   questionText,
//                   subject.subject_name,
//                   ques.ques_id || "",
//                 ]);
//               });
//             });

//             if (sectionRows.length > 0) {
//               doc.autoTable({
//                 head: [
//                   ["Section", "Q No", "Question Text", "Subject", "Ques ID"],
//                 ],
//                 body: sectionRows,
//                 startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 30,
//                 styles: { fontSize: 8 },
//                 headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               });
//             }

//             doc.addPage(); // optional: remove if not needed per subject
//           });

//           callback();
//         },
//         x: 10,
//         y: 10,
//         margin: 10,
//         html2canvas: { scale: 0.4 },
//       });
//     };

//     const setsToProcess = questionData.filter((set) =>
//       selectedSetNames.includes(set.set_name)
//     );
//     let index = 0;

//     const processNextSet = () => {
//       if (index < setsToProcess.length) {
//         generatePDFForSet(setsToProcess[index], () => {
//           index++;
//           processNextSet();
//         });
//       } else {
//         doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);
//       }
//     };

//     processNextSet();
//   };

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <div
//                   className="export-dropdown-container__pre-ques"
//                   ref={exportDropdownRef}
//                 >
//                   <button
//                     className="icon-btn__pre-ques"
//                     onClick={() => setShowExportOptions(!showExportOptions)}
//                   >
//                     <img
//                       src={ExportIcon}
//                       alt="exporticon"
//                       style={{ marginRight: "5px" }}
//                     />{" "}
//                     Export
//                   </button>
//                   {showExportOptions && (
//                     <div className="export-options-dropdown__pre-ques">
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadPDF}
//                       >
//                         <FaFilePdf className="Img-PDF" />
//                         <span>PDF</span>
//                       </button>
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadWord}
//                       >
//                         <FaFileWord className="Img-WORD" />
//                         <span>Word</span>
//                       </button>
//                     </div>
//                   )}
//                 </div>
//                 <button className="icon-btn__pre-ques" onClick={handlePrint}>
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {/* {watermark && <img src={watermarkImg} alt="watermark" className="watermark-image" />} */}
//               {selectedSetNames.length === 0 ? (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               ) : (
//                 questionData
//                   .filter((set) => selectedSetNames.includes(set.set_name))
//                   .map((set) => (
//                     <React.Fragment key={`set-${set.set_name}`}>
//                       {showCoverPage && quesPaperInfo?.paper_cover && (
//                         <div className="a4-page" key={`cover-${set.set_name}`}>
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div
//                             dangerouslySetInnerHTML={{
//                               __html: processedCoverHTML(set.set_name),
//                             }}
//                           />
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Cover Page
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {showCoverPage && quesPaperInfo?.subj_chap_list && (
//                         <div className="a4-page syllabus-page">
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div className="syllabus-heading_prev_ques">
//                             <h2 style={{ textAlign: "center" }}>
//                               Test Syllabus
//                             </h2>
//                           </div>
//                           <table className="syllabus-table_prev_ques">
//                             <thead>
//                               <tr>
//                                 <th>Subject</th>
//                                 <th>Chapters</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                                 <tr key={idx}>
//                                   <td>
//                                     <strong>
//                                       {subj.subject_name.toUpperCase()}
//                                     </strong>
//                                   </td>
//                                   <td>{subj.chapters.join(", ")}</td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Syllabus
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {set.subjects.map((subject, subjectIndex) => (
//                         // <div
//                         //   className="a4-page"
//                         //   key={`set-${set.set_name}-subject-${subject.subject_id}`}
//                         // >
//                         <div
//                           className={`a4-page${
//                             roughPage ? " has-roughwork" : ""
//                           }`}
//                           key={`set-${set.set_name}-subject-${subject.subject_id}`}
//                         >
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           {subject.sections.map((section) => {
//                             const questions = [
//                               ...(section.questions || []),
//                             ].sort(
//                               (a, b) =>
//                                 a.set_ques_position - b.set_ques_position
//                             );
//                             const mid = Math.ceil(questions.length / 2);
//                             const leftQuestions = questions.slice(0, mid);
//                             const rightQuestions = questions.slice(mid);
//                             return (
//                               // <div
//                               //   key={`section-${section.section_name}`}
//                               //   className="section-container__pre-ques"
//                               // >
//                               <div
//                                 key={`section-${section.section_name}`}
//                                 className="section-container__pre-ques"
//                                 style={{
//                                   position: "relative",
//                                   minHeight: "530px",
//                                 }} // To ensure height for absolute positioning
//                               >
//                                 <p className="section-heading__Pre-ques">
//                                   Section {section.section_name}
//                                 </p>
//                                 <p>
//                                   Instruction:{" "}
//                                   {section.section_instruction?.trim()
//                                     ? renderQuestionText(
//                                         section.section_instruction
//                                       )
//                                     : "N/A"}
//                                 </p>
//                                 <div className="page-header__pre-ques">
//                                   <div className="header-left__pre-ques">
//                                     {quesPaperInfo?.header?.date}
//                                   </div>
//                                   <div className="header-center__pre-ques">
//                                     {subject.subject_name}
//                                   </div>
//                                   <div className="header-right__pre-ques">
//                                     {quesPaperInfo?.header?.test_name}
//                                   </div>
//                                 </div>

//                                 {twinColumn ? (
//                                   <div className="question-grid__pre-ques">
//                                     <div className="question-column__pre-ques">
//                                       {leftQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                     <div className="question-column__pre-ques">
//                                       {rightQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + mid + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   </div>
//                                 ) : (
//                                   <div>
//                                     {questions.map((ques, index) => (
//                                       <div
//                                         key={ques.ques_id}
//                                         className="question-block"
//                                       >
//                                         <p>
//                                           <strong>{index + 1}.</strong>{" "}
//                                           {renderQuestionText(ques.ques_text)}
//                                         </p>
//                                         <div className="options__pre-ques">
//                                           {[...ques.options]
//                                             .sort(
//                                               (a, b) =>
//                                                 a.set_option_position -
//                                                 b.set_option_position
//                                             )
//                                             .map((opt, idx) => (
//                                               <p key={opt.option_id}>
//                                                 <span>
//                                                   {getOptionLabel(
//                                                     idx,
//                                                     quesPaperInfo?.option_naming_pattern
//                                                   )}
//                                                 </span>{" "}
//                                                 {renderQuestionText(
//                                                   opt.option_text
//                                                 )}
//                                               </p>
//                                             ))}
//                                         </div>
//                                       </div>
//                                     ))}
//                                   </div>
//                                 )}

//                                 {roughPage && (
//                                   <div className="rough-work-section">
//                                     <strong>Rough Work:</strong>
//                                     <div style={{ height: "100%" }} />
//                                   </div>
//                                 )}
//                               </div>
//                             );
//                           })}
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Page {subjectIndex + 1}
//                             </div>
//                             {/* <div className="footer-right">Set {set.set_name} - {subject.subject_name}</div> */}
//                           </div>
//                         </div>
//                       ))}
//                     </React.Fragment>
//                   ))
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";
// import Colors from "../../../Constants/Colors";
// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const [paginatedPages, setPaginatedPages] = useState([]);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Add this helper function to render content to HTML for measurement
//   const renderContentToHTML = (text) => {
//     if (!text) return "";
//     const decoded = he.decode(text);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts
//       .map((segment) => {
//         if (segment.startsWith("imgsrc=")) {
//           const url = segment.replace("imgsrc=", "");
//           return `<img src="${url}" alt="image" style="max-width: 80px; height: auto; vertical-align: middle; margin: 0 5px;" />`;
//         } else {
//           return segment.replace(/\\\((.*?)\\\)/g, (_, math) => {
//             try {
//               return katex.renderToString(math, {
//                 throwOnError: false,
//                 displayMode: false,
//               });
//             } catch (e) {
//               console.warn("Katex rendering error:", e);
//               return `<span style="color:red;">[LaTeX Error]</span>`;
//             }
//           });
//         }
//       })
//       .join("");
//   };

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     if (!paginatedPages || paginatedPages.length === 0) {
//       alert("There is no content to print.");
//       return;
//     }

//     const AVAILABLE_HEIGHT_MM = (PAGE_CONTENT_HEIGHT_PX / 3.78); // Convert px to mm
// const FOOTER_HEIGHT_MM = 12;
// const PADDING_MM = 8;
// const CALCULATED_WRAPPER_HEIGHT = `calc(297mm - ${PADDING_MM + FOOTER_HEIGHT_MM + 8}mm)`;

//     // Helper to process cover page HTML
//     const getProcessedCoverHTML = (page) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, page.totalQuestionPages)
//         .replace(/#test_date#/gi, new Date().toLocaleDateString("en-GB"))
//         .replace(/#set_name#/gi, page.setName);
//     };

//     let printContent = `
//     <style>
//       body, html { margin: 0 !important; padding: 0 !important; background-color: #fff; font-family: Calibri, sans-serif; }
//       .a4-page { width: 210mm; min-height: 297mm; margin: 0 auto; padding: 10mm; box-sizing: border-box; background: white; position: relative; page-break-after: always; }

//       .page-content-wrapper {
//          height: ${CALCULATED_WRAPPER_HEIGHT};
//         position: relative;
//         padding-bottom: 10mm; /* Space for footer */
//         overflow: hidden;
//       }
//       .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//       .watermark img { width: 300px; height: auto; }
//       .section-heading__Pre-ques { font-size: 16px; font-weight: 600; margin: 0px 0 4px 0; padding-left: 15px; }
//       .question-grid__pre-ques { display: flex; gap: 20px; }
//       .question-column__pre-ques { flex: 1; min-width: 0; }
//       .question-block { margin-bottom: 10px; page-break-inside: avoid; }
//       .question-block p { margin: 0 0 3px 0; line-height: 1.3; }
//       .options__pre-ques p { margin: 3px 0 1px 16px; font-size: 14px; line-height: 1.2; }
//       .page-footer {
//         position: absolute;
//         bottom: 8mm;
//         left: 10mm;
//         right: 10mm;
//         height: 15mm;
//         text-align: center;
//         font-size: 11px;
//         border-top: 1px solid #ccc;
//         padding-top: 4px;
//         color: #444;
//         display: flex;
//         justify-content: space-between;
//         background: white;
//         z-index: 10;
//       }
//       .page-header__pre-ques { display: flex; justify-content: space-between; font-size: 13px; padding: 4px 12px; margin-bottom: 6px; border-bottom: 1px solid #ccc; }
//       .rough-work-section { margin-top: 15px; border-top: 1px solid #ccc; padding-top: 8px; min-height: 60px; }
//       .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 5px; padding-bottom: 8px; }
//       .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//       .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//       .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//       .instructions-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 5px; padding-bottom: 8px; }
//       .instructions-content { margin-top: 5px; }
//       @media print {
//         body * { visibility: hidden !important; }
//         #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//         #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//       }
//       @page { size: A4; margin: 0; }
//     </style>
//   `;

//     // Iterate through the already calculated paginatedPages
//     paginatedPages.forEach((page) => {
//       printContent += `<div class="a4-page">`;

//       // Add watermark if enabled
//       if (watermark) {
//         printContent += `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`;
//       }

//       printContent += `<div class="page-content-wrapper">`;

//       // Generate content based on page type
//       switch (page.type) {
//         case "cover":
//           printContent += `
//     <div style="margin-top: 0 !important; padding-top: 0 !important; position: relative; top: 0;">
//       ${getProcessedCoverHTML(page)}
//     </div>`;
//           break;

//         case "instructions":
//           printContent += `
//           <div class="instructions-heading-print">Instructions</div>
//           <hr style="border: none; border-top: 1px solid #ccc; margin: 5px 0;" />
//           <div class="instructions-content" style="font-size: 14px; text-align: justify;">${quesPaperInfo.instructions_html}</div>`;
//           break;

//         case "syllabus":
//           printContent += `
//           <div class="syllabus-heading-print">Test Syllabus</div>
//           <table class="syllabus-table-print">
//             <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//             <tbody>
//               ${quesPaperInfo.subj_chap_list
//                 .map(
//                   (s) => `
//                 <tr>
//                   <td><strong>${s.subject_name.toUpperCase()}</strong></td>
//                   <td>${s.chapters.join(", ")}</td>
//                 </tr>
//               `
//                 )
//                 .join("")}
//             </tbody>
//           </table>`;
//           break;

//         case "questions":
//           let questionsHtml = `
//           <p class="section-heading__Pre-ques">Section ${
//             page.section.section_name
//           }</p>
//           <p style="padding-left: 15px; margin: 0 0 4px 0;"><strong>Instruction:</strong> ${
//             page.section.section_instruction?.trim()
//               ? renderContentToHTML(page.section.section_instruction)
//               : "N/A"
//           }</p>
//           <div class="page-header__pre-ques">
//             <div>${quesPaperInfo?.header?.date || ""}</div>
//             <div>${page.subject.subject_name}</div>
//             <div>${quesPaperInfo?.header?.test_name || ""}</div>
//           </div>`;

//           const renderQuestionColumn = (qs, offset) =>
//             qs
//               .map(
//                 (q, i) => `
//           <div class="question-block">
//             <p><strong>${offset + i + 1}.</strong> ${renderContentToHTML(
//                   q.ques_text
//                 )}</p>
//             <div class="options__pre-ques">
//               ${q.options
//                 .sort((a, b) => a.set_option_position - b.set_option_position)
//                 .map(
//                   (opt, oi) => `
//                 <p><span>${getOptionLabel(
//                   oi,
//                   quesPaperInfo?.option_naming_pattern
//                 )}</span> ${renderContentToHTML(opt.option_text)}</p>
//               `
//                 )
//                 .join("")}
//             </div>
//           </div>`
//               )
//               .join("");

//           if (twinColumn) {
//             const mid = Math.ceil(page.questions.length / 2);
//             questionsHtml += `
//             <div class="question-grid__pre-ques">
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(0, mid),
//                 page.questionIndexOffset
//               )}</div>
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(mid),
//                 page.questionIndexOffset + mid
//               )}</div>
//             </div>`;
//           } else {
//             questionsHtml += `<div>${renderQuestionColumn(
//               page.questions,
//               page.questionIndexOffset
//             )}</div>`;
//           }

//           // Add rough work section if enabled and this is the last page of the section
//           if (roughPage && page.isLastPageInSection) {
//             questionsHtml += `<div class="rough-work-section"><strong>Rough Work:</strong></div>`;
//           }

//           printContent += questionsHtml;
//           break;

//         default:
//           break;
//       }

//       printContent += `</div>`; // Close page-content-wrapper

//       // Add footer for all page types
//       printContent += `
//       <div class="page-footer">
//         <div>${quesPaperInfo?.footer?.client_name || ""} | ${
//         quesPaperInfo?.footer?.address || ""
//       }</div>
//         <div>
//           ${page.type === "cover" ? `Set ${page.setName} - Cover Page` : ""}
//           ${
//             page.type === "instructions"
//               ? `Set ${page.setName} - Instructions`
//               : ""
//           }
//           ${page.type === "syllabus" ? `Set ${page.setName} - Syllabus` : ""}
//           ${page.type === "questions" ? `Page ${page.pageNumber}` : ""}
//         </div>
//       </div>
//     `;

//       printContent += `</div>`; // Close a4-page
//     });

//     // Create and inject print section
//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);

//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);

//     // Print with a small delay to ensure rendering
//     setTimeout(() => {
//       window.print();
//       // Cleanup after printing
//       setTimeout(() => {
//         if (document.getElementById(printSectionId)) {
//           document.body.removeChild(document.getElementById(printSectionId));
//         }
//       }, 1000);
//     }, 500);
//   };

//   //   const handlePrint = () => {
//   //     const calculateTotalPagesForPrint = (set) => {
//   //       let total = 0;
//   //       let questionPages = 0;

//   //       if (showCoverPage) total++;
//   //       if (quesPaperInfo?.subj_chap_list?.length) total++;

//   //       if (!set) return { total, questionPages };

//   //       set.subjects.forEach((subject) => {
//   //         subject.sections.forEach((section) => {
//   //           if ((section.questions || []).length > 0) {
//   //             const questionsPerPage = 10;
//   //             const pages = Math.ceil(
//   //               section.questions.length / questionsPerPage
//   //             );
//   //             total += pages;
//   //             questionPages += pages;
//   //           }
//   //         });
//   //       });

//   //       return { total, questionPages };
//   //     };

//   //     const renderQuestionTextForPrint = (text) => {
//   //       if (!text) return "";
//   //       const decoded = he.decode(text);
//   //       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//   //       return parts
//   //         .map((segment, idx) => {
//   //           if (segment.startsWith("imgsrc=")) {
//   //             const url = segment.replace("imgsrc=", "");
//   //             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//   //           } else {
//   //             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//   //               try {
//   //                 return katex.renderToString(math, { throwOnError: false });
//   //               } catch (e) {
//   //                 return `<span style="color:red;">Invalid LaTeX</span>`;
//   //               }
//   //             });
//   //           }
//   //         })
//   //         .join("");
//   //     };

//   //     const processedCoverHTML = (setName, totalQuesPages) => {
//   //       if (!quesPaperInfo?.paper_cover) return "";
//   //       const testDate = new Date().toLocaleDateString("en-GB");
//   //       return quesPaperInfo.paper_cover
//   //         .replace(/#total_pages#/gi, totalQuesPages)
//   //         .replace(/#test_date#/gi, testDate)
//   //         .replace(/#set_name#/gi, setName);
//   //     };

//   //     let printContent = `
//   //       <style>
//   //         body, html { margin:0!important; padding:0!important; }
//   //         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//   //         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//   //         .watermark img { width: 300px; height: auto; }
//   //         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//   //         .question-grid__pre-ques { display:flex;}
//   //         .question-column__pre-ques { flex:1; }
//   //         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//   //         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//   //         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//   //         .page-footer span { float:right; }
//   //         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//   //         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//   //         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//   //         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//   //         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//   //         @media print {
//   //           body * { visibility: hidden !important; }
//   //           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//   //           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//   //         }
//   //         @page { size:A4; margin:0; }
//   //       </style>
//   //     `;

//   //     selectedSetNames.forEach((setName) => {
//   //       const currentSet = questionData.find((set) => set.set_name === setName);
//   //       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//   //       let questionPageNum = 1;

//   //       // Cover Page
//   //       if (showCoverPage && quesPaperInfo?.paper_cover) {
//   //         printContent += `
//   //           <div class="a4-page">
//   //             ${
//   //               watermark
//   //                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                 : ""
//   //             }
//   //             <div style="margin:0; padding:0;">
//   //               ${processedCoverHTML(setName, questionPages)}
//   //             </div>
//   //             <div class="page-footer">
//   //               ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //           quesPaperInfo?.footer?.address || ""
//   //         }
//   //               <span>Set ${setName} - Cover Page</span>
//   //             </div>
//   //           </div>`;
//   //       }

//   //       // Instructions Page
//   //       if (showCoverPage && quesPaperInfo?.instructions_html) {
//   //         printContent += `
//   //     <div class="a4-page" style="padding: 20px;">
//   //       ${
//   //         watermark
//   //           ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //           : ""
//   //       }
//   //       <div class="instructions-heading-print" style="font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px;">Instructions</div>

//   //       <hr style="border: none; border-top: 1px solid #ccc; margin-bottom: 16px;" />

//   //       <div style="font-size: 14px; text-align: justify;">
//   //         ${quesPaperInfo.instructions_html}
//   //       </div>

//   //       <div class="page-footer">
//   //         ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //           quesPaperInfo?.footer?.address || ""
//   //         }
//   //         <span>Set ${setName} - Instructions</span>
//   //       </div>
//   //     </div>`;
//   //       }

//   //       // Syllabus Page
//   //       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//   //         printContent += `
//   //           <div class="a4-page" style="padding: 20px;">
//   //             ${
//   //               watermark
//   //                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                 : ""
//   //             }
//   //             <div class="syllabus-heading-print">Test Syllabus</div>
//   //             <table class="syllabus-table-print">
//   //               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//   //               <tbody>
//   //                 ${quesPaperInfo.subj_chap_list
//   //                   .map(
//   //                     (subj) => `
//   //                   <tr>
//   //                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//   //                     <td>${subj.chapters.join(", ")}</td>
//   //                   </tr>`
//   //                   )
//   //                   .join("")}
//   //               </tbody>
//   //             </table>
//   //             <div class="page-footer">
//   //               ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //           quesPaperInfo?.footer?.address || ""
//   //         }
//   //               <span>Set ${setName} - Syllabus</span>
//   //             </div>
//   //           </div>`;
//   //       }

//   //       // Questions per section
//   //       if (currentSet) {
//   //         currentSet.subjects.forEach((subject) => {
//   //           subject.sections.forEach((section) => {
//   //             const allQuestions = [...(section.questions || [])].sort(
//   //               (a, b) => a.set_ques_position - b.set_ques_position
//   //             );
//   //             if (allQuestions.length === 0) return;

//   //             const questionsPerPage = 10;
//   //             const totalPages = Math.ceil(
//   //               allQuestions.length / questionsPerPage
//   //             );
//   //             let questionIndex = 0;

//   //             for (let page = 0; page < totalPages; page++) {
//   //               const pageQuestions = allQuestions.slice(
//   //                 page * questionsPerPage,
//   //                 (page + 1) * questionsPerPage
//   //               );
//   //               const mid = Math.ceil(pageQuestions.length / 2);
//   //               const leftQuestions = pageQuestions.slice(0, mid);
//   //               const rightQuestions = pageQuestions.slice(mid);

//   //               let subjectHtml = `
//   //                 <p class="section-heading__Pre-ques" style="padding-left: 15px;" >Section ${
//   //                   section.section_name
//   //                 }</p>
//   //                 <p><strong style="padding-left: 15px;">Instruction:</strong> ${
//   //                   section.section_instruction?.trim()
//   //                     ? renderQuestionTextForPrint(section.section_instruction)
//   //                     : "N/A"
//   //                 }</p>
//   //                 <div class="page-header__pre-ques">
//   //                   <div>${quesPaperInfo?.header?.date || ""}</div>
//   //                   <div>${subject.subject_name}</div>
//   //                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//   //                 </div>`;

//   //               if (twinColumn) {
//   //                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//   //                 leftQuestions.forEach((ques) => {
//   //                   subjectHtml += `
//   //                     <div class="question-block">
//   //                       <p><strong>${
//   //                         questionIndex + 1
//   //                       }.</strong> ${renderQuestionTextForPrint(
//   //                     ques.ques_text
//   //                   )}</p>
//   //                       <div class="options__pre-ques">
//   //                         ${ques.options
//   //                           .sort(
//   //                             (a, b) =>
//   //                               a.set_option_position - b.set_option_position
//   //                           )
//   //                           .map(
//   //                             (opt, i) =>
//   //                               `<p><span>${getOptionLabel(
//   //                                 i,
//   //                                 quesPaperInfo?.option_naming_pattern
//   //                               )}</span> ${renderQuestionTextForPrint(
//   //                                 opt.option_text
//   //                               )}</p>`
//   //                           )
//   //                           .join("")}
//   //                       </div>
//   //                     </div>`;
//   //                   questionIndex++;
//   //                 });
//   //                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//   //                 rightQuestions.forEach((ques) => {
//   //                   subjectHtml += `
//   //                     <div class="question-block">
//   //                       <p><strong>${
//   //                         questionIndex + 1
//   //                       }.</strong> ${renderQuestionTextForPrint(
//   //                     ques.ques_text
//   //                   )}</p>
//   //                       <div class="options__pre-ques">
//   //                         ${ques.options
//   //                           .sort(
//   //                             (a, b) =>
//   //                               a.set_option_position - b.set_option_position
//   //                           )
//   //                           .map(
//   //                             (opt, i) =>
//   //                               `<p><span>${getOptionLabel(
//   //                                 i,
//   //                                 quesPaperInfo?.option_naming_pattern
//   //                               )}</span> ${renderQuestionTextForPrint(
//   //                                 opt.option_text
//   //                               )}</p>`
//   //                           )
//   //                           .join("")}
//   //                       </div>
//   //                     </div>`;
//   //                   questionIndex++;
//   //                 });
//   //                 subjectHtml += `</div></div>`;
//   //                 if (roughPage) {
//   //                   const isLastPage = page === totalPages - 1;
//   //                   const roughMinHeight = isLastPage ? "100px" : "200px";
//   //                   subjectHtml += `
//   //   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//   //     <strong>Rough Work:</strong>
//   //   </div>
//   // `;
//   //                 }
//   //               } else {
//   //                 pageQuestions.forEach((ques) => {
//   //                   subjectHtml += `
//   //                     <div class="question-block">
//   //                       <p><strong>${
//   //                         questionIndex + 1
//   //                       }.</strong> ${renderQuestionTextForPrint(
//   //                     ques.ques_text
//   //                   )}</p>
//   //                       <div class="options__pre-ques">
//   //                         ${ques.options
//   //                           .sort(
//   //                             (a, b) =>
//   //                               a.set_option_position - b.set_option_position
//   //                           )
//   //                           .map(
//   //                             (opt, i) =>
//   //                               `<p><span>${getOptionLabel(
//   //                                 i,
//   //                                 quesPaperInfo?.option_naming_pattern
//   //                               )}</span> ${renderQuestionTextForPrint(
//   //                                 opt.option_text
//   //                               )}</p>`
//   //                           )
//   //                           .join("")}
//   //                       </div>
//   //                     </div>`;
//   //                   questionIndex++;
//   //                 });

//   //                 if (roughPage) {
//   //                   const isLastPage = page === totalPages - 1;
//   //                   const roughMinHeight = isLastPage ? "100px" : "200px";
//   //                   subjectHtml += `
//   //   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//   //     <strong>Rough Work:</strong>
//   //   </div>
//   // `;
//   //                 }
//   //               }

//   //               printContent += `
//   //                 <div class="a4-page">
//   //                   ${
//   //                     watermark
//   //                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                       : ""
//   //                   }
//   //                   ${subjectHtml}
//   //                   <div class="page-footer">
//   //                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //                 quesPaperInfo?.footer?.address || ""
//   //               }
//   //                     <span>Page ${questionPageNum++}</span>
//   //                   </div>
//   //                 </div>`;
//   //             }
//   //           });
//   //         });
//   //       }
//   //     });

//   //     const printSectionId = "printSectionDynamic";
//   //     let printSection = document.getElementById(printSectionId);
//   //     if (printSection) document.body.removeChild(printSection);
//   //     printSection = document.createElement("div");
//   //     printSection.id = printSectionId;
//   //     printSection.innerHTML = printContent;
//   //     document.body.appendChild(printSection);
//   //     console.log(printContent);
//   //     window.print();

//   //     setTimeout(() => {
//   //       if (printSection) document.body.removeChild(printSection);
//   //     }, 500);
//   //   };

//   // const handleDownloadWord = () => {
//   //   const calculateTotalPagesForPrint = (set) => {
//   //     let total = 0;
//   //     let questionPages = 0;

//   //     if (showCoverPage) total++;
//   //     if (quesPaperInfo?.subj_chap_list?.length) total++;

//   //     if (!set) return { total, questionPages };

//   //     set.subjects.forEach((subject) => {
//   //       subject.sections.forEach((section) => {
//   //         if ((section.questions || []).length > 0) {
//   //           const questionsPerPage = 10;
//   //           const pages = Math.ceil(
//   //             section.questions.length / questionsPerPage
//   //           );
//   //           total += pages;
//   //           questionPages += pages;
//   //         }
//   //       });
//   //     });

//   //     return { total, questionPages };
//   //   };

//   //   const renderQuestionTextForPrint = (text) => {
//   //     if (!text) return "";
//   //     const decoded = he.decode(text);
//   //     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//   //     return parts
//   //       .map((segment, idx) => {
//   //         if (segment.startsWith("imgsrc=")) {
//   //           const url = segment.replace("imgsrc=", "");
//   //           return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//   //         } else {
//   //           return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//   //             try {
//   //               return katex.renderToString(math, { throwOnError: false });
//   //             } catch (e) {
//   //               return `<span style="color:red;">Invalid LaTeX</span>`;
//   //             }
//   //           });
//   //         }
//   //       })
//   //       .join("");
//   //   };

//   //   const processedCoverHTML = (setName, totalQuesPages) => {
//   //     if (!quesPaperInfo?.paper_cover) return "";
//   //     const testDate = new Date().toLocaleDateString("en-GB");
//   //     return quesPaperInfo.paper_cover
//   //       .replace(/#total_pages#/gi, totalQuesPages)
//   //       .replace(/#test_date#/gi, testDate)
//   //       .replace(/#set_name#/gi, setName);
//   //   };

//   //   let printContent = ``;

//   //   selectedSetNames.forEach((setName) => {
//   //     const currentSet = questionData.find((set) => set.set_name === setName);
//   //     const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//   //     let questionPageNum = 1;

//   //     if (showCoverPage && quesPaperInfo?.paper_cover) {
//   //       printContent += `
//   //         <div class="a4-page">
//   //           ${
//   //             watermark
//   //               ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //               : ""
//   //           }
//   //           <div class="page-content">
//   //             ${processedCoverHTML(setName, questionPages)}
//   //           </div>
//   //           <div class="page-footer">
//   //             ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //         quesPaperInfo?.footer?.address || ""
//   //       }
//   //             <span>Set ${setName} - Cover Page</span>
//   //           </div>
//   //         </div>`;
//   //     }

//   //     if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//   //       printContent += `
//   //         <div class="a4-page">
//   //           ${
//   //             watermark
//   //               ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //               : ""
//   //           }
//   //           <div class="page-content">
//   //             <div class="syllabus-heading-print">Test Syllabus</div>
//   //             <table class="syllabus-table-print">
//   //               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//   //               <tbody>
//   //                 ${quesPaperInfo.subj_chap_list
//   //                   .map(
//   //                     (subj) => `
//   //                   <tr>
//   //                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//   //                     <td>${subj.chapters.join(", ")}</td>
//   //                   </tr>`
//   //                   )
//   //                   .join("")}
//   //               </tbody>
//   //             </table>
//   //           </div>
//   //           <div class="page-footer">
//   //             ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //         quesPaperInfo?.footer?.address || ""
//   //       }
//   //             <span>Set ${setName} - Syllabus</span>
//   //           </div>
//   //         </div>`;
//   //     }

//   //     if (currentSet) {
//   //       currentSet.subjects.forEach((subject) => {
//   //         subject.sections.forEach((section) => {
//   //           const allQuestions = [...(section.questions || [])].sort(
//   //             (a, b) => a.set_ques_position - b.set_ques_position
//   //           );
//   //           if (allQuestions.length === 0) return;

//   //           const questionsPerPage = 10;
//   //           const totalPages = Math.ceil(
//   //             allQuestions.length / questionsPerPage
//   //           );
//   //           let questionIndex = 0;

//   //           for (let page = 0; page < totalPages; page++) {
//   //             const pageQuestions = allQuestions.slice(
//   //               page * questionsPerPage,
//   //               (page + 1) * questionsPerPage
//   //             );
//   //             const mid = Math.ceil(pageQuestions.length / 2);
//   //             const leftQuestions = pageQuestions.slice(0, mid);
//   //             const rightQuestions = pageQuestions.slice(mid);

//   //             let subjectHtml = `
//   //               <p class="section-heading__Pre-ques">Section ${
//   //                 section.section_name
//   //               }</p>
//   //               <p><strong>Instruction:</strong> ${
//   //                 section.section_instruction?.trim()
//   //                   ? renderQuestionTextForPrint(section.section_instruction)
//   //                   : "N/A"
//   //               }</p>
//   //               <div class="page-header__pre-ques">
//   //                 <div>${quesPaperInfo?.header?.date || ""}</div>
//   //                 <div>${subject.subject_name}</div>
//   //                 <div>${quesPaperInfo?.header?.test_name || ""}</div>
//   //               </div>`;

//   //             if (twinColumn) {
//   //               subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//   //               leftQuestions.forEach((ques) => {
//   //                 subjectHtml += `
//   //                   <div class="question-block">
//   //                     <p><strong>${
//   //                       questionIndex + 1
//   //                     }.</strong> ${renderQuestionTextForPrint(
//   //                   ques.ques_text
//   //                 )}</p>
//   //                     <div class="options__pre-ques">
//   //                       ${ques.options
//   //                         .sort(
//   //                           (a, b) =>
//   //                             a.set_option_position - b.set_option_position
//   //                         )
//   //                         .map(
//   //                           (opt, i) =>
//   //                             `<p><span>${getOptionLabel(
//   //                               i,
//   //                               quesPaperInfo?.option_naming_pattern
//   //                             )}</span> ${renderQuestionTextForPrint(
//   //                               opt.option_text
//   //                             )}</p>`
//   //                         )
//   //                         .join("")}
//   //                     </div>
//   //                   </div>`;
//   //                 questionIndex++;
//   //               });
//   //               subjectHtml += `</div><div class="question-column__pre-ques">`;
//   //               rightQuestions.forEach((ques) => {
//   //                 subjectHtml += `
//   //                   <div class="question-block">
//   //                     <p><strong>${
//   //                       questionIndex + 1
//   //                     }.</strong> ${renderQuestionTextForPrint(
//   //                   ques.ques_text
//   //                 )}</p>
//   //                     <div class="options__pre-ques">
//   //                       ${ques.options
//   //                         .sort(
//   //                           (a, b) =>
//   //                             a.set_option_position - b.set_option_position
//   //                         )
//   //                         .map(
//   //                           (opt, i) =>
//   //                             `<p><span>${getOptionLabel(
//   //                               i,
//   //                               quesPaperInfo?.option_naming_pattern
//   //                             )}</span> ${renderQuestionTextForPrint(
//   //                               opt.option_text
//   //                             )}</p>`
//   //                         )
//   //                         .join("")}
//   //                     </div>
//   //                   </div>`;
//   //                 questionIndex++;
//   //               });
//   //               subjectHtml += `</div></div>`;
//   //             } else {
//   //               pageQuestions.forEach((ques) => {
//   //                 subjectHtml += `
//   //                   <div class="question-block">
//   //                     <p><strong>${
//   //                       questionIndex + 1
//   //                     }.</strong> ${renderQuestionTextForPrint(
//   //                   ques.ques_text
//   //                 )}</p>
//   //                     <div class="options__pre-ques">
//   //                       ${ques.options
//   //                         .sort(
//   //                           (a, b) =>
//   //                             a.set_option_position - b.set_option_position
//   //                         )
//   //                         .map(
//   //                           (opt, i) =>
//   //                             `<p><span>${getOptionLabel(
//   //                               i,
//   //                               quesPaperInfo?.option_naming_pattern
//   //                             )}</span> ${renderQuestionTextForPrint(
//   //                               opt.option_text
//   //                             )}</p>`
//   //                         )
//   //                         .join("")}
//   //                     </div>
//   //                   </div>`;
//   //                 questionIndex++;
//   //               });
//   //             }

//   //             printContent += `
//   //               <div class="a4-page">
//   //                 ${
//   //                   watermark
//   //                     ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                     : ""
//   //                 }
//   //                 <div class="page-content">${subjectHtml}</div>
//   //                 <div class="page-footer">
//   //                   ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //               quesPaperInfo?.footer?.address || ""
//   //             }
//   //                   <span>Page ${questionPageNum++}</span>
//   //                 </div>
//   //               </div>`;
//   //           }
//   //         });
//   //       });
//   //     }
//   //   });

//   //   const styledHTML = `
//   //     <html>
//   //       <head>
//   //         <meta charset="utf-8">
//   //         <style>
//   //           @page { size: A4; margin: 0; }
//   //           body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//   //           .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//   //           .page-content { max-width: 180mm; margin: auto; }
//   //           .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//   //           .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//   //           .question-block { margin-bottom: 14px; break-inside: avoid; }
//   //           .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//   //           .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//   //           .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//   //           .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//   //           .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//   //           .syllabus-table-print th { background-color: #f0f0f0; }
//   //           .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//   //         </style>
//   //       </head>
//   //       <body>
//   //         ${printContent}
//   //         <footer>
//   //           ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//   //           ${
//   //             quesPaperInfo?.footer?.address ||
//   //             "B â€“ 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//   //           }
//   //         </footer>
//   //       </body>
//   //     </html>
//   //   `;

//   //   const blob = new Blob([styledHTML], {
//   //     type: "application/msword;charset=utf-8",
//   //   });
//   //   const filename = `${
//   //     quesPaperInfo?.ques_paper_name || "question-paper"
//   //   }.doc`;
//   //   const link = document.createElement("a");
//   //   link.href = URL.createObjectURL(blob);
//   //   link.download = filename;
//   //   link.click();
//   // };

//   // const handleDownloadPDF = () => {
//   //   if (!questionData || questionData.length === 0) return;

//   //   const doc = new jsPDF("p", "mm", "a4");

//   //   const generatePDFForSet = (set, callback) => {
//   //     const setName = set.set_name;
//   //     const syllabusRows = quesPaperInfo?.subj_chap_list?.map((item) => [
//   //       item.subject_name,
//   //       item.chapters.join(", "),
//   //     ]);

//   //     doc.html(processedCoverHTML(setName), {
//   //       callback: () => {
//   //         // Syllabus Page
//   //         doc.addPage();
//   //         doc.setFontSize(16);
//   //         doc.text("Test Syllabus", 105, 20, { align: "center" });

//   //         if (syllabusRows?.length) {
//   //           doc.autoTable({
//   //             head: [["Subject", "Chapters"]],
//   //             body: syllabusRows,
//   //             startY: 30,
//   //             styles: { fontSize: 10 },
//   //             headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//   //             theme: "grid",
//   //           });
//   //         }

//   //         // Add question summary next
//   //         doc.addPage();
//   //         doc.setFontSize(16);
//   //         doc.text(`Set ${setName} - Question Paper Summary`, 14, 20);

//   //         set.subjects.forEach((subject) => {
//   //           const sectionRows = [];

//   //           subject.sections.forEach((section) => {
//   //             (section.questions || []).forEach((ques, index) => {
//   //               const questionText = he
//   //                 .decode(ques.ques_text)
//   //                 .replace(/(<([^>]+)>)/gi, "")
//   //                 .slice(0, 100);
//   //               sectionRows.push([
//   //                 section.section_name,
//   //                 `${index + 1}`,
//   //                 questionText,
//   //                 subject.subject_name,
//   //                 ques.ques_id || "",
//   //               ]);
//   //             });
//   //           });

//   //           if (sectionRows.length > 0) {
//   //             doc.autoTable({
//   //               head: [
//   //                 ["Section", "Q No", "Question Text", "Subject", "Ques ID"],
//   //               ],
//   //               body: sectionRows,
//   //               startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 30,
//   //               styles: { fontSize: 8 },
//   //               headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//   //             });
//   //           }

//   //           doc.addPage(); // optional: remove if not needed per subject
//   //         });

//   //         callback();
//   //       },
//   //       x: 10,
//   //       y: 10,
//   //       margin: 10,
//   //       html2canvas: { scale: 0.4 },
//   //     });
//   //   };

//   //   const setsToProcess = questionData.filter((set) =>
//   //     selectedSetNames.includes(set.set_name)
//   //   );
//   //   let index = 0;

//   //   const processNextSet = () => {
//   //     if (index < setsToProcess.length) {
//   //       generatePDFForSet(setsToProcess[index], () => {
//   //         index++;
//   //         processNextSet();
//   //       });
//   //     } else {
//   //       doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);
//   //     }
//   //   };

//   //   processNextSet();
//   // };
//   const PAGE_CONTENT_HEIGHT_PX = 2100;
//   useEffect(() => {
//     const calculateDynamicPages = () => {
//       if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//         setPaginatedPages([]);
//         return;
//       }

//       // A4 page configuration
//       // A4 is 297mm high, minus margins (~40mm) leaves ~257mm usable height
//       // 1mm ≈ 3.78px, so 257mm ≈ 970px
//       // const PAGE_CONTENT_HEIGHT_PX = 960;
//       // const ROUGH_WORK_MIN_HEIGHT_PX = 100;
//       // Updated - uses more of the A4 page (approximately 75-80% of available space)

//       const ROUGH_WORK_MIN_HEIGHT_PX = 50; // Reduced slightly to accommodate more content

//       const newPages = [];
//       const setsToRender = questionData.filter((set) =>
//         selectedSetNames.includes(set.set_name)
//       );

//       // Create hidden measurement container
//       const measureContainer = document.createElement("div");
//       measureContainer.style.position = "absolute";
//       measureContainer.style.visibility = "hidden";
//       measureContainer.style.left = "-9999px";
//       measureContainer.style.width = "calc(210mm - 40mm)"; // A4 width minus margins
//       measureContainer.style.fontFamily = "Calibri, sans-serif";
//       measureContainer.style.fontSize = "14px";
//       measureContainer.style.lineHeight = "1.4";
//       document.body.appendChild(measureContainer);

//       setsToRender.forEach((set) => {
//         let questionPageCounter = 1;

//         // Add Cover Page
//         if (showCoverPage && quesPaperInfo.paper_cover) {
//           newPages.push({
//             type: "cover",
//             key: `cover-${set.set_name}`,
//             setName: set.set_name,
//             totalQuestionPages: "Dynamic",
//           });
//         }

//         // Add Instructions Page
//         if (showCoverPage && quesPaperInfo.instructions_html) {
//           newPages.push({
//             type: "instructions",
//             key: `instructions-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Add Syllabus Page
//         if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//           newPages.push({
//             type: "syllabus",
//             key: `syllabus-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Dynamic Question Pagination
//         set.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             let currentPageQuestions = [];
//             let questionIndexOffset = 0;

//             // Measure section header height
//             const sectionHeaderHTML = `
//             <p style="font-size: 16px; font-weight: 600; margin: 20px 0 4px 0;">Section ${
//               section.section_name
//             }</p>
//             <p style="margin: 0 0 8px 0;">Instruction: ${
//               section.section_instruction?.trim()
//                 ? renderContentToHTML(section.section_instruction)
//                 : "N/A"
//             }</p>
//             <div style="display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc;">
//               <div>${quesPaperInfo?.header?.date || ""}</div>
//               <div>${subject.subject_name}</div>
//               <div>${quesPaperInfo?.header?.test_name || ""}</div>
//             </div>`;

//             measureContainer.innerHTML = sectionHeaderHTML;
//             let currentHeight = measureContainer.offsetHeight;

//             allQuestions.forEach((ques, index) => {
//               // Create HTML for single question to measure
//               const questionHTML = `
//               <div style="margin-bottom: 14px; page-break-inside: avoid;">
//                 <p style="margin: 0 0 4px 0; line-height: 1.4;">
//                   <strong>${
//                     questionIndexOffset + currentPageQuestions.length + 1
//                   }.</strong>
//                   ${renderContentToHTML(ques.ques_text)}
//                 </p>
//                 <div style="margin-left: 16px;">
//                   ${ques.options
//                     .sort(
//                       (a, b) => a.set_option_position - b.set_option_position
//                     )
//                     .map(
//                       (opt, i) => `
//                       <p style="margin: 4px 0; font-size: 14px; line-height: 1.3;">
//                         ${getOptionLabel(
//                           i,
//                           quesPaperInfo?.option_naming_pattern
//                         )} ${renderContentToHTML(opt.option_text)}
//                       </p>
//                     `
//                     )
//                     .join("")}
//                 </div>
//               </div>`;

//               // Measure question height
//               const tempDiv = document.createElement("div");
//               if (twinColumn) {
//                 tempDiv.style.width = "50%";
//               }
//               tempDiv.innerHTML = questionHTML;
//               measureContainer.innerHTML = "";
//               measureContainer.appendChild(tempDiv);

//               const questionHeight = tempDiv.offsetHeight;
//               const isLastQuestion = index === allQuestions.length - 1;
//               const roughWorkHeight =
//                 roughPage && isLastQuestion ? ROUGH_WORK_MIN_HEIGHT_PX : 0;

//               // Check if adding this question exceeds page height
//               if (
//                 currentHeight + questionHeight + roughWorkHeight >
//                   PAGE_CONTENT_HEIGHT_PX &&
//                 currentPageQuestions.length > 0
//               ) {
//                 // Page is full, save current page
//                 newPages.push({
//                   type: "questions",
//                   key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                   setName: set.set_name,
//                   subject,
//                   section,
//                   questions: currentPageQuestions,
//                   questionIndexOffset,
//                   pageNumber: questionPageCounter++,
//                   isLastPageInSection: false,
//                 });

//                 // Start new page
//                 questionIndexOffset += currentPageQuestions.length;
//                 currentPageQuestions = [ques];
//                 measureContainer.innerHTML = sectionHeaderHTML;
//                 currentHeight = measureContainer.offsetHeight + questionHeight;
//               } else {
//                 // Add question to current page
//                 currentPageQuestions.push(ques);
//                 currentHeight += questionHeight;
//               }
//             });

//             // Add final page for section
//             if (currentPageQuestions.length > 0) {
//               newPages.push({
//                 type: "questions",
//                 key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                 setName: set.set_name,
//                 subject,
//                 section,
//                 questions: currentPageQuestions,
//                 questionIndexOffset,
//                 pageNumber: questionPageCounter++,
//                 isLastPageInSection: true,
//               });
//             }
//           });
//         });

//         // Update cover page with actual question page count
//         const totalQPagesForSet = newPages.filter(
//           (p) => p.type === "questions" && p.setName === set.set_name
//         ).length;
//         const coverPageIndex = newPages.findIndex(
//           (p) => p.type === "cover" && p.setName === set.set_name
//         );
//         if (coverPageIndex > -1) {
//           newPages[coverPageIndex].totalQuestionPages = totalQPagesForSet;
//         }
//       });

//       // Cleanup
//       document.body.removeChild(measureContainer);
//       setPaginatedPages(newPages);
//     };

//     const timeoutId = setTimeout(calculateDynamicPages, 100);
//     return () => clearTimeout(timeoutId);
//   }, [
//     questionData,
//     quesPaperInfo,
//     selectedSetNames,
//     showCoverPage,
//     twinColumn,
//     roughPage,
//     watermark,
//   ]);

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <button
//                   className="icon-btn__pre-ques"
//                   style={{ marginRight: "70px" }}
//                   onClick={handlePrint}
//                 >
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {paginatedPages.length > 0 ? (
//                 paginatedPages.map((page) => (
//                   <div
//                     className={`a4-page${
//                       roughPage && page.type === "questions"
//                         ? " has-roughwork"
//                         : ""
//                     }`}
//                     key={page.key}
//                   >
//                     {watermark && (
//                       <img
//                         src={watermarkImg}
//                         alt="watermark"
//                         className="watermark-image"
//                       />
//                     )}

//                     {/* Page Content */}
//                     {page.type === "cover" && (
//                       <div
//                         dangerouslySetInnerHTML={{
//                           __html: quesPaperInfo.paper_cover
//                             .replace(/#total_pages#/gi, page.totalQuestionPages)
//                             .replace(
//                               /#test_date#/gi,
//                               new Date().toLocaleDateString("en-GB")
//                             )
//                             .replace(/#set_name#/gi, page.setName),
//                         }}
//                       />
//                     )}

//                     {page.type === "instructions" && (
//                       <div className="instructions-page">
//                         <div className="instructions-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Instructions</h2>
//                           <hr
//                             style={{
//                               border: "none",
//                               borderTop: `1px solid ${Colors.color4}`,
//                               margin: "1rem 0",
//                             }}
//                           />
//                         </div>
//                         <div
//                           dangerouslySetInnerHTML={{
//                             __html: quesPaperInfo.instructions_html,
//                           }}
//                         />
//                       </div>
//                     )}

//                     {page.type === "syllabus" && (
//                       <div className="syllabus-page">
//                         <div className="syllabus-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Test Syllabus</h2>
//                         </div>
//                         <table className="syllabus-table_prev_ques">
//                           <thead>
//                             <tr>
//                               <th>Subject</th>
//                               <th>Chapters</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                               <tr key={idx}>
//                                 <td>
//                                   <strong>
//                                     {subj.subject_name.toUpperCase()}
//                                   </strong>
//                                 </td>
//                                 <td>{subj.chapters.join(", ")}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}

//                     {page.type === "questions" && (
//                       <div
//                         className="section-container__pre-ques"
//                         style={{ position: "relative", minHeight: "530px" }}
//                       >
//                         <p className="section-heading__Pre-ques">
//                           Section {page.section.section_name}
//                         </p>
//                         <p>
//                           Instruction:{" "}
//                           {page.section.section_instruction?.trim()
//                             ? renderQuestionText(
//                                 page.section.section_instruction
//                               )
//                             : "N/A"}
//                         </p>
//                         <div className="page-header__pre-ques">
//                           <div className="header-left__pre-ques">
//                             {quesPaperInfo?.header?.date}
//                           </div>
//                           <div className="header-center__pre-ques">
//                             {page.subject.subject_name}
//                           </div>
//                           <div className="header-right__pre-ques">
//                             {quesPaperInfo?.header?.test_name}
//                           </div>
//                         </div>

//                         {(() => {
//                           const questions = page.questions;
//                           const mid = Math.ceil(questions.length / 2);
//                           const leftQuestions = questions.slice(0, mid);
//                           const rightQuestions = questions.slice(mid);

//                           return twinColumn ? (
//                             <div className="question-grid__pre-ques">
//                               <div className="question-column__pre-ques">
//                                 {leftQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset + index + 1}.
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                               <div className="question-column__pre-ques">
//                                 {rightQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset +
//                                           mid +
//                                           index +
//                                           1}
//                                         .
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                             </div>
//                           ) : (
//                             <div>
//                               {questions.map((ques, index) => (
//                                 <div
//                                   key={ques.ques_id}
//                                   className="question-block"
//                                 >
//                                   <p>
//                                     <strong>
//                                       {page.questionIndexOffset + index + 1}.
//                                     </strong>{" "}
//                                     {renderQuestionText(ques.ques_text)}
//                                   </p>
//                                   <div className="options__pre-ques">
//                                     {[...ques.options]
//                                       .sort(
//                                         (a, b) =>
//                                           a.set_option_position -
//                                           b.set_option_position
//                                       )
//                                       .map((opt, idx) => (
//                                         <p key={opt.option_id}>
//                                           <span>
//                                             {getOptionLabel(
//                                               idx,
//                                               quesPaperInfo?.option_naming_pattern
//                                             )}
//                                           </span>{" "}
//                                           {renderQuestionText(opt.option_text)}
//                                         </p>
//                                       ))}
//                                   </div>
//                                 </div>
//                               ))}
//                             </div>
//                           );
//                         })()}

//                         {roughPage && (
//                           <div
//                             className="rough-work-section"
//                             style={{
//                               minHeight: page.isLastPageInSection
//                                 ? "100px"
//                                 : "200px",
//                             }}
//                           >
//                             <strong>Rough Work:</strong>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Page Footer */}
//                     <div className="page-footer">
//                       <div className="footer-left">
//                         {quesPaperInfo?.footer?.client_name} |{" "}
//                         {quesPaperInfo?.footer?.address}
//                       </div>
//                       <div className="footer-right">
//                         {page.type === "cover" &&
//                           `Set ${page.setName} - Cover Page`}
//                         {page.type === "syllabus" &&
//                           `Set ${page.setName} - Syllabus`}
//                         {page.type === "questions" && `Page ${page.pageNumber}`}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";
// import Colors from "../../../Constants/Colors";
// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const [paginatedPages, setPaginatedPages] = useState([]);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Add this helper function to render content to HTML for measurement
//   const renderContentToHTML = (text) => {
//     if (!text) return "";
//     const decoded = he.decode(text);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts
//       .map((segment) => {
//         if (segment.startsWith("imgsrc=")) {
//           const url = segment.replace("imgsrc=", "");
//           return `<img src="${url}" alt="image" style="max-width: 80px; height: auto; vertical-align: middle; margin: 0 5px;" />`;
//         } else {
//           return segment.replace(/\\\((.*?)\\\)/g, (_, math) => {
//             try {
//               return katex.renderToString(math, {
//                 throwOnError: false,
//                 displayMode: false,
//               });
//             } catch (e) {
//               console.warn("Katex rendering error:", e);
//               return `<span style="color:red;">[LaTeX Error]</span>`;
//             }
//           });
//         }
//       })
//       .join("");
//   };

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     if (!paginatedPages || paginatedPages.length === 0) {
//       alert("There is no content to print.");
//       return;
//     }

//     // Helper to process cover page HTML
//     const getProcessedCoverHTML = (page) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, page.totalQuestionPages)
//         .replace(/#test_date#/gi, new Date().toLocaleDateString("en-GB"))
//         .replace(/#set_name#/gi, page.setName);
//     };

//     let printContent = `
//     <style>
//       body, html { margin: 0 !important; padding: 0 !important; background-color: #fff; font-family: Calibri, sans-serif; }
//       .a4-page { width: 210mm; min-height: 297mm; margin: 0 auto; padding: 8mm; box-sizing: border-box; background: white; position: relative; page-break-after: always; }
      
//       .page-content-wrapper { 
//         height: calc(297mm - 15mm); 
//         position: relative; 
//         padding-bottom: 15mm; /* Reduced from 25mm */
//         overflow: hidden;
//       }
//         .question-block img,
//   .question-grid__pre-ques img,
//   .question-column__pre-ques img,
//   .options__pre-ques img {
//     width: 30px !important;
//     height: auto !important;
//     margin: 5px !important;
//     vertical-align: middle !important;
//   }

//       .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//       .watermark img { width: 300px; height: auto; }
//       .section-heading__Pre-ques { font-size: 16px; font-weight: 600; margin: 0px 0 2px 0; padding-left: 15px; } /* Reduced margin */
//       .question-grid__pre-ques { display: flex; gap: 15px; } /* Reduced gap */
//       .question-column__pre-ques { flex: 1; min-width: 0; }
//       .question-block { margin-bottom: 6px; page-break-inside: avoid; } /* Reduced margin */
//       .question-block p { margin: 0 0 2px 0; line-height: 1.2; } /* Reduced line-height and margin */
//       .options__pre-ques p { margin: 2px 0 0px 16px; font-size: 14px; line-height: 1.1; } /* Reduced margins and line-height */
//       .page-footer { 
//         position: absolute; 
//         bottom: 5mm; 
//         left: 8mm; 
//         right: 8mm; 
//         height: 12mm; /* Reduced height */
//         text-align: center; 
//         font-size: 11px; 
//         border-top: 1px solid #ccc; 
//         padding-top: 3px; /* Reduced padding */
//         color: #444; 
//         display: flex; 
//         justify-content: space-between;
//         background: white;
//         z-index: 10;
//       }
//       .page-header__pre-ques { display: flex; justify-content: space-between; font-size: 13px; padding: 3px 12px; margin-bottom: 4px; border-bottom: 1px solid #ccc; } /* Reduced padding and margin */
//       .rough-work-section { margin-top: 10px !important; 
//       border-top: 1px dashed #ccc !important; 
//       padding-top: 5px !important; 
//       min-height: 40px !important;
//       page-break-inside: avoid !important;
//       break-inside: avoid !important;
//       page-break-before: avoid !important;} /* Reduced spacing */
//       .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 3px; padding-bottom: 5px; } /* Reduced margins */
//       .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//       .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 6px; text-align: left; vertical-align: top; } /* Reduced padding */
//       .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//       .instructions-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 3px; padding-bottom: 5px; } /* Reduced margins */
//       .instructions-content { margin-top: 3px; } /* Reduced margin */
//       @media print {
//         body * { visibility: hidden !important; }
//         #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//         #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         .rough-work-section {
//         page-break-inside: avoid !important;
//         break-inside: avoid !important;
//         orphans: 3;
//         widows: 3;
//       }
//       }
//       @page { size: A4; margin: 0; }
//     </style>
//   `;

//     // Iterate through the already calculated paginatedPages
//     paginatedPages.forEach((page) => {
//       printContent += `<div class="a4-page">`;

//       // Add watermark if enabled
//       if (watermark) {
//         printContent += `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`;
//       }

//       printContent += `<div class="page-content-wrapper">`;

//       // Generate content based on page type
//       switch (page.type) {
//         case "cover":
//           printContent += `
//     <div class="cover-page-optimal" style="
//       transform: scale(0.9) !important; /* Balanced shrinking - 15% shrink */
//       transform-origin: top center !important;
//       width: 205mm !important; /* Precise compensation (100/0.85) */
//       height: 297mm !important; /* Use mm consistently - A4 height minus footer/margins */
//       font-size: 11.5px !important; /* Good readability */
//       line-height: 1.15 !important; /* Optimal line spacing */
//       margin: 0 !important;
//       padding: 0px !important; /* Efficient padding in mm */
//       max-height: 297mm !important; /* Safe maximum in mm */
//       overflow: hidden !important;
//       box-sizing: border-box !important;
//       position: absolute !important;
//       top: 0 !important;
//       left: 0 !important;
//       background: white !important;
//     ">
//       ${getProcessedCoverHTML(page)}
//     </div>`;
//           break;

//         case "instructions":
//           printContent += `
//           <div class="instructions-heading-print">Instructions</div>
//           <hr style="border: none; border-top: 1px solid #ccc; margin: 5px 0;" />
//           <div class="instructions-content" style="font-size: 14px; text-align: justify;">${quesPaperInfo.instructions_html}</div>`;
//           break;

//         case "syllabus":
//           printContent += `
//           <div class="syllabus-heading-print">Test Syllabus</div>
//           <table class="syllabus-table-print">
//             <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//             <tbody>
//               ${quesPaperInfo.subj_chap_list
//                 .map(
//                   (s) => `
//                 <tr>
//                   <td><strong>${s.subject_name.toUpperCase()}</strong></td>
//                   <td>${s.chapters.join(", ")}</td>
//                 </tr>
//               `
//                 )
//                 .join("")}
//             </tbody>
//           </table>`;
//           break;

//         case "questions":
//           let questionsHtml = `
//           <p class="section-heading__Pre-ques">Section ${
//             page.section.section_name
//           }</p>
//           <p style="padding-left: 15px; margin: 0 0 4px 0;"><strong>Instruction:</strong> ${
//             page.section.section_instruction?.trim()
//               ? renderContentToHTML(page.section.section_instruction)
//               : "N/A"
//           }</p>
//           <div class="page-header__pre-ques">
//             <div>${quesPaperInfo?.header?.date || ""}</div>
//             <div>${page.subject.subject_name}</div>
//             <div>${quesPaperInfo?.header?.test_name || ""}</div>
//           </div>`;

//           const renderQuestionColumn = (qs, offset) =>
//             qs
//               .map(
//                 (q, i) => `
//           <div class="question-block">
//             <p><strong>${offset + i + 1}.</strong> ${renderContentToHTML(
//                   q.ques_text
//                 )}</p>
//             <div class="options__pre-ques">
//               ${q.options
//                 .sort((a, b) => a.set_option_position - b.set_option_position)
//                 .map(
//                   (opt, oi) => `
//                 <p><span>${getOptionLabel(
//                   oi,
//                   quesPaperInfo?.option_naming_pattern
//                 )}</span> ${renderContentToHTML(opt.option_text)}</p>
//               `
//                 )
//                 .join("")}
//             </div>
//           </div>`
//               )
//               .join("");

//           if (twinColumn) {
//             const mid = Math.ceil(page.questions.length / 2);
//             questionsHtml += `
//             <div class="question-grid__pre-ques">
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(0, mid),
//                 page.questionIndexOffset
//               )}</div>
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(mid),
//                 page.questionIndexOffset + mid
//               )}</div>
//             </div>`;
//           } else {
//             questionsHtml += `<div>${renderQuestionColumn(
//               page.questions,
//               page.questionIndexOffset
//             )}</div>`;
//           }

//           // Add rough work section if enabled and this is the last page of the section
//           if (roughPage) {
//             const roughWorkHeight = page.isLastPageInSection ? "60px" : "120px";
//             questionsHtml += `
//             <div class="rough-work-section" style="min-height: ${roughWorkHeight};">
//             <strong>Rough Work:</strong>
//             </div>`;
//           }

//           printContent += questionsHtml;
//           break;

//         default:
//           break;
//       }

//       printContent += `</div>`; // Close page-content-wrapper

//       // Add footer for all page types
//       printContent += `
//       <div class="page-footer">
//         <div>${quesPaperInfo?.footer?.client_name || ""} | ${
//         quesPaperInfo?.footer?.address || ""
//       }</div>
//         <div>
//           ${page.type === "cover" ? `Set ${page.setName} - Cover Page` : ""}
//           ${
//             page.type === "instructions"
//               ? `Set ${page.setName} - Instructions`
//               : ""
//           }
//           ${page.type === "syllabus" ? `Set ${page.setName} - Syllabus` : ""}
//           ${page.type === "questions" ? `Page ${page.pageNumber}` : ""}
//         </div>
//       </div>
//     `;

//       printContent += `</div>`; // Close a4-page
//     });

//     // Create and inject print section
//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);

//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);

//     // Print with a small delay to ensure rendering
//     setTimeout(() => {
//       window.print();
//       // Cleanup after printing
//       setTimeout(() => {
//         if (document.getElementById(printSectionId)) {
//           document.body.removeChild(document.getElementById(printSectionId));
//         }
//       }, 1000);
//     }, 500);
//   };

//   useEffect(() => {
//     const calculateDynamicPages = () => {
//       if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//         setPaginatedPages([]);
//         return;
//       }

//       // Adjust page content height based on layout mode
//       const BASE_PAGE_CONTENT_HEIGHT_PX = 2110;
//       const PAGE_CONTENT_HEIGHT_PX = twinColumn
//         ? BASE_PAGE_CONTENT_HEIGHT_PX
//         : BASE_PAGE_CONTENT_HEIGHT_PX * 0.55; // Reduce available height for single column to maintain consistency

//       const ROUGH_WORK_MIN_HEIGHT_PX = 40;

//       const newPages = [];
//       const setsToRender = questionData.filter((set) =>
//         selectedSetNames.includes(set.set_name)
//       );

//       // Create hidden measurement container
//       const measureContainer = document.createElement("div");
//       measureContainer.style.position = "absolute";
//       measureContainer.style.visibility = "hidden";
//       measureContainer.style.left = "-9999px";
//       measureContainer.style.width = "calc(210mm - 40mm)";
//       measureContainer.style.fontFamily = "Calibri, sans-serif";
//       measureContainer.style.fontSize = "14px";
//       measureContainer.style.lineHeight = "1.4";
//       document.body.appendChild(measureContainer);

//       setsToRender.forEach((set) => {
//         let questionPageCounter = 1;
//         let globalQuestionCounter = 0;

//         // Add Cover Page
//         if (showCoverPage && quesPaperInfo.paper_cover) {
//           newPages.push({
//             type: "cover",
//             key: `cover-${set.set_name}`,
//             setName: set.set_name,
//             totalQuestionPages: "Dynamic",
//           });
//         }

//         // Add Instructions Page
//         if (showCoverPage && quesPaperInfo.instructions_html) {
//           newPages.push({
//             type: "instructions",
//             key: `instructions-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Add Syllabus Page
//         if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//           newPages.push({
//             type: "syllabus",
//             key: `syllabus-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Dynamic Question Pagination
//         set.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             let currentPageQuestions = [];
//             let currentPageStartIndex = globalQuestionCounter;

//             // Measure section header height
//             const sectionHeaderHTML = `
//             <p style="font-size: 16px; font-weight: 600; margin: 20px 0 4px 0;">Section ${
//               section.section_name
//             }</p>
//             <p style="margin: 0 0 8px 0;">Instruction: ${
//               section.section_instruction?.trim()
//                 ? renderContentToHTML(section.section_instruction)
//                 : "N/A"
//             }</p>
//             <div style="display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc;">
//               <div>${quesPaperInfo?.header?.date || ""}</div>
//               <div>${subject.subject_name}</div>
//               <div>${quesPaperInfo?.header?.test_name || ""}</div>
//             </div>`;

//             measureContainer.innerHTML = sectionHeaderHTML;
//             let currentHeight = measureContainer.offsetHeight;

//             allQuestions.forEach((ques, index) => {
//               // Create HTML for single question to measure
//               const questionHTML = `
//               <div style="margin-bottom: 8px; page-break-inside: avoid;">
//                 <p style="margin: 0 0 3px 0; line-height: 1.3;">
//                   <strong>${
//                     globalQuestionCounter + currentPageQuestions.length + 1
//                   }.</strong> 
//                   ${renderContentToHTML(ques.ques_text)}
//                 </p>
//                 <div style="margin-left: 16px;">
//                   ${ques.options
//                     .sort(
//                       (a, b) => a.set_option_position - b.set_option_position
//                     )
//                     .map(
//                       (opt, i) => `
//                         <p style="margin: 3px 0; font-size: 14px; line-height: 1.2;">
//                           ${getOptionLabel(
//                             i,
//                             quesPaperInfo?.option_naming_pattern
//                           )} ${renderContentToHTML(opt.option_text)}
//                         </p>
//                       `
//                     )
//                     .join("")}
//                 </div>
//               </div>`;

//               // Measure question height consistently
//               const tempDiv = document.createElement("div");
//               // Always measure at consistent width for fair comparison
//               tempDiv.style.width = twinColumn ? "50%" : "100%";
//               tempDiv.innerHTML = questionHTML;
//               measureContainer.innerHTML = "";
//               measureContainer.appendChild(tempDiv);

//               let questionHeight = tempDiv.offsetHeight;

//               // Apply layout-specific height adjustment
//               if (twinColumn) {
//                 // In twin column, questions are side by side, so we can fit more vertically
//                 questionHeight = questionHeight;
//               } else {
//                 // In single column, questions take full width and stack vertically
//                 // Apply a multiplier to account for the visual difference
//                 questionHeight = questionHeight * 1.0; // Keep actual measured height
//               }

//               const isLastQuestion = index === allQuestions.length - 1;
//               const roughWorkHeight = roughPage
//                 ? isLastQuestion
//                   ? 60
//                   : 120
//                 : 0;

//               // Check if adding this question exceeds page height
//               const availableHeight = PAGE_CONTENT_HEIGHT_PX - 50;
//               const totalHeightNeeded =
//                 currentHeight + questionHeight + roughWorkHeight;

//               if (
//                 totalHeightNeeded > availableHeight &&
//                 currentPageQuestions.length > 0
//               ) {
//                 // Page is full, save current page
//                 newPages.push({
//                   type: "questions",
//                   key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                   setName: set.set_name,
//                   subject,
//                   section,
//                   questions: currentPageQuestions,
//                   questionIndexOffset: currentPageStartIndex,
//                   pageNumber: questionPageCounter++,
//                   isLastPageInSection: false,
//                 });

//                 // Update global counter and start new page
//                 globalQuestionCounter += currentPageQuestions.length;
//                 currentPageStartIndex = globalQuestionCounter;
//                 currentPageQuestions = [ques];
//                 measureContainer.innerHTML = sectionHeaderHTML;
//                 currentHeight = measureContainer.offsetHeight + questionHeight;
//               } else {
//                 // Add question to current page
//                 currentPageQuestions.push(ques);
//                 currentHeight += questionHeight;
//               }
//             });

//             // Add final page for section
//             if (currentPageQuestions.length > 0) {
//               newPages.push({
//                 type: "questions",
//                 key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                 setName: set.set_name,
//                 subject,
//                 section,
//                 questions: currentPageQuestions,
//                 questionIndexOffset: currentPageStartIndex,
//                 pageNumber: questionPageCounter++,
//                 isLastPageInSection: true,
//               });

//               globalQuestionCounter += currentPageQuestions.length;
//             }
//           });
//         });

//         // Update cover page with actual question page count
//         const totalQPagesForSet = newPages.filter(
//           (p) => p.type === "questions" && p.setName === set.set_name
//         ).length;
//         const coverPageIndex = newPages.findIndex(
//           (p) => p.type === "cover" && p.setName === set.set_name
//         );
//         if (coverPageIndex > -1) {
//           newPages[coverPageIndex].totalQuestionPages = totalQPagesForSet;
//         }
//       });

//       // Cleanup
//       document.body.removeChild(measureContainer);
//       setPaginatedPages(newPages);
//     };

//     const timeoutId = setTimeout(calculateDynamicPages, 100);
//     return () => clearTimeout(timeoutId);
//   }, [
//     questionData,
//     quesPaperInfo,
//     selectedSetNames,
//     showCoverPage,
//     twinColumn,
//     roughPage,
//     watermark,
//   ]);

//   // useEffect(() => {
//   //   const calculateDynamicPages = () => {
//   //     if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//   //       setPaginatedPages([]);
//   //       return;
//   //     }

//   //     // A4 page configuration
//   //     // A4 is 297mm high, minus margins (~40mm) leaves ~257mm usable height
//   //     // 1mm ≈ 3.78px, so 257mm ≈ 970px
//   //     // const PAGE_CONTENT_HEIGHT_PX = 960;
//   //     // const ROUGH_WORK_MIN_HEIGHT_PX = 100;
//   //     // Updated - uses more of the A4 page (approximately 75-80% of available space)
//   //     const PAGE_CONTENT_HEIGHT_PX = 2110;
//   //     const ROUGH_WORK_MIN_HEIGHT_PX = 40; // Reduced slightly to accommodate more content

//   //     const newPages = [];
//   //     const setsToRender = questionData.filter((set) =>
//   //       selectedSetNames.includes(set.set_name)
//   //     );

//   //     // Create hidden measurement container
//   //     const measureContainer = document.createElement("div");
//   //     measureContainer.style.position = "absolute";
//   //     measureContainer.style.visibility = "hidden";
//   //     measureContainer.style.left = "-9999px";
//   //     measureContainer.style.width = "calc(210mm - 40mm)"; // A4 width minus margins
//   //     measureContainer.style.fontFamily = "Calibri, sans-serif";
//   //     measureContainer.style.fontSize = "14px";
//   //     measureContainer.style.lineHeight = "1.4";
//   //     document.body.appendChild(measureContainer);

//   //     setsToRender.forEach((set) => {
//   //       let questionPageCounter = 1;

//   //       // Add Cover Page
//   //       if (showCoverPage && quesPaperInfo.paper_cover) {
//   //         newPages.push({
//   //           type: "cover",
//   //           key: `cover-${set.set_name}`,
//   //           setName: set.set_name,
//   //           totalQuestionPages: "Dynamic",
//   //         });
//   //       }

//   //       // Add Instructions Page
//   //       if (showCoverPage && quesPaperInfo.instructions_html) {
//   //         newPages.push({
//   //           type: "instructions",
//   //           key: `instructions-${set.set_name}`,
//   //           setName: set.set_name,
//   //         });
//   //       }

//   //       // Add Syllabus Page
//   //       if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//   //         newPages.push({
//   //           type: "syllabus",
//   //           key: `syllabus-${set.set_name}`,
//   //           setName: set.set_name,
//   //         });
//   //       }

//   //       // Dynamic Question Pagination
//   //       set.subjects.forEach((subject) => {
//   //         subject.sections.forEach((section) => {
//   //           const allQuestions = [...(section.questions || [])].sort(
//   //             (a, b) => a.set_ques_position - b.set_ques_position
//   //           );
//   //           if (allQuestions.length === 0) return;

//   //           let currentPageQuestions = [];
//   //           let questionIndexOffset = 0;

//   //           // Measure section header height
//   //           const sectionHeaderHTML = `
//   //           <p style="font-size: 16px; font-weight: 600; margin: 20px 0 4px 0;">Section ${
//   //             section.section_name
//   //           }</p>
//   //           <p style="margin: 0 0 8px 0;">Instruction: ${
//   //             section.section_instruction?.trim()
//   //               ? renderContentToHTML(section.section_instruction)
//   //               : "N/A"
//   //           }</p>
//   //           <div style="display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc;">
//   //             <div>${quesPaperInfo?.header?.date || ""}</div>
//   //             <div>${subject.subject_name}</div>
//   //             <div>${quesPaperInfo?.header?.test_name || ""}</div>
//   //           </div>`;

//   //           measureContainer.innerHTML = sectionHeaderHTML;
//   //           let currentHeight = measureContainer.offsetHeight;

//   //           allQuestions.forEach((ques, index) => {
//   //             // Create HTML for single question to measure
//   //             // In the questionHTML template, replace the question block div:
//   //             const questionHTML = `
//   // <div style="margin-bottom: 8px; page-break-inside: avoid;"> <!-- Reduced from 14px -->
//   //   <p style="margin: 0 0 3px 0; line-height: 1.3;"> <!-- Reduced margin and line-height -->
//   //     <strong>${
//   //       questionIndexOffset + currentPageQuestions.length + 1
//   //     }.</strong>
//   //     ${renderContentToHTML(ques.ques_text)}
//   //   </p>
//   //   <div style="margin-left: 16px;">
//   //     ${ques.options
//   //       .sort((a, b) => a.set_option_position - b.set_option_position)
//   //       .map(
//   //         (opt, i) => `
//   //           <p style="margin: 3px 0; font-size: 14px; line-height: 1.2;"> <!-- Reduced margin and line-height -->
//   //             ${getOptionLabel(
//   //               i,
//   //               quesPaperInfo?.option_naming_pattern
//   //             )} ${renderContentToHTML(opt.option_text)}
//   //           </p>
//   //         `
//   //       )
//   //       .join("")}
//   //   </div>
//   // </div>`;

//   //             // Measure question height
//   //             const tempDiv = document.createElement("div");
//   //             if (twinColumn) {
//   //               tempDiv.style.width = "50%";
//   //             }
//   //             tempDiv.innerHTML = questionHTML;
//   //             measureContainer.innerHTML = "";
//   //             measureContainer.appendChild(tempDiv);

//   //             const questionHeight = tempDiv.offsetHeight;
//   //             const isLastQuestion = index === allQuestions.length - 1;
//   //             const roughWorkHeight = roughPage
//   //               ? isLastQuestion
//   //                 ? 60
//   //                 : 120
//   //               : 0; // Match preview heights exactly

//   //             // Check if adding this question exceeds page height
//   //             const availableHeight = PAGE_CONTENT_HEIGHT_PX - 50; // Even smaller buffer
//   //             const totalHeightNeeded =
//   //               currentHeight + questionHeight + roughWorkHeight;

//   //             if (
//   //               totalHeightNeeded > availableHeight &&
//   //               currentPageQuestions.length > 0
//   //             ) {
//   //               // Page is full, save current page
//   //               newPages.push({
//   //                 type: "questions",
//   //                 key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//   //                 setName: set.set_name,
//   //                 subject,
//   //                 section,
//   //                 questions: currentPageQuestions,
//   //                 questionIndexOffset,
//   //                 pageNumber: questionPageCounter++,
//   //                 isLastPageInSection: false,
//   //               });

//   //               // Start new page
//   //               questionIndexOffset += currentPageQuestions.length;
//   //               currentPageQuestions = [ques];
//   //               measureContainer.innerHTML = sectionHeaderHTML;
//   //               currentHeight = measureContainer.offsetHeight + questionHeight;
//   //             } else {
//   //               // Add question to current page
//   //               currentPageQuestions.push(ques);
//   //               currentHeight += questionHeight;
//   //             }
//   //           });

//   //           // Add final page for section
//   //           if (currentPageQuestions.length > 0) {
//   //             newPages.push({
//   //               type: "questions",
//   //               key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//   //               setName: set.set_name,
//   //               subject,
//   //               section,
//   //               questions: currentPageQuestions,
//   //               questionIndexOffset,
//   //               pageNumber: questionPageCounter++,
//   //               isLastPageInSection: true,
//   //             });
//   //           }
//   //         });
//   //       });

//   //       // Update cover page with actual question page count
//   //       const totalQPagesForSet = newPages.filter(
//   //         (p) => p.type === "questions" && p.setName === set.set_name
//   //       ).length;
//   //       const coverPageIndex = newPages.findIndex(
//   //         (p) => p.type === "cover" && p.setName === set.set_name
//   //       );
//   //       if (coverPageIndex > -1) {
//   //         newPages[coverPageIndex].totalQuestionPages = totalQPagesForSet;
//   //       }
//   //     });

//   //     // Cleanup
//   //     document.body.removeChild(measureContainer);
//   //     setPaginatedPages(newPages);
//   //   };

//   //   const timeoutId = setTimeout(calculateDynamicPages, 100);
//   //   return () => clearTimeout(timeoutId);
//   // }, [
//   //   questionData,
//   //   quesPaperInfo,
//   //   selectedSetNames,
//   //   showCoverPage,
//   //   twinColumn,
//   //   roughPage,
//   //   watermark,
//   // ]);

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <button
//                   className="icon-btn__pre-ques"
//                   style={{ marginRight: "70px" }}
//                   onClick={handlePrint}
//                 >
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {paginatedPages.length > 0 ? (
//                 paginatedPages.map((page) => (
//                   <div
//                     className={`a4-page${
//                       roughPage && page.type === "questions"
//                         ? " has-roughwork"
//                         : ""
//                     }`}
//                     key={page.key}
//                   >
//                     {watermark && (
//                       <img
//                         src={watermarkImg}
//                         alt="watermark"
//                         className="watermark-image"
//                       />
//                     )}

//                     {/* Page Content */}
//                     {page.type === "cover" && (
//                       <div
//                         dangerouslySetInnerHTML={{
//                           __html: quesPaperInfo.paper_cover
//                             .replace(/#total_pages#/gi, page.totalQuestionPages)
//                             .replace(
//                               /#test_date#/gi,
//                               new Date().toLocaleDateString("en-GB")
//                             )
//                             .replace(/#set_name#/gi, page.setName),
//                         }}
//                       />
//                     )}

//                     {page.type === "instructions" && (
//                       <div className="instructions-page">
//                         <div className="instructions-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Instructions</h2>
//                           <hr
//                             style={{
//                               border: "none",
//                               borderTop: `1px solid ${Colors.color4}`,
//                               margin: "1rem 0",
//                             }}
//                           />
//                         </div>
//                         <div
//                           dangerouslySetInnerHTML={{
//                             __html: quesPaperInfo.instructions_html,
//                           }}
//                         />
//                       </div>
//                     )}

//                     {page.type === "syllabus" && (
//                       <div className="syllabus-page">
//                         <div className="syllabus-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Test Syllabus</h2>
//                         </div>
//                         <table className="syllabus-table_prev_ques">
//                           <thead>
//                             <tr>
//                               <th>Subject</th>
//                               <th>Chapters</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                               <tr key={idx}>
//                                 <td>
//                                   <strong>
//                                     {subj.subject_name.toUpperCase()}
//                                   </strong>
//                                 </td>
//                                 <td>{subj.chapters.join(", ")}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}

//                     {page.type === "questions" && (
//                       <div
//                         className="section-container__pre-ques"
//                         style={{ position: "relative", minHeight: "530px" }}
//                       >
//                         <p className="section-heading__Pre-ques">
//                           Section {page.section.section_name}
//                         </p>
//                         <p>
//                           Instruction:{" "}
//                           {page.section.section_instruction?.trim()
//                             ? renderQuestionText(
//                                 page.section.section_instruction
//                               )
//                             : "N/A"}
//                         </p>
//                         <div className="page-header__pre-ques">
//                           <div className="header-left__pre-ques">
//                             {quesPaperInfo?.header?.date}
//                           </div>
//                           <div className="header-center__pre-ques">
//                             {page.subject.subject_name}
//                           </div>
//                           <div className="header-right__pre-ques">
//                             {quesPaperInfo?.header?.test_name}
//                           </div>
//                         </div>

//                         {(() => {
//                           const questions = page.questions;
//                           const mid = Math.ceil(questions.length / 2);
//                           const leftQuestions = questions.slice(0, mid);
//                           const rightQuestions = questions.slice(mid);

//                           return twinColumn ? (
//                             <div className="question-grid__pre-ques">
//                               <div className="question-column__pre-ques">
//                                 {leftQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset + index + 1}.
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                               <div className="question-column__pre-ques">
//                                 {rightQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset +
//                                           mid +
//                                           index +
//                                           1}
//                                         .
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                             </div>
//                           ) : (
//                             <div>
//                               {questions.map((ques, index) => (
//                                 <div
//                                   key={ques.ques_id}
//                                   className="question-block"
//                                 >
//                                   <p>
//                                     <strong>
//                                       {page.questionIndexOffset + index + 1}.
//                                     </strong>{" "}
//                                     {renderQuestionText(ques.ques_text)}
//                                   </p>
//                                   <div className="options__pre-ques">
//                                     {[...ques.options]
//                                       .sort(
//                                         (a, b) =>
//                                           a.set_option_position -
//                                           b.set_option_position
//                                       )
//                                       .map((opt, idx) => (
//                                         <p key={opt.option_id}>
//                                           <span>
//                                             {getOptionLabel(
//                                               idx,
//                                               quesPaperInfo?.option_naming_pattern
//                                             )}
//                                           </span>{" "}
//                                           {renderQuestionText(opt.option_text)}
//                                         </p>
//                                       ))}
//                                   </div>
//                                 </div>
//                               ))}
//                             </div>
//                           );
//                         })()}

//                         {roughPage && (
//                           <div
//                             className="rough-work-section"
//                             style={{
//                               minHeight: page.isLastPageInSection
//                                 ? "60px"
//                                 : "120px", // Reduced heights
//                             }}
//                           >
//                             <strong>Rough Work:</strong>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Page Footer */}
//                     <div className="page-footer">
//                       <div className="footer-left">
//                         {quesPaperInfo?.footer?.client_name} |{" "}
//                         {quesPaperInfo?.footer?.address}
//                       </div>
//                       <div className="footer-right">
//                         {page.type === "cover" &&
//                           `Set ${page.setName} - Cover Page`}
//                         {page.type === "syllabus" &&
//                           `Set ${page.setName} - Syllabus`}
//                         {page.type === "questions" && `Page ${page.pageNumber}`}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;



// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";

// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = `
//       <style>
//         body, html { margin:0!important; padding:0!important; }
//         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//         .watermark img { width: 300px; height: auto; }
//         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//         .question-grid__pre-ques { display:flex;}
//         .question-column__pre-ques { flex:1; }
//         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//         .page-footer span { float:right; }
//         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//         @media print {
//           body * { visibility: hidden !important; }
//           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         }
//         @page { size:A4; margin:0; }
//       </style>
//     `;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       // Cover Page
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div style="margin:0; padding:0;">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       // Syllabus Page
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="syllabus-heading-print">Test Syllabus</div>
//             <table class="syllabus-table-print">
//               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//               <tbody>
//                 ${quesPaperInfo.subj_chap_list
//                   .map(
//                     (subj) => `
//                   <tr>
//                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                     <td>${subj.chapters.join(", ")}</td>
//                   </tr>`
//                   )
//                   .join("")}
//               </tbody>
//             </table>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       // Questions per section
//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   ${subjectHtml}
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);
//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);

//     window.print();

//     setTimeout(() => {
//       if (printSection) document.body.removeChild(printSection);
//     }, 500);
//   };

//   const handleDownloadWord = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = ``;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               <div class="syllabus-heading-print">Test Syllabus</div>
//               <table class="syllabus-table-print">
//                 <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//                 <tbody>
//                   ${quesPaperInfo.subj_chap_list
//                     .map(
//                       (subj) => `
//                     <tr>
//                       <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                       <td>${subj.chapters.join(", ")}</td>
//                     </tr>`
//                     )
//                     .join("")}
//                 </tbody>
//               </table>
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   <div class="page-content">${subjectHtml}</div>
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const styledHTML = `
//       <html>
//         <head>
//           <meta charset="utf-8">
//           <style>
//             @page { size: A4; margin: 0; }
//             body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//             .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//             .page-content { max-width: 180mm; margin: auto; }
//             .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//             .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//             .question-block { margin-bottom: 14px; break-inside: avoid; }
//             .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//             .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//             .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//             .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//             .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//             .syllabus-table-print th { background-color: #f0f0f0; }
//             .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//           </style>
//         </head>
//         <body>
//           ${printContent}
//           <footer>
//             ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//             ${
//               quesPaperInfo?.footer?.address ||
//               "B – 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//             }
//           </footer>
//         </body>
//       </html>
//     `;

//     const blob = new Blob([styledHTML], {
//       type: "application/msword;charset=utf-8",
//     });
//     const filename = `${
//       quesPaperInfo?.ques_paper_name || "question-paper"
//     }.doc`;
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = filename;
//     link.click();
//   };

//   /**
//    * Generates the full HTML string for the question paper based on current state.
//    * This is the missing function that resolves the 'not defined' error.
//    */
//   const generatePrintableHTML = () => {
//     // Return early if essential data isn't loaded yet
//     if (!quesPaperInfo || questionData.length === 0) {
//       return "<p>Loading data, please wait...</p>";
//     }

//     // Helper function to calculate the number of pages for questions
//     const calculateTotalPagesForPrint = (set) => {
//       let questionPages = 0;
//       if (!set) return questionPages;
//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             // Adjust questions per page based on layout
//             const questionsPerPage = twinColumn ? 20 : 10;
//             questionPages += Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//           }
//         });
//       });
//       return questionPages;
//     };

//     // Helper function to render text content, including LaTeX and images
//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             // Use inline-block for better alignment with text
//             return `<img src="${url}" style="width:auto; height:1.5em; max-width:100%; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             // Render LaTeX using KaTeX
//             return segment.replace(/\\\((.*?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(he.decode(math), {
//                   throwOnError: false,
//                   displayMode: false,
//                 });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     // Helper function to process the cover page HTML template
//     const processedCoverHTMLForPrint = (setName) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       const currentSet = questionData.find((s) => s.set_name === setName);
//       const totalQuesPages = calculateTotalPagesForPrint(currentSet);
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     // Start building the full HTML string with styles
//     let fullHtml = `
//     <style>
//       body { margin: 0; padding: 0; font-family: sans-serif; }
//       .a4-page { width: 210mm; height: 296mm; padding: 15mm; box-sizing: border-box; background: white; position: relative; page-break-after: always; overflow: hidden; }
//       .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//       .watermark img { width: 400px; height: auto; }
//       .section-heading__Pre-ques { font-size: 16px; font-weight: 600; padding-bottom: 4px; margin-top: 20px; border-bottom: 1px solid #333; }
//       .question-grid__pre-ques { display: flex; gap: 15mm; }
//       .question-column__pre-ques { flex: 1; min-width: 0; }
//       .question-block { margin-bottom: 12px; page-break-inside: avoid; }
//       .options__pre-ques p { margin: 4px 0 0 16px; font-size: 14px; }
//       .page-footer { position: absolute; bottom: 10mm; left: 15mm; right: 15mm; font-size: 11px; border-top: 1px solid #ccc; padding-top: 4px; color: #444; display: flex; justify-content: space-between; }
//       .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//       .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//       .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; }
//       .page-header__pre-ques { display: flex; justify-content: space-between; font-size: 13px; padding: 4px 0; margin-bottom: 8px; border-bottom: 1px solid #ccc; }
//     </style>
//   `;

//     // Loop through each selected set and build its pages
//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       if (!currentSet) return;

//       let pageCounter = 1;

//       // Add Cover Page if toggled
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         fullHtml += `<div class="a4-page">${
//           watermark
//             ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//             : ""
//         }${processedCoverHTMLForPrint(setName)}<div class="page-footer"><div>${
//           quesPaperInfo?.footer?.client_name || ""
//         } | ${
//           quesPaperInfo?.footer?.address || ""
//         }</div><div>Set ${setName} - Cover Page</div></div></div>`;
//       }

//       // Add Syllabus Page if toggled
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         fullHtml += `<div class="a4-page">${
//           watermark
//             ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//             : ""
//         }<div class="syllabus-heading-print">Test Syllabus</div><table class="syllabus-table-print"><thead><tr><th>Subject</th><th>Chapters</th></tr></thead><tbody>${quesPaperInfo.subj_chap_list
//           .map(
//             (subj) =>
//               `<tr><td><strong>${subj.subject_name.toUpperCase()}</strong></td><td>${subj.chapters.join(
//                 ", "
//               )}</td></tr>`
//           )
//           .join("")}</tbody></table><div class="page-footer"><div>${
//           quesPaperInfo?.footer?.client_name || ""
//         } | ${
//           quesPaperInfo?.footer?.address || ""
//         }</div><div>Set ${setName} - Syllabus</div></div></div>`;
//       }

//       // Loop through subjects and sections to create question pages
//       currentSet.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           const allQuestions = [...(section.questions || [])].sort(
//             (a, b) => a.set_ques_position - b.set_ques_position
//           );
//           if (allQuestions.length === 0) return;

//           const questionsPerPage = twinColumn ? 20 : 10;
//           const totalPagesForSection = Math.ceil(
//             allQuestions.length / questionsPerPage
//           );

//           for (let page = 0; page < totalPagesForSection; page++) {
//             const pageQuestions = allQuestions.slice(
//               page * questionsPerPage,
//               (page + 1) * questionsPerPage
//             );
//             const questionStartIndex = page * questionsPerPage;
//             let pageHtml = "";

//             if (twinColumn) {
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftCol = pageQuestions.slice(0, mid);
//               const rightCol = pageQuestions.slice(mid);
//               pageHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">${leftCol
//                 .map(
//                   (ques, i) =>
//                     `<div class="question-block"><p><strong>${
//                       questionStartIndex + i + 1
//                     }.</strong> ${renderQuestionTextForPrint(
//                       ques.ques_text
//                     )}</p><div class="options__pre-ques">${ques.options
//                       .sort(
//                         (a, b) => a.set_option_position - b.set_option_position
//                       )
//                       .map(
//                         (opt, oi) =>
//                           `<p><span>${getOptionLabel(
//                             oi,
//                             quesPaperInfo?.option_naming_pattern
//                           )}</span> ${renderQuestionTextForPrint(
//                             opt.option_text
//                           )}</p>`
//                       )
//                       .join("")}</div></div>`
//                 )
//                 .join(
//                   ""
//                 )}</div><div class="question-column__pre-ques">${rightCol
//                 .map(
//                   (ques, i) =>
//                     `<div class="question-block"><p><strong>${
//                       questionStartIndex + mid + i + 1
//                     }.</strong> ${renderQuestionTextForPrint(
//                       ques.ques_text
//                     )}</p><div class="options__pre-ques">${ques.options
//                       .sort(
//                         (a, b) => a.set_option_position - b.set_option_position
//                       )
//                       .map(
//                         (opt, oi) =>
//                           `<p><span>${getOptionLabel(
//                             oi,
//                             quesPaperInfo?.option_naming_pattern
//                           )}</span> ${renderQuestionTextForPrint(
//                             opt.option_text
//                           )}</p>`
//                       )
//                       .join("")}</div></div>`
//                 )
//                 .join("")}</div></div>`;
//             } else {
//               pageHtml += pageQuestions
//                 .map(
//                   (ques, i) =>
//                     `<div class="question-block"><p><strong>${
//                       questionStartIndex + i + 1
//                     }.</strong> ${renderQuestionTextForPrint(
//                       ques.ques_text
//                     )}</p><div class="options__pre-ques">${ques.options
//                       .sort(
//                         (a, b) => a.set_option_position - b.set_option_position
//                       )
//                       .map(
//                         (opt, oi) =>
//                           `<p><span>${getOptionLabel(
//                             oi,
//                             quesPaperInfo?.option_naming_pattern
//                           )}</span> ${renderQuestionTextForPrint(
//                             opt.option_text
//                           )}</p>`
//                       )
//                       .join("")}</div></div>`
//                 )
//                 .join("");
//             }

//             fullHtml += `<div class="a4-page">${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }<div class="page-header__pre-ques"><div>${
//               quesPaperInfo?.header?.date || ""
//             }</div><div>${subject.subject_name}</div><div>${
//               quesPaperInfo?.header?.test_name || ""
//             }</div></div><p class="section-heading__Pre-ques">Section ${
//               section.section_name
//             }</p><p><strong>Instruction:</strong> ${
//               section.section_instruction?.trim()
//                 ? renderQuestionTextForPrint(section.section_instruction)
//                 : "N/A"
//             }</p>${pageHtml}<div class="page-footer"><div>${
//               quesPaperInfo?.footer?.client_name || ""
//             } | ${
//               quesPaperInfo?.footer?.address || ""
//             }</div><div>Page ${pageCounter++}</div></div></div>`;
//           }
//         });
//       });

//       // Add Rough Work page if toggled
//       if (roughPage) {
//         fullHtml += `<div class="a4-page">${
//           watermark
//             ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//             : ""
//         }<h2 style="text-align:center; margin-top: 40px;">Rough Work</h2><div class="page-footer"><div>${
//           quesPaperInfo?.footer?.client_name || ""
//         } | ${
//           quesPaperInfo?.footer?.address || ""
//         }</div><div>Rough Work</div></div></div>`;
//       }
//     });
//     return fullHtml;
//   };

//   const handleDownloadPDF = async () => {
//     // // Get the container element that is actually visible on the screen
//     // const printArea = contentRef.current;
//     // if (!printArea) {
//     //   alert("Preview area not found. Cannot generate PDF.");
//     //   return;
//     // }

//     // // Show a loading indicator for better user experience
//     // const loader = document.createElement('div');
//     // loader.innerText = 'Generating PDF, please wait...';
//     // Object.assign(loader.style, {
//     //   position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
//     //   backgroundColor: 'rgba(255, 255, 255, 0.9)', padding: '20px', border: '1px solid #ccc',
//     //   borderRadius: '10px', boxShadow: '0 4px 15px rgba(0,0,0,0.2)', zIndex: '10000'
//     // });
//     // document.body.appendChild(loader);

//     // try {
//     //   // Find all the rendered ".a4-page" divs inside the live preview
//     //   const pages = printArea.querySelectorAll('.a4-page');
//     //   if (pages.length === 0) {
//     //     throw new Error("No pages found to export. Please select a set to preview.");
//     //   }

//     //   const doc = new jsPDF('p', 'mm', 'a4');
//     //   const pdfWidth = doc.internal.pageSize.getWidth();
//     //   const pdfHeight = doc.internal.pageSize.getHeight();

//     //   // Process each visible page sequentially
//     //   for (let i = 0; i < pages.length; i++) {
//     //     const pageElement = pages[i];

//     //     // Crucial step: Ensure the page is scrolled into view before capturing
//     //     // This forces the browser to fully render it.
//     //     pageElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     //     await new Promise(resolve => setTimeout(resolve, 100)); // Brief pause for rendering

//     //     const canvas = await html2canvas(pageElement, {
//     //       scale: 2.5,         // Increase scale for sharper text and images
//     //       useCORS: true,      // Allows capturing cross-origin images
//     //       logging: false,     // Clean up console logs
//     //       // Provide context to help html2canvas render correctly
//     //       windowWidth: printArea.scrollWidth,
//     //       windowHeight: printArea.scrollHeight,
//     //     });

//     //     // Add a new page to the PDF for each element after the first one
//     //     if (i > 0) {
//     //       doc.addPage();
//     //     }

//     //     const imgData = canvas.toDataURL('image/jpeg', 0.95);
//     //     doc.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST');
//     //   }

//     //   // Save the final document
//     //   doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);

//     // } catch (error) {
//     //   console.error("Error generating PDF:", error);
//     //   alert(`An error occurred while generating the PDF: ${error.message}`);
//     // } finally {
//     //   // Clean up by removing the loader
//     //   document.body.removeChild(loader);
//     // }
//     const loader = document.createElement("div");
//     loader.innerText = "Generating PDF, please wait...";
//     document.body.appendChild(loader);

//     try {
//       const htmlContent = generatePrintableHTML();
//       const container = document.createElement("div");
//       container.style.position = "fixed";
//       container.style.left = "-9999px";
//       container.style.top = "0";
//       container.innerHTML = htmlContent;
//       document.body.appendChild(container);

//       const images = Array.from(container.querySelectorAll("img"));
//       await Promise.all(
//         images.map((img) =>
//           img.complete
//             ? Promise.resolve()
//             : new Promise((res) => {
//                 img.onload = res;
//                 img.onerror = res;
//               })
//         )
//       );

//       const pages = container.querySelectorAll(".a4-page");
//       const doc = new jsPDF("p", "mm", "a4");
//       const pdfWidth = doc.internal.pageSize.getWidth();
//       const pdfHeight = doc.internal.pageSize.getHeight();

//       for (let i = 0; i < pages.length; i++) {
//         const pageElement = pages[i];
//         const canvas = await html2canvas(pageElement, {
//           backgroundColor: null,
//           scale: 2,
//           useCORS: true,
//         });
//         const imgData = canvas.toDataURL("image/jpeg", 0.95);
//         if (i !== 0) doc.addPage();
//         doc.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
//       }

//       doc.save(`${quesPaperInfo?.ques_paper_name || "exported"}.pdf`);
//       document.body.removeChild(container);
//     } catch (error) {
//       console.error("Error generating PDF:", error);
//       alert("Failed to generate PDF.");
//     } finally {
//       document.body.removeChild(loader);
//     }
//   };

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <div
//                   className="export-dropdown-container__pre-ques"
//                   ref={exportDropdownRef}
//                 >
//                   <button
//                     className="icon-btn__pre-ques"
//                     onClick={() => setShowExportOptions(!showExportOptions)}
//                   >
//                     <img
//                       src={ExportIcon}
//                       alt="exporticon"
//                       style={{ marginRight: "5px" }}
//                     />{" "}
//                     Export
//                   </button>
//                   {showExportOptions && (
//                     <div className="export-options-dropdown__pre-ques">
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadPDF}
//                       >
//                         <FaFilePdf className="Img-PDF" />
//                         <span>PDF</span>
//                       </button>
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadWord}
//                       >
//                         <FaFileWord className="Img-WORD" />
//                         <span>Word</span>
//                       </button>
//                     </div>
//                   )}
//                 </div>
//                 <button className="icon-btn__pre-ques" onClick={handlePrint}>
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {/* {watermark && <img src={watermarkImg} alt="watermark" className="watermark-image" />} */}
//               {selectedSetNames.length === 0 ? (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               ) : (
//                 questionData
//                   .filter((set) => selectedSetNames.includes(set.set_name))
//                   .map((set) => (
//                     <React.Fragment key={`set-${set.set_name}`}>
//                       {showCoverPage && quesPaperInfo?.paper_cover && (
//                         <div className="a4-page" key={`cover-${set.set_name}`}>
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div
//                             dangerouslySetInnerHTML={{
//                               __html: processedCoverHTML(set.set_name),
//                             }}
//                           />
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Cover Page
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {showCoverPage && quesPaperInfo?.subj_chap_list && (
//                         <div className="a4-page syllabus-page">
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div className="syllabus-heading_prev_ques">
//                             <h2 style={{ textAlign: "center" }}>
//                               Test Syllabus
//                             </h2>
//                           </div>
//                           <table className="syllabus-table_prev_ques">
//                             <thead>
//                               <tr>
//                                 <th>Subject</th>
//                                 <th>Chapters</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                                 <tr key={idx}>
//                                   <td>
//                                     <strong>
//                                       {(subj.subject_name || "").toUpperCase()}
//                                     </strong>
//                                   </td>
//                                   <td>{(subj.chapters || []).join(", ")}</td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Syllabus
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {set.subjects.map((subject, subjectIndex) => (
//                         <div
//                           className="a4-page"
//                           key={`set-${set.set_name}-subject-${subject.subject_id}`}
//                         >
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           {subject.sections.map((section) => {
//                             const questions = [
//                               ...(section.questions || []),
//                             ].sort(
//                               (a, b) =>
//                                 a.set_ques_position - b.set_ques_position
//                             );
//                             const mid = Math.ceil(questions.length / 2);
//                             const leftQuestions = questions.slice(0, mid);
//                             const rightQuestions = questions.slice(mid);
//                             return (
//                               <div
//                                 key={`section-${section.section_name}`}
//                                 className="section-container__pre-ques"
//                               >
//                                 <p className="section-heading__Pre-ques">
//                                   Section {section.section_name}
//                                 </p>
//                                 <p>
//                                   Instruction:{" "}
//                                   {section.section_instruction?.trim()
//                                     ? renderQuestionText(
//                                         section.section_instruction
//                                       )
//                                     : "N/A"}
//                                 </p>
//                                 <div className="page-header__pre-ques">
//                                   <div className="header-left__pre-ques">
//                                     {quesPaperInfo?.header?.date}
//                                   </div>
//                                   <div className="header-center__pre-ques">
//                                     {subject.subject_name}
//                                   </div>
//                                   <div className="header-right__pre-ques">
//                                     {quesPaperInfo?.header?.test_name}
//                                   </div>
//                                 </div>
//                                 {twinColumn ? (
//                                   <div className="question-grid__pre-ques">
//                                     <div className="question-column__pre-ques">
//                                       {leftQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                     <div className="question-column__pre-ques">
//                                       {rightQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + mid + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   </div>
//                                 ) : (
//                                   <div>
//                                     {questions.map((ques, index) => (
//                                       <div
//                                         key={ques.ques_id}
//                                         className="question-block"
//                                       >
//                                         <p>
//                                           <strong>{index + 1}.</strong>{" "}
//                                           {renderQuestionText(ques.ques_text)}
//                                         </p>
//                                         <div className="options__pre-ques">
//                                           {[...ques.options]
//                                             .sort(
//                                               (a, b) =>
//                                                 a.set_option_position -
//                                                 b.set_option_position
//                                             )
//                                             .map((opt, idx) => (
//                                               <p key={opt.option_id}>
//                                                 <span>
//                                                   {getOptionLabel(
//                                                     idx,
//                                                     quesPaperInfo?.option_naming_pattern
//                                                   )}
//                                                 </span>{" "}
//                                                 {renderQuestionText(
//                                                   opt.option_text
//                                                 )}
//                                               </p>
//                                             ))}
//                                         </div>
//                                       </div>
//                                     ))}
//                                   </div>
//                                 )}
//                               </div>
//                             );
//                           })}
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Page {subjectIndex + 1}
//                             </div>
//                             {/* <div className="footer-right">Set {set.set_name} - {subject.subject_name}</div> */}
//                           </div>
//                         </div>
//                       ))}
//                     </React.Fragment>
//                   ))
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";

// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = `
//       <style>
//         body, html { margin:0!important; padding:0!important; }
//         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//         .watermark img { width: 300px; height: auto; }
//         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//         .question-grid__pre-ques { display:flex;}
//         .question-column__pre-ques { flex:1; }
//         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//         .page-footer span { float:right; }
//         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//         @media print {
//           body * { visibility: hidden !important; }
//           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         }
//         @page { size:A4; margin:0; }
//       </style>
//     `;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       // Cover Page
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div style="margin:0; padding:0;">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       // Syllabus Page
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page" style="padding: 20px;">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="syllabus-heading-print">Test Syllabus</div>
//             <table class="syllabus-table-print">
//               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//               <tbody>
//                 ${quesPaperInfo.subj_chap_list
//                   .map(
//                     (subj) => `
//                   <tr>
//                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                     <td>${subj.chapters.join(", ")}</td>
//                   </tr>`
//                   )
//                   .join("")}
//               </tbody>
//             </table>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       // Questions per section
//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques" style="padding-left: 15px;" >Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong style="padding-left: 15px;">Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//                 if (roughPage) {
//                   const isLastPage = page === totalPages - 1;
//                   const roughMinHeight = isLastPage ? "100px" : "200px";
//                   subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//                 }
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });

//                 if (roughPage) {
//                   const isLastPage = page === totalPages - 1;
//                   const roughMinHeight = isLastPage ? "100px" : "200px";
//                   subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//                 }
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   ${subjectHtml}
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);
//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);
//     console.log(printContent);
//     window.print();

//     setTimeout(() => {
//       if (printSection) document.body.removeChild(printSection);
//     }, 500);
//   };

//   const handleDownloadWord = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = ``;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               <div class="syllabus-heading-print">Test Syllabus</div>
//               <table class="syllabus-table-print">
//                 <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//                 <tbody>
//                   ${quesPaperInfo.subj_chap_list
//                     .map(
//                       (subj) => `
//                     <tr>
//                       <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                       <td>${subj.chapters.join(", ")}</td>
//                     </tr>`
//                     )
//                     .join("")}
//                 </tbody>
//               </table>
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   <div class="page-content">${subjectHtml}</div>
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const styledHTML = `
//       <html>
//         <head>
//           <meta charset="utf-8">
//           <style>
//             @page { size: A4; margin: 0; }
//             body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//             .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//             .page-content { max-width: 180mm; margin: auto; }
//             .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//             .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//             .question-block { margin-bottom: 14px; break-inside: avoid; }
//             .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//             .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//             .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//             .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//             .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//             .syllabus-table-print th { background-color: #f0f0f0; }
//             .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//           </style>
//         </head>
//         <body>
//           ${printContent}
//           <footer>
//             ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//             ${
//               quesPaperInfo?.footer?.address ||
//               "B â€“ 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//             }
//           </footer>
//         </body>
//       </html>
//     `;

//     const blob = new Blob([styledHTML], {
//       type: "application/msword;charset=utf-8",
//     });
//     const filename = `${
//       quesPaperInfo?.ques_paper_name || "question-paper"
//     }.doc`;
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = filename;
//     link.click();
//   };

//   const handleDownloadPDF = () => {
//     if (!questionData || questionData.length === 0) return;

//     const doc = new jsPDF("p", "mm", "a4");

//     const generatePDFForSet = (set, callback) => {
//       const setName = set.set_name;
//       const syllabusRows = quesPaperInfo?.subj_chap_list?.map((item) => [
//         item.subject_name,
//         item.chapters.join(", "),
//       ]);

//       doc.html(processedCoverHTML(setName), {
//         callback: () => {
//           // Syllabus Page
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text("Test Syllabus", 105, 20, { align: "center" });

//           if (syllabusRows?.length) {
//             doc.autoTable({
//               head: [["Subject", "Chapters"]],
//               body: syllabusRows,
//               startY: 30,
//               styles: { fontSize: 10 },
//               headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               theme: "grid",
//             });
//           }

//           // Add question summary next
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text(`Set ${setName} - Question Paper Summary`, 14, 20);

//           set.subjects.forEach((subject) => {
//             const sectionRows = [];

//             subject.sections.forEach((section) => {
//               (section.questions || []).forEach((ques, index) => {
//                 const questionText = he
//                   .decode(ques.ques_text)
//                   .replace(/(<([^>]+)>)/gi, "")
//                   .slice(0, 100);
//                 sectionRows.push([
//                   section.section_name,
//                   `${index + 1}`,
//                   questionText,
//                   subject.subject_name,
//                   ques.ques_id || "",
//                 ]);
//               });
//             });

//             if (sectionRows.length > 0) {
//               doc.autoTable({
//                 head: [
//                   ["Section", "Q No", "Question Text", "Subject", "Ques ID"],
//                 ],
//                 body: sectionRows,
//                 startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 30,
//                 styles: { fontSize: 8 },
//                 headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               });
//             }

//             doc.addPage(); // optional: remove if not needed per subject
//           });

//           callback();
//         },
//         x: 10,
//         y: 10,
//         margin: 10,
//         html2canvas: { scale: 0.4 },
//       });
//     };

//     const setsToProcess = questionData.filter((set) =>
//       selectedSetNames.includes(set.set_name)
//     );
//     let index = 0;

//     const processNextSet = () => {
//       if (index < setsToProcess.length) {
//         generatePDFForSet(setsToProcess[index], () => {
//           index++;
//           processNextSet();
//         });
//       } else {
//         doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);
//       }
//     };

//     processNextSet();
//   };

//   const previewPages = React.useMemo(() => {
//     const pages = [];
//     if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//       return [];
//     }

//     const setsToRender = questionData.filter((set) =>
//       selectedSetNames.includes(set.set_name)
//     );

//     // This function pre-calculates the total number of question pages for a given set.
//     // This is needed for the #total_pages# placeholder on the cover page.
//     const calculateTotalQuestionPages = (set) => {
//       let count = 0;
//       if (!set) return 0;
//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           const questionsPerPage = 10;
//           count += Math.ceil(
//             (section.questions || []).length / questionsPerPage
//           );
//         });
//       });
//       return count;
//     };

//     setsToRender.forEach((set) => {
//       let questionPageCounter = 1; // This will be the running page number for display.
//       const totalQuestionPagesForSet = calculateTotalQuestionPages(set);

//       // 1. Add Cover Page
//       if (showCoverPage && quesPaperInfo.paper_cover) {
//         pages.push({
//           type: "cover",
//           key: `cover-${set.set_name}`,
//           setName: set.set_name,
//           totalQuestionPages: totalQuestionPagesForSet,
//         });
//       }

//       // 2. Add Syllabus Page
//       if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//         pages.push({
//           type: "syllabus",
//           key: `syllabus-${set.set_name}`,
//           setName: set.set_name,
//         });
//       }

//       // 3. Add Question Pages (Paginated)
//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           const allQuestions = [...(section.questions || [])].sort(
//             (a, b) => a.set_ques_position - b.set_ques_position
//           );
//           if (allQuestions.length === 0) return;

//           const questionsPerPage = 10;
//           const totalPagesInSection = Math.ceil(
//             allQuestions.length / questionsPerPage
//           );
//           let questionIndex = 0; // To track question number within the section

//           for (let i = 0; i < totalPagesInSection; i++) {
//             const pageQuestions = allQuestions.slice(
//               i * questionsPerPage,
//               (i + 1) * questionsPerPage
//             );

//             pages.push({
//               type: "questions",
//               key: `questions-${set.set_name}-${subject.subject_id}-${section.section_name}-${i}`,
//               setName: set.set_name,
//               subject,
//               section,
//               questions: pageQuestions,
//               questionIndexOffset: questionIndex,
//               pageNumber: questionPageCounter++,
//               isLastPageInSection: i === totalPagesInSection - 1,
//             });
//             questionIndex += pageQuestions.length;
//           }
//         });
//       });
//     });

//     return pages;
//   }, [
//     questionData,
//     quesPaperInfo,
//     selectedSetNames,
//     showCoverPage,
//     watermark,
//     twinColumn,
//     roughPage,
//   ]);

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <div
//                   className="export-dropdown-container__pre-ques"
//                   ref={exportDropdownRef}
//                 >
//                   <button
//                     className="icon-btn__pre-ques"
//                     onClick={() => setShowExportOptions(!showExportOptions)}
//                   >
//                     <img
//                       src={ExportIcon}
//                       alt="exporticon"
//                       style={{ marginRight: "5px" }}
//                     />{" "}
//                     Export
//                   </button>
//                   {showExportOptions && (
//                     <div className="export-options-dropdown__pre-ques">
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadPDF}
//                       >
//                         <FaFilePdf className="Img-PDF" />
//                         <span>PDF</span>
//                       </button>
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadWord}
//                       >
//                         <FaFileWord className="Img-WORD" />
//                         <span>Word</span>
//                       </button>
//                     </div>
//                   )}
//                 </div>
//                 <button className="icon-btn__pre-ques" onClick={handlePrint}>
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {previewPages.length > 0 ? (
//                 previewPages.map((page) => (
//                   <div
//                     className={`a4-page${
//                       roughPage && page.type === "questions"
//                         ? " has-roughwork"
//                         : ""
//                     }`}
//                     key={page.key}
//                   >
//                     {watermark && (
//                       <img
//                         src={watermarkImg}
//                         alt="watermark"
//                         className="watermark-image"
//                       />
//                     )}

//                     {/* Page Content */}
//                     {page.type === "cover" && (
//                       <div
//                         dangerouslySetInnerHTML={{
//                           __html: quesPaperInfo.paper_cover
//                             .replace(/#total_pages#/gi, page.totalQuestionPages)
//                             .replace(
//                               /#test_date#/gi,
//                               new Date().toLocaleDateString("en-GB")
//                             )
//                             .replace(/#set_name#/gi, page.setName),
//                         }}
//                       />
//                     )}

//                     {page.type === "syllabus" && (
//                       <div className="syllabus-page">
//                         <div className="syllabus-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Test Syllabus</h2>
//                         </div>
//                         <table className="syllabus-table_prev_ques">
//                           <thead>
//                             <tr>
//                               <th>Subject</th>
//                               <th>Chapters</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                               <tr key={idx}>
//                                 <td>
//                                   <strong>
//                                     {subj.subject_name.toUpperCase()}
//                                   </strong>
//                                 </td>
//                                 <td>{subj.chapters.join(", ")}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}

//                     {page.type === "questions" && (
//                       <div
//                         className="section-container__pre-ques"
//                         style={{ position: "relative", minHeight: "530px" }}
//                       >
//                         <p className="section-heading__Pre-ques">
//                           Section {page.section.section_name}
//                         </p>
//                         <p>
//                           Instruction:{" "}
//                           {page.section.section_instruction?.trim()
//                             ? renderQuestionText(
//                                 page.section.section_instruction
//                               )
//                             : "N/A"}
//                         </p>
//                         <div className="page-header__pre-ques">
//                           <div className="header-left__pre-ques">
//                             {quesPaperInfo?.header?.date}
//                           </div>
//                           <div className="header-center__pre-ques">
//                             {page.subject.subject_name}
//                           </div>
//                           <div className="header-right__pre-ques">
//                             {quesPaperInfo?.header?.test_name}
//                           </div>
//                         </div>

//                         {(() => {
//                           const questions = page.questions;
//                           const mid = Math.ceil(questions.length / 2);
//                           const leftQuestions = questions.slice(0, mid);
//                           const rightQuestions = questions.slice(mid);

//                           return twinColumn ? (
//                             <div className="question-grid__pre-ques">
//                               <div className="question-column__pre-ques">
//                                 {leftQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset + index + 1}.
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                               <div className="question-column__pre-ques">
//                                 {rightQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset +
//                                           mid +
//                                           index +
//                                           1}
//                                         .
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                             </div>
//                           ) : (
//                             <div>
//                               {questions.map((ques, index) => (
//                                 <div
//                                   key={ques.ques_id}
//                                   className="question-block"
//                                 >
//                                   <p>
//                                     <strong>
//                                       {page.questionIndexOffset + index + 1}.
//                                     </strong>{" "}
//                                     {renderQuestionText(ques.ques_text)}
//                                   </p>
//                                   <div className="options__pre-ques">
//                                     {[...ques.options]
//                                       .sort(
//                                         (a, b) =>
//                                           a.set_option_position -
//                                           b.set_option_position
//                                       )
//                                       .map((opt, idx) => (
//                                         <p key={opt.option_id}>
//                                           <span>
//                                             {getOptionLabel(
//                                               idx,
//                                               quesPaperInfo?.option_naming_pattern
//                                             )}
//                                           </span>{" "}
//                                           {renderQuestionText(opt.option_text)}
//                                         </p>
//                                       ))}
//                                   </div>
//                                 </div>
//                               ))}
//                             </div>
//                           );
//                         })()}

//                         {roughPage && (
//                           <div
//                             className="rough-work-section"
//                             style={{
//                               minHeight: page.isLastPageInSection
//                                 ? "100px"
//                                 : "200px",
//                             }}
//                           >
//                             <strong>Rough Work:</strong>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Page Footer */}
//                     <div className="page-footer">
//                       <div className="footer-left">
//                         {quesPaperInfo?.footer?.client_name} |{" "}
//                         {quesPaperInfo?.footer?.address}
//                       </div>
//                       <div className="footer-right">
//                         {page.type === "cover" &&
//                           `Set ${page.setName} - Cover Page`}
//                         {page.type === "syllabus" &&
//                           `Set ${page.setName} - Syllabus`}
//                         {page.type === "questions" && `Page ${page.pageNumber}`}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";

// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = `
//       <style>
//         body, html { margin:0!important; padding:0!important; }
//         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//         .watermark img { width: 300px; height: auto; }
//         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//         .question-grid__pre-ques { display:flex;}
//         .question-column__pre-ques { flex:1; }
//         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//         .page-footer span { float:right; }
//         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//         @media print {
//           body * { visibility: hidden !important; }
//           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         }
//         @page { size:A4; margin:0; }
//       </style>
//     `;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       // Cover Page
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div style="margin:0; padding:0;">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       // Syllabus Page
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page" style="padding: 20px;">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="syllabus-heading-print">Test Syllabus</div>
//             <table class="syllabus-table-print">
//               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//               <tbody>
//                 ${quesPaperInfo.subj_chap_list
//                   .map(
//                     (subj) => `
//                   <tr>
//                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                     <td>${subj.chapters.join(", ")}</td>
//                   </tr>`
//                   )
//                   .join("")}
//               </tbody>
//             </table>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       // Questions per section
//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques" style="padding-left: 15px;" >Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong style="padding-left: 15px;">Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//                 const isLastPage = page === totalPages - 1;
//                 const roughMinHeight = isLastPage ? "100px" : "200px";
//                 subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                   const isLastPage = page === totalPages - 1;
//                   const roughMinHeight = isLastPage ? "100px" : "200px";
//                   subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   ${subjectHtml}
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);
//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);
//     console.log(printContent);
//     window.print();

//     setTimeout(() => {
//       if (printSection) document.body.removeChild(printSection);
//     }, 500);
//   };

//   const handleDownloadWord = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = ``;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               <div class="syllabus-heading-print">Test Syllabus</div>
//               <table class="syllabus-table-print">
//                 <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//                 <tbody>
//                   ${quesPaperInfo.subj_chap_list
//                     .map(
//                       (subj) => `
//                     <tr>
//                       <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                       <td>${subj.chapters.join(", ")}</td>
//                     </tr>`
//                     )
//                     .join("")}
//                 </tbody>
//               </table>
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   <div class="page-content">${subjectHtml}</div>
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const styledHTML = `
//       <html>
//         <head>
//           <meta charset="utf-8">
//           <style>
//             @page { size: A4; margin: 0; }
//             body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//             .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//             .page-content { max-width: 180mm; margin: auto; }
//             .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//             .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//             .question-block { margin-bottom: 14px; break-inside: avoid; }
//             .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//             .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//             .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//             .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//             .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//             .syllabus-table-print th { background-color: #f0f0f0; }
//             .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//           </style>
//         </head>
//         <body>
//           ${printContent}
//           <footer>
//             ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//             ${
//               quesPaperInfo?.footer?.address ||
//               "B â€“ 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//             }
//           </footer>
//         </body>
//       </html>
//     `;

//     const blob = new Blob([styledHTML], {
//       type: "application/msword;charset=utf-8",
//     });
//     const filename = `${
//       quesPaperInfo?.ques_paper_name || "question-paper"
//     }.doc`;
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = filename;
//     link.click();
//   };

//   const handleDownloadPDF = () => {
//     if (!questionData || questionData.length === 0) return;

//     const doc = new jsPDF("p", "mm", "a4");

//     const generatePDFForSet = (set, callback) => {
//       const setName = set.set_name;
//       const syllabusRows = quesPaperInfo?.subj_chap_list?.map((item) => [
//         item.subject_name,
//         item.chapters.join(", "),
//       ]);

//       doc.html(processedCoverHTML(setName), {
//         callback: () => {
//           // Syllabus Page
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text("Test Syllabus", 105, 20, { align: "center" });

//           if (syllabusRows?.length) {
//             doc.autoTable({
//               head: [["Subject", "Chapters"]],
//               body: syllabusRows,
//               startY: 30,
//               styles: { fontSize: 10 },
//               headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               theme: "grid",
//             });
//           }

//           // Add question summary next
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text(`Set ${setName} - Question Paper Summary`, 14, 20);

//           set.subjects.forEach((subject) => {
//             const sectionRows = [];

//             subject.sections.forEach((section) => {
//               (section.questions || []).forEach((ques, index) => {
//                 const questionText = he
//                   .decode(ques.ques_text)
//                   .replace(/(<([^>]+)>)/gi, "")
//                   .slice(0, 100);
//                 sectionRows.push([
//                   section.section_name,
//                   `${index + 1}`,
//                   questionText,
//                   subject.subject_name,
//                   ques.ques_id || "",
//                 ]);
//               });
//             });

//             if (sectionRows.length > 0) {
//               doc.autoTable({
//                 head: [
//                   ["Section", "Q No", "Question Text", "Subject", "Ques ID"],
//                 ],
//                 body: sectionRows,
//                 startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 30,
//                 styles: { fontSize: 8 },
//                 headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               });
//             }

//             doc.addPage(); // optional: remove if not needed per subject
//           });

//           callback();
//         },
//         x: 10,
//         y: 10,
//         margin: 10,
//         html2canvas: { scale: 0.4 },
//       });
//     };

//     const setsToProcess = questionData.filter((set) =>
//       selectedSetNames.includes(set.set_name)
//     );
//     let index = 0;

//     const processNextSet = () => {
//       if (index < setsToProcess.length) {
//         generatePDFForSet(setsToProcess[index], () => {
//           index++;
//           processNextSet();
//         });
//       } else {
//         doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);
//       }
//     };

//     processNextSet();
//   };

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <div
//                   className="export-dropdown-container__pre-ques"
//                   ref={exportDropdownRef}
//                 >
//                   <button
//                     className="icon-btn__pre-ques"
//                     onClick={() => setShowExportOptions(!showExportOptions)}
//                   >
//                     <img
//                       src={ExportIcon}
//                       alt="exporticon"
//                       style={{ marginRight: "5px" }}
//                     />{" "}
//                     Export
//                   </button>
//                   {showExportOptions && (
//                     <div className="export-options-dropdown__pre-ques">
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadPDF}
//                       >
//                         <FaFilePdf className="Img-PDF" />
//                         <span>PDF</span>
//                       </button>
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadWord}
//                       >
//                         <FaFileWord className="Img-WORD" />
//                         <span>Word</span>
//                       </button>
//                     </div>
//                   )}
//                 </div>
//                 <button className="icon-btn__pre-ques" onClick={handlePrint}>
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {/* {watermark && <img src={watermarkImg} alt="watermark" className="watermark-image" />} */}
//               {selectedSetNames.length === 0 ? (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               ) : (
//                 questionData
//                   .filter((set) => selectedSetNames.includes(set.set_name))
//                   .map((set) => (
//                     <React.Fragment key={`set-${set.set_name}`}>
//                       {showCoverPage && quesPaperInfo?.paper_cover && (
//                         <div className="a4-page" key={`cover-${set.set_name}`}>
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div
//                             dangerouslySetInnerHTML={{
//                               __html: processedCoverHTML(set.set_name),
//                             }}
//                           />
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Cover Page
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {showCoverPage && quesPaperInfo?.subj_chap_list && (
//                         <div className="a4-page syllabus-page">
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div className="syllabus-heading_prev_ques">
//                             <h2 style={{ textAlign: "center" }}>
//                               Test Syllabus
//                             </h2>
//                           </div>
//                           <table className="syllabus-table_prev_ques">
//                             <thead>
//                               <tr>
//                                 <th>Subject</th>
//                                 <th>Chapters</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                                 <tr key={idx}>
//                                   <td>
//                                     <strong>
//                                       {subj.subject_name.toUpperCase()}
//                                     </strong>
//                                   </td>
//                                   <td>{subj.chapters.join(", ")}</td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Syllabus
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {set.subjects.map((subject, subjectIndex) => (
//                         // <div
//                         //   className="a4-page"
//                         //   key={`set-${set.set_name}-subject-${subject.subject_id}`}
//                         // >
//                         <div
//                           className={`a4-page${
//                             roughPage ? " has-roughwork" : ""
//                           }`}
//                           key={`set-${set.set_name}-subject-${subject.subject_id}`}
//                         >
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           {subject.sections.map((section) => {
//                             const questions = [
//                               ...(section.questions || []),
//                             ].sort(
//                               (a, b) =>
//                                 a.set_ques_position - b.set_ques_position
//                             );
//                             const mid = Math.ceil(questions.length / 2);
//                             const leftQuestions = questions.slice(0, mid);
//                             const rightQuestions = questions.slice(mid);
//                             return (
//                               // <div
//                               //   key={`section-${section.section_name}`}
//                               //   className="section-container__pre-ques"
//                               // >
//                               <div
//                                 key={`section-${section.section_name}`}
//                                 className="section-container__pre-ques"
//                                 style={{
//                                   position: "relative",
//                                   minHeight: "530px",
//                                 }} // To ensure height for absolute positioning
//                               >
//                                 <p className="section-heading__Pre-ques">
//                                   Section {section.section_name}
//                                 </p>
//                                 <p>
//                                   Instruction:{" "}
//                                   {section.section_instruction?.trim()
//                                     ? renderQuestionText(
//                                         section.section_instruction
//                                       )
//                                     : "N/A"}
//                                 </p>
//                                 <div className="page-header__pre-ques">
//                                   <div className="header-left__pre-ques">
//                                     {quesPaperInfo?.header?.date}
//                                   </div>
//                                   <div className="header-center__pre-ques">
//                                     {subject.subject_name}
//                                   </div>
//                                   <div className="header-right__pre-ques">
//                                     {quesPaperInfo?.header?.test_name}
//                                   </div>
//                                 </div>

//                                 {twinColumn ? (
//                                   <div className="question-grid__pre-ques">
//                                     <div className="question-column__pre-ques">
//                                       {leftQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                     <div className="question-column__pre-ques">
//                                       {rightQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + mid + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   </div>
//                                 ) : (
//                                   <div>
//                                     {questions.map((ques, index) => (
//                                       <div
//                                         key={ques.ques_id}
//                                         className="question-block"
//                                       >
//                                         <p>
//                                           <strong>{index + 1}.</strong>{" "}
//                                           {renderQuestionText(ques.ques_text)}
//                                         </p>
//                                         <div className="options__pre-ques">
//                                           {[...ques.options]
//                                             .sort(
//                                               (a, b) =>
//                                                 a.set_option_position -
//                                                 b.set_option_position
//                                             )
//                                             .map((opt, idx) => (
//                                               <p key={opt.option_id}>
//                                                 <span>
//                                                   {getOptionLabel(
//                                                     idx,
//                                                     quesPaperInfo?.option_naming_pattern
//                                                   )}
//                                                 </span>{" "}
//                                                 {renderQuestionText(
//                                                   opt.option_text
//                                                 )}
//                                               </p>
//                                             ))}
//                                         </div>
//                                       </div>
//                                     ))}
//                                   </div>
//                                 )}

//                                 {roughPage && (
//                                   <div className="rough-work-section">
//                                     <strong>Rough Work:</strong>
//                                     <div style={{ height: "100%" }} />
//                                   </div>
//                                 )}
//                               </div>
//                             );
//                           })}
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Page {subjectIndex + 1}
//                             </div>
//                             {/* <div className="footer-right">Set {set.set_name} - {subject.subject_name}</div> */}
//                           </div>
//                         </div>
//                       ))}
//                     </React.Fragment>
//                   ))
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";
// import Colors from "../../../Constants/Colors";
// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const [paginatedPages, setPaginatedPages] = useState([]);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Add this helper function to render content to HTML for measurement
//   const renderContentToHTML = (text) => {
//     if (!text) return "";
//     const decoded = he.decode(text);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts
//       .map((segment) => {
//         if (segment.startsWith("imgsrc=")) {
//           const url = segment.replace("imgsrc=", "");
//           return `<img src="${url}" alt="image" style="max-width: 80px; height: auto; vertical-align: middle; margin: 0 5px;" />`;
//         } else {
//           return segment.replace(/\\\((.*?)\\\)/g, (_, math) => {
//             try {
//               return katex.renderToString(math, {
//                 throwOnError: false,
//                 displayMode: false,
//               });
//             } catch (e) {
//               console.warn("Katex rendering error:", e);
//               return `<span style="color:red;">[LaTeX Error]</span>`;
//             }
//           });
//         }
//       })
//       .join("");
//   };

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     if (!paginatedPages || paginatedPages.length === 0) {
//       alert("There is no content to print.");
//       return;
//     }

//     const AVAILABLE_HEIGHT_MM = (PAGE_CONTENT_HEIGHT_PX / 3.78); // Convert px to mm
// const FOOTER_HEIGHT_MM = 12;
// const PADDING_MM = 8;
// const CALCULATED_WRAPPER_HEIGHT = `calc(297mm - ${PADDING_MM + FOOTER_HEIGHT_MM + 8}mm)`;

//     // Helper to process cover page HTML
//     const getProcessedCoverHTML = (page) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, page.totalQuestionPages)
//         .replace(/#test_date#/gi, new Date().toLocaleDateString("en-GB"))
//         .replace(/#set_name#/gi, page.setName);
//     };

//     let printContent = `
//     <style>
//       body, html { margin: 0 !important; padding: 0 !important; background-color: #fff; font-family: Calibri, sans-serif; }
//       .a4-page { width: 210mm; min-height: 297mm; margin: 0 auto; padding: 10mm; box-sizing: border-box; background: white; position: relative; page-break-after: always; }

//       .page-content-wrapper {
//          height: ${CALCULATED_WRAPPER_HEIGHT};
//         position: relative;
//         padding-bottom: 10mm; /* Space for footer */
//         overflow: hidden;
//       }
//       .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//       .watermark img { width: 300px; height: auto; }
//       .section-heading__Pre-ques { font-size: 16px; font-weight: 600; margin: 0px 0 4px 0; padding-left: 15px; }
//       .question-grid__pre-ques { display: flex; gap: 20px; }
//       .question-column__pre-ques { flex: 1; min-width: 0; }
//       .question-block { margin-bottom: 10px; page-break-inside: avoid; }
//       .question-block p { margin: 0 0 3px 0; line-height: 1.3; }
//       .options__pre-ques p { margin: 3px 0 1px 16px; font-size: 14px; line-height: 1.2; }
//       .page-footer {
//         position: absolute;
//         bottom: 8mm;
//         left: 10mm;
//         right: 10mm;
//         height: 15mm;
//         text-align: center;
//         font-size: 11px;
//         border-top: 1px solid #ccc;
//         padding-top: 4px;
//         color: #444;
//         display: flex;
//         justify-content: space-between;
//         background: white;
//         z-index: 10;
//       }
//       .page-header__pre-ques { display: flex; justify-content: space-between; font-size: 13px; padding: 4px 12px; margin-bottom: 6px; border-bottom: 1px solid #ccc; }
//       .rough-work-section { margin-top: 15px; border-top: 1px solid #ccc; padding-top: 8px; min-height: 60px; }
//       .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 5px; padding-bottom: 8px; }
//       .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//       .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//       .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//       .instructions-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 5px; padding-bottom: 8px; }
//       .instructions-content { margin-top: 5px; }
//       @media print {
//         body * { visibility: hidden !important; }
//         #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//         #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//       }
//       @page { size: A4; margin: 0; }
//     </style>
//   `;

//     // Iterate through the already calculated paginatedPages
//     paginatedPages.forEach((page) => {
//       printContent += `<div class="a4-page">`;

//       // Add watermark if enabled
//       if (watermark) {
//         printContent += `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`;
//       }

//       printContent += `<div class="page-content-wrapper">`;

//       // Generate content based on page type
//       switch (page.type) {
//         case "cover":
//           printContent += `
//     <div style="margin-top: 0 !important; padding-top: 0 !important; position: relative; top: 0;">
//       ${getProcessedCoverHTML(page)}
//     </div>`;
//           break;

//         case "instructions":
//           printContent += `
//           <div class="instructions-heading-print">Instructions</div>
//           <hr style="border: none; border-top: 1px solid #ccc; margin: 5px 0;" />
//           <div class="instructions-content" style="font-size: 14px; text-align: justify;">${quesPaperInfo.instructions_html}</div>`;
//           break;

//         case "syllabus":
//           printContent += `
//           <div class="syllabus-heading-print">Test Syllabus</div>
//           <table class="syllabus-table-print">
//             <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//             <tbody>
//               ${quesPaperInfo.subj_chap_list
//                 .map(
//                   (s) => `
//                 <tr>
//                   <td><strong>${s.subject_name.toUpperCase()}</strong></td>
//                   <td>${s.chapters.join(", ")}</td>
//                 </tr>
//               `
//                 )
//                 .join("")}
//             </tbody>
//           </table>`;
//           break;

//         case "questions":
//           let questionsHtml = `
//           <p class="section-heading__Pre-ques">Section ${
//             page.section.section_name
//           }</p>
//           <p style="padding-left: 15px; margin: 0 0 4px 0;"><strong>Instruction:</strong> ${
//             page.section.section_instruction?.trim()
//               ? renderContentToHTML(page.section.section_instruction)
//               : "N/A"
//           }</p>
//           <div class="page-header__pre-ques">
//             <div>${quesPaperInfo?.header?.date || ""}</div>
//             <div>${page.subject.subject_name}</div>
//             <div>${quesPaperInfo?.header?.test_name || ""}</div>
//           </div>`;

//           const renderQuestionColumn = (qs, offset) =>
//             qs
//               .map(
//                 (q, i) => `
//           <div class="question-block">
//             <p><strong>${offset + i + 1}.</strong> ${renderContentToHTML(
//                   q.ques_text
//                 )}</p>
//             <div class="options__pre-ques">
//               ${q.options
//                 .sort((a, b) => a.set_option_position - b.set_option_position)
//                 .map(
//                   (opt, oi) => `
//                 <p><span>${getOptionLabel(
//                   oi,
//                   quesPaperInfo?.option_naming_pattern
//                 )}</span> ${renderContentToHTML(opt.option_text)}</p>
//               `
//                 )
//                 .join("")}
//             </div>
//           </div>`
//               )
//               .join("");

//           if (twinColumn) {
//             const mid = Math.ceil(page.questions.length / 2);
//             questionsHtml += `
//             <div class="question-grid__pre-ques">
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(0, mid),
//                 page.questionIndexOffset
//               )}</div>
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(mid),
//                 page.questionIndexOffset + mid
//               )}</div>
//             </div>`;
//           } else {
//             questionsHtml += `<div>${renderQuestionColumn(
//               page.questions,
//               page.questionIndexOffset
//             )}</div>`;
//           }

//           // Add rough work section if enabled and this is the last page of the section
//           if (roughPage && page.isLastPageInSection) {
//             questionsHtml += `<div class="rough-work-section"><strong>Rough Work:</strong></div>`;
//           }

//           printContent += questionsHtml;
//           break;

//         default:
//           break;
//       }

//       printContent += `</div>`; // Close page-content-wrapper

//       // Add footer for all page types
//       printContent += `
//       <div class="page-footer">
//         <div>${quesPaperInfo?.footer?.client_name || ""} | ${
//         quesPaperInfo?.footer?.address || ""
//       }</div>
//         <div>
//           ${page.type === "cover" ? `Set ${page.setName} - Cover Page` : ""}
//           ${
//             page.type === "instructions"
//               ? `Set ${page.setName} - Instructions`
//               : ""
//           }
//           ${page.type === "syllabus" ? `Set ${page.setName} - Syllabus` : ""}
//           ${page.type === "questions" ? `Page ${page.pageNumber}` : ""}
//         </div>
//       </div>
//     `;

//       printContent += `</div>`; // Close a4-page
//     });

//     // Create and inject print section
//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);

//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);

//     // Print with a small delay to ensure rendering
//     setTimeout(() => {
//       window.print();
//       // Cleanup after printing
//       setTimeout(() => {
//         if (document.getElementById(printSectionId)) {
//           document.body.removeChild(document.getElementById(printSectionId));
//         }
//       }, 1000);
//     }, 500);
//   };

//   //   const handlePrint = () => {
//   //     const calculateTotalPagesForPrint = (set) => {
//   //       let total = 0;
//   //       let questionPages = 0;

//   //       if (showCoverPage) total++;
//   //       if (quesPaperInfo?.subj_chap_list?.length) total++;

//   //       if (!set) return { total, questionPages };

//   //       set.subjects.forEach((subject) => {
//   //         subject.sections.forEach((section) => {
//   //           if ((section.questions || []).length > 0) {
//   //             const questionsPerPage = 10;
//   //             const pages = Math.ceil(
//   //               section.questions.length / questionsPerPage
//   //             );
//   //             total += pages;
//   //             questionPages += pages;
//   //           }
//   //         });
//   //       });

//   //       return { total, questionPages };
//   //     };

//   //     const renderQuestionTextForPrint = (text) => {
//   //       if (!text) return "";
//   //       const decoded = he.decode(text);
//   //       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//   //       return parts
//   //         .map((segment, idx) => {
//   //           if (segment.startsWith("imgsrc=")) {
//   //             const url = segment.replace("imgsrc=", "");
//   //             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//   //           } else {
//   //             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//   //               try {
//   //                 return katex.renderToString(math, { throwOnError: false });
//   //               } catch (e) {
//   //                 return `<span style="color:red;">Invalid LaTeX</span>`;
//   //               }
//   //             });
//   //           }
//   //         })
//   //         .join("");
//   //     };

//   //     const processedCoverHTML = (setName, totalQuesPages) => {
//   //       if (!quesPaperInfo?.paper_cover) return "";
//   //       const testDate = new Date().toLocaleDateString("en-GB");
//   //       return quesPaperInfo.paper_cover
//   //         .replace(/#total_pages#/gi, totalQuesPages)
//   //         .replace(/#test_date#/gi, testDate)
//   //         .replace(/#set_name#/gi, setName);
//   //     };

//   //     let printContent = `
//   //       <style>
//   //         body, html { margin:0!important; padding:0!important; }
//   //         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//   //         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//   //         .watermark img { width: 300px; height: auto; }
//   //         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//   //         .question-grid__pre-ques { display:flex;}
//   //         .question-column__pre-ques { flex:1; }
//   //         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//   //         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//   //         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//   //         .page-footer span { float:right; }
//   //         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//   //         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//   //         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//   //         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//   //         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//   //         @media print {
//   //           body * { visibility: hidden !important; }
//   //           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//   //           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//   //         }
//   //         @page { size:A4; margin:0; }
//   //       </style>
//   //     `;

//   //     selectedSetNames.forEach((setName) => {
//   //       const currentSet = questionData.find((set) => set.set_name === setName);
//   //       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//   //       let questionPageNum = 1;

//   //       // Cover Page
//   //       if (showCoverPage && quesPaperInfo?.paper_cover) {
//   //         printContent += `
//   //           <div class="a4-page">
//   //             ${
//   //               watermark
//   //                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                 : ""
//   //             }
//   //             <div style="margin:0; padding:0;">
//   //               ${processedCoverHTML(setName, questionPages)}
//   //             </div>
//   //             <div class="page-footer">
//   //               ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //           quesPaperInfo?.footer?.address || ""
//   //         }
//   //               <span>Set ${setName} - Cover Page</span>
//   //             </div>
//   //           </div>`;
//   //       }

//   //       // Instructions Page
//   //       if (showCoverPage && quesPaperInfo?.instructions_html) {
//   //         printContent += `
//   //     <div class="a4-page" style="padding: 20px;">
//   //       ${
//   //         watermark
//   //           ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //           : ""
//   //       }
//   //       <div class="instructions-heading-print" style="font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px;">Instructions</div>

//   //       <hr style="border: none; border-top: 1px solid #ccc; margin-bottom: 16px;" />

//   //       <div style="font-size: 14px; text-align: justify;">
//   //         ${quesPaperInfo.instructions_html}
//   //       </div>

//   //       <div class="page-footer">
//   //         ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //           quesPaperInfo?.footer?.address || ""
//   //         }
//   //         <span>Set ${setName} - Instructions</span>
//   //       </div>
//   //     </div>`;
//   //       }

//   //       // Syllabus Page
//   //       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//   //         printContent += `
//   //           <div class="a4-page" style="padding: 20px;">
//   //             ${
//   //               watermark
//   //                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                 : ""
//   //             }
//   //             <div class="syllabus-heading-print">Test Syllabus</div>
//   //             <table class="syllabus-table-print">
//   //               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//   //               <tbody>
//   //                 ${quesPaperInfo.subj_chap_list
//   //                   .map(
//   //                     (subj) => `
//   //                   <tr>
//   //                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//   //                     <td>${subj.chapters.join(", ")}</td>
//   //                   </tr>`
//   //                   )
//   //                   .join("")}
//   //               </tbody>
//   //             </table>
//   //             <div class="page-footer">
//   //               ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //           quesPaperInfo?.footer?.address || ""
//   //         }
//   //               <span>Set ${setName} - Syllabus</span>
//   //             </div>
//   //           </div>`;
//   //       }

//   //       // Questions per section
//   //       if (currentSet) {
//   //         currentSet.subjects.forEach((subject) => {
//   //           subject.sections.forEach((section) => {
//   //             const allQuestions = [...(section.questions || [])].sort(
//   //               (a, b) => a.set_ques_position - b.set_ques_position
//   //             );
//   //             if (allQuestions.length === 0) return;

//   //             const questionsPerPage = 10;
//   //             const totalPages = Math.ceil(
//   //               allQuestions.length / questionsPerPage
//   //             );
//   //             let questionIndex = 0;

//   //             for (let page = 0; page < totalPages; page++) {
//   //               const pageQuestions = allQuestions.slice(
//   //                 page * questionsPerPage,
//   //                 (page + 1) * questionsPerPage
//   //               );
//   //               const mid = Math.ceil(pageQuestions.length / 2);
//   //               const leftQuestions = pageQuestions.slice(0, mid);
//   //               const rightQuestions = pageQuestions.slice(mid);

//   //               let subjectHtml = `
//   //                 <p class="section-heading__Pre-ques" style="padding-left: 15px;" >Section ${
//   //                   section.section_name
//   //                 }</p>
//   //                 <p><strong style="padding-left: 15px;">Instruction:</strong> ${
//   //                   section.section_instruction?.trim()
//   //                     ? renderQuestionTextForPrint(section.section_instruction)
//   //                     : "N/A"
//   //                 }</p>
//   //                 <div class="page-header__pre-ques">
//   //                   <div>${quesPaperInfo?.header?.date || ""}</div>
//   //                   <div>${subject.subject_name}</div>
//   //                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//   //                 </div>`;

//   //               if (twinColumn) {
//   //                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//   //                 leftQuestions.forEach((ques) => {
//   //                   subjectHtml += `
//   //                     <div class="question-block">
//   //                       <p><strong>${
//   //                         questionIndex + 1
//   //                       }.</strong> ${renderQuestionTextForPrint(
//   //                     ques.ques_text
//   //                   )}</p>
//   //                       <div class="options__pre-ques">
//   //                         ${ques.options
//   //                           .sort(
//   //                             (a, b) =>
//   //                               a.set_option_position - b.set_option_position
//   //                           )
//   //                           .map(
//   //                             (opt, i) =>
//   //                               `<p><span>${getOptionLabel(
//   //                                 i,
//   //                                 quesPaperInfo?.option_naming_pattern
//   //                               )}</span> ${renderQuestionTextForPrint(
//   //                                 opt.option_text
//   //                               )}</p>`
//   //                           )
//   //                           .join("")}
//   //                       </div>
//   //                     </div>`;
//   //                   questionIndex++;
//   //                 });
//   //                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//   //                 rightQuestions.forEach((ques) => {
//   //                   subjectHtml += `
//   //                     <div class="question-block">
//   //                       <p><strong>${
//   //                         questionIndex + 1
//   //                       }.</strong> ${renderQuestionTextForPrint(
//   //                     ques.ques_text
//   //                   )}</p>
//   //                       <div class="options__pre-ques">
//   //                         ${ques.options
//   //                           .sort(
//   //                             (a, b) =>
//   //                               a.set_option_position - b.set_option_position
//   //                           )
//   //                           .map(
//   //                             (opt, i) =>
//   //                               `<p><span>${getOptionLabel(
//   //                                 i,
//   //                                 quesPaperInfo?.option_naming_pattern
//   //                               )}</span> ${renderQuestionTextForPrint(
//   //                                 opt.option_text
//   //                               )}</p>`
//   //                           )
//   //                           .join("")}
//   //                       </div>
//   //                     </div>`;
//   //                   questionIndex++;
//   //                 });
//   //                 subjectHtml += `</div></div>`;
//   //                 if (roughPage) {
//   //                   const isLastPage = page === totalPages - 1;
//   //                   const roughMinHeight = isLastPage ? "100px" : "200px";
//   //                   subjectHtml += `
//   //   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//   //     <strong>Rough Work:</strong>
//   //   </div>
//   // `;
//   //                 }
//   //               } else {
//   //                 pageQuestions.forEach((ques) => {
//   //                   subjectHtml += `
//   //                     <div class="question-block">
//   //                       <p><strong>${
//   //                         questionIndex + 1
//   //                       }.</strong> ${renderQuestionTextForPrint(
//   //                     ques.ques_text
//   //                   )}</p>
//   //                       <div class="options__pre-ques">
//   //                         ${ques.options
//   //                           .sort(
//   //                             (a, b) =>
//   //                               a.set_option_position - b.set_option_position
//   //                           )
//   //                           .map(
//   //                             (opt, i) =>
//   //                               `<p><span>${getOptionLabel(
//   //                                 i,
//   //                                 quesPaperInfo?.option_naming_pattern
//   //                               )}</span> ${renderQuestionTextForPrint(
//   //                                 opt.option_text
//   //                               )}</p>`
//   //                           )
//   //                           .join("")}
//   //                       </div>
//   //                     </div>`;
//   //                   questionIndex++;
//   //                 });

//   //                 if (roughPage) {
//   //                   const isLastPage = page === totalPages - 1;
//   //                   const roughMinHeight = isLastPage ? "100px" : "200px";
//   //                   subjectHtml += `
//   //   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//   //     <strong>Rough Work:</strong>
//   //   </div>
//   // `;
//   //                 }
//   //               }

//   //               printContent += `
//   //                 <div class="a4-page">
//   //                   ${
//   //                     watermark
//   //                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                       : ""
//   //                   }
//   //                   ${subjectHtml}
//   //                   <div class="page-footer">
//   //                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //                 quesPaperInfo?.footer?.address || ""
//   //               }
//   //                     <span>Page ${questionPageNum++}</span>
//   //                   </div>
//   //                 </div>`;
//   //             }
//   //           });
//   //         });
//   //       }
//   //     });

//   //     const printSectionId = "printSectionDynamic";
//   //     let printSection = document.getElementById(printSectionId);
//   //     if (printSection) document.body.removeChild(printSection);
//   //     printSection = document.createElement("div");
//   //     printSection.id = printSectionId;
//   //     printSection.innerHTML = printContent;
//   //     document.body.appendChild(printSection);
//   //     console.log(printContent);
//   //     window.print();

//   //     setTimeout(() => {
//   //       if (printSection) document.body.removeChild(printSection);
//   //     }, 500);
//   //   };

//   // const handleDownloadWord = () => {
//   //   const calculateTotalPagesForPrint = (set) => {
//   //     let total = 0;
//   //     let questionPages = 0;

//   //     if (showCoverPage) total++;
//   //     if (quesPaperInfo?.subj_chap_list?.length) total++;

//   //     if (!set) return { total, questionPages };

//   //     set.subjects.forEach((subject) => {
//   //       subject.sections.forEach((section) => {
//   //         if ((section.questions || []).length > 0) {
//   //           const questionsPerPage = 10;
//   //           const pages = Math.ceil(
//   //             section.questions.length / questionsPerPage
//   //           );
//   //           total += pages;
//   //           questionPages += pages;
//   //         }
//   //       });
//   //     });

//   //     return { total, questionPages };
//   //   };

//   //   const renderQuestionTextForPrint = (text) => {
//   //     if (!text) return "";
//   //     const decoded = he.decode(text);
//   //     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//   //     return parts
//   //       .map((segment, idx) => {
//   //         if (segment.startsWith("imgsrc=")) {
//   //           const url = segment.replace("imgsrc=", "");
//   //           return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//   //         } else {
//   //           return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//   //             try {
//   //               return katex.renderToString(math, { throwOnError: false });
//   //             } catch (e) {
//   //               return `<span style="color:red;">Invalid LaTeX</span>`;
//   //             }
//   //           });
//   //         }
//   //       })
//   //       .join("");
//   //   };

//   //   const processedCoverHTML = (setName, totalQuesPages) => {
//   //     if (!quesPaperInfo?.paper_cover) return "";
//   //     const testDate = new Date().toLocaleDateString("en-GB");
//   //     return quesPaperInfo.paper_cover
//   //       .replace(/#total_pages#/gi, totalQuesPages)
//   //       .replace(/#test_date#/gi, testDate)
//   //       .replace(/#set_name#/gi, setName);
//   //   };

//   //   let printContent = ``;

//   //   selectedSetNames.forEach((setName) => {
//   //     const currentSet = questionData.find((set) => set.set_name === setName);
//   //     const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//   //     let questionPageNum = 1;

//   //     if (showCoverPage && quesPaperInfo?.paper_cover) {
//   //       printContent += `
//   //         <div class="a4-page">
//   //           ${
//   //             watermark
//   //               ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //               : ""
//   //           }
//   //           <div class="page-content">
//   //             ${processedCoverHTML(setName, questionPages)}
//   //           </div>
//   //           <div class="page-footer">
//   //             ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //         quesPaperInfo?.footer?.address || ""
//   //       }
//   //             <span>Set ${setName} - Cover Page</span>
//   //           </div>
//   //         </div>`;
//   //     }

//   //     if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//   //       printContent += `
//   //         <div class="a4-page">
//   //           ${
//   //             watermark
//   //               ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //               : ""
//   //           }
//   //           <div class="page-content">
//   //             <div class="syllabus-heading-print">Test Syllabus</div>
//   //             <table class="syllabus-table-print">
//   //               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//   //               <tbody>
//   //                 ${quesPaperInfo.subj_chap_list
//   //                   .map(
//   //                     (subj) => `
//   //                   <tr>
//   //                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//   //                     <td>${subj.chapters.join(", ")}</td>
//   //                   </tr>`
//   //                   )
//   //                   .join("")}
//   //               </tbody>
//   //             </table>
//   //           </div>
//   //           <div class="page-footer">
//   //             ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //         quesPaperInfo?.footer?.address || ""
//   //       }
//   //             <span>Set ${setName} - Syllabus</span>
//   //           </div>
//   //         </div>`;
//   //     }

//   //     if (currentSet) {
//   //       currentSet.subjects.forEach((subject) => {
//   //         subject.sections.forEach((section) => {
//   //           const allQuestions = [...(section.questions || [])].sort(
//   //             (a, b) => a.set_ques_position - b.set_ques_position
//   //           );
//   //           if (allQuestions.length === 0) return;

//   //           const questionsPerPage = 10;
//   //           const totalPages = Math.ceil(
//   //             allQuestions.length / questionsPerPage
//   //           );
//   //           let questionIndex = 0;

//   //           for (let page = 0; page < totalPages; page++) {
//   //             const pageQuestions = allQuestions.slice(
//   //               page * questionsPerPage,
//   //               (page + 1) * questionsPerPage
//   //             );
//   //             const mid = Math.ceil(pageQuestions.length / 2);
//   //             const leftQuestions = pageQuestions.slice(0, mid);
//   //             const rightQuestions = pageQuestions.slice(mid);

//   //             let subjectHtml = `
//   //               <p class="section-heading__Pre-ques">Section ${
//   //                 section.section_name
//   //               }</p>
//   //               <p><strong>Instruction:</strong> ${
//   //                 section.section_instruction?.trim()
//   //                   ? renderQuestionTextForPrint(section.section_instruction)
//   //                   : "N/A"
//   //               }</p>
//   //               <div class="page-header__pre-ques">
//   //                 <div>${quesPaperInfo?.header?.date || ""}</div>
//   //                 <div>${subject.subject_name}</div>
//   //                 <div>${quesPaperInfo?.header?.test_name || ""}</div>
//   //               </div>`;

//   //             if (twinColumn) {
//   //               subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//   //               leftQuestions.forEach((ques) => {
//   //                 subjectHtml += `
//   //                   <div class="question-block">
//   //                     <p><strong>${
//   //                       questionIndex + 1
//   //                     }.</strong> ${renderQuestionTextForPrint(
//   //                   ques.ques_text
//   //                 )}</p>
//   //                     <div class="options__pre-ques">
//   //                       ${ques.options
//   //                         .sort(
//   //                           (a, b) =>
//   //                             a.set_option_position - b.set_option_position
//   //                         )
//   //                         .map(
//   //                           (opt, i) =>
//   //                             `<p><span>${getOptionLabel(
//   //                               i,
//   //                               quesPaperInfo?.option_naming_pattern
//   //                             )}</span> ${renderQuestionTextForPrint(
//   //                               opt.option_text
//   //                             )}</p>`
//   //                         )
//   //                         .join("")}
//   //                     </div>
//   //                   </div>`;
//   //                 questionIndex++;
//   //               });
//   //               subjectHtml += `</div><div class="question-column__pre-ques">`;
//   //               rightQuestions.forEach((ques) => {
//   //                 subjectHtml += `
//   //                   <div class="question-block">
//   //                     <p><strong>${
//   //                       questionIndex + 1
//   //                     }.</strong> ${renderQuestionTextForPrint(
//   //                   ques.ques_text
//   //                 )}</p>
//   //                     <div class="options__pre-ques">
//   //                       ${ques.options
//   //                         .sort(
//   //                           (a, b) =>
//   //                             a.set_option_position - b.set_option_position
//   //                         )
//   //                         .map(
//   //                           (opt, i) =>
//   //                             `<p><span>${getOptionLabel(
//   //                               i,
//   //                               quesPaperInfo?.option_naming_pattern
//   //                             )}</span> ${renderQuestionTextForPrint(
//   //                               opt.option_text
//   //                             )}</p>`
//   //                         )
//   //                         .join("")}
//   //                     </div>
//   //                   </div>`;
//   //                 questionIndex++;
//   //               });
//   //               subjectHtml += `</div></div>`;
//   //             } else {
//   //               pageQuestions.forEach((ques) => {
//   //                 subjectHtml += `
//   //                   <div class="question-block">
//   //                     <p><strong>${
//   //                       questionIndex + 1
//   //                     }.</strong> ${renderQuestionTextForPrint(
//   //                   ques.ques_text
//   //                 )}</p>
//   //                     <div class="options__pre-ques">
//   //                       ${ques.options
//   //                         .sort(
//   //                           (a, b) =>
//   //                             a.set_option_position - b.set_option_position
//   //                         )
//   //                         .map(
//   //                           (opt, i) =>
//   //                             `<p><span>${getOptionLabel(
//   //                               i,
//   //                               quesPaperInfo?.option_naming_pattern
//   //                             )}</span> ${renderQuestionTextForPrint(
//   //                               opt.option_text
//   //                             )}</p>`
//   //                         )
//   //                         .join("")}
//   //                     </div>
//   //                   </div>`;
//   //                 questionIndex++;
//   //               });
//   //             }

//   //             printContent += `
//   //               <div class="a4-page">
//   //                 ${
//   //                   watermark
//   //                     ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                     : ""
//   //                 }
//   //                 <div class="page-content">${subjectHtml}</div>
//   //                 <div class="page-footer">
//   //                   ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //               quesPaperInfo?.footer?.address || ""
//   //             }
//   //                   <span>Page ${questionPageNum++}</span>
//   //                 </div>
//   //               </div>`;
//   //           }
//   //         });
//   //       });
//   //     }
//   //   });

//   //   const styledHTML = `
//   //     <html>
//   //       <head>
//   //         <meta charset="utf-8">
//   //         <style>
//   //           @page { size: A4; margin: 0; }
//   //           body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//   //           .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//   //           .page-content { max-width: 180mm; margin: auto; }
//   //           .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//   //           .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//   //           .question-block { margin-bottom: 14px; break-inside: avoid; }
//   //           .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//   //           .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//   //           .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//   //           .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//   //           .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//   //           .syllabus-table-print th { background-color: #f0f0f0; }
//   //           .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//   //         </style>
//   //       </head>
//   //       <body>
//   //         ${printContent}
//   //         <footer>
//   //           ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//   //           ${
//   //             quesPaperInfo?.footer?.address ||
//   //             "B â€“ 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//   //           }
//   //         </footer>
//   //       </body>
//   //     </html>
//   //   `;

//   //   const blob = new Blob([styledHTML], {
//   //     type: "application/msword;charset=utf-8",
//   //   });
//   //   const filename = `${
//   //     quesPaperInfo?.ques_paper_name || "question-paper"
//   //   }.doc`;
//   //   const link = document.createElement("a");
//   //   link.href = URL.createObjectURL(blob);
//   //   link.download = filename;
//   //   link.click();
//   // };

//   // const handleDownloadPDF = () => {
//   //   if (!questionData || questionData.length === 0) return;

//   //   const doc = new jsPDF("p", "mm", "a4");

//   //   const generatePDFForSet = (set, callback) => {
//   //     const setName = set.set_name;
//   //     const syllabusRows = quesPaperInfo?.subj_chap_list?.map((item) => [
//   //       item.subject_name,
//   //       item.chapters.join(", "),
//   //     ]);

//   //     doc.html(processedCoverHTML(setName), {
//   //       callback: () => {
//   //         // Syllabus Page
//   //         doc.addPage();
//   //         doc.setFontSize(16);
//   //         doc.text("Test Syllabus", 105, 20, { align: "center" });

//   //         if (syllabusRows?.length) {
//   //           doc.autoTable({
//   //             head: [["Subject", "Chapters"]],
//   //             body: syllabusRows,
//   //             startY: 30,
//   //             styles: { fontSize: 10 },
//   //             headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//   //             theme: "grid",
//   //           });
//   //         }

//   //         // Add question summary next
//   //         doc.addPage();
//   //         doc.setFontSize(16);
//   //         doc.text(`Set ${setName} - Question Paper Summary`, 14, 20);

//   //         set.subjects.forEach((subject) => {
//   //           const sectionRows = [];

//   //           subject.sections.forEach((section) => {
//   //             (section.questions || []).forEach((ques, index) => {
//   //               const questionText = he
//   //                 .decode(ques.ques_text)
//   //                 .replace(/(<([^>]+)>)/gi, "")
//   //                 .slice(0, 100);
//   //               sectionRows.push([
//   //                 section.section_name,
//   //                 `${index + 1}`,
//   //                 questionText,
//   //                 subject.subject_name,
//   //                 ques.ques_id || "",
//   //               ]);
//   //             });
//   //           });

//   //           if (sectionRows.length > 0) {
//   //             doc.autoTable({
//   //               head: [
//   //                 ["Section", "Q No", "Question Text", "Subject", "Ques ID"],
//   //               ],
//   //               body: sectionRows,
//   //               startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 30,
//   //               styles: { fontSize: 8 },
//   //               headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//   //             });
//   //           }

//   //           doc.addPage(); // optional: remove if not needed per subject
//   //         });

//   //         callback();
//   //       },
//   //       x: 10,
//   //       y: 10,
//   //       margin: 10,
//   //       html2canvas: { scale: 0.4 },
//   //     });
//   //   };

//   //   const setsToProcess = questionData.filter((set) =>
//   //     selectedSetNames.includes(set.set_name)
//   //   );
//   //   let index = 0;

//   //   const processNextSet = () => {
//   //     if (index < setsToProcess.length) {
//   //       generatePDFForSet(setsToProcess[index], () => {
//   //         index++;
//   //         processNextSet();
//   //       });
//   //     } else {
//   //       doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);
//   //     }
//   //   };

//   //   processNextSet();
//   // };
//   const PAGE_CONTENT_HEIGHT_PX = 2100;
//   useEffect(() => {
//     const calculateDynamicPages = () => {
//       if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//         setPaginatedPages([]);
//         return;
//       }

//       // A4 page configuration
//       // A4 is 297mm high, minus margins (~40mm) leaves ~257mm usable height
//       // 1mm ≈ 3.78px, so 257mm ≈ 970px
//       // const PAGE_CONTENT_HEIGHT_PX = 960;
//       // const ROUGH_WORK_MIN_HEIGHT_PX = 100;
//       // Updated - uses more of the A4 page (approximately 75-80% of available space)

//       const ROUGH_WORK_MIN_HEIGHT_PX = 50; // Reduced slightly to accommodate more content

//       const newPages = [];
//       const setsToRender = questionData.filter((set) =>
//         selectedSetNames.includes(set.set_name)
//       );

//       // Create hidden measurement container
//       const measureContainer = document.createElement("div");
//       measureContainer.style.position = "absolute";
//       measureContainer.style.visibility = "hidden";
//       measureContainer.style.left = "-9999px";
//       measureContainer.style.width = "calc(210mm - 40mm)"; // A4 width minus margins
//       measureContainer.style.fontFamily = "Calibri, sans-serif";
//       measureContainer.style.fontSize = "14px";
//       measureContainer.style.lineHeight = "1.4";
//       document.body.appendChild(measureContainer);

//       setsToRender.forEach((set) => {
//         let questionPageCounter = 1;

//         // Add Cover Page
//         if (showCoverPage && quesPaperInfo.paper_cover) {
//           newPages.push({
//             type: "cover",
//             key: `cover-${set.set_name}`,
//             setName: set.set_name,
//             totalQuestionPages: "Dynamic",
//           });
//         }

//         // Add Instructions Page
//         if (showCoverPage && quesPaperInfo.instructions_html) {
//           newPages.push({
//             type: "instructions",
//             key: `instructions-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Add Syllabus Page
//         if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//           newPages.push({
//             type: "syllabus",
//             key: `syllabus-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Dynamic Question Pagination
//         set.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             let currentPageQuestions = [];
//             let questionIndexOffset = 0;

//             // Measure section header height
//             const sectionHeaderHTML = `
//             <p style="font-size: 16px; font-weight: 600; margin: 20px 0 4px 0;">Section ${
//               section.section_name
//             }</p>
//             <p style="margin: 0 0 8px 0;">Instruction: ${
//               section.section_instruction?.trim()
//                 ? renderContentToHTML(section.section_instruction)
//                 : "N/A"
//             }</p>
//             <div style="display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc;">
//               <div>${quesPaperInfo?.header?.date || ""}</div>
//               <div>${subject.subject_name}</div>
//               <div>${quesPaperInfo?.header?.test_name || ""}</div>
//             </div>`;

//             measureContainer.innerHTML = sectionHeaderHTML;
//             let currentHeight = measureContainer.offsetHeight;

//             allQuestions.forEach((ques, index) => {
//               // Create HTML for single question to measure
//               const questionHTML = `
//               <div style="margin-bottom: 14px; page-break-inside: avoid;">
//                 <p style="margin: 0 0 4px 0; line-height: 1.4;">
//                   <strong>${
//                     questionIndexOffset + currentPageQuestions.length + 1
//                   }.</strong>
//                   ${renderContentToHTML(ques.ques_text)}
//                 </p>
//                 <div style="margin-left: 16px;">
//                   ${ques.options
//                     .sort(
//                       (a, b) => a.set_option_position - b.set_option_position
//                     )
//                     .map(
//                       (opt, i) => `
//                       <p style="margin: 4px 0; font-size: 14px; line-height: 1.3;">
//                         ${getOptionLabel(
//                           i,
//                           quesPaperInfo?.option_naming_pattern
//                         )} ${renderContentToHTML(opt.option_text)}
//                       </p>
//                     `
//                     )
//                     .join("")}
//                 </div>
//               </div>`;

//               // Measure question height
//               const tempDiv = document.createElement("div");
//               if (twinColumn) {
//                 tempDiv.style.width = "50%";
//               }
//               tempDiv.innerHTML = questionHTML;
//               measureContainer.innerHTML = "";
//               measureContainer.appendChild(tempDiv);

//               const questionHeight = tempDiv.offsetHeight;
//               const isLastQuestion = index === allQuestions.length - 1;
//               const roughWorkHeight =
//                 roughPage && isLastQuestion ? ROUGH_WORK_MIN_HEIGHT_PX : 0;

//               // Check if adding this question exceeds page height
//               if (
//                 currentHeight + questionHeight + roughWorkHeight >
//                   PAGE_CONTENT_HEIGHT_PX &&
//                 currentPageQuestions.length > 0
//               ) {
//                 // Page is full, save current page
//                 newPages.push({
//                   type: "questions",
//                   key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                   setName: set.set_name,
//                   subject,
//                   section,
//                   questions: currentPageQuestions,
//                   questionIndexOffset,
//                   pageNumber: questionPageCounter++,
//                   isLastPageInSection: false,
//                 });

//                 // Start new page
//                 questionIndexOffset += currentPageQuestions.length;
//                 currentPageQuestions = [ques];
//                 measureContainer.innerHTML = sectionHeaderHTML;
//                 currentHeight = measureContainer.offsetHeight + questionHeight;
//               } else {
//                 // Add question to current page
//                 currentPageQuestions.push(ques);
//                 currentHeight += questionHeight;
//               }
//             });

//             // Add final page for section
//             if (currentPageQuestions.length > 0) {
//               newPages.push({
//                 type: "questions",
//                 key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                 setName: set.set_name,
//                 subject,
//                 section,
//                 questions: currentPageQuestions,
//                 questionIndexOffset,
//                 pageNumber: questionPageCounter++,
//                 isLastPageInSection: true,
//               });
//             }
//           });
//         });

//         // Update cover page with actual question page count
//         const totalQPagesForSet = newPages.filter(
//           (p) => p.type === "questions" && p.setName === set.set_name
//         ).length;
//         const coverPageIndex = newPages.findIndex(
//           (p) => p.type === "cover" && p.setName === set.set_name
//         );
//         if (coverPageIndex > -1) {
//           newPages[coverPageIndex].totalQuestionPages = totalQPagesForSet;
//         }
//       });

//       // Cleanup
//       document.body.removeChild(measureContainer);
//       setPaginatedPages(newPages);
//     };

//     const timeoutId = setTimeout(calculateDynamicPages, 100);
//     return () => clearTimeout(timeoutId);
//   }, [
//     questionData,
//     quesPaperInfo,
//     selectedSetNames,
//     showCoverPage,
//     twinColumn,
//     roughPage,
//     watermark,
//   ]);

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <button
//                   className="icon-btn__pre-ques"
//                   style={{ marginRight: "70px" }}
//                   onClick={handlePrint}
//                 >
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {paginatedPages.length > 0 ? (
//                 paginatedPages.map((page) => (
//                   <div
//                     className={`a4-page${
//                       roughPage && page.type === "questions"
//                         ? " has-roughwork"
//                         : ""
//                     }`}
//                     key={page.key}
//                   >
//                     {watermark && (
//                       <img
//                         src={watermarkImg}
//                         alt="watermark"
//                         className="watermark-image"
//                       />
//                     )}

//                     {/* Page Content */}
//                     {page.type === "cover" && (
//                       <div
//                         dangerouslySetInnerHTML={{
//                           __html: quesPaperInfo.paper_cover
//                             .replace(/#total_pages#/gi, page.totalQuestionPages)
//                             .replace(
//                               /#test_date#/gi,
//                               new Date().toLocaleDateString("en-GB")
//                             )
//                             .replace(/#set_name#/gi, page.setName),
//                         }}
//                       />
//                     )}

//                     {page.type === "instructions" && (
//                       <div className="instructions-page">
//                         <div className="instructions-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Instructions</h2>
//                           <hr
//                             style={{
//                               border: "none",
//                               borderTop: `1px solid ${Colors.color4}`,
//                               margin: "1rem 0",
//                             }}
//                           />
//                         </div>
//                         <div
//                           dangerouslySetInnerHTML={{
//                             __html: quesPaperInfo.instructions_html,
//                           }}
//                         />
//                       </div>
//                     )}

//                     {page.type === "syllabus" && (
//                       <div className="syllabus-page">
//                         <div className="syllabus-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Test Syllabus</h2>
//                         </div>
//                         <table className="syllabus-table_prev_ques">
//                           <thead>
//                             <tr>
//                               <th>Subject</th>
//                               <th>Chapters</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                               <tr key={idx}>
//                                 <td>
//                                   <strong>
//                                     {subj.subject_name.toUpperCase()}
//                                   </strong>
//                                 </td>
//                                 <td>{subj.chapters.join(", ")}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}

//                     {page.type === "questions" && (
//                       <div
//                         className="section-container__pre-ques"
//                         style={{ position: "relative", minHeight: "530px" }}
//                       >
//                         <p className="section-heading__Pre-ques">
//                           Section {page.section.section_name}
//                         </p>
//                         <p>
//                           Instruction:{" "}
//                           {page.section.section_instruction?.trim()
//                             ? renderQuestionText(
//                                 page.section.section_instruction
//                               )
//                             : "N/A"}
//                         </p>
//                         <div className="page-header__pre-ques">
//                           <div className="header-left__pre-ques">
//                             {quesPaperInfo?.header?.date}
//                           </div>
//                           <div className="header-center__pre-ques">
//                             {page.subject.subject_name}
//                           </div>
//                           <div className="header-right__pre-ques">
//                             {quesPaperInfo?.header?.test_name}
//                           </div>
//                         </div>

//                         {(() => {
//                           const questions = page.questions;
//                           const mid = Math.ceil(questions.length / 2);
//                           const leftQuestions = questions.slice(0, mid);
//                           const rightQuestions = questions.slice(mid);

//                           return twinColumn ? (
//                             <div className="question-grid__pre-ques">
//                               <div className="question-column__pre-ques">
//                                 {leftQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset + index + 1}.
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                               <div className="question-column__pre-ques">
//                                 {rightQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset +
//                                           mid +
//                                           index +
//                                           1}
//                                         .
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                             </div>
//                           ) : (
//                             <div>
//                               {questions.map((ques, index) => (
//                                 <div
//                                   key={ques.ques_id}
//                                   className="question-block"
//                                 >
//                                   <p>
//                                     <strong>
//                                       {page.questionIndexOffset + index + 1}.
//                                     </strong>{" "}
//                                     {renderQuestionText(ques.ques_text)}
//                                   </p>
//                                   <div className="options__pre-ques">
//                                     {[...ques.options]
//                                       .sort(
//                                         (a, b) =>
//                                           a.set_option_position -
//                                           b.set_option_position
//                                       )
//                                       .map((opt, idx) => (
//                                         <p key={opt.option_id}>
//                                           <span>
//                                             {getOptionLabel(
//                                               idx,
//                                               quesPaperInfo?.option_naming_pattern
//                                             )}
//                                           </span>{" "}
//                                           {renderQuestionText(opt.option_text)}
//                                         </p>
//                                       ))}
//                                   </div>
//                                 </div>
//                               ))}
//                             </div>
//                           );
//                         })()}

//                         {roughPage && (
//                           <div
//                             className="rough-work-section"
//                             style={{
//                               minHeight: page.isLastPageInSection
//                                 ? "100px"
//                                 : "200px",
//                             }}
//                           >
//                             <strong>Rough Work:</strong>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Page Footer */}
//                     <div className="page-footer">
//                       <div className="footer-left">
//                         {quesPaperInfo?.footer?.client_name} |{" "}
//                         {quesPaperInfo?.footer?.address}
//                       </div>
//                       <div className="footer-right">
//                         {page.type === "cover" &&
//                           `Set ${page.setName} - Cover Page`}
//                         {page.type === "syllabus" &&
//                           `Set ${page.setName} - Syllabus`}
//                         {page.type === "questions" && `Page ${page.pageNumber}`}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";
// import Colors from "../../../Constants/Colors";
// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const [paginatedPages, setPaginatedPages] = useState([]);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Add this helper function to render content to HTML for measurement
//   const renderContentToHTML = (text) => {
//     if (!text) return "";
//     const decoded = he.decode(text);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts
//       .map((segment) => {
//         if (segment.startsWith("imgsrc=")) {
//           const url = segment.replace("imgsrc=", "");
//           return `<img src="${url}" alt="image" style="max-width: 80px; height: auto; vertical-align: middle; margin: 0 5px;" />`;
//         } else {
//           return segment.replace(/\\\((.*?)\\\)/g, (_, math) => {
//             try {
//               return katex.renderToString(math, {
//                 throwOnError: false,
//                 displayMode: false,
//               });
//             } catch (e) {
//               console.warn("Katex rendering error:", e);
//               return `<span style="color:red;">[LaTeX Error]</span>`;
//             }
//           });
//         }
//       })
//       .join("");
//   };

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     if (!paginatedPages || paginatedPages.length === 0) {
//       alert("There is no content to print.");
//       return;
//     }

//     // Helper to process cover page HTML
//     const getProcessedCoverHTML = (page) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, page.totalQuestionPages)
//         .replace(/#test_date#/gi, new Date().toLocaleDateString("en-GB"))
//         .replace(/#set_name#/gi, page.setName);
//     };

//     let printContent = `
//     <style>
//       body, html { margin: 0 !important; padding: 0 !important; background-color: #fff; font-family: Calibri, sans-serif; }
//       .a4-page { width: 210mm; min-height: 297mm; margin: 0 auto; padding: 8mm; box-sizing: border-box; background: white; position: relative; page-break-after: always; }
      
//       .page-content-wrapper { 
//         height: calc(297mm - 15mm); 
//         position: relative; 
//         padding-bottom: 15mm; /* Reduced from 25mm */
//         overflow: hidden;
//       }
//         .question-block img,
//   .question-grid__pre-ques img,
//   .question-column__pre-ques img,
//   .options__pre-ques img {
//     width: 30px !important;
//     height: auto !important;
//     margin: 5px !important;
//     vertical-align: middle !important;
//   }

//       .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//       .watermark img { width: 300px; height: auto; }
//       .section-heading__Pre-ques { font-size: 16px; font-weight: 600; margin: 0px 0 2px 0; padding-left: 15px; } /* Reduced margin */
//       .question-grid__pre-ques { display: flex; gap: 15px; } /* Reduced gap */
//       .question-column__pre-ques { flex: 1; min-width: 0; }
//       .question-block { margin-bottom: 6px; page-break-inside: avoid; } /* Reduced margin */
//       .question-block p { margin: 0 0 2px 0; line-height: 1.2; } /* Reduced line-height and margin */
//       .options__pre-ques p { margin: 2px 0 0px 16px; font-size: 14px; line-height: 1.1; } /* Reduced margins and line-height */
//       .page-footer { 
//         position: absolute; 
//         bottom: 5mm; 
//         left: 8mm; 
//         right: 8mm; 
//         height: 12mm; /* Reduced height */
//         text-align: center; 
//         font-size: 11px; 
//         border-top: 1px solid #ccc; 
//         padding-top: 3px; /* Reduced padding */
//         color: #444; 
//         display: flex; 
//         justify-content: space-between;
//         background: white;
//         z-index: 10;
//       }
//       .page-header__pre-ques { display: flex; justify-content: space-between; font-size: 13px; padding: 3px 12px; margin-bottom: 4px; border-bottom: 1px solid #ccc; } /* Reduced padding and margin */
//       .rough-work-section { margin-top: 10px !important; 
//       border-top: 1px dashed #ccc !important; 
//       padding-top: 5px !important; 
//       min-height: 40px !important;
//       page-break-inside: avoid !important;
//       break-inside: avoid !important;
//       page-break-before: avoid !important;} /* Reduced spacing */
//       .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 3px; padding-bottom: 5px; } /* Reduced margins */
//       .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//       .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 6px; text-align: left; vertical-align: top; } /* Reduced padding */
//       .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//       .instructions-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 3px; padding-bottom: 5px; } /* Reduced margins */
//       .instructions-content { margin-top: 3px; } /* Reduced margin */
//       @media print {
//         body * { visibility: hidden !important; }
//         #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//         #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         .rough-work-section {
//         page-break-inside: avoid !important;
//         break-inside: avoid !important;
//         orphans: 3;
//         widows: 3;
//       }
//       }
//       @page { size: A4; margin: 0; }
//     </style>
//   `;

//     // Iterate through the already calculated paginatedPages
//     paginatedPages.forEach((page) => {
//       printContent += `<div class="a4-page">`;

//       // Add watermark if enabled
//       if (watermark) {
//         printContent += `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`;
//       }

//       printContent += `<div class="page-content-wrapper">`;

//       // Generate content based on page type
//       switch (page.type) {
//         case "cover":
//           printContent += `
//     <div class="cover-page-optimal" style="
//       transform: scale(0.9) !important; /* Balanced shrinking - 15% shrink */
//       transform-origin: top center !important;
//       width: 205mm !important; /* Precise compensation (100/0.85) */
//       height: 297mm !important; /* Use mm consistently - A4 height minus footer/margins */
//       font-size: 11.5px !important; /* Good readability */
//       line-height: 1.15 !important; /* Optimal line spacing */
//       margin: 0 !important;
//       padding: 0px !important; /* Efficient padding in mm */
//       max-height: 297mm !important; /* Safe maximum in mm */
//       overflow: hidden !important;
//       box-sizing: border-box !important;
//       position: absolute !important;
//       top: 0 !important;
//       left: 0 !important;
//       background: white !important;
//     ">
//       ${getProcessedCoverHTML(page)}
//     </div>`;
//           break;

//         case "instructions":
//           printContent += `
//           <div class="instructions-heading-print">Instructions</div>
//           <hr style="border: none; border-top: 1px solid #ccc; margin: 5px 0;" />
//           <div class="instructions-content" style="font-size: 14px; text-align: justify;">${quesPaperInfo.instructions_html}</div>`;
//           break;

//         case "syllabus":
//           printContent += `
//           <div class="syllabus-heading-print">Test Syllabus</div>
//           <table class="syllabus-table-print">
//             <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//             <tbody>
//               ${quesPaperInfo.subj_chap_list
//                 .map(
//                   (s) => `
//                 <tr>
//                   <td><strong>${s.subject_name.toUpperCase()}</strong></td>
//                   <td>${s.chapters.join(", ")}</td>
//                 </tr>
//               `
//                 )
//                 .join("")}
//             </tbody>
//           </table>`;
//           break;

//         case "questions":
//           let questionsHtml = `
//           <p class="section-heading__Pre-ques">Section ${
//             page.section.section_name
//           }</p>
//           <p style="padding-left: 15px; margin: 0 0 4px 0;"><strong>Instruction:</strong> ${
//             page.section.section_instruction?.trim()
//               ? renderContentToHTML(page.section.section_instruction)
//               : "N/A"
//           }</p>
//           <div class="page-header__pre-ques">
//             <div>${quesPaperInfo?.header?.date || ""}</div>
//             <div>${page.subject.subject_name}</div>
//             <div>${quesPaperInfo?.header?.test_name || ""}</div>
//           </div>`;

//           const renderQuestionColumn = (qs, offset) =>
//             qs
//               .map(
//                 (q, i) => `
//           <div class="question-block">
//             <p><strong>${offset + i + 1}.</strong> ${renderContentToHTML(
//                   q.ques_text
//                 )}</p>
//             <div class="options__pre-ques">
//               ${q.options
//                 .sort((a, b) => a.set_option_position - b.set_option_position)
//                 .map(
//                   (opt, oi) => `
//                 <p><span>${getOptionLabel(
//                   oi,
//                   quesPaperInfo?.option_naming_pattern
//                 )}</span> ${renderContentToHTML(opt.option_text)}</p>
//               `
//                 )
//                 .join("")}
//             </div>
//           </div>`
//               )
//               .join("");

//           if (twinColumn) {
//             const mid = Math.ceil(page.questions.length / 2);
//             questionsHtml += `
//             <div class="question-grid__pre-ques">
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(0, mid),
//                 page.questionIndexOffset
//               )}</div>
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(mid),
//                 page.questionIndexOffset + mid
//               )}</div>
//             </div>`;
//           } else {
//             questionsHtml += `<div>${renderQuestionColumn(
//               page.questions,
//               page.questionIndexOffset
//             )}</div>`;
//           }

//           // Add rough work section if enabled and this is the last page of the section
//           if (roughPage) {
//             const roughWorkHeight = page.isLastPageInSection ? "60px" : "120px";
//             questionsHtml += `
//             <div class="rough-work-section" style="min-height: ${roughWorkHeight};">
//             <strong>Rough Work:</strong>
//             </div>`;
//           }

//           printContent += questionsHtml;
//           break;

//         default:
//           break;
//       }

//       printContent += `</div>`; // Close page-content-wrapper

//       // Add footer for all page types
//       printContent += `
//       <div class="page-footer">
//         <div>${quesPaperInfo?.footer?.client_name || ""} | ${
//         quesPaperInfo?.footer?.address || ""
//       }</div>
//         <div>
//           ${page.type === "cover" ? `Set ${page.setName} - Cover Page` : ""}
//           ${
//             page.type === "instructions"
//               ? `Set ${page.setName} - Instructions`
//               : ""
//           }
//           ${page.type === "syllabus" ? `Set ${page.setName} - Syllabus` : ""}
//           ${page.type === "questions" ? `Page ${page.pageNumber}` : ""}
//         </div>
//       </div>
//     `;

//       printContent += `</div>`; // Close a4-page
//     });

//     // Create and inject print section
//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);

//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);

//     // Print with a small delay to ensure rendering
//     setTimeout(() => {
//       window.print();
//       // Cleanup after printing
//       setTimeout(() => {
//         if (document.getElementById(printSectionId)) {
//           document.body.removeChild(document.getElementById(printSectionId));
//         }
//       }, 1000);
//     }, 500);
//   };

//   useEffect(() => {
//     const calculateDynamicPages = () => {
//       if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//         setPaginatedPages([]);
//         return;
//       }

//       // Adjust page content height based on layout mode
//       const BASE_PAGE_CONTENT_HEIGHT_PX = 2110;
//       const PAGE_CONTENT_HEIGHT_PX = twinColumn
//         ? BASE_PAGE_CONTENT_HEIGHT_PX
//         : BASE_PAGE_CONTENT_HEIGHT_PX * 0.55; // Reduce available height for single column to maintain consistency

//       const ROUGH_WORK_MIN_HEIGHT_PX = 40;

//       const newPages = [];
//       const setsToRender = questionData.filter((set) =>
//         selectedSetNames.includes(set.set_name)
//       );

//       // Create hidden measurement container
//       const measureContainer = document.createElement("div");
//       measureContainer.style.position = "absolute";
//       measureContainer.style.visibility = "hidden";
//       measureContainer.style.left = "-9999px";
//       measureContainer.style.width = "calc(210mm - 40mm)";
//       measureContainer.style.fontFamily = "Calibri, sans-serif";
//       measureContainer.style.fontSize = "14px";
//       measureContainer.style.lineHeight = "1.4";
//       document.body.appendChild(measureContainer);

//       setsToRender.forEach((set) => {
//         let questionPageCounter = 1;
//         let globalQuestionCounter = 0;

//         // Add Cover Page
//         if (showCoverPage && quesPaperInfo.paper_cover) {
//           newPages.push({
//             type: "cover",
//             key: `cover-${set.set_name}`,
//             setName: set.set_name,
//             totalQuestionPages: "Dynamic",
//           });
//         }

//         // Add Instructions Page
//         if (showCoverPage && quesPaperInfo.instructions_html) {
//           newPages.push({
//             type: "instructions",
//             key: `instructions-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Add Syllabus Page
//         if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//           newPages.push({
//             type: "syllabus",
//             key: `syllabus-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Dynamic Question Pagination
//         set.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             let currentPageQuestions = [];
//             let currentPageStartIndex = globalQuestionCounter;

//             // Measure section header height
//             const sectionHeaderHTML = `
//             <p style="font-size: 16px; font-weight: 600; margin: 20px 0 4px 0;">Section ${
//               section.section_name
//             }</p>
//             <p style="margin: 0 0 8px 0;">Instruction: ${
//               section.section_instruction?.trim()
//                 ? renderContentToHTML(section.section_instruction)
//                 : "N/A"
//             }</p>
//             <div style="display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc;">
//               <div>${quesPaperInfo?.header?.date || ""}</div>
//               <div>${subject.subject_name}</div>
//               <div>${quesPaperInfo?.header?.test_name || ""}</div>
//             </div>`;

//             measureContainer.innerHTML = sectionHeaderHTML;
//             let currentHeight = measureContainer.offsetHeight;

//             allQuestions.forEach((ques, index) => {
//               // Create HTML for single question to measure
//               const questionHTML = `
//               <div style="margin-bottom: 8px; page-break-inside: avoid;">
//                 <p style="margin: 0 0 3px 0; line-height: 1.3;">
//                   <strong>${
//                     globalQuestionCounter + currentPageQuestions.length + 1
//                   }.</strong> 
//                   ${renderContentToHTML(ques.ques_text)}
//                 </p>
//                 <div style="margin-left: 16px;">
//                   ${ques.options
//                     .sort(
//                       (a, b) => a.set_option_position - b.set_option_position
//                     )
//                     .map(
//                       (opt, i) => `
//                         <p style="margin: 3px 0; font-size: 14px; line-height: 1.2;">
//                           ${getOptionLabel(
//                             i,
//                             quesPaperInfo?.option_naming_pattern
//                           )} ${renderContentToHTML(opt.option_text)}
//                         </p>
//                       `
//                     )
//                     .join("")}
//                 </div>
//               </div>`;

//               // Measure question height consistently
//               const tempDiv = document.createElement("div");
//               // Always measure at consistent width for fair comparison
//               tempDiv.style.width = twinColumn ? "50%" : "100%";
//               tempDiv.innerHTML = questionHTML;
//               measureContainer.innerHTML = "";
//               measureContainer.appendChild(tempDiv);

//               let questionHeight = tempDiv.offsetHeight;

//               // Apply layout-specific height adjustment
//               if (twinColumn) {
//                 // In twin column, questions are side by side, so we can fit more vertically
//                 questionHeight = questionHeight;
//               } else {
//                 // In single column, questions take full width and stack vertically
//                 // Apply a multiplier to account for the visual difference
//                 questionHeight = questionHeight * 1.0; // Keep actual measured height
//               }

//               const isLastQuestion = index === allQuestions.length - 1;
//               const roughWorkHeight = roughPage
//                 ? isLastQuestion
//                   ? 60
//                   : 120
//                 : 0;

//               // Check if adding this question exceeds page height
//               const availableHeight = PAGE_CONTENT_HEIGHT_PX - 50;
//               const totalHeightNeeded =
//                 currentHeight + questionHeight + roughWorkHeight;

//               if (
//                 totalHeightNeeded > availableHeight &&
//                 currentPageQuestions.length > 0
//               ) {
//                 // Page is full, save current page
//                 newPages.push({
//                   type: "questions",
//                   key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                   setName: set.set_name,
//                   subject,
//                   section,
//                   questions: currentPageQuestions,
//                   questionIndexOffset: currentPageStartIndex,
//                   pageNumber: questionPageCounter++,
//                   isLastPageInSection: false,
//                 });

//                 // Update global counter and start new page
//                 globalQuestionCounter += currentPageQuestions.length;
//                 currentPageStartIndex = globalQuestionCounter;
//                 currentPageQuestions = [ques];
//                 measureContainer.innerHTML = sectionHeaderHTML;
//                 currentHeight = measureContainer.offsetHeight + questionHeight;
//               } else {
//                 // Add question to current page
//                 currentPageQuestions.push(ques);
//                 currentHeight += questionHeight;
//               }
//             });

//             // Add final page for section
//             if (currentPageQuestions.length > 0) {
//               newPages.push({
//                 type: "questions",
//                 key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                 setName: set.set_name,
//                 subject,
//                 section,
//                 questions: currentPageQuestions,
//                 questionIndexOffset: currentPageStartIndex,
//                 pageNumber: questionPageCounter++,
//                 isLastPageInSection: true,
//               });

//               globalQuestionCounter += currentPageQuestions.length;
//             }
//           });
//         });

//         // Update cover page with actual question page count
//         const totalQPagesForSet = newPages.filter(
//           (p) => p.type === "questions" && p.setName === set.set_name
//         ).length;
//         const coverPageIndex = newPages.findIndex(
//           (p) => p.type === "cover" && p.setName === set.set_name
//         );
//         if (coverPageIndex > -1) {
//           newPages[coverPageIndex].totalQuestionPages = totalQPagesForSet;
//         }
//       });

//       // Cleanup
//       document.body.removeChild(measureContainer);
//       setPaginatedPages(newPages);
//     };

//     const timeoutId = setTimeout(calculateDynamicPages, 100);
//     return () => clearTimeout(timeoutId);
//   }, [
//     questionData,
//     quesPaperInfo,
//     selectedSetNames,
//     showCoverPage,
//     twinColumn,
//     roughPage,
//     watermark,
//   ]);

//   // useEffect(() => {
//   //   const calculateDynamicPages = () => {
//   //     if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//   //       setPaginatedPages([]);
//   //       return;
//   //     }

//   //     // A4 page configuration
//   //     // A4 is 297mm high, minus margins (~40mm) leaves ~257mm usable height
//   //     // 1mm ≈ 3.78px, so 257mm ≈ 970px
//   //     // const PAGE_CONTENT_HEIGHT_PX = 960;
//   //     // const ROUGH_WORK_MIN_HEIGHT_PX = 100;
//   //     // Updated - uses more of the A4 page (approximately 75-80% of available space)
//   //     const PAGE_CONTENT_HEIGHT_PX = 2110;
//   //     const ROUGH_WORK_MIN_HEIGHT_PX = 40; // Reduced slightly to accommodate more content

//   //     const newPages = [];
//   //     const setsToRender = questionData.filter((set) =>
//   //       selectedSetNames.includes(set.set_name)
//   //     );

//   //     // Create hidden measurement container
//   //     const measureContainer = document.createElement("div");
//   //     measureContainer.style.position = "absolute";
//   //     measureContainer.style.visibility = "hidden";
//   //     measureContainer.style.left = "-9999px";
//   //     measureContainer.style.width = "calc(210mm - 40mm)"; // A4 width minus margins
//   //     measureContainer.style.fontFamily = "Calibri, sans-serif";
//   //     measureContainer.style.fontSize = "14px";
//   //     measureContainer.style.lineHeight = "1.4";
//   //     document.body.appendChild(measureContainer);

//   //     setsToRender.forEach((set) => {
//   //       let questionPageCounter = 1;

//   //       // Add Cover Page
//   //       if (showCoverPage && quesPaperInfo.paper_cover) {
//   //         newPages.push({
//   //           type: "cover",
//   //           key: `cover-${set.set_name}`,
//   //           setName: set.set_name,
//   //           totalQuestionPages: "Dynamic",
//   //         });
//   //       }

//   //       // Add Instructions Page
//   //       if (showCoverPage && quesPaperInfo.instructions_html) {
//   //         newPages.push({
//   //           type: "instructions",
//   //           key: `instructions-${set.set_name}`,
//   //           setName: set.set_name,
//   //         });
//   //       }

//   //       // Add Syllabus Page
//   //       if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//   //         newPages.push({
//   //           type: "syllabus",
//   //           key: `syllabus-${set.set_name}`,
//   //           setName: set.set_name,
//   //         });
//   //       }

//   //       // Dynamic Question Pagination
//   //       set.subjects.forEach((subject) => {
//   //         subject.sections.forEach((section) => {
//   //           const allQuestions = [...(section.questions || [])].sort(
//   //             (a, b) => a.set_ques_position - b.set_ques_position
//   //           );
//   //           if (allQuestions.length === 0) return;

//   //           let currentPageQuestions = [];
//   //           let questionIndexOffset = 0;

//   //           // Measure section header height
//   //           const sectionHeaderHTML = `
//   //           <p style="font-size: 16px; font-weight: 600; margin: 20px 0 4px 0;">Section ${
//   //             section.section_name
//   //           }</p>
//   //           <p style="margin: 0 0 8px 0;">Instruction: ${
//   //             section.section_instruction?.trim()
//   //               ? renderContentToHTML(section.section_instruction)
//   //               : "N/A"
//   //           }</p>
//   //           <div style="display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc;">
//   //             <div>${quesPaperInfo?.header?.date || ""}</div>
//   //             <div>${subject.subject_name}</div>
//   //             <div>${quesPaperInfo?.header?.test_name || ""}</div>
//   //           </div>`;

//   //           measureContainer.innerHTML = sectionHeaderHTML;
//   //           let currentHeight = measureContainer.offsetHeight;

//   //           allQuestions.forEach((ques, index) => {
//   //             // Create HTML for single question to measure
//   //             // In the questionHTML template, replace the question block div:
//   //             const questionHTML = `
//   // <div style="margin-bottom: 8px; page-break-inside: avoid;"> <!-- Reduced from 14px -->
//   //   <p style="margin: 0 0 3px 0; line-height: 1.3;"> <!-- Reduced margin and line-height -->
//   //     <strong>${
//   //       questionIndexOffset + currentPageQuestions.length + 1
//   //     }.</strong>
//   //     ${renderContentToHTML(ques.ques_text)}
//   //   </p>
//   //   <div style="margin-left: 16px;">
//   //     ${ques.options
//   //       .sort((a, b) => a.set_option_position - b.set_option_position)
//   //       .map(
//   //         (opt, i) => `
//   //           <p style="margin: 3px 0; font-size: 14px; line-height: 1.2;"> <!-- Reduced margin and line-height -->
//   //             ${getOptionLabel(
//   //               i,
//   //               quesPaperInfo?.option_naming_pattern
//   //             )} ${renderContentToHTML(opt.option_text)}
//   //           </p>
//   //         `
//   //       )
//   //       .join("")}
//   //   </div>
//   // </div>`;

//   //             // Measure question height
//   //             const tempDiv = document.createElement("div");
//   //             if (twinColumn) {
//   //               tempDiv.style.width = "50%";
//   //             }
//   //             tempDiv.innerHTML = questionHTML;
//   //             measureContainer.innerHTML = "";
//   //             measureContainer.appendChild(tempDiv);

//   //             const questionHeight = tempDiv.offsetHeight;
//   //             const isLastQuestion = index === allQuestions.length - 1;
//   //             const roughWorkHeight = roughPage
//   //               ? isLastQuestion
//   //                 ? 60
//   //                 : 120
//   //               : 0; // Match preview heights exactly

//   //             // Check if adding this question exceeds page height
//   //             const availableHeight = PAGE_CONTENT_HEIGHT_PX - 50; // Even smaller buffer
//   //             const totalHeightNeeded =
//   //               currentHeight + questionHeight + roughWorkHeight;

//   //             if (
//   //               totalHeightNeeded > availableHeight &&
//   //               currentPageQuestions.length > 0
//   //             ) {
//   //               // Page is full, save current page
//   //               newPages.push({
//   //                 type: "questions",
//   //                 key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//   //                 setName: set.set_name,
//   //                 subject,
//   //                 section,
//   //                 questions: currentPageQuestions,
//   //                 questionIndexOffset,
//   //                 pageNumber: questionPageCounter++,
//   //                 isLastPageInSection: false,
//   //               });

//   //               // Start new page
//   //               questionIndexOffset += currentPageQuestions.length;
//   //               currentPageQuestions = [ques];
//   //               measureContainer.innerHTML = sectionHeaderHTML;
//   //               currentHeight = measureContainer.offsetHeight + questionHeight;
//   //             } else {
//   //               // Add question to current page
//   //               currentPageQuestions.push(ques);
//   //               currentHeight += questionHeight;
//   //             }
//   //           });

//   //           // Add final page for section
//   //           if (currentPageQuestions.length > 0) {
//   //             newPages.push({
//   //               type: "questions",
//   //               key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//   //               setName: set.set_name,
//   //               subject,
//   //               section,
//   //               questions: currentPageQuestions,
//   //               questionIndexOffset,
//   //               pageNumber: questionPageCounter++,
//   //               isLastPageInSection: true,
//   //             });
//   //           }
//   //         });
//   //       });

//   //       // Update cover page with actual question page count
//   //       const totalQPagesForSet = newPages.filter(
//   //         (p) => p.type === "questions" && p.setName === set.set_name
//   //       ).length;
//   //       const coverPageIndex = newPages.findIndex(
//   //         (p) => p.type === "cover" && p.setName === set.set_name
//   //       );
//   //       if (coverPageIndex > -1) {
//   //         newPages[coverPageIndex].totalQuestionPages = totalQPagesForSet;
//   //       }
//   //     });

//   //     // Cleanup
//   //     document.body.removeChild(measureContainer);
//   //     setPaginatedPages(newPages);
//   //   };

//   //   const timeoutId = setTimeout(calculateDynamicPages, 100);
//   //   return () => clearTimeout(timeoutId);
//   // }, [
//   //   questionData,
//   //   quesPaperInfo,
//   //   selectedSetNames,
//   //   showCoverPage,
//   //   twinColumn,
//   //   roughPage,
//   //   watermark,
//   // ]);

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <button
//                   className="icon-btn__pre-ques"
//                   style={{ marginRight: "70px" }}
//                   onClick={handlePrint}
//                 >
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {paginatedPages.length > 0 ? (
//                 paginatedPages.map((page) => (
//                   <div
//                     className={`a4-page${
//                       roughPage && page.type === "questions"
//                         ? " has-roughwork"
//                         : ""
//                     }`}
//                     key={page.key}
//                   >
//                     {watermark && (
//                       <img
//                         src={watermarkImg}
//                         alt="watermark"
//                         className="watermark-image"
//                       />
//                     )}

//                     {/* Page Content */}
//                     {page.type === "cover" && (
//                       <div
//                         dangerouslySetInnerHTML={{
//                           __html: quesPaperInfo.paper_cover
//                             .replace(/#total_pages#/gi, page.totalQuestionPages)
//                             .replace(
//                               /#test_date#/gi,
//                               new Date().toLocaleDateString("en-GB")
//                             )
//                             .replace(/#set_name#/gi, page.setName),
//                         }}
//                       />
//                     )}

//                     {page.type === "instructions" && (
//                       <div className="instructions-page">
//                         <div className="instructions-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Instructions</h2>
//                           <hr
//                             style={{
//                               border: "none",
//                               borderTop: `1px solid ${Colors.color4}`,
//                               margin: "1rem 0",
//                             }}
//                           />
//                         </div>
//                         <div
//                           dangerouslySetInnerHTML={{
//                             __html: quesPaperInfo.instructions_html,
//                           }}
//                         />
//                       </div>
//                     )}

//                     {page.type === "syllabus" && (
//                       <div className="syllabus-page">
//                         <div className="syllabus-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Test Syllabus</h2>
//                         </div>
//                         <table className="syllabus-table_prev_ques">
//                           <thead>
//                             <tr>
//                               <th>Subject</th>
//                               <th>Chapters</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                               <tr key={idx}>
//                                 <td>
//                                   <strong>
//                                     {subj.subject_name.toUpperCase()}
//                                   </strong>
//                                 </td>
//                                 <td>{subj.chapters.join(", ")}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}

//                     {page.type === "questions" && (
//                       <div
//                         className="section-container__pre-ques"
//                         style={{ position: "relative", minHeight: "530px" }}
//                       >
//                         <p className="section-heading__Pre-ques">
//                           Section {page.section.section_name}
//                         </p>
//                         <p>
//                           Instruction:{" "}
//                           {page.section.section_instruction?.trim()
//                             ? renderQuestionText(
//                                 page.section.section_instruction
//                               )
//                             : "N/A"}
//                         </p>
//                         <div className="page-header__pre-ques">
//                           <div className="header-left__pre-ques">
//                             {quesPaperInfo?.header?.date}
//                           </div>
//                           <div className="header-center__pre-ques">
//                             {page.subject.subject_name}
//                           </div>
//                           <div className="header-right__pre-ques">
//                             {quesPaperInfo?.header?.test_name}
//                           </div>
//                         </div>

//                         {(() => {
//                           const questions = page.questions;
//                           const mid = Math.ceil(questions.length / 2);
//                           const leftQuestions = questions.slice(0, mid);
//                           const rightQuestions = questions.slice(mid);

//                           return twinColumn ? (
//                             <div className="question-grid__pre-ques">
//                               <div className="question-column__pre-ques">
//                                 {leftQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset + index + 1}.
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                               <div className="question-column__pre-ques">
//                                 {rightQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset +
//                                           mid +
//                                           index +
//                                           1}
//                                         .
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                             </div>
//                           ) : (
//                             <div>
//                               {questions.map((ques, index) => (
//                                 <div
//                                   key={ques.ques_id}
//                                   className="question-block"
//                                 >
//                                   <p>
//                                     <strong>
//                                       {page.questionIndexOffset + index + 1}.
//                                     </strong>{" "}
//                                     {renderQuestionText(ques.ques_text)}
//                                   </p>
//                                   <div className="options__pre-ques">
//                                     {[...ques.options]
//                                       .sort(
//                                         (a, b) =>
//                                           a.set_option_position -
//                                           b.set_option_position
//                                       )
//                                       .map((opt, idx) => (
//                                         <p key={opt.option_id}>
//                                           <span>
//                                             {getOptionLabel(
//                                               idx,
//                                               quesPaperInfo?.option_naming_pattern
//                                             )}
//                                           </span>{" "}
//                                           {renderQuestionText(opt.option_text)}
//                                         </p>
//                                       ))}
//                                   </div>
//                                 </div>
//                               ))}
//                             </div>
//                           );
//                         })()}

//                         {roughPage && (
//                           <div
//                             className="rough-work-section"
//                             style={{
//                               minHeight: page.isLastPageInSection
//                                 ? "60px"
//                                 : "120px", // Reduced heights
//                             }}
//                           >
//                             <strong>Rough Work:</strong>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Page Footer */}
//                     <div className="page-footer">
//                       <div className="footer-left">
//                         {quesPaperInfo?.footer?.client_name} |{" "}
//                         {quesPaperInfo?.footer?.address}
//                       </div>
//                       <div className="footer-right">
//                         {page.type === "cover" &&
//                           `Set ${page.setName} - Cover Page`}
//                         {page.type === "syllabus" &&
//                           `Set ${page.setName} - Syllabus`}
//                         {page.type === "questions" && `Page ${page.pageNumber}`}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;



// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";

// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = `
//       <style>
//         body, html { margin:0!important; padding:0!important; }
//         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//         .watermark img { width: 300px; height: auto; }
//         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//         .question-grid__pre-ques { display:flex;}
//         .question-column__pre-ques { flex:1; }
//         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//         .page-footer span { float:right; }
//         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//         @media print {
//           body * { visibility: hidden !important; }
//           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         }
//         @page { size:A4; margin:0; }
//       </style>
//     `;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       // Cover Page
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div style="margin:0; padding:0;">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       // Syllabus Page
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="syllabus-heading-print">Test Syllabus</div>
//             <table class="syllabus-table-print">
//               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//               <tbody>
//                 ${quesPaperInfo.subj_chap_list
//                   .map(
//                     (subj) => `
//                   <tr>
//                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                     <td>${subj.chapters.join(", ")}</td>
//                   </tr>`
//                   )
//                   .join("")}
//               </tbody>
//             </table>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       // Questions per section
//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   ${subjectHtml}
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);
//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);

//     window.print();

//     setTimeout(() => {
//       if (printSection) document.body.removeChild(printSection);
//     }, 500);
//   };

//   const handleDownloadWord = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = ``;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               <div class="syllabus-heading-print">Test Syllabus</div>
//               <table class="syllabus-table-print">
//                 <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//                 <tbody>
//                   ${quesPaperInfo.subj_chap_list
//                     .map(
//                       (subj) => `
//                     <tr>
//                       <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                       <td>${subj.chapters.join(", ")}</td>
//                     </tr>`
//                     )
//                     .join("")}
//                 </tbody>
//               </table>
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   <div class="page-content">${subjectHtml}</div>
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const styledHTML = `
//       <html>
//         <head>
//           <meta charset="utf-8">
//           <style>
//             @page { size: A4; margin: 0; }
//             body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//             .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//             .page-content { max-width: 180mm; margin: auto; }
//             .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//             .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//             .question-block { margin-bottom: 14px; break-inside: avoid; }
//             .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//             .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//             .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//             .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//             .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//             .syllabus-table-print th { background-color: #f0f0f0; }
//             .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//           </style>
//         </head>
//         <body>
//           ${printContent}
//           <footer>
//             ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//             ${
//               quesPaperInfo?.footer?.address ||
//               "B – 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//             }
//           </footer>
//         </body>
//       </html>
//     `;

//     const blob = new Blob([styledHTML], {
//       type: "application/msword;charset=utf-8",
//     });
//     const filename = `${
//       quesPaperInfo?.ques_paper_name || "question-paper"
//     }.doc`;
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = filename;
//     link.click();
//   };

//   /**
//    * Generates the full HTML string for the question paper based on current state.
//    * This is the missing function that resolves the 'not defined' error.
//    */
//   const generatePrintableHTML = () => {
//     // Return early if essential data isn't loaded yet
//     if (!quesPaperInfo || questionData.length === 0) {
//       return "<p>Loading data, please wait...</p>";
//     }

//     // Helper function to calculate the number of pages for questions
//     const calculateTotalPagesForPrint = (set) => {
//       let questionPages = 0;
//       if (!set) return questionPages;
//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             // Adjust questions per page based on layout
//             const questionsPerPage = twinColumn ? 20 : 10;
//             questionPages += Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//           }
//         });
//       });
//       return questionPages;
//     };

//     // Helper function to render text content, including LaTeX and images
//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             // Use inline-block for better alignment with text
//             return `<img src="${url}" style="width:auto; height:1.5em; max-width:100%; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             // Render LaTeX using KaTeX
//             return segment.replace(/\\\((.*?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(he.decode(math), {
//                   throwOnError: false,
//                   displayMode: false,
//                 });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     // Helper function to process the cover page HTML template
//     const processedCoverHTMLForPrint = (setName) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       const currentSet = questionData.find((s) => s.set_name === setName);
//       const totalQuesPages = calculateTotalPagesForPrint(currentSet);
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     // Start building the full HTML string with styles
//     let fullHtml = `
//     <style>
//       body { margin: 0; padding: 0; font-family: sans-serif; }
//       .a4-page { width: 210mm; height: 296mm; padding: 15mm; box-sizing: border-box; background: white; position: relative; page-break-after: always; overflow: hidden; }
//       .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//       .watermark img { width: 400px; height: auto; }
//       .section-heading__Pre-ques { font-size: 16px; font-weight: 600; padding-bottom: 4px; margin-top: 20px; border-bottom: 1px solid #333; }
//       .question-grid__pre-ques { display: flex; gap: 15mm; }
//       .question-column__pre-ques { flex: 1; min-width: 0; }
//       .question-block { margin-bottom: 12px; page-break-inside: avoid; }
//       .options__pre-ques p { margin: 4px 0 0 16px; font-size: 14px; }
//       .page-footer { position: absolute; bottom: 10mm; left: 15mm; right: 15mm; font-size: 11px; border-top: 1px solid #ccc; padding-top: 4px; color: #444; display: flex; justify-content: space-between; }
//       .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//       .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//       .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; }
//       .page-header__pre-ques { display: flex; justify-content: space-between; font-size: 13px; padding: 4px 0; margin-bottom: 8px; border-bottom: 1px solid #ccc; }
//     </style>
//   `;

//     // Loop through each selected set and build its pages
//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       if (!currentSet) return;

//       let pageCounter = 1;

//       // Add Cover Page if toggled
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         fullHtml += `<div class="a4-page">${
//           watermark
//             ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//             : ""
//         }${processedCoverHTMLForPrint(setName)}<div class="page-footer"><div>${
//           quesPaperInfo?.footer?.client_name || ""
//         } | ${
//           quesPaperInfo?.footer?.address || ""
//         }</div><div>Set ${setName} - Cover Page</div></div></div>`;
//       }

//       // Add Syllabus Page if toggled
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         fullHtml += `<div class="a4-page">${
//           watermark
//             ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//             : ""
//         }<div class="syllabus-heading-print">Test Syllabus</div><table class="syllabus-table-print"><thead><tr><th>Subject</th><th>Chapters</th></tr></thead><tbody>${quesPaperInfo.subj_chap_list
//           .map(
//             (subj) =>
//               `<tr><td><strong>${subj.subject_name.toUpperCase()}</strong></td><td>${subj.chapters.join(
//                 ", "
//               )}</td></tr>`
//           )
//           .join("")}</tbody></table><div class="page-footer"><div>${
//           quesPaperInfo?.footer?.client_name || ""
//         } | ${
//           quesPaperInfo?.footer?.address || ""
//         }</div><div>Set ${setName} - Syllabus</div></div></div>`;
//       }

//       // Loop through subjects and sections to create question pages
//       currentSet.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           const allQuestions = [...(section.questions || [])].sort(
//             (a, b) => a.set_ques_position - b.set_ques_position
//           );
//           if (allQuestions.length === 0) return;

//           const questionsPerPage = twinColumn ? 20 : 10;
//           const totalPagesForSection = Math.ceil(
//             allQuestions.length / questionsPerPage
//           );

//           for (let page = 0; page < totalPagesForSection; page++) {
//             const pageQuestions = allQuestions.slice(
//               page * questionsPerPage,
//               (page + 1) * questionsPerPage
//             );
//             const questionStartIndex = page * questionsPerPage;
//             let pageHtml = "";

//             if (twinColumn) {
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftCol = pageQuestions.slice(0, mid);
//               const rightCol = pageQuestions.slice(mid);
//               pageHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">${leftCol
//                 .map(
//                   (ques, i) =>
//                     `<div class="question-block"><p><strong>${
//                       questionStartIndex + i + 1
//                     }.</strong> ${renderQuestionTextForPrint(
//                       ques.ques_text
//                     )}</p><div class="options__pre-ques">${ques.options
//                       .sort(
//                         (a, b) => a.set_option_position - b.set_option_position
//                       )
//                       .map(
//                         (opt, oi) =>
//                           `<p><span>${getOptionLabel(
//                             oi,
//                             quesPaperInfo?.option_naming_pattern
//                           )}</span> ${renderQuestionTextForPrint(
//                             opt.option_text
//                           )}</p>`
//                       )
//                       .join("")}</div></div>`
//                 )
//                 .join(
//                   ""
//                 )}</div><div class="question-column__pre-ques">${rightCol
//                 .map(
//                   (ques, i) =>
//                     `<div class="question-block"><p><strong>${
//                       questionStartIndex + mid + i + 1
//                     }.</strong> ${renderQuestionTextForPrint(
//                       ques.ques_text
//                     )}</p><div class="options__pre-ques">${ques.options
//                       .sort(
//                         (a, b) => a.set_option_position - b.set_option_position
//                       )
//                       .map(
//                         (opt, oi) =>
//                           `<p><span>${getOptionLabel(
//                             oi,
//                             quesPaperInfo?.option_naming_pattern
//                           )}</span> ${renderQuestionTextForPrint(
//                             opt.option_text
//                           )}</p>`
//                       )
//                       .join("")}</div></div>`
//                 )
//                 .join("")}</div></div>`;
//             } else {
//               pageHtml += pageQuestions
//                 .map(
//                   (ques, i) =>
//                     `<div class="question-block"><p><strong>${
//                       questionStartIndex + i + 1
//                     }.</strong> ${renderQuestionTextForPrint(
//                       ques.ques_text
//                     )}</p><div class="options__pre-ques">${ques.options
//                       .sort(
//                         (a, b) => a.set_option_position - b.set_option_position
//                       )
//                       .map(
//                         (opt, oi) =>
//                           `<p><span>${getOptionLabel(
//                             oi,
//                             quesPaperInfo?.option_naming_pattern
//                           )}</span> ${renderQuestionTextForPrint(
//                             opt.option_text
//                           )}</p>`
//                       )
//                       .join("")}</div></div>`
//                 )
//                 .join("");
//             }

//             fullHtml += `<div class="a4-page">${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }<div class="page-header__pre-ques"><div>${
//               quesPaperInfo?.header?.date || ""
//             }</div><div>${subject.subject_name}</div><div>${
//               quesPaperInfo?.header?.test_name || ""
//             }</div></div><p class="section-heading__Pre-ques">Section ${
//               section.section_name
//             }</p><p><strong>Instruction:</strong> ${
//               section.section_instruction?.trim()
//                 ? renderQuestionTextForPrint(section.section_instruction)
//                 : "N/A"
//             }</p>${pageHtml}<div class="page-footer"><div>${
//               quesPaperInfo?.footer?.client_name || ""
//             } | ${
//               quesPaperInfo?.footer?.address || ""
//             }</div><div>Page ${pageCounter++}</div></div></div>`;
//           }
//         });
//       });

//       // Add Rough Work page if toggled
//       if (roughPage) {
//         fullHtml += `<div class="a4-page">${
//           watermark
//             ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//             : ""
//         }<h2 style="text-align:center; margin-top: 40px;">Rough Work</h2><div class="page-footer"><div>${
//           quesPaperInfo?.footer?.client_name || ""
//         } | ${
//           quesPaperInfo?.footer?.address || ""
//         }</div><div>Rough Work</div></div></div>`;
//       }
//     });
//     return fullHtml;
//   };

//   const handleDownloadPDF = async () => {
//     // // Get the container element that is actually visible on the screen
//     // const printArea = contentRef.current;
//     // if (!printArea) {
//     //   alert("Preview area not found. Cannot generate PDF.");
//     //   return;
//     // }

//     // // Show a loading indicator for better user experience
//     // const loader = document.createElement('div');
//     // loader.innerText = 'Generating PDF, please wait...';
//     // Object.assign(loader.style, {
//     //   position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
//     //   backgroundColor: 'rgba(255, 255, 255, 0.9)', padding: '20px', border: '1px solid #ccc',
//     //   borderRadius: '10px', boxShadow: '0 4px 15px rgba(0,0,0,0.2)', zIndex: '10000'
//     // });
//     // document.body.appendChild(loader);

//     // try {
//     //   // Find all the rendered ".a4-page" divs inside the live preview
//     //   const pages = printArea.querySelectorAll('.a4-page');
//     //   if (pages.length === 0) {
//     //     throw new Error("No pages found to export. Please select a set to preview.");
//     //   }

//     //   const doc = new jsPDF('p', 'mm', 'a4');
//     //   const pdfWidth = doc.internal.pageSize.getWidth();
//     //   const pdfHeight = doc.internal.pageSize.getHeight();

//     //   // Process each visible page sequentially
//     //   for (let i = 0; i < pages.length; i++) {
//     //     const pageElement = pages[i];

//     //     // Crucial step: Ensure the page is scrolled into view before capturing
//     //     // This forces the browser to fully render it.
//     //     pageElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     //     await new Promise(resolve => setTimeout(resolve, 100)); // Brief pause for rendering

//     //     const canvas = await html2canvas(pageElement, {
//     //       scale: 2.5,         // Increase scale for sharper text and images
//     //       useCORS: true,      // Allows capturing cross-origin images
//     //       logging: false,     // Clean up console logs
//     //       // Provide context to help html2canvas render correctly
//     //       windowWidth: printArea.scrollWidth,
//     //       windowHeight: printArea.scrollHeight,
//     //     });

//     //     // Add a new page to the PDF for each element after the first one
//     //     if (i > 0) {
//     //       doc.addPage();
//     //     }

//     //     const imgData = canvas.toDataURL('image/jpeg', 0.95);
//     //     doc.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST');
//     //   }

//     //   // Save the final document
//     //   doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);

//     // } catch (error) {
//     //   console.error("Error generating PDF:", error);
//     //   alert(`An error occurred while generating the PDF: ${error.message}`);
//     // } finally {
//     //   // Clean up by removing the loader
//     //   document.body.removeChild(loader);
//     // }
//     const loader = document.createElement("div");
//     loader.innerText = "Generating PDF, please wait...";
//     document.body.appendChild(loader);

//     try {
//       const htmlContent = generatePrintableHTML();
//       const container = document.createElement("div");
//       container.style.position = "fixed";
//       container.style.left = "-9999px";
//       container.style.top = "0";
//       container.innerHTML = htmlContent;
//       document.body.appendChild(container);

//       const images = Array.from(container.querySelectorAll("img"));
//       await Promise.all(
//         images.map((img) =>
//           img.complete
//             ? Promise.resolve()
//             : new Promise((res) => {
//                 img.onload = res;
//                 img.onerror = res;
//               })
//         )
//       );

//       const pages = container.querySelectorAll(".a4-page");
//       const doc = new jsPDF("p", "mm", "a4");
//       const pdfWidth = doc.internal.pageSize.getWidth();
//       const pdfHeight = doc.internal.pageSize.getHeight();

//       for (let i = 0; i < pages.length; i++) {
//         const pageElement = pages[i];
//         const canvas = await html2canvas(pageElement, {
//           backgroundColor: null,
//           scale: 2,
//           useCORS: true,
//         });
//         const imgData = canvas.toDataURL("image/jpeg", 0.95);
//         if (i !== 0) doc.addPage();
//         doc.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
//       }

//       doc.save(`${quesPaperInfo?.ques_paper_name || "exported"}.pdf`);
//       document.body.removeChild(container);
//     } catch (error) {
//       console.error("Error generating PDF:", error);
//       alert("Failed to generate PDF.");
//     } finally {
//       document.body.removeChild(loader);
//     }
//   };

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <div
//                   className="export-dropdown-container__pre-ques"
//                   ref={exportDropdownRef}
//                 >
//                   <button
//                     className="icon-btn__pre-ques"
//                     onClick={() => setShowExportOptions(!showExportOptions)}
//                   >
//                     <img
//                       src={ExportIcon}
//                       alt="exporticon"
//                       style={{ marginRight: "5px" }}
//                     />{" "}
//                     Export
//                   </button>
//                   {showExportOptions && (
//                     <div className="export-options-dropdown__pre-ques">
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadPDF}
//                       >
//                         <FaFilePdf className="Img-PDF" />
//                         <span>PDF</span>
//                       </button>
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadWord}
//                       >
//                         <FaFileWord className="Img-WORD" />
//                         <span>Word</span>
//                       </button>
//                     </div>
//                   )}
//                 </div>
//                 <button className="icon-btn__pre-ques" onClick={handlePrint}>
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {/* {watermark && <img src={watermarkImg} alt="watermark" className="watermark-image" />} */}
//               {selectedSetNames.length === 0 ? (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               ) : (
//                 questionData
//                   .filter((set) => selectedSetNames.includes(set.set_name))
//                   .map((set) => (
//                     <React.Fragment key={`set-${set.set_name}`}>
//                       {showCoverPage && quesPaperInfo?.paper_cover && (
//                         <div className="a4-page" key={`cover-${set.set_name}`}>
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div
//                             dangerouslySetInnerHTML={{
//                               __html: processedCoverHTML(set.set_name),
//                             }}
//                           />
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Cover Page
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {showCoverPage && quesPaperInfo?.subj_chap_list && (
//                         <div className="a4-page syllabus-page">
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div className="syllabus-heading_prev_ques">
//                             <h2 style={{ textAlign: "center" }}>
//                               Test Syllabus
//                             </h2>
//                           </div>
//                           <table className="syllabus-table_prev_ques">
//                             <thead>
//                               <tr>
//                                 <th>Subject</th>
//                                 <th>Chapters</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                                 <tr key={idx}>
//                                   <td>
//                                     <strong>
//                                       {(subj.subject_name || "").toUpperCase()}
//                                     </strong>
//                                   </td>
//                                   <td>{(subj.chapters || []).join(", ")}</td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Syllabus
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {set.subjects.map((subject, subjectIndex) => (
//                         <div
//                           className="a4-page"
//                           key={`set-${set.set_name}-subject-${subject.subject_id}`}
//                         >
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           {subject.sections.map((section) => {
//                             const questions = [
//                               ...(section.questions || []),
//                             ].sort(
//                               (a, b) =>
//                                 a.set_ques_position - b.set_ques_position
//                             );
//                             const mid = Math.ceil(questions.length / 2);
//                             const leftQuestions = questions.slice(0, mid);
//                             const rightQuestions = questions.slice(mid);
//                             return (
//                               <div
//                                 key={`section-${section.section_name}`}
//                                 className="section-container__pre-ques"
//                               >
//                                 <p className="section-heading__Pre-ques">
//                                   Section {section.section_name}
//                                 </p>
//                                 <p>
//                                   Instruction:{" "}
//                                   {section.section_instruction?.trim()
//                                     ? renderQuestionText(
//                                         section.section_instruction
//                                       )
//                                     : "N/A"}
//                                 </p>
//                                 <div className="page-header__pre-ques">
//                                   <div className="header-left__pre-ques">
//                                     {quesPaperInfo?.header?.date}
//                                   </div>
//                                   <div className="header-center__pre-ques">
//                                     {subject.subject_name}
//                                   </div>
//                                   <div className="header-right__pre-ques">
//                                     {quesPaperInfo?.header?.test_name}
//                                   </div>
//                                 </div>
//                                 {twinColumn ? (
//                                   <div className="question-grid__pre-ques">
//                                     <div className="question-column__pre-ques">
//                                       {leftQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                     <div className="question-column__pre-ques">
//                                       {rightQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + mid + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   </div>
//                                 ) : (
//                                   <div>
//                                     {questions.map((ques, index) => (
//                                       <div
//                                         key={ques.ques_id}
//                                         className="question-block"
//                                       >
//                                         <p>
//                                           <strong>{index + 1}.</strong>{" "}
//                                           {renderQuestionText(ques.ques_text)}
//                                         </p>
//                                         <div className="options__pre-ques">
//                                           {[...ques.options]
//                                             .sort(
//                                               (a, b) =>
//                                                 a.set_option_position -
//                                                 b.set_option_position
//                                             )
//                                             .map((opt, idx) => (
//                                               <p key={opt.option_id}>
//                                                 <span>
//                                                   {getOptionLabel(
//                                                     idx,
//                                                     quesPaperInfo?.option_naming_pattern
//                                                   )}
//                                                 </span>{" "}
//                                                 {renderQuestionText(
//                                                   opt.option_text
//                                                 )}
//                                               </p>
//                                             ))}
//                                         </div>
//                                       </div>
//                                     ))}
//                                   </div>
//                                 )}
//                               </div>
//                             );
//                           })}
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Page {subjectIndex + 1}
//                             </div>
//                             {/* <div className="footer-right">Set {set.set_name} - {subject.subject_name}</div> */}
//                           </div>
//                         </div>
//                       ))}
//                     </React.Fragment>
//                   ))
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";

// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = `
//       <style>
//         body, html { margin:0!important; padding:0!important; }
//         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//         .watermark img { width: 300px; height: auto; }
//         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//         .question-grid__pre-ques { display:flex;}
//         .question-column__pre-ques { flex:1; }
//         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//         .page-footer span { float:right; }
//         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//         @media print {
//           body * { visibility: hidden !important; }
//           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         }
//         @page { size:A4; margin:0; }
//       </style>
//     `;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       // Cover Page
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div style="margin:0; padding:0;">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       // Syllabus Page
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page" style="padding: 20px;">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="syllabus-heading-print">Test Syllabus</div>
//             <table class="syllabus-table-print">
//               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//               <tbody>
//                 ${quesPaperInfo.subj_chap_list
//                   .map(
//                     (subj) => `
//                   <tr>
//                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                     <td>${subj.chapters.join(", ")}</td>
//                   </tr>`
//                   )
//                   .join("")}
//               </tbody>
//             </table>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       // Questions per section
//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques" style="padding-left: 15px;" >Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong style="padding-left: 15px;">Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//                 if (roughPage) {
//                   const isLastPage = page === totalPages - 1;
//                   const roughMinHeight = isLastPage ? "100px" : "200px";
//                   subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//                 }
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });

//                 if (roughPage) {
//                   const isLastPage = page === totalPages - 1;
//                   const roughMinHeight = isLastPage ? "100px" : "200px";
//                   subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//                 }
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   ${subjectHtml}
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);
//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);
//     console.log(printContent);
//     window.print();

//     setTimeout(() => {
//       if (printSection) document.body.removeChild(printSection);
//     }, 500);
//   };

//   const handleDownloadWord = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = ``;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               <div class="syllabus-heading-print">Test Syllabus</div>
//               <table class="syllabus-table-print">
//                 <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//                 <tbody>
//                   ${quesPaperInfo.subj_chap_list
//                     .map(
//                       (subj) => `
//                     <tr>
//                       <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                       <td>${subj.chapters.join(", ")}</td>
//                     </tr>`
//                     )
//                     .join("")}
//                 </tbody>
//               </table>
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   <div class="page-content">${subjectHtml}</div>
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const styledHTML = `
//       <html>
//         <head>
//           <meta charset="utf-8">
//           <style>
//             @page { size: A4; margin: 0; }
//             body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//             .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//             .page-content { max-width: 180mm; margin: auto; }
//             .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//             .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//             .question-block { margin-bottom: 14px; break-inside: avoid; }
//             .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//             .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//             .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//             .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//             .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//             .syllabus-table-print th { background-color: #f0f0f0; }
//             .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//           </style>
//         </head>
//         <body>
//           ${printContent}
//           <footer>
//             ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//             ${
//               quesPaperInfo?.footer?.address ||
//               "B â€“ 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//             }
//           </footer>
//         </body>
//       </html>
//     `;

//     const blob = new Blob([styledHTML], {
//       type: "application/msword;charset=utf-8",
//     });
//     const filename = `${
//       quesPaperInfo?.ques_paper_name || "question-paper"
//     }.doc`;
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = filename;
//     link.click();
//   };

//   const handleDownloadPDF = () => {
//     if (!questionData || questionData.length === 0) return;

//     const doc = new jsPDF("p", "mm", "a4");

//     const generatePDFForSet = (set, callback) => {
//       const setName = set.set_name;
//       const syllabusRows = quesPaperInfo?.subj_chap_list?.map((item) => [
//         item.subject_name,
//         item.chapters.join(", "),
//       ]);

//       doc.html(processedCoverHTML(setName), {
//         callback: () => {
//           // Syllabus Page
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text("Test Syllabus", 105, 20, { align: "center" });

//           if (syllabusRows?.length) {
//             doc.autoTable({
//               head: [["Subject", "Chapters"]],
//               body: syllabusRows,
//               startY: 30,
//               styles: { fontSize: 10 },
//               headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               theme: "grid",
//             });
//           }

//           // Add question summary next
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text(`Set ${setName} - Question Paper Summary`, 14, 20);

//           set.subjects.forEach((subject) => {
//             const sectionRows = [];

//             subject.sections.forEach((section) => {
//               (section.questions || []).forEach((ques, index) => {
//                 const questionText = he
//                   .decode(ques.ques_text)
//                   .replace(/(<([^>]+)>)/gi, "")
//                   .slice(0, 100);
//                 sectionRows.push([
//                   section.section_name,
//                   `${index + 1}`,
//                   questionText,
//                   subject.subject_name,
//                   ques.ques_id || "",
//                 ]);
//               });
//             });

//             if (sectionRows.length > 0) {
//               doc.autoTable({
//                 head: [
//                   ["Section", "Q No", "Question Text", "Subject", "Ques ID"],
//                 ],
//                 body: sectionRows,
//                 startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 30,
//                 styles: { fontSize: 8 },
//                 headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               });
//             }

//             doc.addPage(); // optional: remove if not needed per subject
//           });

//           callback();
//         },
//         x: 10,
//         y: 10,
//         margin: 10,
//         html2canvas: { scale: 0.4 },
//       });
//     };

//     const setsToProcess = questionData.filter((set) =>
//       selectedSetNames.includes(set.set_name)
//     );
//     let index = 0;

//     const processNextSet = () => {
//       if (index < setsToProcess.length) {
//         generatePDFForSet(setsToProcess[index], () => {
//           index++;
//           processNextSet();
//         });
//       } else {
//         doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);
//       }
//     };

//     processNextSet();
//   };

//   const previewPages = React.useMemo(() => {
//     const pages = [];
//     if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//       return [];
//     }

//     const setsToRender = questionData.filter((set) =>
//       selectedSetNames.includes(set.set_name)
//     );

//     // This function pre-calculates the total number of question pages for a given set.
//     // This is needed for the #total_pages# placeholder on the cover page.
//     const calculateTotalQuestionPages = (set) => {
//       let count = 0;
//       if (!set) return 0;
//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           const questionsPerPage = 10;
//           count += Math.ceil(
//             (section.questions || []).length / questionsPerPage
//           );
//         });
//       });
//       return count;
//     };

//     setsToRender.forEach((set) => {
//       let questionPageCounter = 1; // This will be the running page number for display.
//       const totalQuestionPagesForSet = calculateTotalQuestionPages(set);

//       // 1. Add Cover Page
//       if (showCoverPage && quesPaperInfo.paper_cover) {
//         pages.push({
//           type: "cover",
//           key: `cover-${set.set_name}`,
//           setName: set.set_name,
//           totalQuestionPages: totalQuestionPagesForSet,
//         });
//       }

//       // 2. Add Syllabus Page
//       if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//         pages.push({
//           type: "syllabus",
//           key: `syllabus-${set.set_name}`,
//           setName: set.set_name,
//         });
//       }

//       // 3. Add Question Pages (Paginated)
//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           const allQuestions = [...(section.questions || [])].sort(
//             (a, b) => a.set_ques_position - b.set_ques_position
//           );
//           if (allQuestions.length === 0) return;

//           const questionsPerPage = 10;
//           const totalPagesInSection = Math.ceil(
//             allQuestions.length / questionsPerPage
//           );
//           let questionIndex = 0; // To track question number within the section

//           for (let i = 0; i < totalPagesInSection; i++) {
//             const pageQuestions = allQuestions.slice(
//               i * questionsPerPage,
//               (i + 1) * questionsPerPage
//             );

//             pages.push({
//               type: "questions",
//               key: `questions-${set.set_name}-${subject.subject_id}-${section.section_name}-${i}`,
//               setName: set.set_name,
//               subject,
//               section,
//               questions: pageQuestions,
//               questionIndexOffset: questionIndex,
//               pageNumber: questionPageCounter++,
//               isLastPageInSection: i === totalPagesInSection - 1,
//             });
//             questionIndex += pageQuestions.length;
//           }
//         });
//       });
//     });

//     return pages;
//   }, [
//     questionData,
//     quesPaperInfo,
//     selectedSetNames,
//     showCoverPage,
//     watermark,
//     twinColumn,
//     roughPage,
//   ]);

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <div
//                   className="export-dropdown-container__pre-ques"
//                   ref={exportDropdownRef}
//                 >
//                   <button
//                     className="icon-btn__pre-ques"
//                     onClick={() => setShowExportOptions(!showExportOptions)}
//                   >
//                     <img
//                       src={ExportIcon}
//                       alt="exporticon"
//                       style={{ marginRight: "5px" }}
//                     />{" "}
//                     Export
//                   </button>
//                   {showExportOptions && (
//                     <div className="export-options-dropdown__pre-ques">
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadPDF}
//                       >
//                         <FaFilePdf className="Img-PDF" />
//                         <span>PDF</span>
//                       </button>
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadWord}
//                       >
//                         <FaFileWord className="Img-WORD" />
//                         <span>Word</span>
//                       </button>
//                     </div>
//                   )}
//                 </div>
//                 <button className="icon-btn__pre-ques" onClick={handlePrint}>
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {previewPages.length > 0 ? (
//                 previewPages.map((page) => (
//                   <div
//                     className={`a4-page${
//                       roughPage && page.type === "questions"
//                         ? " has-roughwork"
//                         : ""
//                     }`}
//                     key={page.key}
//                   >
//                     {watermark && (
//                       <img
//                         src={watermarkImg}
//                         alt="watermark"
//                         className="watermark-image"
//                       />
//                     )}

//                     {/* Page Content */}
//                     {page.type === "cover" && (
//                       <div
//                         dangerouslySetInnerHTML={{
//                           __html: quesPaperInfo.paper_cover
//                             .replace(/#total_pages#/gi, page.totalQuestionPages)
//                             .replace(
//                               /#test_date#/gi,
//                               new Date().toLocaleDateString("en-GB")
//                             )
//                             .replace(/#set_name#/gi, page.setName),
//                         }}
//                       />
//                     )}

//                     {page.type === "syllabus" && (
//                       <div className="syllabus-page">
//                         <div className="syllabus-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Test Syllabus</h2>
//                         </div>
//                         <table className="syllabus-table_prev_ques">
//                           <thead>
//                             <tr>
//                               <th>Subject</th>
//                               <th>Chapters</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                               <tr key={idx}>
//                                 <td>
//                                   <strong>
//                                     {subj.subject_name.toUpperCase()}
//                                   </strong>
//                                 </td>
//                                 <td>{subj.chapters.join(", ")}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}

//                     {page.type === "questions" && (
//                       <div
//                         className="section-container__pre-ques"
//                         style={{ position: "relative", minHeight: "530px" }}
//                       >
//                         <p className="section-heading__Pre-ques">
//                           Section {page.section.section_name}
//                         </p>
//                         <p>
//                           Instruction:{" "}
//                           {page.section.section_instruction?.trim()
//                             ? renderQuestionText(
//                                 page.section.section_instruction
//                               )
//                             : "N/A"}
//                         </p>
//                         <div className="page-header__pre-ques">
//                           <div className="header-left__pre-ques">
//                             {quesPaperInfo?.header?.date}
//                           </div>
//                           <div className="header-center__pre-ques">
//                             {page.subject.subject_name}
//                           </div>
//                           <div className="header-right__pre-ques">
//                             {quesPaperInfo?.header?.test_name}
//                           </div>
//                         </div>

//                         {(() => {
//                           const questions = page.questions;
//                           const mid = Math.ceil(questions.length / 2);
//                           const leftQuestions = questions.slice(0, mid);
//                           const rightQuestions = questions.slice(mid);

//                           return twinColumn ? (
//                             <div className="question-grid__pre-ques">
//                               <div className="question-column__pre-ques">
//                                 {leftQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset + index + 1}.
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                               <div className="question-column__pre-ques">
//                                 {rightQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset +
//                                           mid +
//                                           index +
//                                           1}
//                                         .
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                             </div>
//                           ) : (
//                             <div>
//                               {questions.map((ques, index) => (
//                                 <div
//                                   key={ques.ques_id}
//                                   className="question-block"
//                                 >
//                                   <p>
//                                     <strong>
//                                       {page.questionIndexOffset + index + 1}.
//                                     </strong>{" "}
//                                     {renderQuestionText(ques.ques_text)}
//                                   </p>
//                                   <div className="options__pre-ques">
//                                     {[...ques.options]
//                                       .sort(
//                                         (a, b) =>
//                                           a.set_option_position -
//                                           b.set_option_position
//                                       )
//                                       .map((opt, idx) => (
//                                         <p key={opt.option_id}>
//                                           <span>
//                                             {getOptionLabel(
//                                               idx,
//                                               quesPaperInfo?.option_naming_pattern
//                                             )}
//                                           </span>{" "}
//                                           {renderQuestionText(opt.option_text)}
//                                         </p>
//                                       ))}
//                                   </div>
//                                 </div>
//                               ))}
//                             </div>
//                           );
//                         })()}

//                         {roughPage && (
//                           <div
//                             className="rough-work-section"
//                             style={{
//                               minHeight: page.isLastPageInSection
//                                 ? "100px"
//                                 : "200px",
//                             }}
//                           >
//                             <strong>Rough Work:</strong>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Page Footer */}
//                     <div className="page-footer">
//                       <div className="footer-left">
//                         {quesPaperInfo?.footer?.client_name} |{" "}
//                         {quesPaperInfo?.footer?.address}
//                       </div>
//                       <div className="footer-right">
//                         {page.type === "cover" &&
//                           `Set ${page.setName} - Cover Page`}
//                         {page.type === "syllabus" &&
//                           `Set ${page.setName} - Syllabus`}
//                         {page.type === "questions" && `Page ${page.pageNumber}`}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";

// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = `
//       <style>
//         body, html { margin:0!important; padding:0!important; }
//         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//         .watermark img { width: 300px; height: auto; }
//         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//         .question-grid__pre-ques { display:flex;}
//         .question-column__pre-ques { flex:1; }
//         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//         .page-footer span { float:right; }
//         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//         @media print {
//           body * { visibility: hidden !important; }
//           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         }
//         @page { size:A4; margin:0; }
//       </style>
//     `;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       // Cover Page
//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div style="margin:0; padding:0;">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       // Syllabus Page
//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page" style="padding: 20px;">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="syllabus-heading-print">Test Syllabus</div>
//             <table class="syllabus-table-print">
//               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//               <tbody>
//                 ${quesPaperInfo.subj_chap_list
//                   .map(
//                     (subj) => `
//                   <tr>
//                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                     <td>${subj.chapters.join(", ")}</td>
//                   </tr>`
//                   )
//                   .join("")}
//               </tbody>
//             </table>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       // Questions per section
//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques" style="padding-left: 15px;" >Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong style="padding-left: 15px;">Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//                 const isLastPage = page === totalPages - 1;
//                 const roughMinHeight = isLastPage ? "100px" : "200px";
//                 subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                   const isLastPage = page === totalPages - 1;
//                   const roughMinHeight = isLastPage ? "100px" : "200px";
//                   subjectHtml += `
//   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//     <strong>Rough Work:</strong>
//   </div>
// `;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   ${subjectHtml}
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);
//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);
//     console.log(printContent);
//     window.print();

//     setTimeout(() => {
//       if (printSection) document.body.removeChild(printSection);
//     }, 500);
//   };

//   const handleDownloadWord = () => {
//     const calculateTotalPagesForPrint = (set) => {
//       let total = 0;
//       let questionPages = 0;

//       if (showCoverPage) total++;
//       if (quesPaperInfo?.subj_chap_list?.length) total++;

//       if (!set) return { total, questionPages };

//       set.subjects.forEach((subject) => {
//         subject.sections.forEach((section) => {
//           if ((section.questions || []).length > 0) {
//             const questionsPerPage = 10;
//             const pages = Math.ceil(
//               section.questions.length / questionsPerPage
//             );
//             total += pages;
//             questionPages += pages;
//           }
//         });
//       });

//       return { total, questionPages };
//     };

//     const renderQuestionTextForPrint = (text) => {
//       if (!text) return "";
//       const decoded = he.decode(text);
//       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//       return parts
//         .map((segment, idx) => {
//           if (segment.startsWith("imgsrc=")) {
//             const url = segment.replace("imgsrc=", "");
//             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//           } else {
//             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//               try {
//                 return katex.renderToString(math, { throwOnError: false });
//               } catch (e) {
//                 return `<span style="color:red;">Invalid LaTeX</span>`;
//               }
//             });
//           }
//         })
//         .join("");
//     };

//     const processedCoverHTML = (setName, totalQuesPages) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       const testDate = new Date().toLocaleDateString("en-GB");
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, totalQuesPages)
//         .replace(/#test_date#/gi, testDate)
//         .replace(/#set_name#/gi, setName);
//     };

//     let printContent = ``;

//     selectedSetNames.forEach((setName) => {
//       const currentSet = questionData.find((set) => set.set_name === setName);
//       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//       let questionPageNum = 1;

//       if (showCoverPage && quesPaperInfo?.paper_cover) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               ${processedCoverHTML(setName, questionPages)}
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Cover Page</span>
//             </div>
//           </div>`;
//       }

//       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//         printContent += `
//           <div class="a4-page">
//             ${
//               watermark
//                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                 : ""
//             }
//             <div class="page-content">
//               <div class="syllabus-heading-print">Test Syllabus</div>
//               <table class="syllabus-table-print">
//                 <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//                 <tbody>
//                   ${quesPaperInfo.subj_chap_list
//                     .map(
//                       (subj) => `
//                     <tr>
//                       <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//                       <td>${subj.chapters.join(", ")}</td>
//                     </tr>`
//                     )
//                     .join("")}
//                 </tbody>
//               </table>
//             </div>
//             <div class="page-footer">
//               ${quesPaperInfo?.footer?.client_name || ""} | ${
//           quesPaperInfo?.footer?.address || ""
//         }
//               <span>Set ${setName} - Syllabus</span>
//             </div>
//           </div>`;
//       }

//       if (currentSet) {
//         currentSet.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             const questionsPerPage = 10;
//             const totalPages = Math.ceil(
//               allQuestions.length / questionsPerPage
//             );
//             let questionIndex = 0;

//             for (let page = 0; page < totalPages; page++) {
//               const pageQuestions = allQuestions.slice(
//                 page * questionsPerPage,
//                 (page + 1) * questionsPerPage
//               );
//               const mid = Math.ceil(pageQuestions.length / 2);
//               const leftQuestions = pageQuestions.slice(0, mid);
//               const rightQuestions = pageQuestions.slice(mid);

//               let subjectHtml = `
//                 <p class="section-heading__Pre-ques">Section ${
//                   section.section_name
//                 }</p>
//                 <p><strong>Instruction:</strong> ${
//                   section.section_instruction?.trim()
//                     ? renderQuestionTextForPrint(section.section_instruction)
//                     : "N/A"
//                 }</p>
//                 <div class="page-header__pre-ques">
//                   <div>${quesPaperInfo?.header?.date || ""}</div>
//                   <div>${subject.subject_name}</div>
//                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//                 </div>`;

//               if (twinColumn) {
//                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//                 leftQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//                 rightQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//                 subjectHtml += `</div></div>`;
//               } else {
//                 pageQuestions.forEach((ques) => {
//                   subjectHtml += `
//                     <div class="question-block">
//                       <p><strong>${
//                         questionIndex + 1
//                       }.</strong> ${renderQuestionTextForPrint(
//                     ques.ques_text
//                   )}</p>
//                       <div class="options__pre-ques">
//                         ${ques.options
//                           .sort(
//                             (a, b) =>
//                               a.set_option_position - b.set_option_position
//                           )
//                           .map(
//                             (opt, i) =>
//                               `<p><span>${getOptionLabel(
//                                 i,
//                                 quesPaperInfo?.option_naming_pattern
//                               )}</span> ${renderQuestionTextForPrint(
//                                 opt.option_text
//                               )}</p>`
//                           )
//                           .join("")}
//                       </div>
//                     </div>`;
//                   questionIndex++;
//                 });
//               }

//               printContent += `
//                 <div class="a4-page">
//                   ${
//                     watermark
//                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//                       : ""
//                   }
//                   <div class="page-content">${subjectHtml}</div>
//                   <div class="page-footer">
//                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//                 quesPaperInfo?.footer?.address || ""
//               }
//                     <span>Page ${questionPageNum++}</span>
//                   </div>
//                 </div>`;
//             }
//           });
//         });
//       }
//     });

//     const styledHTML = `
//       <html>
//         <head>
//           <meta charset="utf-8">
//           <style>
//             @page { size: A4; margin: 0; }
//             body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//             .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//             .page-content { max-width: 180mm; margin: auto; }
//             .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//             .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//             .question-block { margin-bottom: 14px; break-inside: avoid; }
//             .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//             .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//             .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//             .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//             .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//             .syllabus-table-print th { background-color: #f0f0f0; }
//             .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//           </style>
//         </head>
//         <body>
//           ${printContent}
//           <footer>
//             ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//             ${
//               quesPaperInfo?.footer?.address ||
//               "B â€“ 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//             }
//           </footer>
//         </body>
//       </html>
//     `;

//     const blob = new Blob([styledHTML], {
//       type: "application/msword;charset=utf-8",
//     });
//     const filename = `${
//       quesPaperInfo?.ques_paper_name || "question-paper"
//     }.doc`;
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = filename;
//     link.click();
//   };

//   const handleDownloadPDF = () => {
//     if (!questionData || questionData.length === 0) return;

//     const doc = new jsPDF("p", "mm", "a4");

//     const generatePDFForSet = (set, callback) => {
//       const setName = set.set_name;
//       const syllabusRows = quesPaperInfo?.subj_chap_list?.map((item) => [
//         item.subject_name,
//         item.chapters.join(", "),
//       ]);

//       doc.html(processedCoverHTML(setName), {
//         callback: () => {
//           // Syllabus Page
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text("Test Syllabus", 105, 20, { align: "center" });

//           if (syllabusRows?.length) {
//             doc.autoTable({
//               head: [["Subject", "Chapters"]],
//               body: syllabusRows,
//               startY: 30,
//               styles: { fontSize: 10 },
//               headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               theme: "grid",
//             });
//           }

//           // Add question summary next
//           doc.addPage();
//           doc.setFontSize(16);
//           doc.text(`Set ${setName} - Question Paper Summary`, 14, 20);

//           set.subjects.forEach((subject) => {
//             const sectionRows = [];

//             subject.sections.forEach((section) => {
//               (section.questions || []).forEach((ques, index) => {
//                 const questionText = he
//                   .decode(ques.ques_text)
//                   .replace(/(<([^>]+)>)/gi, "")
//                   .slice(0, 100);
//                 sectionRows.push([
//                   section.section_name,
//                   `${index + 1}`,
//                   questionText,
//                   subject.subject_name,
//                   ques.ques_id || "",
//                 ]);
//               });
//             });

//             if (sectionRows.length > 0) {
//               doc.autoTable({
//                 head: [
//                   ["Section", "Q No", "Question Text", "Subject", "Ques ID"],
//                 ],
//                 body: sectionRows,
//                 startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 30,
//                 styles: { fontSize: 8 },
//                 headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//               });
//             }

//             doc.addPage(); // optional: remove if not needed per subject
//           });

//           callback();
//         },
//         x: 10,
//         y: 10,
//         margin: 10,
//         html2canvas: { scale: 0.4 },
//       });
//     };

//     const setsToProcess = questionData.filter((set) =>
//       selectedSetNames.includes(set.set_name)
//     );
//     let index = 0;

//     const processNextSet = () => {
//       if (index < setsToProcess.length) {
//         generatePDFForSet(setsToProcess[index], () => {
//           index++;
//           processNextSet();
//         });
//       } else {
//         doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);
//       }
//     };

//     processNextSet();
//   };

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <div
//                   className="export-dropdown-container__pre-ques"
//                   ref={exportDropdownRef}
//                 >
//                   <button
//                     className="icon-btn__pre-ques"
//                     onClick={() => setShowExportOptions(!showExportOptions)}
//                   >
//                     <img
//                       src={ExportIcon}
//                       alt="exporticon"
//                       style={{ marginRight: "5px" }}
//                     />{" "}
//                     Export
//                   </button>
//                   {showExportOptions && (
//                     <div className="export-options-dropdown__pre-ques">
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadPDF}
//                       >
//                         <FaFilePdf className="Img-PDF" />
//                         <span>PDF</span>
//                       </button>
//                       <button
//                         className="export-option__pre-ques"
//                         onClick={handleDownloadWord}
//                       >
//                         <FaFileWord className="Img-WORD" />
//                         <span>Word</span>
//                       </button>
//                     </div>
//                   )}
//                 </div>
//                 <button className="icon-btn__pre-ques" onClick={handlePrint}>
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {/* {watermark && <img src={watermarkImg} alt="watermark" className="watermark-image" />} */}
//               {selectedSetNames.length === 0 ? (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               ) : (
//                 questionData
//                   .filter((set) => selectedSetNames.includes(set.set_name))
//                   .map((set) => (
//                     <React.Fragment key={`set-${set.set_name}`}>
//                       {showCoverPage && quesPaperInfo?.paper_cover && (
//                         <div className="a4-page" key={`cover-${set.set_name}`}>
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div
//                             dangerouslySetInnerHTML={{
//                               __html: processedCoverHTML(set.set_name),
//                             }}
//                           />
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Cover Page
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {showCoverPage && quesPaperInfo?.subj_chap_list && (
//                         <div className="a4-page syllabus-page">
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           <div className="syllabus-heading_prev_ques">
//                             <h2 style={{ textAlign: "center" }}>
//                               Test Syllabus
//                             </h2>
//                           </div>
//                           <table className="syllabus-table_prev_ques">
//                             <thead>
//                               <tr>
//                                 <th>Subject</th>
//                                 <th>Chapters</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                                 <tr key={idx}>
//                                   <td>
//                                     <strong>
//                                       {subj.subject_name.toUpperCase()}
//                                     </strong>
//                                   </td>
//                                   <td>{subj.chapters.join(", ")}</td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Set {set.set_name} - Syllabus
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {set.subjects.map((subject, subjectIndex) => (
//                         // <div
//                         //   className="a4-page"
//                         //   key={`set-${set.set_name}-subject-${subject.subject_id}`}
//                         // >
//                         <div
//                           className={`a4-page${
//                             roughPage ? " has-roughwork" : ""
//                           }`}
//                           key={`set-${set.set_name}-subject-${subject.subject_id}`}
//                         >
//                           {watermark && (
//                             <img
//                               src={watermarkImg}
//                               alt="watermark"
//                               className="watermark-image"
//                             />
//                           )}
//                           {subject.sections.map((section) => {
//                             const questions = [
//                               ...(section.questions || []),
//                             ].sort(
//                               (a, b) =>
//                                 a.set_ques_position - b.set_ques_position
//                             );
//                             const mid = Math.ceil(questions.length / 2);
//                             const leftQuestions = questions.slice(0, mid);
//                             const rightQuestions = questions.slice(mid);
//                             return (
//                               // <div
//                               //   key={`section-${section.section_name}`}
//                               //   className="section-container__pre-ques"
//                               // >
//                               <div
//                                 key={`section-${section.section_name}`}
//                                 className="section-container__pre-ques"
//                                 style={{
//                                   position: "relative",
//                                   minHeight: "530px",
//                                 }} // To ensure height for absolute positioning
//                               >
//                                 <p className="section-heading__Pre-ques">
//                                   Section {section.section_name}
//                                 </p>
//                                 <p>
//                                   Instruction:{" "}
//                                   {section.section_instruction?.trim()
//                                     ? renderQuestionText(
//                                         section.section_instruction
//                                       )
//                                     : "N/A"}
//                                 </p>
//                                 <div className="page-header__pre-ques">
//                                   <div className="header-left__pre-ques">
//                                     {quesPaperInfo?.header?.date}
//                                   </div>
//                                   <div className="header-center__pre-ques">
//                                     {subject.subject_name}
//                                   </div>
//                                   <div className="header-right__pre-ques">
//                                     {quesPaperInfo?.header?.test_name}
//                                   </div>
//                                 </div>

//                                 {twinColumn ? (
//                                   <div className="question-grid__pre-ques">
//                                     <div className="question-column__pre-ques">
//                                       {leftQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                     <div className="question-column__pre-ques">
//                                       {rightQuestions.map((ques, index) => (
//                                         <div
//                                           key={ques.ques_id}
//                                           className="question-block"
//                                         >
//                                           <p>
//                                             <strong>{index + mid + 1}.</strong>{" "}
//                                             {renderQuestionText(ques.ques_text)}
//                                           </p>
//                                           <div className="options__pre-ques">
//                                             {[...ques.options]
//                                               .sort(
//                                                 (a, b) =>
//                                                   a.set_option_position -
//                                                   b.set_option_position
//                                               )
//                                               .map((opt, idx) => (
//                                                 <p key={opt.option_id}>
//                                                   <span>
//                                                     {getOptionLabel(
//                                                       idx,
//                                                       quesPaperInfo?.option_naming_pattern
//                                                     )}
//                                                   </span>{" "}
//                                                   {renderQuestionText(
//                                                     opt.option_text
//                                                   )}
//                                                 </p>
//                                               ))}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   </div>
//                                 ) : (
//                                   <div>
//                                     {questions.map((ques, index) => (
//                                       <div
//                                         key={ques.ques_id}
//                                         className="question-block"
//                                       >
//                                         <p>
//                                           <strong>{index + 1}.</strong>{" "}
//                                           {renderQuestionText(ques.ques_text)}
//                                         </p>
//                                         <div className="options__pre-ques">
//                                           {[...ques.options]
//                                             .sort(
//                                               (a, b) =>
//                                                 a.set_option_position -
//                                                 b.set_option_position
//                                             )
//                                             .map((opt, idx) => (
//                                               <p key={opt.option_id}>
//                                                 <span>
//                                                   {getOptionLabel(
//                                                     idx,
//                                                     quesPaperInfo?.option_naming_pattern
//                                                   )}
//                                                 </span>{" "}
//                                                 {renderQuestionText(
//                                                   opt.option_text
//                                                 )}
//                                               </p>
//                                             ))}
//                                         </div>
//                                       </div>
//                                     ))}
//                                   </div>
//                                 )}

//                                 {roughPage && (
//                                   <div className="rough-work-section">
//                                     <strong>Rough Work:</strong>
//                                     <div style={{ height: "100%" }} />
//                                   </div>
//                                 )}
//                               </div>
//                             );
//                           })}
//                           <div className="page-footer">
//                             <div className="footer-left">
//                               {quesPaperInfo?.footer?.client_name} |{" "}
//                               {quesPaperInfo?.footer?.address}
//                             </div>
//                             <div className="footer-right">
//                               Page {subjectIndex + 1}
//                             </div>
//                             {/* <div className="footer-right">Set {set.set_name} - {subject.subject_name}</div> */}
//                           </div>
//                         </div>
//                       ))}
//                     </React.Fragment>
//                   ))
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";
// import Colors from "../../../Constants/Colors";
// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const [paginatedPages, setPaginatedPages] = useState([]);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Add this helper function to render content to HTML for measurement
//   const renderContentToHTML = (text) => {
//     if (!text) return "";
//     const decoded = he.decode(text);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts
//       .map((segment) => {
//         if (segment.startsWith("imgsrc=")) {
//           const url = segment.replace("imgsrc=", "");
//           return `<img src="${url}" alt="image" style="max-width: 80px; height: auto; vertical-align: middle; margin: 0 5px;" />`;
//         } else {
//           return segment.replace(/\\\((.*?)\\\)/g, (_, math) => {
//             try {
//               return katex.renderToString(math, {
//                 throwOnError: false,
//                 displayMode: false,
//               });
//             } catch (e) {
//               console.warn("Katex rendering error:", e);
//               return `<span style="color:red;">[LaTeX Error]</span>`;
//             }
//           });
//         }
//       })
//       .join("");
//   };

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     if (!paginatedPages || paginatedPages.length === 0) {
//       alert("There is no content to print.");
//       return;
//     }

//     const AVAILABLE_HEIGHT_MM = (PAGE_CONTENT_HEIGHT_PX / 3.78); // Convert px to mm
// const FOOTER_HEIGHT_MM = 12;
// const PADDING_MM = 8;
// const CALCULATED_WRAPPER_HEIGHT = `calc(297mm - ${PADDING_MM + FOOTER_HEIGHT_MM + 8}mm)`;

//     // Helper to process cover page HTML
//     const getProcessedCoverHTML = (page) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, page.totalQuestionPages)
//         .replace(/#test_date#/gi, new Date().toLocaleDateString("en-GB"))
//         .replace(/#set_name#/gi, page.setName);
//     };

//     let printContent = `
//     <style>
//       body, html { margin: 0 !important; padding: 0 !important; background-color: #fff; font-family: Calibri, sans-serif; }
//       .a4-page { width: 210mm; min-height: 297mm; margin: 0 auto; padding: 10mm; box-sizing: border-box; background: white; position: relative; page-break-after: always; }

//       .page-content-wrapper {
//          height: ${CALCULATED_WRAPPER_HEIGHT};
//         position: relative;
//         padding-bottom: 10mm; /* Space for footer */
//         overflow: hidden;
//       }
//       .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//       .watermark img { width: 300px; height: auto; }
//       .section-heading__Pre-ques { font-size: 16px; font-weight: 600; margin: 0px 0 4px 0; padding-left: 15px; }
//       .question-grid__pre-ques { display: flex; gap: 20px; }
//       .question-column__pre-ques { flex: 1; min-width: 0; }
//       .question-block { margin-bottom: 10px; page-break-inside: avoid; }
//       .question-block p { margin: 0 0 3px 0; line-height: 1.3; }
//       .options__pre-ques p { margin: 3px 0 1px 16px; font-size: 14px; line-height: 1.2; }
//       .page-footer {
//         position: absolute;
//         bottom: 8mm;
//         left: 10mm;
//         right: 10mm;
//         height: 15mm;
//         text-align: center;
//         font-size: 11px;
//         border-top: 1px solid #ccc;
//         padding-top: 4px;
//         color: #444;
//         display: flex;
//         justify-content: space-between;
//         background: white;
//         z-index: 10;
//       }
//       .page-header__pre-ques { display: flex; justify-content: space-between; font-size: 13px; padding: 4px 12px; margin-bottom: 6px; border-bottom: 1px solid #ccc; }
//       .rough-work-section { margin-top: 15px; border-top: 1px solid #ccc; padding-top: 8px; min-height: 60px; }
//       .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 5px; padding-bottom: 8px; }
//       .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//       .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//       .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//       .instructions-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 5px; padding-bottom: 8px; }
//       .instructions-content { margin-top: 5px; }
//       @media print {
//         body * { visibility: hidden !important; }
//         #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//         #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//       }
//       @page { size: A4; margin: 0; }
//     </style>
//   `;

//     // Iterate through the already calculated paginatedPages
//     paginatedPages.forEach((page) => {
//       printContent += `<div class="a4-page">`;

//       // Add watermark if enabled
//       if (watermark) {
//         printContent += `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`;
//       }

//       printContent += `<div class="page-content-wrapper">`;

//       // Generate content based on page type
//       switch (page.type) {
//         case "cover":
//           printContent += `
//     <div style="margin-top: 0 !important; padding-top: 0 !important; position: relative; top: 0;">
//       ${getProcessedCoverHTML(page)}
//     </div>`;
//           break;

//         case "instructions":
//           printContent += `
//           <div class="instructions-heading-print">Instructions</div>
//           <hr style="border: none; border-top: 1px solid #ccc; margin: 5px 0;" />
//           <div class="instructions-content" style="font-size: 14px; text-align: justify;">${quesPaperInfo.instructions_html}</div>`;
//           break;

//         case "syllabus":
//           printContent += `
//           <div class="syllabus-heading-print">Test Syllabus</div>
//           <table class="syllabus-table-print">
//             <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//             <tbody>
//               ${quesPaperInfo.subj_chap_list
//                 .map(
//                   (s) => `
//                 <tr>
//                   <td><strong>${s.subject_name.toUpperCase()}</strong></td>
//                   <td>${s.chapters.join(", ")}</td>
//                 </tr>
//               `
//                 )
//                 .join("")}
//             </tbody>
//           </table>`;
//           break;

//         case "questions":
//           let questionsHtml = `
//           <p class="section-heading__Pre-ques">Section ${
//             page.section.section_name
//           }</p>
//           <p style="padding-left: 15px; margin: 0 0 4px 0;"><strong>Instruction:</strong> ${
//             page.section.section_instruction?.trim()
//               ? renderContentToHTML(page.section.section_instruction)
//               : "N/A"
//           }</p>
//           <div class="page-header__pre-ques">
//             <div>${quesPaperInfo?.header?.date || ""}</div>
//             <div>${page.subject.subject_name}</div>
//             <div>${quesPaperInfo?.header?.test_name || ""}</div>
//           </div>`;

//           const renderQuestionColumn = (qs, offset) =>
//             qs
//               .map(
//                 (q, i) => `
//           <div class="question-block">
//             <p><strong>${offset + i + 1}.</strong> ${renderContentToHTML(
//                   q.ques_text
//                 )}</p>
//             <div class="options__pre-ques">
//               ${q.options
//                 .sort((a, b) => a.set_option_position - b.set_option_position)
//                 .map(
//                   (opt, oi) => `
//                 <p><span>${getOptionLabel(
//                   oi,
//                   quesPaperInfo?.option_naming_pattern
//                 )}</span> ${renderContentToHTML(opt.option_text)}</p>
//               `
//                 )
//                 .join("")}
//             </div>
//           </div>`
//               )
//               .join("");

//           if (twinColumn) {
//             const mid = Math.ceil(page.questions.length / 2);
//             questionsHtml += `
//             <div class="question-grid__pre-ques">
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(0, mid),
//                 page.questionIndexOffset
//               )}</div>
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(mid),
//                 page.questionIndexOffset + mid
//               )}</div>
//             </div>`;
//           } else {
//             questionsHtml += `<div>${renderQuestionColumn(
//               page.questions,
//               page.questionIndexOffset
//             )}</div>`;
//           }

//           // Add rough work section if enabled and this is the last page of the section
//           if (roughPage && page.isLastPageInSection) {
//             questionsHtml += `<div class="rough-work-section"><strong>Rough Work:</strong></div>`;
//           }

//           printContent += questionsHtml;
//           break;

//         default:
//           break;
//       }

//       printContent += `</div>`; // Close page-content-wrapper

//       // Add footer for all page types
//       printContent += `
//       <div class="page-footer">
//         <div>${quesPaperInfo?.footer?.client_name || ""} | ${
//         quesPaperInfo?.footer?.address || ""
//       }</div>
//         <div>
//           ${page.type === "cover" ? `Set ${page.setName} - Cover Page` : ""}
//           ${
//             page.type === "instructions"
//               ? `Set ${page.setName} - Instructions`
//               : ""
//           }
//           ${page.type === "syllabus" ? `Set ${page.setName} - Syllabus` : ""}
//           ${page.type === "questions" ? `Page ${page.pageNumber}` : ""}
//         </div>
//       </div>
//     `;

//       printContent += `</div>`; // Close a4-page
//     });

//     // Create and inject print section
//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);

//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);

//     // Print with a small delay to ensure rendering
//     setTimeout(() => {
//       window.print();
//       // Cleanup after printing
//       setTimeout(() => {
//         if (document.getElementById(printSectionId)) {
//           document.body.removeChild(document.getElementById(printSectionId));
//         }
//       }, 1000);
//     }, 500);
//   };

//   //   const handlePrint = () => {
//   //     const calculateTotalPagesForPrint = (set) => {
//   //       let total = 0;
//   //       let questionPages = 0;

//   //       if (showCoverPage) total++;
//   //       if (quesPaperInfo?.subj_chap_list?.length) total++;

//   //       if (!set) return { total, questionPages };

//   //       set.subjects.forEach((subject) => {
//   //         subject.sections.forEach((section) => {
//   //           if ((section.questions || []).length > 0) {
//   //             const questionsPerPage = 10;
//   //             const pages = Math.ceil(
//   //               section.questions.length / questionsPerPage
//   //             );
//   //             total += pages;
//   //             questionPages += pages;
//   //           }
//   //         });
//   //       });

//   //       return { total, questionPages };
//   //     };

//   //     const renderQuestionTextForPrint = (text) => {
//   //       if (!text) return "";
//   //       const decoded = he.decode(text);
//   //       const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//   //       return parts
//   //         .map((segment, idx) => {
//   //           if (segment.startsWith("imgsrc=")) {
//   //             const url = segment.replace("imgsrc=", "");
//   //             return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//   //           } else {
//   //             return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//   //               try {
//   //                 return katex.renderToString(math, { throwOnError: false });
//   //               } catch (e) {
//   //                 return `<span style="color:red;">Invalid LaTeX</span>`;
//   //               }
//   //             });
//   //           }
//   //         })
//   //         .join("");
//   //     };

//   //     const processedCoverHTML = (setName, totalQuesPages) => {
//   //       if (!quesPaperInfo?.paper_cover) return "";
//   //       const testDate = new Date().toLocaleDateString("en-GB");
//   //       return quesPaperInfo.paper_cover
//   //         .replace(/#total_pages#/gi, totalQuesPages)
//   //         .replace(/#test_date#/gi, testDate)
//   //         .replace(/#set_name#/gi, setName);
//   //     };

//   //     let printContent = `
//   //       <style>
//   //         body, html { margin:0!important; padding:0!important; }
//   //         .a4-page { width:210mm; min-height:297mm; margin:0 auto; padding:0; background:white; position:relative; page-break-after: always;}
//   //         .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//   //         .watermark img { width: 300px; height: auto; }
//   //         .section-heading__Pre-ques { font-size: 16px; font-weight:600; padding-bottom:4px; margin-top:20px;}
//   //         .question-grid__pre-ques { display:flex;}
//   //         .question-column__pre-ques { flex:1; }
//   //         .question-block { margin-bottom:14px; page-break-inside:avoid;}
//   //         .options__pre-ques p { margin-left:16px; margin-top:4px; font-size:14px;}
//   //         .page-footer { position:absolute; bottom:10mm; width:100%;text-align:center;font-size:11px;border-top:1px solid #ccc;padding-top:4px; color:#444;}
//   //         .page-footer span { float:right; }
//   //         .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px; }
//   //         .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//   //         .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; text-align: left; vertical-align: top; }
//   //         .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//   //         .page-header__pre-ques { display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc; }
//   //         @media print {
//   //           body * { visibility: hidden !important; }
//   //           #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//   //           #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//   //         }
//   //         @page { size:A4; margin:0; }
//   //       </style>
//   //     `;

//   //     selectedSetNames.forEach((setName) => {
//   //       const currentSet = questionData.find((set) => set.set_name === setName);
//   //       const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//   //       let questionPageNum = 1;

//   //       // Cover Page
//   //       if (showCoverPage && quesPaperInfo?.paper_cover) {
//   //         printContent += `
//   //           <div class="a4-page">
//   //             ${
//   //               watermark
//   //                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                 : ""
//   //             }
//   //             <div style="margin:0; padding:0;">
//   //               ${processedCoverHTML(setName, questionPages)}
//   //             </div>
//   //             <div class="page-footer">
//   //               ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //           quesPaperInfo?.footer?.address || ""
//   //         }
//   //               <span>Set ${setName} - Cover Page</span>
//   //             </div>
//   //           </div>`;
//   //       }

//   //       // Instructions Page
//   //       if (showCoverPage && quesPaperInfo?.instructions_html) {
//   //         printContent += `
//   //     <div class="a4-page" style="padding: 20px;">
//   //       ${
//   //         watermark
//   //           ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //           : ""
//   //       }
//   //       <div class="instructions-heading-print" style="font-size: 20px; font-weight: bold; text-align: center; margin-top: 40px; padding-bottom: 10px;">Instructions</div>

//   //       <hr style="border: none; border-top: 1px solid #ccc; margin-bottom: 16px;" />

//   //       <div style="font-size: 14px; text-align: justify;">
//   //         ${quesPaperInfo.instructions_html}
//   //       </div>

//   //       <div class="page-footer">
//   //         ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //           quesPaperInfo?.footer?.address || ""
//   //         }
//   //         <span>Set ${setName} - Instructions</span>
//   //       </div>
//   //     </div>`;
//   //       }

//   //       // Syllabus Page
//   //       if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//   //         printContent += `
//   //           <div class="a4-page" style="padding: 20px;">
//   //             ${
//   //               watermark
//   //                 ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                 : ""
//   //             }
//   //             <div class="syllabus-heading-print">Test Syllabus</div>
//   //             <table class="syllabus-table-print">
//   //               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//   //               <tbody>
//   //                 ${quesPaperInfo.subj_chap_list
//   //                   .map(
//   //                     (subj) => `
//   //                   <tr>
//   //                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//   //                     <td>${subj.chapters.join(", ")}</td>
//   //                   </tr>`
//   //                   )
//   //                   .join("")}
//   //               </tbody>
//   //             </table>
//   //             <div class="page-footer">
//   //               ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //           quesPaperInfo?.footer?.address || ""
//   //         }
//   //               <span>Set ${setName} - Syllabus</span>
//   //             </div>
//   //           </div>`;
//   //       }

//   //       // Questions per section
//   //       if (currentSet) {
//   //         currentSet.subjects.forEach((subject) => {
//   //           subject.sections.forEach((section) => {
//   //             const allQuestions = [...(section.questions || [])].sort(
//   //               (a, b) => a.set_ques_position - b.set_ques_position
//   //             );
//   //             if (allQuestions.length === 0) return;

//   //             const questionsPerPage = 10;
//   //             const totalPages = Math.ceil(
//   //               allQuestions.length / questionsPerPage
//   //             );
//   //             let questionIndex = 0;

//   //             for (let page = 0; page < totalPages; page++) {
//   //               const pageQuestions = allQuestions.slice(
//   //                 page * questionsPerPage,
//   //                 (page + 1) * questionsPerPage
//   //               );
//   //               const mid = Math.ceil(pageQuestions.length / 2);
//   //               const leftQuestions = pageQuestions.slice(0, mid);
//   //               const rightQuestions = pageQuestions.slice(mid);

//   //               let subjectHtml = `
//   //                 <p class="section-heading__Pre-ques" style="padding-left: 15px;" >Section ${
//   //                   section.section_name
//   //                 }</p>
//   //                 <p><strong style="padding-left: 15px;">Instruction:</strong> ${
//   //                   section.section_instruction?.trim()
//   //                     ? renderQuestionTextForPrint(section.section_instruction)
//   //                     : "N/A"
//   //                 }</p>
//   //                 <div class="page-header__pre-ques">
//   //                   <div>${quesPaperInfo?.header?.date || ""}</div>
//   //                   <div>${subject.subject_name}</div>
//   //                   <div>${quesPaperInfo?.header?.test_name || ""}</div>
//   //                 </div>`;

//   //               if (twinColumn) {
//   //                 subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//   //                 leftQuestions.forEach((ques) => {
//   //                   subjectHtml += `
//   //                     <div class="question-block">
//   //                       <p><strong>${
//   //                         questionIndex + 1
//   //                       }.</strong> ${renderQuestionTextForPrint(
//   //                     ques.ques_text
//   //                   )}</p>
//   //                       <div class="options__pre-ques">
//   //                         ${ques.options
//   //                           .sort(
//   //                             (a, b) =>
//   //                               a.set_option_position - b.set_option_position
//   //                           )
//   //                           .map(
//   //                             (opt, i) =>
//   //                               `<p><span>${getOptionLabel(
//   //                                 i,
//   //                                 quesPaperInfo?.option_naming_pattern
//   //                               )}</span> ${renderQuestionTextForPrint(
//   //                                 opt.option_text
//   //                               )}</p>`
//   //                           )
//   //                           .join("")}
//   //                       </div>
//   //                     </div>`;
//   //                   questionIndex++;
//   //                 });
//   //                 subjectHtml += `</div><div class="question-column__pre-ques">`;
//   //                 rightQuestions.forEach((ques) => {
//   //                   subjectHtml += `
//   //                     <div class="question-block">
//   //                       <p><strong>${
//   //                         questionIndex + 1
//   //                       }.</strong> ${renderQuestionTextForPrint(
//   //                     ques.ques_text
//   //                   )}</p>
//   //                       <div class="options__pre-ques">
//   //                         ${ques.options
//   //                           .sort(
//   //                             (a, b) =>
//   //                               a.set_option_position - b.set_option_position
//   //                           )
//   //                           .map(
//   //                             (opt, i) =>
//   //                               `<p><span>${getOptionLabel(
//   //                                 i,
//   //                                 quesPaperInfo?.option_naming_pattern
//   //                               )}</span> ${renderQuestionTextForPrint(
//   //                                 opt.option_text
//   //                               )}</p>`
//   //                           )
//   //                           .join("")}
//   //                       </div>
//   //                     </div>`;
//   //                   questionIndex++;
//   //                 });
//   //                 subjectHtml += `</div></div>`;
//   //                 if (roughPage) {
//   //                   const isLastPage = page === totalPages - 1;
//   //                   const roughMinHeight = isLastPage ? "100px" : "200px";
//   //                   subjectHtml += `
//   //   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//   //     <strong>Rough Work:</strong>
//   //   </div>
//   // `;
//   //                 }
//   //               } else {
//   //                 pageQuestions.forEach((ques) => {
//   //                   subjectHtml += `
//   //                     <div class="question-block">
//   //                       <p><strong>${
//   //                         questionIndex + 1
//   //                       }.</strong> ${renderQuestionTextForPrint(
//   //                     ques.ques_text
//   //                   )}</p>
//   //                       <div class="options__pre-ques">
//   //                         ${ques.options
//   //                           .sort(
//   //                             (a, b) =>
//   //                               a.set_option_position - b.set_option_position
//   //                           )
//   //                           .map(
//   //                             (opt, i) =>
//   //                               `<p><span>${getOptionLabel(
//   //                                 i,
//   //                                 quesPaperInfo?.option_naming_pattern
//   //                               )}</span> ${renderQuestionTextForPrint(
//   //                                 opt.option_text
//   //                               )}</p>`
//   //                           )
//   //                           .join("")}
//   //                       </div>
//   //                     </div>`;
//   //                   questionIndex++;
//   //                 });

//   //                 if (roughPage) {
//   //                   const isLastPage = page === totalPages - 1;
//   //                   const roughMinHeight = isLastPage ? "100px" : "200px";
//   //                   subjectHtml += `
//   //   <div class="rough-work-section" style="min-height:${roughMinHeight};">
//   //     <strong>Rough Work:</strong>
//   //   </div>
//   // `;
//   //                 }
//   //               }

//   //               printContent += `
//   //                 <div class="a4-page">
//   //                   ${
//   //                     watermark
//   //                       ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                       : ""
//   //                   }
//   //                   ${subjectHtml}
//   //                   <div class="page-footer">
//   //                     ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //                 quesPaperInfo?.footer?.address || ""
//   //               }
//   //                     <span>Page ${questionPageNum++}</span>
//   //                   </div>
//   //                 </div>`;
//   //             }
//   //           });
//   //         });
//   //       }
//   //     });

//   //     const printSectionId = "printSectionDynamic";
//   //     let printSection = document.getElementById(printSectionId);
//   //     if (printSection) document.body.removeChild(printSection);
//   //     printSection = document.createElement("div");
//   //     printSection.id = printSectionId;
//   //     printSection.innerHTML = printContent;
//   //     document.body.appendChild(printSection);
//   //     console.log(printContent);
//   //     window.print();

//   //     setTimeout(() => {
//   //       if (printSection) document.body.removeChild(printSection);
//   //     }, 500);
//   //   };

//   // const handleDownloadWord = () => {
//   //   const calculateTotalPagesForPrint = (set) => {
//   //     let total = 0;
//   //     let questionPages = 0;

//   //     if (showCoverPage) total++;
//   //     if (quesPaperInfo?.subj_chap_list?.length) total++;

//   //     if (!set) return { total, questionPages };

//   //     set.subjects.forEach((subject) => {
//   //       subject.sections.forEach((section) => {
//   //         if ((section.questions || []).length > 0) {
//   //           const questionsPerPage = 10;
//   //           const pages = Math.ceil(
//   //             section.questions.length / questionsPerPage
//   //           );
//   //           total += pages;
//   //           questionPages += pages;
//   //         }
//   //       });
//   //     });

//   //     return { total, questionPages };
//   //   };

//   //   const renderQuestionTextForPrint = (text) => {
//   //     if (!text) return "";
//   //     const decoded = he.decode(text);
//   //     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//   //     return parts
//   //       .map((segment, idx) => {
//   //         if (segment.startsWith("imgsrc=")) {
//   //           const url = segment.replace("imgsrc=", "");
//   //           return `<img src="${url}" alt="img-${idx}" style="width:30px; height:auto; margin:5px; vertical-align:middle; display:inline-block;" />`;
//   //         } else {
//   //           return segment.replace(/\\\((.+?)\\\)/g, (_, math) => {
//   //             try {
//   //               return katex.renderToString(math, { throwOnError: false });
//   //             } catch (e) {
//   //               return `<span style="color:red;">Invalid LaTeX</span>`;
//   //             }
//   //           });
//   //         }
//   //       })
//   //       .join("");
//   //   };

//   //   const processedCoverHTML = (setName, totalQuesPages) => {
//   //     if (!quesPaperInfo?.paper_cover) return "";
//   //     const testDate = new Date().toLocaleDateString("en-GB");
//   //     return quesPaperInfo.paper_cover
//   //       .replace(/#total_pages#/gi, totalQuesPages)
//   //       .replace(/#test_date#/gi, testDate)
//   //       .replace(/#set_name#/gi, setName);
//   //   };

//   //   let printContent = ``;

//   //   selectedSetNames.forEach((setName) => {
//   //     const currentSet = questionData.find((set) => set.set_name === setName);
//   //     const { total, questionPages } = calculateTotalPagesForPrint(currentSet);
//   //     let questionPageNum = 1;

//   //     if (showCoverPage && quesPaperInfo?.paper_cover) {
//   //       printContent += `
//   //         <div class="a4-page">
//   //           ${
//   //             watermark
//   //               ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //               : ""
//   //           }
//   //           <div class="page-content">
//   //             ${processedCoverHTML(setName, questionPages)}
//   //           </div>
//   //           <div class="page-footer">
//   //             ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //         quesPaperInfo?.footer?.address || ""
//   //       }
//   //             <span>Set ${setName} - Cover Page</span>
//   //           </div>
//   //         </div>`;
//   //     }

//   //     if (showCoverPage && quesPaperInfo?.subj_chap_list?.length > 0) {
//   //       printContent += `
//   //         <div class="a4-page">
//   //           ${
//   //             watermark
//   //               ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //               : ""
//   //           }
//   //           <div class="page-content">
//   //             <div class="syllabus-heading-print">Test Syllabus</div>
//   //             <table class="syllabus-table-print">
//   //               <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//   //               <tbody>
//   //                 ${quesPaperInfo.subj_chap_list
//   //                   .map(
//   //                     (subj) => `
//   //                   <tr>
//   //                     <td><strong>${subj.subject_name.toUpperCase()}</strong></td>
//   //                     <td>${subj.chapters.join(", ")}</td>
//   //                   </tr>`
//   //                   )
//   //                   .join("")}
//   //               </tbody>
//   //             </table>
//   //           </div>
//   //           <div class="page-footer">
//   //             ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //         quesPaperInfo?.footer?.address || ""
//   //       }
//   //             <span>Set ${setName} - Syllabus</span>
//   //           </div>
//   //         </div>`;
//   //     }

//   //     if (currentSet) {
//   //       currentSet.subjects.forEach((subject) => {
//   //         subject.sections.forEach((section) => {
//   //           const allQuestions = [...(section.questions || [])].sort(
//   //             (a, b) => a.set_ques_position - b.set_ques_position
//   //           );
//   //           if (allQuestions.length === 0) return;

//   //           const questionsPerPage = 10;
//   //           const totalPages = Math.ceil(
//   //             allQuestions.length / questionsPerPage
//   //           );
//   //           let questionIndex = 0;

//   //           for (let page = 0; page < totalPages; page++) {
//   //             const pageQuestions = allQuestions.slice(
//   //               page * questionsPerPage,
//   //               (page + 1) * questionsPerPage
//   //             );
//   //             const mid = Math.ceil(pageQuestions.length / 2);
//   //             const leftQuestions = pageQuestions.slice(0, mid);
//   //             const rightQuestions = pageQuestions.slice(mid);

//   //             let subjectHtml = `
//   //               <p class="section-heading__Pre-ques">Section ${
//   //                 section.section_name
//   //               }</p>
//   //               <p><strong>Instruction:</strong> ${
//   //                 section.section_instruction?.trim()
//   //                   ? renderQuestionTextForPrint(section.section_instruction)
//   //                   : "N/A"
//   //               }</p>
//   //               <div class="page-header__pre-ques">
//   //                 <div>${quesPaperInfo?.header?.date || ""}</div>
//   //                 <div>${subject.subject_name}</div>
//   //                 <div>${quesPaperInfo?.header?.test_name || ""}</div>
//   //               </div>`;

//   //             if (twinColumn) {
//   //               subjectHtml += `<div class="question-grid__pre-ques"><div class="question-column__pre-ques">`;
//   //               leftQuestions.forEach((ques) => {
//   //                 subjectHtml += `
//   //                   <div class="question-block">
//   //                     <p><strong>${
//   //                       questionIndex + 1
//   //                     }.</strong> ${renderQuestionTextForPrint(
//   //                   ques.ques_text
//   //                 )}</p>
//   //                     <div class="options__pre-ques">
//   //                       ${ques.options
//   //                         .sort(
//   //                           (a, b) =>
//   //                             a.set_option_position - b.set_option_position
//   //                         )
//   //                         .map(
//   //                           (opt, i) =>
//   //                             `<p><span>${getOptionLabel(
//   //                               i,
//   //                               quesPaperInfo?.option_naming_pattern
//   //                             )}</span> ${renderQuestionTextForPrint(
//   //                               opt.option_text
//   //                             )}</p>`
//   //                         )
//   //                         .join("")}
//   //                     </div>
//   //                   </div>`;
//   //                 questionIndex++;
//   //               });
//   //               subjectHtml += `</div><div class="question-column__pre-ques">`;
//   //               rightQuestions.forEach((ques) => {
//   //                 subjectHtml += `
//   //                   <div class="question-block">
//   //                     <p><strong>${
//   //                       questionIndex + 1
//   //                     }.</strong> ${renderQuestionTextForPrint(
//   //                   ques.ques_text
//   //                 )}</p>
//   //                     <div class="options__pre-ques">
//   //                       ${ques.options
//   //                         .sort(
//   //                           (a, b) =>
//   //                             a.set_option_position - b.set_option_position
//   //                         )
//   //                         .map(
//   //                           (opt, i) =>
//   //                             `<p><span>${getOptionLabel(
//   //                               i,
//   //                               quesPaperInfo?.option_naming_pattern
//   //                             )}</span> ${renderQuestionTextForPrint(
//   //                               opt.option_text
//   //                             )}</p>`
//   //                         )
//   //                         .join("")}
//   //                     </div>
//   //                   </div>`;
//   //                 questionIndex++;
//   //               });
//   //               subjectHtml += `</div></div>`;
//   //             } else {
//   //               pageQuestions.forEach((ques) => {
//   //                 subjectHtml += `
//   //                   <div class="question-block">
//   //                     <p><strong>${
//   //                       questionIndex + 1
//   //                     }.</strong> ${renderQuestionTextForPrint(
//   //                   ques.ques_text
//   //                 )}</p>
//   //                     <div class="options__pre-ques">
//   //                       ${ques.options
//   //                         .sort(
//   //                           (a, b) =>
//   //                             a.set_option_position - b.set_option_position
//   //                         )
//   //                         .map(
//   //                           (opt, i) =>
//   //                             `<p><span>${getOptionLabel(
//   //                               i,
//   //                               quesPaperInfo?.option_naming_pattern
//   //                             )}</span> ${renderQuestionTextForPrint(
//   //                               opt.option_text
//   //                             )}</p>`
//   //                         )
//   //                         .join("")}
//   //                     </div>
//   //                   </div>`;
//   //                 questionIndex++;
//   //               });
//   //             }

//   //             printContent += `
//   //               <div class="a4-page">
//   //                 ${
//   //                   watermark
//   //                     ? `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`
//   //                     : ""
//   //                 }
//   //                 <div class="page-content">${subjectHtml}</div>
//   //                 <div class="page-footer">
//   //                   ${quesPaperInfo?.footer?.client_name || ""} | ${
//   //               quesPaperInfo?.footer?.address || ""
//   //             }
//   //                   <span>Page ${questionPageNum++}</span>
//   //                 </div>
//   //               </div>`;
//   //           }
//   //         });
//   //       });
//   //     }
//   //   });

//   //   const styledHTML = `
//   //     <html>
//   //       <head>
//   //         <meta charset="utf-8">
//   //         <style>
//   //           @page { size: A4; margin: 0; }
//   //           body { font-family: Calibri, sans-serif; margin: 0; padding: 0; }
//   //           .a4-page { width: 100%; page-break-after: always; padding: 20mm; box-sizing: border-box; }
//   //           .page-content { max-width: 180mm; margin: auto; }
//   //           .question-grid__pre-ques { display: table; width: 100%; table-layout: fixed; }
//   //           .question-column__pre-ques { display: table-cell; vertical-align: top; width: 50%; padding-right: 20px; }
//   //           .question-block { margin-bottom: 14px; break-inside: avoid; }
//   //           .options__pre-ques p { margin-left: 16px; margin-top: 4px; font-size: 14px; }
//   //           .section-heading__Pre-ques { font-weight: bold; font-size: 16px; margin-top: 16px; }
//   //           .watermark img { position: absolute; top: 50%; left: 50%; width: 300px; transform: translate(-50%, -50%); opacity: 0.08; z-index: -1; }
//   //           .syllabus-table-print { width: 100%; table-layout: fixed; border-collapse: collapse; }
//   //           .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 8px; word-break: break-word; vertical-align: top; }
//   //           .syllabus-table-print th { background-color: #f0f0f0; }
//   //           .page-footer { text-align: right; font-size: 12px; margin-top: 20px; }
//   //         </style>
//   //       </head>
//   //       <body>
//   //         ${printContent}
//   //         <footer>
//   //           ${quesPaperInfo?.footer?.client_name || "DEFINITE SUCCESS"} |
//   //           ${
//   //             quesPaperInfo?.footer?.address ||
//   //             "B â€“ 63, Kasturba Nagar Near Chetak Bridge Bhopal."
//   //           }
//   //         </footer>
//   //       </body>
//   //     </html>
//   //   `;

//   //   const blob = new Blob([styledHTML], {
//   //     type: "application/msword;charset=utf-8",
//   //   });
//   //   const filename = `${
//   //     quesPaperInfo?.ques_paper_name || "question-paper"
//   //   }.doc`;
//   //   const link = document.createElement("a");
//   //   link.href = URL.createObjectURL(blob);
//   //   link.download = filename;
//   //   link.click();
//   // };

//   // const handleDownloadPDF = () => {
//   //   if (!questionData || questionData.length === 0) return;

//   //   const doc = new jsPDF("p", "mm", "a4");

//   //   const generatePDFForSet = (set, callback) => {
//   //     const setName = set.set_name;
//   //     const syllabusRows = quesPaperInfo?.subj_chap_list?.map((item) => [
//   //       item.subject_name,
//   //       item.chapters.join(", "),
//   //     ]);

//   //     doc.html(processedCoverHTML(setName), {
//   //       callback: () => {
//   //         // Syllabus Page
//   //         doc.addPage();
//   //         doc.setFontSize(16);
//   //         doc.text("Test Syllabus", 105, 20, { align: "center" });

//   //         if (syllabusRows?.length) {
//   //           doc.autoTable({
//   //             head: [["Subject", "Chapters"]],
//   //             body: syllabusRows,
//   //             startY: 30,
//   //             styles: { fontSize: 10 },
//   //             headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//   //             theme: "grid",
//   //           });
//   //         }

//   //         // Add question summary next
//   //         doc.addPage();
//   //         doc.setFontSize(16);
//   //         doc.text(`Set ${setName} - Question Paper Summary`, 14, 20);

//   //         set.subjects.forEach((subject) => {
//   //           const sectionRows = [];

//   //           subject.sections.forEach((section) => {
//   //             (section.questions || []).forEach((ques, index) => {
//   //               const questionText = he
//   //                 .decode(ques.ques_text)
//   //                 .replace(/(<([^>]+)>)/gi, "")
//   //                 .slice(0, 100);
//   //               sectionRows.push([
//   //                 section.section_name,
//   //                 `${index + 1}`,
//   //                 questionText,
//   //                 subject.subject_name,
//   //                 ques.ques_id || "",
//   //               ]);
//   //             });
//   //           });

//   //           if (sectionRows.length > 0) {
//   //             doc.autoTable({
//   //               head: [
//   //                 ["Section", "Q No", "Question Text", "Subject", "Ques ID"],
//   //               ],
//   //               body: sectionRows,
//   //               startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 30,
//   //               styles: { fontSize: 8 },
//   //               headStyles: { fillColor: [22, 160, 133], textColor: 255 },
//   //             });
//   //           }

//   //           doc.addPage(); // optional: remove if not needed per subject
//   //         });

//   //         callback();
//   //       },
//   //       x: 10,
//   //       y: 10,
//   //       margin: 10,
//   //       html2canvas: { scale: 0.4 },
//   //     });
//   //   };

//   //   const setsToProcess = questionData.filter((set) =>
//   //     selectedSetNames.includes(set.set_name)
//   //   );
//   //   let index = 0;

//   //   const processNextSet = () => {
//   //     if (index < setsToProcess.length) {
//   //       generatePDFForSet(setsToProcess[index], () => {
//   //         index++;
//   //         processNextSet();
//   //       });
//   //     } else {
//   //       doc.save(`${quesPaperInfo?.ques_paper_name || "question-paper"}.pdf`);
//   //     }
//   //   };

//   //   processNextSet();
//   // };
//   const PAGE_CONTENT_HEIGHT_PX = 2100;
//   useEffect(() => {
//     const calculateDynamicPages = () => {
//       if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//         setPaginatedPages([]);
//         return;
//       }

//       // A4 page configuration
//       // A4 is 297mm high, minus margins (~40mm) leaves ~257mm usable height
//       // 1mm ≈ 3.78px, so 257mm ≈ 970px
//       // const PAGE_CONTENT_HEIGHT_PX = 960;
//       // const ROUGH_WORK_MIN_HEIGHT_PX = 100;
//       // Updated - uses more of the A4 page (approximately 75-80% of available space)

//       const ROUGH_WORK_MIN_HEIGHT_PX = 50; // Reduced slightly to accommodate more content

//       const newPages = [];
//       const setsToRender = questionData.filter((set) =>
//         selectedSetNames.includes(set.set_name)
//       );

//       // Create hidden measurement container
//       const measureContainer = document.createElement("div");
//       measureContainer.style.position = "absolute";
//       measureContainer.style.visibility = "hidden";
//       measureContainer.style.left = "-9999px";
//       measureContainer.style.width = "calc(210mm - 40mm)"; // A4 width minus margins
//       measureContainer.style.fontFamily = "Calibri, sans-serif";
//       measureContainer.style.fontSize = "14px";
//       measureContainer.style.lineHeight = "1.4";
//       document.body.appendChild(measureContainer);

//       setsToRender.forEach((set) => {
//         let questionPageCounter = 1;

//         // Add Cover Page
//         if (showCoverPage && quesPaperInfo.paper_cover) {
//           newPages.push({
//             type: "cover",
//             key: `cover-${set.set_name}`,
//             setName: set.set_name,
//             totalQuestionPages: "Dynamic",
//           });
//         }

//         // Add Instructions Page
//         if (showCoverPage && quesPaperInfo.instructions_html) {
//           newPages.push({
//             type: "instructions",
//             key: `instructions-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Add Syllabus Page
//         if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//           newPages.push({
//             type: "syllabus",
//             key: `syllabus-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Dynamic Question Pagination
//         set.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             let currentPageQuestions = [];
//             let questionIndexOffset = 0;

//             // Measure section header height
//             const sectionHeaderHTML = `
//             <p style="font-size: 16px; font-weight: 600; margin: 20px 0 4px 0;">Section ${
//               section.section_name
//             }</p>
//             <p style="margin: 0 0 8px 0;">Instruction: ${
//               section.section_instruction?.trim()
//                 ? renderContentToHTML(section.section_instruction)
//                 : "N/A"
//             }</p>
//             <div style="display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc;">
//               <div>${quesPaperInfo?.header?.date || ""}</div>
//               <div>${subject.subject_name}</div>
//               <div>${quesPaperInfo?.header?.test_name || ""}</div>
//             </div>`;

//             measureContainer.innerHTML = sectionHeaderHTML;
//             let currentHeight = measureContainer.offsetHeight;

//             allQuestions.forEach((ques, index) => {
//               // Create HTML for single question to measure
//               const questionHTML = `
//               <div style="margin-bottom: 14px; page-break-inside: avoid;">
//                 <p style="margin: 0 0 4px 0; line-height: 1.4;">
//                   <strong>${
//                     questionIndexOffset + currentPageQuestions.length + 1
//                   }.</strong>
//                   ${renderContentToHTML(ques.ques_text)}
//                 </p>
//                 <div style="margin-left: 16px;">
//                   ${ques.options
//                     .sort(
//                       (a, b) => a.set_option_position - b.set_option_position
//                     )
//                     .map(
//                       (opt, i) => `
//                       <p style="margin: 4px 0; font-size: 14px; line-height: 1.3;">
//                         ${getOptionLabel(
//                           i,
//                           quesPaperInfo?.option_naming_pattern
//                         )} ${renderContentToHTML(opt.option_text)}
//                       </p>
//                     `
//                     )
//                     .join("")}
//                 </div>
//               </div>`;

//               // Measure question height
//               const tempDiv = document.createElement("div");
//               if (twinColumn) {
//                 tempDiv.style.width = "50%";
//               }
//               tempDiv.innerHTML = questionHTML;
//               measureContainer.innerHTML = "";
//               measureContainer.appendChild(tempDiv);

//               const questionHeight = tempDiv.offsetHeight;
//               const isLastQuestion = index === allQuestions.length - 1;
//               const roughWorkHeight =
//                 roughPage && isLastQuestion ? ROUGH_WORK_MIN_HEIGHT_PX : 0;

//               // Check if adding this question exceeds page height
//               if (
//                 currentHeight + questionHeight + roughWorkHeight >
//                   PAGE_CONTENT_HEIGHT_PX &&
//                 currentPageQuestions.length > 0
//               ) {
//                 // Page is full, save current page
//                 newPages.push({
//                   type: "questions",
//                   key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                   setName: set.set_name,
//                   subject,
//                   section,
//                   questions: currentPageQuestions,
//                   questionIndexOffset,
//                   pageNumber: questionPageCounter++,
//                   isLastPageInSection: false,
//                 });

//                 // Start new page
//                 questionIndexOffset += currentPageQuestions.length;
//                 currentPageQuestions = [ques];
//                 measureContainer.innerHTML = sectionHeaderHTML;
//                 currentHeight = measureContainer.offsetHeight + questionHeight;
//               } else {
//                 // Add question to current page
//                 currentPageQuestions.push(ques);
//                 currentHeight += questionHeight;
//               }
//             });

//             // Add final page for section
//             if (currentPageQuestions.length > 0) {
//               newPages.push({
//                 type: "questions",
//                 key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                 setName: set.set_name,
//                 subject,
//                 section,
//                 questions: currentPageQuestions,
//                 questionIndexOffset,
//                 pageNumber: questionPageCounter++,
//                 isLastPageInSection: true,
//               });
//             }
//           });
//         });

//         // Update cover page with actual question page count
//         const totalQPagesForSet = newPages.filter(
//           (p) => p.type === "questions" && p.setName === set.set_name
//         ).length;
//         const coverPageIndex = newPages.findIndex(
//           (p) => p.type === "cover" && p.setName === set.set_name
//         );
//         if (coverPageIndex > -1) {
//           newPages[coverPageIndex].totalQuestionPages = totalQPagesForSet;
//         }
//       });

//       // Cleanup
//       document.body.removeChild(measureContainer);
//       setPaginatedPages(newPages);
//     };

//     const timeoutId = setTimeout(calculateDynamicPages, 100);
//     return () => clearTimeout(timeoutId);
//   }, [
//     questionData,
//     quesPaperInfo,
//     selectedSetNames,
//     showCoverPage,
//     twinColumn,
//     roughPage,
//     watermark,
//   ]);

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <button
//                   className="icon-btn__pre-ques"
//                   style={{ marginRight: "70px" }}
//                   onClick={handlePrint}
//                 >
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {paginatedPages.length > 0 ? (
//                 paginatedPages.map((page) => (
//                   <div
//                     className={`a4-page${
//                       roughPage && page.type === "questions"
//                         ? " has-roughwork"
//                         : ""
//                     }`}
//                     key={page.key}
//                   >
//                     {watermark && (
//                       <img
//                         src={watermarkImg}
//                         alt="watermark"
//                         className="watermark-image"
//                       />
//                     )}

//                     {/* Page Content */}
//                     {page.type === "cover" && (
//                       <div
//                         dangerouslySetInnerHTML={{
//                           __html: quesPaperInfo.paper_cover
//                             .replace(/#total_pages#/gi, page.totalQuestionPages)
//                             .replace(
//                               /#test_date#/gi,
//                               new Date().toLocaleDateString("en-GB")
//                             )
//                             .replace(/#set_name#/gi, page.setName),
//                         }}
//                       />
//                     )}

//                     {page.type === "instructions" && (
//                       <div className="instructions-page">
//                         <div className="instructions-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Instructions</h2>
//                           <hr
//                             style={{
//                               border: "none",
//                               borderTop: `1px solid ${Colors.color4}`,
//                               margin: "1rem 0",
//                             }}
//                           />
//                         </div>
//                         <div
//                           dangerouslySetInnerHTML={{
//                             __html: quesPaperInfo.instructions_html,
//                           }}
//                         />
//                       </div>
//                     )}

//                     {page.type === "syllabus" && (
//                       <div className="syllabus-page">
//                         <div className="syllabus-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Test Syllabus</h2>
//                         </div>
//                         <table className="syllabus-table_prev_ques">
//                           <thead>
//                             <tr>
//                               <th>Subject</th>
//                               <th>Chapters</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                               <tr key={idx}>
//                                 <td>
//                                   <strong>
//                                     {subj.subject_name.toUpperCase()}
//                                   </strong>
//                                 </td>
//                                 <td>{subj.chapters.join(", ")}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}

//                     {page.type === "questions" && (
//                       <div
//                         className="section-container__pre-ques"
//                         style={{ position: "relative", minHeight: "530px" }}
//                       >
//                         <p className="section-heading__Pre-ques">
//                           Section {page.section.section_name}
//                         </p>
//                         <p>
//                           Instruction:{" "}
//                           {page.section.section_instruction?.trim()
//                             ? renderQuestionText(
//                                 page.section.section_instruction
//                               )
//                             : "N/A"}
//                         </p>
//                         <div className="page-header__pre-ques">
//                           <div className="header-left__pre-ques">
//                             {quesPaperInfo?.header?.date}
//                           </div>
//                           <div className="header-center__pre-ques">
//                             {page.subject.subject_name}
//                           </div>
//                           <div className="header-right__pre-ques">
//                             {quesPaperInfo?.header?.test_name}
//                           </div>
//                         </div>

//                         {(() => {
//                           const questions = page.questions;
//                           const mid = Math.ceil(questions.length / 2);
//                           const leftQuestions = questions.slice(0, mid);
//                           const rightQuestions = questions.slice(mid);

//                           return twinColumn ? (
//                             <div className="question-grid__pre-ques">
//                               <div className="question-column__pre-ques">
//                                 {leftQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset + index + 1}.
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                               <div className="question-column__pre-ques">
//                                 {rightQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset +
//                                           mid +
//                                           index +
//                                           1}
//                                         .
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                             </div>
//                           ) : (
//                             <div>
//                               {questions.map((ques, index) => (
//                                 <div
//                                   key={ques.ques_id}
//                                   className="question-block"
//                                 >
//                                   <p>
//                                     <strong>
//                                       {page.questionIndexOffset + index + 1}.
//                                     </strong>{" "}
//                                     {renderQuestionText(ques.ques_text)}
//                                   </p>
//                                   <div className="options__pre-ques">
//                                     {[...ques.options]
//                                       .sort(
//                                         (a, b) =>
//                                           a.set_option_position -
//                                           b.set_option_position
//                                       )
//                                       .map((opt, idx) => (
//                                         <p key={opt.option_id}>
//                                           <span>
//                                             {getOptionLabel(
//                                               idx,
//                                               quesPaperInfo?.option_naming_pattern
//                                             )}
//                                           </span>{" "}
//                                           {renderQuestionText(opt.option_text)}
//                                         </p>
//                                       ))}
//                                   </div>
//                                 </div>
//                               ))}
//                             </div>
//                           );
//                         })()}

//                         {roughPage && (
//                           <div
//                             className="rough-work-section"
//                             style={{
//                               minHeight: page.isLastPageInSection
//                                 ? "100px"
//                                 : "200px",
//                             }}
//                           >
//                             <strong>Rough Work:</strong>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Page Footer */}
//                     <div className="page-footer">
//                       <div className="footer-left">
//                         {quesPaperInfo?.footer?.client_name} |{" "}
//                         {quesPaperInfo?.footer?.address}
//                       </div>
//                       <div className="footer-right">
//                         {page.type === "cover" &&
//                           `Set ${page.setName} - Cover Page`}
//                         {page.type === "syllabus" &&
//                           `Set ${page.setName} - Syllabus`}
//                         {page.type === "questions" && `Page ${page.pageNumber}`}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;

// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import "./previewquestion.css";
// import Latex from "react-latex-next";
// import he from "he";
// import { API_BASE_URL } from "../../../Config/Config";
// import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
// import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
// import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
// import { FaFilePdf } from "react-icons/fa6";
// import { FaFileWord } from "react-icons/fa";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import jsPDF from "jspdf";
// import Colors from "../../../Constants/Colors";
// function PreviewQuesPaper({ showModal, onClose }) {
//   const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const [showCoverPage, setShowCoverPage] = useState(true);
//   const [twinColumn, setTwinColumn] = useState(true);
//   const [watermark, setWatermark] = useState(true);
//   const [roughPage, setRoughPage] = useState(false);
//   const [pageCountsBySet, setPageCountsBySet] = useState({});
//   const contentRef = useRef();
//   const location = useLocation();
//   const exportDropdownRef = useRef();
//   const searchParams = new URLSearchParams(location.search);
//   const testScheduleId = searchParams.get("IDs");
//   const accessToken = localStorage.getItem("other");
//   const [showExportOptions, setShowExportOptions] = useState(false);

//   const [paginatedPages, setPaginatedPages] = useState([]);

//   const availableSets = ["A", "B", "C", "D"];

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, [selectedSetNames]);

//   useEffect(() => {
//     if (questionData.length > 0) {
//       const counts = {};
//       questionData.forEach((set) => {
//         counts[set.set_name] = set.subjects.length;
//       });
//       setPageCountsBySet(counts);
//     }
//   }, [questionData]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         exportDropdownRef.current &&
//         !exportDropdownRef.current.contains(event.target)
//       ) {
//         setShowExportOptions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Add this helper function to render content to HTML for measurement
//   const renderContentToHTML = (text) => {
//     if (!text) return "";
//     const decoded = he.decode(text);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts
//       .map((segment) => {
//         if (segment.startsWith("imgsrc=")) {
//           const url = segment.replace("imgsrc=", "");
//           return `<img src="${url}" alt="image" style="max-width: 80px; height: auto; vertical-align: middle; margin: 0 5px;" />`;
//         } else {
//           return segment.replace(/\\\((.*?)\\\)/g, (_, math) => {
//             try {
//               return katex.renderToString(math, {
//                 throwOnError: false,
//                 displayMode: false,
//               });
//             } catch (e) {
//               console.warn("Katex rendering error:", e);
//               return `<span style="color:red;">[LaTeX Error]</span>`;
//             }
//           });
//         }
//       })
//       .join("");
//   };

//   const renderQuestionText = (questionText) => {
//     const decoded = he.decode(questionText);
//     const parts = decoded.split(/(imgsrc=[^ ]+)/g);
//     return parts.map((segment, idx) => {
//       if (segment.startsWith("imgsrc=")) {
//         const url = segment.replace("imgsrc=", "");
//         return (
//           <img
//             key={idx}
//             src={url}
//             alt={`img-${idx}`}
//             style={{ width: "30px", height: "auto", margin: "5px" }}
//           />
//         );
//       } else {
//         return (
//           <span key={idx}>
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

//   const getOptionLabel = (index, pattern) => {
//     if (pattern === 1) return `${index + 1}.`;
//     if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
//     if (pattern === 3)
//       return (
//         ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
//         `${index + 1}.`
//       );
//     return `${index + 1}.`;
//   };

//   const processedCoverHTML = (setName) => {
//     if (!quesPaperInfo?.paper_cover) return "";
//     const testDate = new Date().toLocaleDateString("en-GB");
//     const totalPages = pageCountsBySet[setName] || "";
//     return quesPaperInfo.paper_cover
//       .replace(/#total_pages#/gi, totalPages)
//       .replace(/#test_date#/gi, testDate)
//       .replace(/#set_name#/gi, setName);
//   };

//   const handlePrint = () => {
//     if (!paginatedPages || paginatedPages.length === 0) {
//       alert("There is no content to print.");
//       return;
//     }

//     // Helper to process cover page HTML
//     const getProcessedCoverHTML = (page) => {
//       if (!quesPaperInfo?.paper_cover) return "";
//       return quesPaperInfo.paper_cover
//         .replace(/#total_pages#/gi, page.totalQuestionPages)
//         .replace(/#test_date#/gi, new Date().toLocaleDateString("en-GB"))
//         .replace(/#set_name#/gi, page.setName);
//     };

//     let printContent = `
//     <style>
//       body, html { margin: 0 !important; padding: 0 !important; background-color: #fff; font-family: Calibri, sans-serif; }
//       .a4-page { width: 210mm; min-height: 297mm; margin: 0 auto; padding: 8mm; box-sizing: border-box; background: white; position: relative; page-break-after: always; }
      
//       .page-content-wrapper { 
//         height: calc(297mm - 15mm); 
//         position: relative; 
//         padding-bottom: 15mm; /* Reduced from 25mm */
//         overflow: hidden;
//       }
//         .question-block img,
//   .question-grid__pre-ques img,
//   .question-column__pre-ques img,
//   .options__pre-ques img {
//     width: 30px !important;
//     height: auto !important;
//     margin: 5px !important;
//     vertical-align: middle !important;
//   }

//       .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
//       .watermark img { width: 300px; height: auto; }
//       .section-heading__Pre-ques { font-size: 16px; font-weight: 600; margin: 0px 0 2px 0; padding-left: 15px; } /* Reduced margin */
//       .question-grid__pre-ques { display: flex; gap: 15px; } /* Reduced gap */
//       .question-column__pre-ques { flex: 1; min-width: 0; }
//       .question-block { margin-bottom: 6px; page-break-inside: avoid; } /* Reduced margin */
//       .question-block p { margin: 0 0 2px 0; line-height: 1.2; } /* Reduced line-height and margin */
//       .options__pre-ques p { margin: 2px 0 0px 16px; font-size: 14px; line-height: 1.1; } /* Reduced margins and line-height */
//       .page-footer { 
//         position: absolute; 
//         bottom: 5mm; 
//         left: 8mm; 
//         right: 8mm; 
//         height: 12mm; /* Reduced height */
//         text-align: center; 
//         font-size: 11px; 
//         border-top: 1px solid #ccc; 
//         padding-top: 3px; /* Reduced padding */
//         color: #444; 
//         display: flex; 
//         justify-content: space-between;
//         background: white;
//         z-index: 10;
//       }
//       .page-header__pre-ques { display: flex; justify-content: space-between; font-size: 13px; padding: 3px 12px; margin-bottom: 4px; border-bottom: 1px solid #ccc; } /* Reduced padding and margin */
//       .rough-work-section { margin-top: 10px !important; 
//       border-top: 1px dashed #ccc !important; 
//       padding-top: 5px !important; 
//       min-height: 40px !important;
//       page-break-inside: avoid !important;
//       break-inside: avoid !important;
//       page-break-before: avoid !important;} /* Reduced spacing */
//       .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 3px; padding-bottom: 5px; } /* Reduced margins */
//       .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
//       .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 6px; text-align: left; vertical-align: top; } /* Reduced padding */
//       .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
//       .instructions-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 3px; padding-bottom: 5px; } /* Reduced margins */
//       .instructions-content { margin-top: 3px; } /* Reduced margin */
//       @media print {
//         body * { visibility: hidden !important; }
//         #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
//         #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
//         .rough-work-section {
//         page-break-inside: avoid !important;
//         break-inside: avoid !important;
//         orphans: 3;
//         widows: 3;
//       }
//       }
//       @page { size: A4; margin: 0; }
//     </style>
//   `;

//     // Iterate through the already calculated paginatedPages
//     paginatedPages.forEach((page) => {
//       printContent += `<div class="a4-page">`;

//       // Add watermark if enabled
//       if (watermark) {
//         printContent += `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`;
//       }

//       printContent += `<div class="page-content-wrapper">`;

//       // Generate content based on page type
//       switch (page.type) {
//         case "cover":
//           printContent += `
//     <div class="cover-page-optimal" style="
//       transform: scale(0.9) !important; /* Balanced shrinking - 15% shrink */
//       transform-origin: top center !important;
//       width: 205mm !important; /* Precise compensation (100/0.85) */
//       height: 297mm !important; /* Use mm consistently - A4 height minus footer/margins */
//       font-size: 11.5px !important; /* Good readability */
//       line-height: 1.15 !important; /* Optimal line spacing */
//       margin: 0 !important;
//       padding: 0px !important; /* Efficient padding in mm */
//       max-height: 297mm !important; /* Safe maximum in mm */
//       overflow: hidden !important;
//       box-sizing: border-box !important;
//       position: absolute !important;
//       top: 0 !important;
//       left: 0 !important;
//       background: white !important;
//     ">
//       ${getProcessedCoverHTML(page)}
//     </div>`;
//           break;

//         case "instructions":
//           printContent += `
//           <div class="instructions-heading-print">Instructions</div>
//           <hr style="border: none; border-top: 1px solid #ccc; margin: 5px 0;" />
//           <div class="instructions-content" style="font-size: 14px; text-align: justify;">${quesPaperInfo.instructions_html}</div>`;
//           break;

//         case "syllabus":
//           printContent += `
//           <div class="syllabus-heading-print">Test Syllabus</div>
//           <table class="syllabus-table-print">
//             <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
//             <tbody>
//               ${quesPaperInfo.subj_chap_list
//                 .map(
//                   (s) => `
//                 <tr>
//                   <td><strong>${s.subject_name.toUpperCase()}</strong></td>
//                   <td>${s.chapters.join(", ")}</td>
//                 </tr>
//               `
//                 )
//                 .join("")}
//             </tbody>
//           </table>`;
//           break;

//         case "questions":
//           let questionsHtml = `
//           <p class="section-heading__Pre-ques">Section ${
//             page.section.section_name
//           }</p>
//           <p style="padding-left: 15px; margin: 0 0 4px 0;"><strong>Instruction:</strong> ${
//             page.section.section_instruction?.trim()
//               ? renderContentToHTML(page.section.section_instruction)
//               : "N/A"
//           }</p>
//           <div class="page-header__pre-ques">
//             <div>${quesPaperInfo?.header?.date || ""}</div>
//             <div>${page.subject.subject_name}</div>
//             <div>${quesPaperInfo?.header?.test_name || ""}</div>
//           </div>`;

//           const renderQuestionColumn = (qs, offset) =>
//             qs
//               .map(
//                 (q, i) => `
//           <div class="question-block">
//             <p><strong>${offset + i + 1}.</strong> ${renderContentToHTML(
//                   q.ques_text
//                 )}</p>
//             <div class="options__pre-ques">
//               ${q.options
//                 .sort((a, b) => a.set_option_position - b.set_option_position)
//                 .map(
//                   (opt, oi) => `
//                 <p><span>${getOptionLabel(
//                   oi,
//                   quesPaperInfo?.option_naming_pattern
//                 )}</span> ${renderContentToHTML(opt.option_text)}</p>
//               `
//                 )
//                 .join("")}
//             </div>
//           </div>`
//               )
//               .join("");

//           if (twinColumn) {
//             const mid = Math.ceil(page.questions.length / 2);
//             questionsHtml += `
//             <div class="question-grid__pre-ques">
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(0, mid),
//                 page.questionIndexOffset
//               )}</div>
//               <div class="question-column__pre-ques">${renderQuestionColumn(
//                 page.questions.slice(mid),
//                 page.questionIndexOffset + mid
//               )}</div>
//             </div>`;
//           } else {
//             questionsHtml += `<div>${renderQuestionColumn(
//               page.questions,
//               page.questionIndexOffset
//             )}</div>`;
//           }

//           // Add rough work section if enabled and this is the last page of the section
//           if (roughPage) {
//             const roughWorkHeight = page.isLastPageInSection ? "60px" : "120px";
//             questionsHtml += `
//             <div class="rough-work-section" style="min-height: ${roughWorkHeight};">
//             <strong>Rough Work:</strong>
//             </div>`;
//           }

//           printContent += questionsHtml;
//           break;

//         default:
//           break;
//       }

//       printContent += `</div>`; // Close page-content-wrapper

//       // Add footer for all page types
//       printContent += `
//       <div class="page-footer">
//         <div>${quesPaperInfo?.footer?.client_name || ""} | ${
//         quesPaperInfo?.footer?.address || ""
//       }</div>
//         <div>
//           ${page.type === "cover" ? `Set ${page.setName} - Cover Page` : ""}
//           ${
//             page.type === "instructions"
//               ? `Set ${page.setName} - Instructions`
//               : ""
//           }
//           ${page.type === "syllabus" ? `Set ${page.setName} - Syllabus` : ""}
//           ${page.type === "questions" ? `Page ${page.pageNumber}` : ""}
//         </div>
//       </div>
//     `;

//       printContent += `</div>`; // Close a4-page
//     });

//     // Create and inject print section
//     const printSectionId = "printSectionDynamic";
//     let printSection = document.getElementById(printSectionId);
//     if (printSection) document.body.removeChild(printSection);

//     printSection = document.createElement("div");
//     printSection.id = printSectionId;
//     printSection.innerHTML = printContent;
//     document.body.appendChild(printSection);

//     // Print with a small delay to ensure rendering
//     setTimeout(() => {
//       window.print();
//       // Cleanup after printing
//       setTimeout(() => {
//         if (document.getElementById(printSectionId)) {
//           document.body.removeChild(document.getElementById(printSectionId));
//         }
//       }, 1000);
//     }, 500);
//   };

//   useEffect(() => {
//     const calculateDynamicPages = () => {
//       if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//         setPaginatedPages([]);
//         return;
//       }

//       // Adjust page content height based on layout mode
//       const BASE_PAGE_CONTENT_HEIGHT_PX = 2110;
//       const PAGE_CONTENT_HEIGHT_PX = twinColumn
//         ? BASE_PAGE_CONTENT_HEIGHT_PX
//         : BASE_PAGE_CONTENT_HEIGHT_PX * 0.55; // Reduce available height for single column to maintain consistency

//       const ROUGH_WORK_MIN_HEIGHT_PX = 40;

//       const newPages = [];
//       const setsToRender = questionData.filter((set) =>
//         selectedSetNames.includes(set.set_name)
//       );

//       // Create hidden measurement container
//       const measureContainer = document.createElement("div");
//       measureContainer.style.position = "absolute";
//       measureContainer.style.visibility = "hidden";
//       measureContainer.style.left = "-9999px";
//       measureContainer.style.width = "calc(210mm - 40mm)";
//       measureContainer.style.fontFamily = "Calibri, sans-serif";
//       measureContainer.style.fontSize = "14px";
//       measureContainer.style.lineHeight = "1.4";
//       document.body.appendChild(measureContainer);

//       setsToRender.forEach((set) => {
//         let questionPageCounter = 1;
//         let globalQuestionCounter = 0;

//         // Add Cover Page
//         if (showCoverPage && quesPaperInfo.paper_cover) {
//           newPages.push({
//             type: "cover",
//             key: `cover-${set.set_name}`,
//             setName: set.set_name,
//             totalQuestionPages: "Dynamic",
//           });
//         }

//         // Add Instructions Page
//         if (showCoverPage && quesPaperInfo.instructions_html) {
//           newPages.push({
//             type: "instructions",
//             key: `instructions-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Add Syllabus Page
//         if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//           newPages.push({
//             type: "syllabus",
//             key: `syllabus-${set.set_name}`,
//             setName: set.set_name,
//           });
//         }

//         // Dynamic Question Pagination
//         set.subjects.forEach((subject) => {
//           subject.sections.forEach((section) => {
//             const allQuestions = [...(section.questions || [])].sort(
//               (a, b) => a.set_ques_position - b.set_ques_position
//             );
//             if (allQuestions.length === 0) return;

//             let currentPageQuestions = [];
//             let currentPageStartIndex = globalQuestionCounter;

//             // Measure section header height
//             const sectionHeaderHTML = `
//             <p style="font-size: 16px; font-weight: 600; margin: 20px 0 4px 0;">Section ${
//               section.section_name
//             }</p>
//             <p style="margin: 0 0 8px 0;">Instruction: ${
//               section.section_instruction?.trim()
//                 ? renderContentToHTML(section.section_instruction)
//                 : "N/A"
//             }</p>
//             <div style="display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc;">
//               <div>${quesPaperInfo?.header?.date || ""}</div>
//               <div>${subject.subject_name}</div>
//               <div>${quesPaperInfo?.header?.test_name || ""}</div>
//             </div>`;

//             measureContainer.innerHTML = sectionHeaderHTML;
//             let currentHeight = measureContainer.offsetHeight;

//             allQuestions.forEach((ques, index) => {
//               // Create HTML for single question to measure
//               const questionHTML = `
//               <div style="margin-bottom: 8px; page-break-inside: avoid;">
//                 <p style="margin: 0 0 3px 0; line-height: 1.3;">
//                   <strong>${
//                     globalQuestionCounter + currentPageQuestions.length + 1
//                   }.</strong> 
//                   ${renderContentToHTML(ques.ques_text)}
//                 </p>
//                 <div style="margin-left: 16px;">
//                   ${ques.options
//                     .sort(
//                       (a, b) => a.set_option_position - b.set_option_position
//                     )
//                     .map(
//                       (opt, i) => `
//                         <p style="margin: 3px 0; font-size: 14px; line-height: 1.2;">
//                           ${getOptionLabel(
//                             i,
//                             quesPaperInfo?.option_naming_pattern
//                           )} ${renderContentToHTML(opt.option_text)}
//                         </p>
//                       `
//                     )
//                     .join("")}
//                 </div>
//               </div>`;

//               // Measure question height consistently
//               const tempDiv = document.createElement("div");
//               // Always measure at consistent width for fair comparison
//               tempDiv.style.width = twinColumn ? "50%" : "100%";
//               tempDiv.innerHTML = questionHTML;
//               measureContainer.innerHTML = "";
//               measureContainer.appendChild(tempDiv);

//               let questionHeight = tempDiv.offsetHeight;

//               // Apply layout-specific height adjustment
//               if (twinColumn) {
//                 // In twin column, questions are side by side, so we can fit more vertically
//                 questionHeight = questionHeight;
//               } else {
//                 // In single column, questions take full width and stack vertically
//                 // Apply a multiplier to account for the visual difference
//                 questionHeight = questionHeight * 1.0; // Keep actual measured height
//               }

//               const isLastQuestion = index === allQuestions.length - 1;
//               const roughWorkHeight = roughPage
//                 ? isLastQuestion
//                   ? 60
//                   : 120
//                 : 0;

//               // Check if adding this question exceeds page height
//               const availableHeight = PAGE_CONTENT_HEIGHT_PX - 50;
//               const totalHeightNeeded =
//                 currentHeight + questionHeight + roughWorkHeight;

//               if (
//                 totalHeightNeeded > availableHeight &&
//                 currentPageQuestions.length > 0
//               ) {
//                 // Page is full, save current page
//                 newPages.push({
//                   type: "questions",
//                   key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                   setName: set.set_name,
//                   subject,
//                   section,
//                   questions: currentPageQuestions,
//                   questionIndexOffset: currentPageStartIndex,
//                   pageNumber: questionPageCounter++,
//                   isLastPageInSection: false,
//                 });

//                 // Update global counter and start new page
//                 globalQuestionCounter += currentPageQuestions.length;
//                 currentPageStartIndex = globalQuestionCounter;
//                 currentPageQuestions = [ques];
//                 measureContainer.innerHTML = sectionHeaderHTML;
//                 currentHeight = measureContainer.offsetHeight + questionHeight;
//               } else {
//                 // Add question to current page
//                 currentPageQuestions.push(ques);
//                 currentHeight += questionHeight;
//               }
//             });

//             // Add final page for section
//             if (currentPageQuestions.length > 0) {
//               newPages.push({
//                 type: "questions",
//                 key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//                 setName: set.set_name,
//                 subject,
//                 section,
//                 questions: currentPageQuestions,
//                 questionIndexOffset: currentPageStartIndex,
//                 pageNumber: questionPageCounter++,
//                 isLastPageInSection: true,
//               });

//               globalQuestionCounter += currentPageQuestions.length;
//             }
//           });
//         });

//         // Update cover page with actual question page count
//         const totalQPagesForSet = newPages.filter(
//           (p) => p.type === "questions" && p.setName === set.set_name
//         ).length;
//         const coverPageIndex = newPages.findIndex(
//           (p) => p.type === "cover" && p.setName === set.set_name
//         );
//         if (coverPageIndex > -1) {
//           newPages[coverPageIndex].totalQuestionPages = totalQPagesForSet;
//         }
//       });

//       // Cleanup
//       document.body.removeChild(measureContainer);
//       setPaginatedPages(newPages);
//     };

//     const timeoutId = setTimeout(calculateDynamicPages, 100);
//     return () => clearTimeout(timeoutId);
//   }, [
//     questionData,
//     quesPaperInfo,
//     selectedSetNames,
//     showCoverPage,
//     twinColumn,
//     roughPage,
//     watermark,
//   ]);

//   // useEffect(() => {
//   //   const calculateDynamicPages = () => {
//   //     if (!questionData || questionData.length === 0 || !quesPaperInfo) {
//   //       setPaginatedPages([]);
//   //       return;
//   //     }

//   //     // A4 page configuration
//   //     // A4 is 297mm high, minus margins (~40mm) leaves ~257mm usable height
//   //     // 1mm ≈ 3.78px, so 257mm ≈ 970px
//   //     // const PAGE_CONTENT_HEIGHT_PX = 960;
//   //     // const ROUGH_WORK_MIN_HEIGHT_PX = 100;
//   //     // Updated - uses more of the A4 page (approximately 75-80% of available space)
//   //     const PAGE_CONTENT_HEIGHT_PX = 2110;
//   //     const ROUGH_WORK_MIN_HEIGHT_PX = 40; // Reduced slightly to accommodate more content

//   //     const newPages = [];
//   //     const setsToRender = questionData.filter((set) =>
//   //       selectedSetNames.includes(set.set_name)
//   //     );

//   //     // Create hidden measurement container
//   //     const measureContainer = document.createElement("div");
//   //     measureContainer.style.position = "absolute";
//   //     measureContainer.style.visibility = "hidden";
//   //     measureContainer.style.left = "-9999px";
//   //     measureContainer.style.width = "calc(210mm - 40mm)"; // A4 width minus margins
//   //     measureContainer.style.fontFamily = "Calibri, sans-serif";
//   //     measureContainer.style.fontSize = "14px";
//   //     measureContainer.style.lineHeight = "1.4";
//   //     document.body.appendChild(measureContainer);

//   //     setsToRender.forEach((set) => {
//   //       let questionPageCounter = 1;

//   //       // Add Cover Page
//   //       if (showCoverPage && quesPaperInfo.paper_cover) {
//   //         newPages.push({
//   //           type: "cover",
//   //           key: `cover-${set.set_name}`,
//   //           setName: set.set_name,
//   //           totalQuestionPages: "Dynamic",
//   //         });
//   //       }

//   //       // Add Instructions Page
//   //       if (showCoverPage && quesPaperInfo.instructions_html) {
//   //         newPages.push({
//   //           type: "instructions",
//   //           key: `instructions-${set.set_name}`,
//   //           setName: set.set_name,
//   //         });
//   //       }

//   //       // Add Syllabus Page
//   //       if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
//   //         newPages.push({
//   //           type: "syllabus",
//   //           key: `syllabus-${set.set_name}`,
//   //           setName: set.set_name,
//   //         });
//   //       }

//   //       // Dynamic Question Pagination
//   //       set.subjects.forEach((subject) => {
//   //         subject.sections.forEach((section) => {
//   //           const allQuestions = [...(section.questions || [])].sort(
//   //             (a, b) => a.set_ques_position - b.set_ques_position
//   //           );
//   //           if (allQuestions.length === 0) return;

//   //           let currentPageQuestions = [];
//   //           let questionIndexOffset = 0;

//   //           // Measure section header height
//   //           const sectionHeaderHTML = `
//   //           <p style="font-size: 16px; font-weight: 600; margin: 20px 0 4px 0;">Section ${
//   //             section.section_name
//   //           }</p>
//   //           <p style="margin: 0 0 8px 0;">Instruction: ${
//   //             section.section_instruction?.trim()
//   //               ? renderContentToHTML(section.section_instruction)
//   //               : "N/A"
//   //           }</p>
//   //           <div style="display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc;">
//   //             <div>${quesPaperInfo?.header?.date || ""}</div>
//   //             <div>${subject.subject_name}</div>
//   //             <div>${quesPaperInfo?.header?.test_name || ""}</div>
//   //           </div>`;

//   //           measureContainer.innerHTML = sectionHeaderHTML;
//   //           let currentHeight = measureContainer.offsetHeight;

//   //           allQuestions.forEach((ques, index) => {
//   //             // Create HTML for single question to measure
//   //             // In the questionHTML template, replace the question block div:
//   //             const questionHTML = `
//   // <div style="margin-bottom: 8px; page-break-inside: avoid;"> <!-- Reduced from 14px -->
//   //   <p style="margin: 0 0 3px 0; line-height: 1.3;"> <!-- Reduced margin and line-height -->
//   //     <strong>${
//   //       questionIndexOffset + currentPageQuestions.length + 1
//   //     }.</strong>
//   //     ${renderContentToHTML(ques.ques_text)}
//   //   </p>
//   //   <div style="margin-left: 16px;">
//   //     ${ques.options
//   //       .sort((a, b) => a.set_option_position - b.set_option_position)
//   //       .map(
//   //         (opt, i) => `
//   //           <p style="margin: 3px 0; font-size: 14px; line-height: 1.2;"> <!-- Reduced margin and line-height -->
//   //             ${getOptionLabel(
//   //               i,
//   //               quesPaperInfo?.option_naming_pattern
//   //             )} ${renderContentToHTML(opt.option_text)}
//   //           </p>
//   //         `
//   //       )
//   //       .join("")}
//   //   </div>
//   // </div>`;

//   //             // Measure question height
//   //             const tempDiv = document.createElement("div");
//   //             if (twinColumn) {
//   //               tempDiv.style.width = "50%";
//   //             }
//   //             tempDiv.innerHTML = questionHTML;
//   //             measureContainer.innerHTML = "";
//   //             measureContainer.appendChild(tempDiv);

//   //             const questionHeight = tempDiv.offsetHeight;
//   //             const isLastQuestion = index === allQuestions.length - 1;
//   //             const roughWorkHeight = roughPage
//   //               ? isLastQuestion
//   //                 ? 60
//   //                 : 120
//   //               : 0; // Match preview heights exactly

//   //             // Check if adding this question exceeds page height
//   //             const availableHeight = PAGE_CONTENT_HEIGHT_PX - 50; // Even smaller buffer
//   //             const totalHeightNeeded =
//   //               currentHeight + questionHeight + roughWorkHeight;

//   //             if (
//   //               totalHeightNeeded > availableHeight &&
//   //               currentPageQuestions.length > 0
//   //             ) {
//   //               // Page is full, save current page
//   //               newPages.push({
//   //                 type: "questions",
//   //                 key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//   //                 setName: set.set_name,
//   //                 subject,
//   //                 section,
//   //                 questions: currentPageQuestions,
//   //                 questionIndexOffset,
//   //                 pageNumber: questionPageCounter++,
//   //                 isLastPageInSection: false,
//   //               });

//   //               // Start new page
//   //               questionIndexOffset += currentPageQuestions.length;
//   //               currentPageQuestions = [ques];
//   //               measureContainer.innerHTML = sectionHeaderHTML;
//   //               currentHeight = measureContainer.offsetHeight + questionHeight;
//   //             } else {
//   //               // Add question to current page
//   //               currentPageQuestions.push(ques);
//   //               currentHeight += questionHeight;
//   //             }
//   //           });

//   //           // Add final page for section
//   //           if (currentPageQuestions.length > 0) {
//   //             newPages.push({
//   //               type: "questions",
//   //               key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
//   //               setName: set.set_name,
//   //               subject,
//   //               section,
//   //               questions: currentPageQuestions,
//   //               questionIndexOffset,
//   //               pageNumber: questionPageCounter++,
//   //               isLastPageInSection: true,
//   //             });
//   //           }
//   //         });
//   //       });

//   //       // Update cover page with actual question page count
//   //       const totalQPagesForSet = newPages.filter(
//   //         (p) => p.type === "questions" && p.setName === set.set_name
//   //       ).length;
//   //       const coverPageIndex = newPages.findIndex(
//   //         (p) => p.type === "cover" && p.setName === set.set_name
//   //       );
//   //       if (coverPageIndex > -1) {
//   //         newPages[coverPageIndex].totalQuestionPages = totalQPagesForSet;
//   //       }
//   //     });

//   //     // Cleanup
//   //     document.body.removeChild(measureContainer);
//   //     setPaginatedPages(newPages);
//   //   };

//   //   const timeoutId = setTimeout(calculateDynamicPages, 100);
//   //   return () => clearTimeout(timeoutId);
//   // }, [
//   //   questionData,
//   //   quesPaperInfo,
//   //   selectedSetNames,
//   //   showCoverPage,
//   //   twinColumn,
//   //   roughPage,
//   //   watermark,
//   // ]);

//   return (
//     <div className="create-role-container">
//       {showModal && (
//         <div className="modal-overlay__pre-ques">
//           <div className="modal-content__pre_ques">
//             <button
//               className="modal-close-btn__pre_ques"
//               onClick={() => onClose(false)}
//             >
//               X
//             </button>
//             <div className="preview-toolbar">
//               <div className="preview-toolbar-left">
//                 <span className="toolbar-label">Set</span>
//                 {availableSets.map((set) => (
//                   <label key={set} className="toolbar-radio">
//                     <input
//                       type="radio"
//                       name="set"
//                       value={set}
//                       checked={
//                         selectedSetNames.length === 1 &&
//                         selectedSetNames[0] === set
//                       }
//                       onChange={() => setSelectedSetNames([set])}
//                     />
//                     {set}
//                   </label>
//                 ))}
//                 <label className="toolbar-radio">
//                   <input
//                     type="radio"
//                     name="set"
//                     value="All"
//                     checked={selectedSetNames.length === availableSets.length}
//                     onChange={() =>
//                       setSelectedSetNames(
//                         selectedSetNames.length === availableSets.length
//                           ? []
//                           : availableSets
//                       )
//                     }
//                   />
//                   All
//                 </label>
//               </div>
//               <div className="preview-toolbar-middle">
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={showCoverPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setShowCoverPage(!showCoverPage)}
//                   />{" "}
//                   Cover Page
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={twinColumn}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setTwinColumn(!twinColumn)}
//                   />{" "}
//                   Twin Column
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={watermark}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setWatermark(!watermark)}
//                   />{" "}
//                   Watermark
//                 </label>
//                 <label style={{ display: "flex", color: "#2F2E40" }}>
//                   <input
//                     type="checkbox"
//                     checked={roughPage}
//                     className="delete-question-checkbox-dqc"
//                     onChange={() => setRoughPage(!roughPage)}
//                   />{" "}
//                   Rough Work
//                 </label>
//               </div>
//               <div className="preview-toolbar-right__pre-ques">
//                 <button
//                   className="icon-btn__pre-ques"
//                   style={{ marginRight: "70px" }}
//                   onClick={handlePrint}
//                 >
//                   <img
//                     src={PrintIcon}
//                     alt="printicon"
//                     style={{ marginRight: "5px" }}
//                   />{" "}
//                   Print
//                 </button>
//               </div>
//             </div>

//             <div
//               className="modal-body__pre-ques watermark-container"
//               ref={contentRef}
//             >
//               {paginatedPages.length > 0 ? (
//                 paginatedPages.map((page) => (
//                   <div
//                     className={`a4-page${
//                       roughPage && page.type === "questions"
//                         ? " has-roughwork"
//                         : ""
//                     }`}
//                     key={page.key}
//                   >
//                     {watermark && (
//                       <img
//                         src={watermarkImg}
//                         alt="watermark"
//                         className="watermark-image"
//                       />
//                     )}

//                     {/* Page Content */}
//                     {page.type === "cover" && (
//                       <div
//                         dangerouslySetInnerHTML={{
//                           __html: quesPaperInfo.paper_cover
//                             .replace(/#total_pages#/gi, page.totalQuestionPages)
//                             .replace(
//                               /#test_date#/gi,
//                               new Date().toLocaleDateString("en-GB")
//                             )
//                             .replace(/#set_name#/gi, page.setName),
//                         }}
//                       />
//                     )}

//                     {page.type === "instructions" && (
//                       <div className="instructions-page">
//                         <div className="instructions-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Instructions</h2>
//                           <hr
//                             style={{
//                               border: "none",
//                               borderTop: `1px solid ${Colors.color4}`,
//                               margin: "1rem 0",
//                             }}
//                           />
//                         </div>
//                         <div
//                           dangerouslySetInnerHTML={{
//                             __html: quesPaperInfo.instructions_html,
//                           }}
//                         />
//                       </div>
//                     )}

//                     {page.type === "syllabus" && (
//                       <div className="syllabus-page">
//                         <div className="syllabus-heading_prev_ques">
//                           <h2 style={{ textAlign: "center" }}>Test Syllabus</h2>
//                         </div>
//                         <table className="syllabus-table_prev_ques">
//                           <thead>
//                             <tr>
//                               <th>Subject</th>
//                               <th>Chapters</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {quesPaperInfo.subj_chap_list.map((subj, idx) => (
//                               <tr key={idx}>
//                                 <td>
//                                   <strong>
//                                     {subj.subject_name.toUpperCase()}
//                                   </strong>
//                                 </td>
//                                 <td>{subj.chapters.join(", ")}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}

//                     {page.type === "questions" && (
//                       <div
//                         className="section-container__pre-ques"
//                         style={{ position: "relative", minHeight: "530px" }}
//                       >
//                         <p className="section-heading__Pre-ques">
//                           Section {page.section.section_name}
//                         </p>
//                         <p>
//                           Instruction:{" "}
//                           {page.section.section_instruction?.trim()
//                             ? renderQuestionText(
//                                 page.section.section_instruction
//                               )
//                             : "N/A"}
//                         </p>
//                         <div className="page-header__pre-ques">
//                           <div className="header-left__pre-ques">
//                             {quesPaperInfo?.header?.date}
//                           </div>
//                           <div className="header-center__pre-ques">
//                             {page.subject.subject_name}
//                           </div>
//                           <div className="header-right__pre-ques">
//                             {quesPaperInfo?.header?.test_name}
//                           </div>
//                         </div>

//                         {(() => {
//                           const questions = page.questions;
//                           const mid = Math.ceil(questions.length / 2);
//                           const leftQuestions = questions.slice(0, mid);
//                           const rightQuestions = questions.slice(mid);

//                           return twinColumn ? (
//                             <div className="question-grid__pre-ques">
//                               <div className="question-column__pre-ques">
//                                 {leftQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset + index + 1}.
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                               <div className="question-column__pre-ques">
//                                 {rightQuestions.map((ques, index) => (
//                                   <div
//                                     key={ques.ques_id}
//                                     className="question-block"
//                                   >
//                                     <p>
//                                       <strong>
//                                         {page.questionIndexOffset +
//                                           mid +
//                                           index +
//                                           1}
//                                         .
//                                       </strong>{" "}
//                                       {renderQuestionText(ques.ques_text)}
//                                     </p>
//                                     <div className="options__pre-ques">
//                                       {[...ques.options]
//                                         .sort(
//                                           (a, b) =>
//                                             a.set_option_position -
//                                             b.set_option_position
//                                         )
//                                         .map((opt, idx) => (
//                                           <p key={opt.option_id}>
//                                             <span>
//                                               {getOptionLabel(
//                                                 idx,
//                                                 quesPaperInfo?.option_naming_pattern
//                                               )}
//                                             </span>{" "}
//                                             {renderQuestionText(
//                                               opt.option_text
//                                             )}
//                                           </p>
//                                         ))}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>
//                             </div>
//                           ) : (
//                             <div>
//                               {questions.map((ques, index) => (
//                                 <div
//                                   key={ques.ques_id}
//                                   className="question-block"
//                                 >
//                                   <p>
//                                     <strong>
//                                       {page.questionIndexOffset + index + 1}.
//                                     </strong>{" "}
//                                     {renderQuestionText(ques.ques_text)}
//                                   </p>
//                                   <div className="options__pre-ques">
//                                     {[...ques.options]
//                                       .sort(
//                                         (a, b) =>
//                                           a.set_option_position -
//                                           b.set_option_position
//                                       )
//                                       .map((opt, idx) => (
//                                         <p key={opt.option_id}>
//                                           <span>
//                                             {getOptionLabel(
//                                               idx,
//                                               quesPaperInfo?.option_naming_pattern
//                                             )}
//                                           </span>{" "}
//                                           {renderQuestionText(opt.option_text)}
//                                         </p>
//                                       ))}
//                                   </div>
//                                 </div>
//                               ))}
//                             </div>
//                           );
//                         })()}

//                         {roughPage && (
//                           <div
//                             className="rough-work-section"
//                             style={{
//                               minHeight: page.isLastPageInSection
//                                 ? "60px"
//                                 : "120px", // Reduced heights
//                             }}
//                           >
//                             <strong>Rough Work:</strong>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Page Footer */}
//                     <div className="page-footer">
//                       <div className="footer-left">
//                         {quesPaperInfo?.footer?.client_name} |{" "}
//                         {quesPaperInfo?.footer?.address}
//                       </div>
//                       <div className="footer-right">
//                         {page.type === "cover" &&
//                           `Set ${page.setName} - Cover Page`}
//                         {page.type === "syllabus" &&
//                           `Set ${page.setName} - Syllabus`}
//                         {page.type === "questions" && `Page ${page.pageNumber}`}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="no-set-selected-message">
//                   <p
//                     style={{
//                       textAlign: "center",
//                       marginTop: "50px",
//                       fontSize: "18px",
//                       color: "#444",
//                     }}
//                   >
//                     Please select at least one Set (A, B, C, or D) to preview
//                     the question paper.
//                   </p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PreviewQuesPaper;



import React, { useState, useEffect, useRef } from "react";
import "./previewquestion.css";
import Latex from "react-latex-next";
import he from "he";
import ExportIcon from "../../../Assets/Images/CommanImages/fileexport.png";
import PrintIcon from "../../../Assets/Images/CommanImages/print.png";
import watermarkImg from "../../../Assets/Images/client_logos/Reports/water_mark_img.png";
import { FaFilePdf } from "react-icons/fa6";
import { FaFileWord } from "react-icons/fa";
import katex from "katex";
import "katex/dist/katex.min.css";
import jsPDF from "jspdf";
import Colors from "../../../Constants/Colors";
function PreviewQuesPaper({ showModal, onClose, onQuestionPaperDetails, previewData }) {
  const [selectedSetNames, setSelectedSetNames] = useState(["A"]);
  const [questionData, setQuestionData] = useState([]);
  const [quesPaperInfo, setQuesPaperInfo] = useState(null);
  const [showCoverPage, setShowCoverPage] = useState(true);
  const [twinColumn, setTwinColumn] = useState(true);
  const [watermark, setWatermark] = useState(true);
  const [roughPage, setRoughPage] = useState(false);
  const [pageCountsBySet, setPageCountsBySet] = useState({});
  const contentRef = useRef();
  const exportDropdownRef = useRef();
  const [showExportOptions, setShowExportOptions] = useState(false);

  const [paginatedPages, setPaginatedPages] = useState([]);

  // Derive available sets from the API response (what the paper actually has)
  const availableSets = questionData.map((s) => s.set_name);

  // Populate data from the previewData prop passed by the parent
  useEffect(() => {
    if (!previewData) return;
    const allSets = (previewData.sets || []).map((s) => s.set_name);
    setQuestionData(previewData.sets || []);
    setQuesPaperInfo(previewData.ques_paper_info || null);
    // Select first set by default
    if (allSets.length > 0) setSelectedSetNames([allSets[0]]);
    if (previewData.ques_paper_info && onQuestionPaperDetails) {
      onQuestionPaperDetails({
        ques_paper_name: previewData.ques_paper_info.ques_paper_name,
        ques_paper_id: previewData.ques_paper_info.ques_paper_id,
      });
    }
  }, [previewData]);

  useEffect(() => {
    if (questionData.length > 0) {
      const counts = {};
      questionData.forEach((set) => {
        counts[set.set_name] = set.subjects.length;
      });
      setPageCountsBySet(counts);
    }
  }, [questionData]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        exportDropdownRef.current &&
        !exportDropdownRef.current.contains(event.target)
      ) {
        setShowExportOptions(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Add this helper function to render content to HTML for measurement
  const renderContentToHTML = (text) => {
    if (!text) return "";
    const decoded = he.decode(text);
    const parts = decoded.split(/(imgsrc=[^ ]+)/g);
    return parts
      .map((segment) => {
        if (segment.startsWith("imgsrc=")) {
          const url = segment.replace("imgsrc=", "");
          return `<img src="${url}" alt="image" style="max-width: 80px; height: auto; vertical-align: middle; margin: 0 5px;" />`;
        } else {
          return segment.replace(/\\\((.*?)\\\)/g, (_, math) => {
            try {
              return katex.renderToString(math, {
                throwOnError: false,
                displayMode: false,
              });
            } catch (e) {
              console.warn("Katex rendering error:", e);
              return `<span style="color:red;">[LaTeX Error]</span>`;
            }
          });
        }
      })
      .join("");
  };

  const renderQuestionText = (questionText) => {
    const decoded = he.decode(questionText);
    const parts = decoded.split(/(imgsrc=[^ ]+)/g);
    return parts.map((segment, idx) => {
      if (segment.startsWith("imgsrc=")) {
        const url = segment.replace("imgsrc=", "");
        return (
          <img
            key={idx}
            src={url}
            alt={`img-${idx}`}
            style={{ width: "30px", height: "auto", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={idx}>
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };

  const getOptionLabel = (index, pattern) => {
    if (pattern === 1) return `${index + 1}.`;
    if (pattern === 2) return `${String.fromCharCode(97 + index)}.`;
    if (pattern === 3)
      return (
        ["i", "ii", "iii", "iv", "v", "vi", "vii", "viii", "ix", "x"][index] ||
        `${index + 1}.`
      );
    return `${index + 1}.`;
  };

  const processedCoverHTML = (setName) => {
    if (!quesPaperInfo?.paper_cover) return "";
    const testDate = new Date().toLocaleDateString("en-GB");
    const totalPages = pageCountsBySet[setName] || "";
    return quesPaperInfo.paper_cover
      .replace(/#total_pages#/gi, totalPages)
      .replace(/#test_date#/gi, testDate)
      .replace(/#set_name#/gi, setName);
  };

  const handlePrint = () => {
    if (!paginatedPages || paginatedPages.length === 0) {
      alert("There is no content to print.");
      return;
    }

    // Helper to process cover page HTML
    const getProcessedCoverHTML = (page) => {
      if (!quesPaperInfo?.paper_cover) return "";
      return quesPaperInfo.paper_cover
        .replace(/#total_pages#/gi, page.totalQuestionPages)
        .replace(/#test_date#/gi, new Date().toLocaleDateString("en-GB"))
        .replace(/#set_name#/gi, page.setName);
    };

    let printContent = `
    <style>
      body, html { margin: 0 !important; padding: 0 !important; background-color: #fff; font-family: Calibri, sans-serif; }
      .a4-page { width: 210mm; min-height: 297mm; margin: 0 auto; padding: 8mm; box-sizing: border-box; background: white; position: relative; page-break-after: always; }
      
      .page-content-wrapper { 
        height: calc(297mm - 15mm); 
        position: relative; 
        padding-bottom: 15mm; /* Reduced from 25mm */
        overflow: hidden;
      }
        .question-block img,
  .question-grid__pre-ques img,
  .question-column__pre-ques img,
  .options__pre-ques img {
    width: 30px !important;
    height: auto !important;
    margin: 5px !important;
    vertical-align: middle !important;
  }

      .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0.07; z-index: 0; pointer-events: none; }
      .watermark img { width: 300px; height: auto; }
      .section-heading__Pre-ques { font-size: 16px; font-weight: 600; margin: 0px 0 2px 0; padding-left: 15px; } /* Reduced margin */
      .question-grid__pre-ques { display: flex; gap: 15px; } /* Reduced gap */
      .question-column__pre-ques { flex: 1; min-width: 0; }
      .question-block { margin-bottom: 6px; page-break-inside: avoid; } /* Reduced margin */
      .question-block p { margin: 0 0 2px 0; line-height: 1.2; } /* Reduced line-height and margin */
      .options__pre-ques p { margin: 2px 0 0px 16px; font-size: 14px; line-height: 1.1; } /* Reduced margins and line-height */
      .page-footer { 
        position: absolute; 
        bottom: 5mm; 
        left: 8mm; 
        right: 8mm; 
        height: 12mm; /* Reduced height */
        text-align: center; 
        font-size: 11px; 
        border-top: 1px solid #ccc; 
        padding-top: 3px; /* Reduced padding */
        color: #444; 
        display: flex; 
        justify-content: space-between;
        background: white;
        z-index: 10;
      }
      .page-header__pre-ques { display: flex; justify-content: space-between; font-size: 13px; padding: 3px 12px; margin-bottom: 4px; border-bottom: 1px solid #ccc; } /* Reduced padding and margin */
      .rough-work-section { margin-top: 10px !important; 
      border-top: 1px dashed #ccc !important; 
      padding-top: 5px !important; 
      min-height: 40px !important;
      page-break-inside: avoid !important;
      break-inside: avoid !important;
      page-break-before: avoid !important;} /* Reduced spacing */
      .syllabus-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 3px; padding-bottom: 5px; } /* Reduced margins */
      .syllabus-table-print { width: 100%; border-collapse: collapse; font-size: 14px; }
      .syllabus-table-print th, .syllabus-table-print td { border: 1px solid #999; padding: 6px; text-align: left; vertical-align: top; } /* Reduced padding */
      .syllabus-table-print th { background-color: #f0f0f0; font-weight: bold; }
      .instructions-heading-print { font-size: 20px; font-weight: bold; text-align: center; margin-top: 3px; padding-bottom: 5px; } /* Reduced margins */
      .instructions-content { margin-top: 3px; } /* Reduced margin */
      @media print {
        body * { visibility: hidden !important; }
        #printSectionDynamic, #printSectionDynamic * { visibility: visible !important; }
        #printSectionDynamic { position: absolute !important; left: 0; top: 0; width: 100%; }
        .rough-work-section {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
        orphans: 3;
        widows: 3;
      }
      }
      @page { size: A4; margin: 0; }
    </style>
  `;

    // Iterate through the already calculated paginatedPages
    paginatedPages.forEach((page) => {
      printContent += `<div class="a4-page">`;

      // Add watermark if enabled
      if (watermark) {
        printContent += `<div class="watermark"><img src="${watermarkImg}" alt="Watermark" /></div>`;
      }

      printContent += `<div class="page-content-wrapper">`;

      // Generate content based on page type
      switch (page.type) {
        case "cover":
          printContent += `
    <div class="cover-page-optimal" style="
      transform: scale(0.9) !important; /* Balanced shrinking - 15% shrink */
      transform-origin: top center !important;
      width: 205mm !important; /* Precise compensation (100/0.85) */
      height: 297mm !important; /* Use mm consistently - A4 height minus footer/margins */
      font-size: 11.5px !important; /* Good readability */
      line-height: 1.15 !important; /* Optimal line spacing */
      margin: 0 !important;
      padding: 0px !important; /* Efficient padding in mm */
      max-height: 297mm !important; /* Safe maximum in mm */
      overflow: hidden !important;
      box-sizing: border-box !important;
      position: absolute !important;
      top: 0 !important;
      left: 0 !important;
      background: white !important;
    ">
      ${getProcessedCoverHTML(page)}
    </div>`;
          break;

        case "instructions":
          printContent += `
          <div class="instructions-heading-print">Instructions</div>
          <hr style="border: none; border-top: 1px solid #ccc; margin: 5px 0;" />
          <div class="instructions-content" style="font-size: 14px; text-align: justify;">${quesPaperInfo.instructions_html}</div>`;
          break;

        case "syllabus":
          printContent += `
          <div class="syllabus-heading-print">Test Syllabus</div>
          <table class="syllabus-table-print">
            <thead><tr><th>Subject</th><th>Chapters</th></tr></thead>
            <tbody>
              ${quesPaperInfo.subj_chap_list
                .map(
                  (s) => `
                <tr>
                  <td><strong>${(s.subject_superset_name || "").toUpperCase()}</strong></td>
                  <td>${(s.chapters || []).join(", ")}</td>
                </tr>
              `
                )
                .join("")}
            </tbody>
          </table>`;
          break;

        case "questions":
          let questionsHtml = `
          <p class="section-heading__Pre-ques">Section ${
            page.section.section_name
          }</p>
          <p style="padding-left: 15px; margin: 0 0 4px 0;"><strong>Instruction:</strong> ${
            page.section.section_instruction?.trim()
              ? renderContentToHTML(page.section.section_instruction)
              : "N/A"
          }</p>
          <div class="page-header__pre-ques">
            <div>${quesPaperInfo?.header?.date || ""}</div>
            <div>${page.subject.subject_superset_name}</div>
            <div>${quesPaperInfo?.header?.test_name || ""}</div>
          </div>`;

          const renderQuestionColumn = (qs, offset) =>
            qs
              .map(
                (q, i) => `
          <div class="question-block">
            <p><strong>${offset + i + 1}.</strong> ${renderContentToHTML(
                  q.ques_text
                )}</p>
            <div class="options__pre-ques">
              ${q.options
                .sort((a, b) => a.set_option_position - b.set_option_position)
                .map(
                  (opt, oi) => `
                <p><span>${getOptionLabel(
                  oi,
                  quesPaperInfo?.option_naming_pattern
                )}</span> ${renderContentToHTML(opt.option_text)}</p>
              `
                )
                .join("")}
            </div>
          </div>`
              )
              .join("");

          if (twinColumn) {
            const mid = Math.ceil(page.questions.length / 2);
            questionsHtml += `
            <div class="question-grid__pre-ques">
              <div class="question-column__pre-ques">${renderQuestionColumn(
                page.questions.slice(0, mid),
                page.questionIndexOffset
              )}</div>
              <div class="question-column__pre-ques">${renderQuestionColumn(
                page.questions.slice(mid),
                page.questionIndexOffset + mid
              )}</div>
            </div>`;
          } else {
            questionsHtml += `<div>${renderQuestionColumn(
              page.questions,
              page.questionIndexOffset
            )}</div>`;
          }

          // Add rough work section if enabled and this is the last page of the section
          if (roughPage) {
            const roughWorkHeight = page.isLastPageInSection ? "60px" : "120px";
            questionsHtml += `
            <div class="rough-work-section" style="min-height: ${roughWorkHeight};">
            <strong>Rough Work:</strong>
            </div>`;
          }

          printContent += questionsHtml;
          break;

        default:
          break;
      }

      printContent += `</div>`; // Close page-content-wrapper

      // Add footer for all page types
      printContent += `
      <div class="page-footer">
        <div>${quesPaperInfo?.footer?.client_name || ""} | ${
        quesPaperInfo?.footer?.address || ""
      }</div>
        <div>
          ${page.type === "cover" ? `Set ${page.setName} - Cover Page` : ""}
          ${
            page.type === "instructions"
              ? `Set ${page.setName} - Instructions`
              : ""
          }
          ${page.type === "syllabus" ? `Set ${page.setName} - Syllabus` : ""}
          ${page.type === "questions" ? `Page ${page.pageNumber}` : ""}
        </div>
      </div>
    `;

      printContent += `</div>`; // Close a4-page
    });

    // Create and inject print section
    const printSectionId = "printSectionDynamic";
    let printSection = document.getElementById(printSectionId);
    if (printSection) document.body.removeChild(printSection);

    printSection = document.createElement("div");
    printSection.id = printSectionId;
    printSection.innerHTML = printContent;
    document.body.appendChild(printSection);

    // Print with a small delay to ensure rendering
    setTimeout(() => {
      window.print();
      // Cleanup after printing
      setTimeout(() => {
        if (document.getElementById(printSectionId)) {
          document.body.removeChild(document.getElementById(printSectionId));
        }
      }, 1000);
    }, 500);
  };

  useEffect(() => {
    const calculateDynamicPages = () => {
      if (!questionData || questionData.length === 0 || !quesPaperInfo) {
        setPaginatedPages([]);
        return;
      }

      // Adjust page content height based on layout mode
      const BASE_PAGE_CONTENT_HEIGHT_PX = 2110;
      const PAGE_CONTENT_HEIGHT_PX = twinColumn
        ? BASE_PAGE_CONTENT_HEIGHT_PX
        : BASE_PAGE_CONTENT_HEIGHT_PX * 0.55; // Reduce available height for single column to maintain consistency

      const ROUGH_WORK_MIN_HEIGHT_PX = 40;

      const newPages = [];
      const setsToRender = questionData.filter((set) =>
        selectedSetNames.includes(set.set_name)
      );

      // Create hidden measurement container
      const measureContainer = document.createElement("div");
      measureContainer.style.position = "absolute";
      measureContainer.style.visibility = "hidden";
      measureContainer.style.left = "-9999px";
      measureContainer.style.width = "calc(210mm - 40mm)";
      measureContainer.style.fontFamily = "Calibri, sans-serif";
      measureContainer.style.fontSize = "14px";
      measureContainer.style.lineHeight = "1.4";
      document.body.appendChild(measureContainer);

      setsToRender.forEach((set) => {
        let questionPageCounter = 1;
        let globalQuestionCounter = 0;

        // Add Cover Page
        if (showCoverPage && quesPaperInfo.paper_cover) {
          newPages.push({
            type: "cover",
            key: `cover-${set.set_name}`,
            setName: set.set_name,
            totalQuestionPages: "Dynamic",
          });
        }

        // Add Instructions Page
        if (showCoverPage && quesPaperInfo.instructions_html) {
          newPages.push({
            type: "instructions",
            key: `instructions-${set.set_name}`,
            setName: set.set_name,
          });
        }

        // Add Syllabus Page
        if (showCoverPage && quesPaperInfo.subj_chap_list?.length > 0) {
          newPages.push({
            type: "syllabus",
            key: `syllabus-${set.set_name}`,
            setName: set.set_name,
          });
        }

        // Dynamic Question Pagination
        set.subjects.forEach((subject) => {
          subject.sections.forEach((section) => {
            const allQuestions = [...(section.questions || [])].sort(
              (a, b) => a.set_ques_position - b.set_ques_position
            );
            if (allQuestions.length === 0) return;

            let currentPageQuestions = [];
            let currentPageStartIndex = globalQuestionCounter;

            // Measure section header height
            const sectionHeaderHTML = `
            <p style="font-size: 16px; font-weight: 600; margin: 20px 0 4px 0;">Section ${
              section.section_name
            }</p>
            <p style="margin: 0 0 8px 0;">Instruction: ${
              section.section_instruction?.trim()
                ? renderContentToHTML(section.section_instruction)
                : "N/A"
            }</p>
            <div style="display:flex; justify-content:space-between; font-size:13px; padding:4px 12px; margin-bottom:8px; border-bottom:1px solid #ccc;">
              <div>${quesPaperInfo?.header?.date || ""}</div>
              <div>${subject.subject_superset_name}</div>
              <div>${quesPaperInfo?.header?.test_name || ""}</div>
            </div>`;

            measureContainer.innerHTML = sectionHeaderHTML;
            let currentHeight = measureContainer.offsetHeight;

            allQuestions.forEach((ques, index) => {
              // Create HTML for single question to measure
              const questionHTML = `
              <div style="margin-bottom: 8px; page-break-inside: avoid;">
                <p style="margin: 0 0 3px 0; line-height: 1.3;">
                  <strong>${
                    globalQuestionCounter + currentPageQuestions.length + 1
                  }.</strong> 
                  ${renderContentToHTML(ques.ques_text)}
                </p>
                <div style="margin-left: 16px;">
                  ${ques.options
                    .sort(
                      (a, b) => a.set_option_position - b.set_option_position
                    )
                    .map(
                      (opt, i) => `
                        <p style="margin: 3px 0; font-size: 14px; line-height: 1.2;">
                          ${getOptionLabel(
                            i,
                            quesPaperInfo?.option_naming_pattern
                          )} ${renderContentToHTML(opt.option_text)}
                        </p>
                      `
                    )
                    .join("")}
                </div>
              </div>`;

              // Measure question height consistently
              const tempDiv = document.createElement("div");
              // Always measure at consistent width for fair comparison
              tempDiv.style.width = twinColumn ? "50%" : "100%";
              tempDiv.innerHTML = questionHTML;
              measureContainer.innerHTML = "";
              measureContainer.appendChild(tempDiv);

              let questionHeight = tempDiv.offsetHeight;

              // Apply layout-specific height adjustment
              if (twinColumn) {
                // In twin column, questions are side by side, so we can fit more vertically
                questionHeight = questionHeight;
              } else {
                // In single column, questions take full width and stack vertically
                // Apply a multiplier to account for the visual difference
                questionHeight = questionHeight * 1.0; // Keep actual measured height
              }

              const isLastQuestion = index === allQuestions.length - 1;
              const roughWorkHeight = roughPage
                ? isLastQuestion
                  ? 60
                  : 120
                : 0;

              // Check if adding this question exceeds page height
              const availableHeight = PAGE_CONTENT_HEIGHT_PX - 50;
              const totalHeightNeeded =
                currentHeight + questionHeight + roughWorkHeight;

              if (
                totalHeightNeeded > availableHeight &&
                currentPageQuestions.length > 0
              ) {
                // Page is full, save current page
                newPages.push({
                  type: "questions",
                  key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
                  setName: set.set_name,
                  subject,
                  section,
                  questions: currentPageQuestions,
                  questionIndexOffset: currentPageStartIndex,
                  pageNumber: questionPageCounter++,
                  isLastPageInSection: false,
                });

                // Update global counter and start new page
                globalQuestionCounter += currentPageQuestions.length;
                currentPageStartIndex = globalQuestionCounter;
                currentPageQuestions = [ques];
                measureContainer.innerHTML = sectionHeaderHTML;
                currentHeight = measureContainer.offsetHeight + questionHeight;
              } else {
                // Add question to current page
                currentPageQuestions.push(ques);
                currentHeight += questionHeight;
              }
            });

            // Add final page for section
            if (currentPageQuestions.length > 0) {
              newPages.push({
                type: "questions",
                key: `questions-${set.set_name}-${section.section_name}-${newPages.length}`,
                setName: set.set_name,
                subject,
                section,
                questions: currentPageQuestions,
                questionIndexOffset: currentPageStartIndex,
                pageNumber: questionPageCounter++,
                isLastPageInSection: true,
              });

              globalQuestionCounter += currentPageQuestions.length;
            }
          });
        });

        // Update cover page with actual question page count
        const totalQPagesForSet = newPages.filter(
          (p) => p.type === "questions" && p.setName === set.set_name
        ).length;
        const coverPageIndex = newPages.findIndex(
          (p) => p.type === "cover" && p.setName === set.set_name
        );
        if (coverPageIndex > -1) {
          newPages[coverPageIndex].totalQuestionPages = totalQPagesForSet;
        }
      });

      // Cleanup
      document.body.removeChild(measureContainer);
      setPaginatedPages(newPages);
    };

    const timeoutId = setTimeout(calculateDynamicPages, 100);
    return () => clearTimeout(timeoutId);
  }, [
    questionData,
    quesPaperInfo,
    selectedSetNames,
    showCoverPage,
    twinColumn,
    roughPage,
    watermark,
  ]);

  return (
    <div className="create-role-container">
      {showModal && (
        <div className="modal-overlay__pre-ques">
          <div className="modal-content__pre_ques">
            <button
              className="modal-close-btn__pre_ques"
              onClick={() => onClose(false)}
            >
              X
            </button>
            <div className="preview-toolbar">
              <div className="preview-toolbar-left">
                <span className="toolbar-label">Set</span>
                {availableSets.map((set) => (
                  <label key={set} className="toolbar-radio">
                    <input
                      type="radio"
                      name="set"
                      value={set}
                      checked={
                        selectedSetNames.length === 1 &&
                        selectedSetNames[0] === set
                      }
                      onChange={() => setSelectedSetNames([set])}
                    />
                    {set}
                  </label>
                ))}
                <label className="toolbar-radio">
                  <input
                    type="radio"
                    name="set"
                    value="All"
                    checked={selectedSetNames.length === availableSets.length}
                    onChange={() =>
                      setSelectedSetNames(
                        selectedSetNames.length === availableSets.length
                          ? []
                          : availableSets
                      )
                    }
                  />
                  All
                </label>
              </div>
              <div className="preview-toolbar-middle">
                <label style={{ display: "flex", color: "#2F2E40" }}>
                  <input
                    type="checkbox"
                    checked={showCoverPage}
                    className="delete-question-checkbox-dqc"
                    onChange={() => setShowCoverPage(!showCoverPage)}
                  />{" "}
                  Cover Page
                </label>
                <label style={{ display: "flex", color: "#2F2E40" }}>
                  <input
                    type="checkbox"
                    checked={twinColumn}
                    className="delete-question-checkbox-dqc"
                    onChange={() => setTwinColumn(!twinColumn)}
                  />{" "}
                  Twin Column
                </label>
                <label style={{ display: "flex", color: "#2F2E40" }}>
                  <input
                    type="checkbox"
                    checked={watermark}
                    className="delete-question-checkbox-dqc"
                    onChange={() => setWatermark(!watermark)}
                  />{" "}
                  Watermark
                </label>
                <label style={{ display: "flex", color: "#2F2E40" }}>
                  <input
                    type="checkbox"
                    checked={roughPage}
                    className="delete-question-checkbox-dqc"
                    onChange={() => setRoughPage(!roughPage)}
                  />{" "}
                  Rough Work
                </label>
              </div>
              <div className="preview-toolbar-right__pre-ques">
                <button
                  className="icon-btn__pre-ques"
                  style={{ marginRight: "70px" }}
                  onClick={handlePrint}
                >
                  {/* <img
                    src={PrintIcon}
                    alt="printicon"
                    style={{ marginRight: "5px" }}
                  />{" "}
                  Print */}
                </button>
              </div>
            </div>

            <div
              className="modal-body__pre-ques watermark-container"
              ref={contentRef}
            >
              {paginatedPages.length > 0 ? (
                paginatedPages.map((page) => (
                  <div
                    className={`a4-page${
                      roughPage && page.type === "questions"
                        ? " has-roughwork"
                        : ""
                    }`}
                    key={page.key}
                  >
                    {watermark && (
                      <img
                        src={watermarkImg}
                        alt="watermark"
                        className="watermark-image"
                      />
                    )}

                    {/* Page Content */}
                    {page.type === "cover" && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: quesPaperInfo.paper_cover
                            .replace(/#total_pages#/gi, page.totalQuestionPages)
                            .replace(
                              /#test_date#/gi,
                              new Date().toLocaleDateString("en-GB")
                            )
                            .replace(/#set_name#/gi, page.setName),
                        }}
                      />
                    )}

                    {page.type === "instructions" && (
                      <div className="instructions-page">
                        <div className="instructions-heading_prev_ques">
                          <h2 style={{ textAlign: "center" }}>Instructions</h2>
                          <hr
                            style={{
                              border: "none",
                              borderTop: `1px solid ${Colors.color4}`,
                              margin: "1rem 0",
                            }}
                          />
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: quesPaperInfo.instructions_html,
                          }}
                        />
                      </div>
                    )}

                    {page.type === "syllabus" && (
                      <div className="syllabus-page">
                        <div className="syllabus-heading_prev_ques">
                          <h2 style={{ textAlign: "center" }}>Test Syllabus</h2>
                        </div>
                        <table className="syllabus-table_prev_ques">
                          <thead>
                            <tr>
                              <th>Subject</th>
                              <th>Chapters</th>
                            </tr>
                          </thead>
                          <tbody>
                            {quesPaperInfo.subj_chap_list.map((subj, idx) => (
                              <tr key={idx}>
                                <td>
                                  <strong>
                                    {(subj.subject_superset_name || "").toUpperCase()}
                                  </strong>
                                </td>
                                <td>{subj.chapters.join(", ")}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {page.type === "questions" && (
                      <div
                        className="section-container__pre-ques"
                        style={{ position: "relative", minHeight: "530px" }}
                      >
                        <p className="section-heading__Pre-ques">
                          Section {page.section.section_name}
                        </p>
                        <p>
                          Instruction:{" "}
                          {page.section.section_instruction?.trim()
                            ? renderQuestionText(
                                page.section.section_instruction
                              )
                            : "N/A"}
                        </p>
                        <div className="page-header__pre-ques">
                          <div className="header-left__pre-ques">
                            {quesPaperInfo?.header?.date}
                          </div>
                          <div className="header-center__pre-ques">
                            {page.subject.subject_superset_name}
                          </div>
                          <div className="header-right__pre-ques">
                            {quesPaperInfo?.header?.test_name}
                          </div>
                        </div>

                        {(() => {
                          const questions = page.questions;
                          const mid = Math.ceil(questions.length / 2);
                          const leftQuestions = questions.slice(0, mid);
                          const rightQuestions = questions.slice(mid);

                          return twinColumn ? (
                            <div className="question-grid__pre-ques">
                              <div className="question-column__pre-ques">
                                {leftQuestions.map((ques, index) => (
                                  <div
                                    key={ques.ques_id}
                                    className="question-block"
                                  >
                                    <p>
                                      <strong>
                                        {page.questionIndexOffset + index + 1}.
                                      </strong>{" "}
                                      {renderQuestionText(ques.ques_text)}
                                    </p>
                                    <div className="options__pre-ques">
                                      {[...ques.options]
                                        .sort(
                                          (a, b) =>
                                            a.set_option_position -
                                            b.set_option_position
                                        )
                                        .map((opt, idx) => (
                                          <p key={opt.option_id}>
                                            <span>
                                              {getOptionLabel(
                                                idx,
                                                quesPaperInfo?.option_naming_pattern
                                              )}
                                            </span>{" "}
                                            {renderQuestionText(
                                              opt.option_text
                                            )}
                                          </p>
                                        ))}
                                    </div>
                                  </div>
                                ))}
                              </div>
                              <div className="question-column__pre-ques">
                                {rightQuestions.map((ques, index) => (
                                  <div
                                    key={ques.ques_id}
                                    className="question-block"
                                  >
                                    <p>
                                      <strong>
                                        {page.questionIndexOffset +
                                          mid +
                                          index +
                                          1}
                                        .
                                      </strong>{" "}
                                      {renderQuestionText(ques.ques_text)}
                                    </p>
                                    <div className="options__pre-ques">
                                      {[...ques.options]
                                        .sort(
                                          (a, b) =>
                                            a.set_option_position -
                                            b.set_option_position
                                        )
                                        .map((opt, idx) => (
                                          <p key={opt.option_id}>
                                            <span>
                                              {getOptionLabel(
                                                idx,
                                                quesPaperInfo?.option_naming_pattern
                                              )}
                                            </span>{" "}
                                            {renderQuestionText(
                                              opt.option_text
                                            )}
                                          </p>
                                        ))}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ) : (
                            <div>
                              {questions.map((ques, index) => (
                                <div
                                  key={ques.ques_id}
                                  className="question-block"
                                >
                                  <p>
                                    <strong>
                                      {page.questionIndexOffset + index + 1}.
                                    </strong>{" "}
                                    {renderQuestionText(ques.ques_text)}
                                  </p>
                                  <div className="options__pre-ques">
                                    {[...ques.options]
                                      .sort(
                                        (a, b) =>
                                          a.set_option_position -
                                          b.set_option_position
                                      )
                                      .map((opt, idx) => (
                                        <p key={opt.option_id}>
                                          <span>
                                            {getOptionLabel(
                                              idx,
                                              quesPaperInfo?.option_naming_pattern
                                            )}
                                          </span>{" "}
                                          {renderQuestionText(opt.option_text)}
                                        </p>
                                      ))}
                                  </div>
                                </div>
                              ))}
                            </div>
                          );
                        })()}

                        {roughPage && (
                          <div
                            className="rough-work-section"
                            style={{
                              minHeight: page.isLastPageInSection
                                ? "60px"
                                : "120px", // Reduced heights
                            }}
                          >
                            <strong>Rough Work:</strong>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Page Footer */}
                    <div className="page-footer">
                      <div className="footer-left">
                        {quesPaperInfo?.footer?.client_name} |{" "}
                        {quesPaperInfo?.footer?.address}
                      </div>
                      <div className="footer-right">
                        {page.type === "cover" &&
                          `Set ${page.setName} - Cover Page`}
                        {page.type === "syllabus" &&
                          `Set ${page.setName} - Syllabus`}
                        {page.type === "questions" && `Page ${page.pageNumber}`}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-set-selected-message">
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "50px",
                      fontSize: "18px",
                      color: "#444",
                    }}
                  >
                    Please select at least one Set (A, B, C, or D) to preview
                    the question paper.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PreviewQuesPaper;
